webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('grafana.core', ['ngRoute']));


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(524),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (Settings) {
  "use strict";

  var bootData = window.grafanaBootData || { settings: {} };
  var options = bootData.settings;
  options.bootData = bootData;

  return new Settings(options);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_emitter__ = __webpack_require__(278);
///<reference path="../headers/common.d.ts" />

var appEvents = new __WEBPACK_IMPORTED_MODULE_0__utils_emitter__["a" /* Emitter */]();
/* harmony default export */ __webpack_exports__["a"] = (appEvents);


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = react2AngularDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);

function react2AngularDirective(name, component, options) {
    __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].directive(name, ['reactDirective', function (reactDirective) {
            return reactDirective(component, options);
        }]);
}


/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(10),
  __webpack_require__(4),
  __webpack_require__(1)
], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _, moment) {
  'use strict';

  var kbn = {};
  kbn.valueFormats = {};

  kbn.regexEscape = function(value) {
    return value.replace(/[\\^$*+?.()|[\]{}\/]/g, '\\$&');
  };

  ///// HELPER FUNCTIONS /////

  kbn.round_interval = function(interval) {
    switch (true) {
      // 0.015s
      case (interval < 15):
        return 10;      // 0.01s
      // 0.035s
      case (interval < 35):
        return 20;      // 0.02s
      // 0.075s
      case (interval < 75):
        return 50;       // 0.05s
      // 0.15s
      case (interval < 150):
        return 100;      // 0.1s
      // 0.35s
      case (interval < 350):
        return 200;      // 0.2s
      // 0.75s
      case (interval < 750):
        return 500;       // 0.5s
      // 1.5s
      case (interval < 1500):
        return 1000;      // 1s
      // 3.5s
      case (interval < 3500):
        return 2000;      // 2s
      // 7.5s
      case (interval < 7500):
        return 5000;      // 5s
      // 12.5s
      case (interval < 12500):
        return 10000;     // 10s
      // 17.5s
      case (interval < 17500):
        return 15000;     // 15s
      // 25s
      case (interval < 25000):
        return 20000;     // 20s
      // 45s
      case (interval < 45000):
        return 30000;     // 30s
      // 1.5m
      case (interval < 90000):
        return 60000;     // 1m
      // 3.5m
      case (interval < 210000):
        return 120000;    // 2m
      // 7.5m
      case (interval < 450000):
        return 300000;    // 5m
      // 12.5m
      case (interval < 750000):
        return 600000;    // 10m
      // 12.5m
      case (interval < 1050000):
        return 900000;    // 15m
      // 25m
      case (interval < 1500000):
        return 1200000;   // 20m
      // 45m
      case (interval < 2700000):
        return 1800000;   // 30m
      // 1.5h
      case (interval < 5400000):
        return 3600000;   // 1h
      // 2.5h
      case (interval < 9000000):
        return 7200000;   // 2h
      // 4.5h
      case (interval < 16200000):
        return 10800000;  // 3h
      // 9h
      case (interval < 32400000):
        return 21600000;  // 6h
      // 1d
      case (interval < 86400000):
        return 43200000;  // 12h
      // 1w
      case (interval < 604800000):
        return 86400000;  // 1d
      // 3w
      case (interval < 1814400000):
        return 604800000; // 1w
      // 6w
      case (interval < 3628800000):
        return 2592000000; // 30d
      default:
        return 31536000000; // 1y
    }
  };

  kbn.secondsToHms = function(seconds) {
    var numyears = Math.floor(seconds / 31536000);
    if(numyears){
      return numyears + 'y';
    }
    var numdays = Math.floor((seconds % 31536000) / 86400);
    if(numdays){
      return numdays + 'd';
    }
    var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
    if(numhours){
      return numhours + 'h';
    }
    var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
    if(numminutes){
      return numminutes + 'm';
    }
    var numseconds = Math.floor((((seconds % 31536000) % 86400) % 3600) % 60);
    if(numseconds){
      return numseconds + 's';
    }
    var nummilliseconds = Math.floor(seconds * 1000.0);
    if(nummilliseconds){
      return nummilliseconds + 'ms';
    }

    return 'less than a millisecond'; //'just now' //or other string you like;
  };

  kbn.to_percent = function(number,outof) {
    return Math.floor((number/outof)*10000)/100 + "%";
  };

  kbn.addslashes = function(str) {
    str = str.replace(/\\/g, '\\\\');
    str = str.replace(/\'/g, '\\\'');
    str = str.replace(/\"/g, '\\"');
    str = str.replace(/\0/g, '\\0');
    return str;
  };

  kbn.interval_regex = /(\d+(?:\.\d+)?)(ms|[Mwdhmsy])/;

  // histogram & trends
  kbn.intervals_in_seconds = {
    y: 31536000,
    M: 2592000,
    w: 604800,
    d: 86400,
    h: 3600,
    m: 60,
    s: 1,
    ms: 0.001
  };

  kbn.calculateInterval = function(range, resolution, lowLimitInterval) {
    var lowLimitMs = 1; // 1 millisecond default low limit
    var intervalMs;

    if (lowLimitInterval) {
      if (lowLimitInterval[0] === '>') {
        lowLimitInterval = lowLimitInterval.slice(1);
      }
      lowLimitMs = kbn.interval_to_ms(lowLimitInterval);
    }

    intervalMs = kbn.round_interval((range.to.valueOf() - range.from.valueOf()) / resolution);
    if (lowLimitMs > intervalMs) {
      intervalMs = lowLimitMs;
    }

    return {
      intervalMs: intervalMs,
      interval: kbn.secondsToHms(intervalMs / 1000),
    };
  };

  kbn.describe_interval = function (string) {
    var matches = string.match(kbn.interval_regex);
    if (!matches || !_.has(kbn.intervals_in_seconds, matches[2])) {
      throw new Error('Invalid interval string, expecting a number followed by one of "Mwdhmsy"');
    } else {
      return {
        sec: kbn.intervals_in_seconds[matches[2]],
        type: matches[2],
        count: parseInt(matches[1], 10)
      };
    }
  };

  kbn.interval_to_ms = function(string) {
    var info = kbn.describe_interval(string);
    return info.sec * 1000 * info.count;
  };

  kbn.interval_to_seconds = function (string) {
    var info = kbn.describe_interval(string);
    return info.sec * info.count;
  };

  kbn.query_color_dot = function (color, diameter) {
    return '<div class="icon-circle" style="' + [
      'display:inline-block',
      'color:' + color,
      'font-size:' + diameter + 'px',
    ].join(';') + '"></div>';
  };

  kbn.slugifyForUrl = function(str) {
    return str
      .toLowerCase()
      .replace(/[^\w ]+/g,'')
      .replace(/ +/g,'-');
  };

  kbn.stringToJsRegex = function(str) {
    if (str[0] !== '/') {
      return new RegExp('^' + str + '$');
    }

    var match = str.match(new RegExp('^/(.*?)/(g?i?m?y?)$'));
    return new RegExp(match[1], match[2]);
  };

  kbn.toFixed = function(value, decimals) {
    if (value === null) {
      return "";
    }

    var factor = decimals ? Math.pow(10, Math.max(0, decimals)) : 1;
    var formatted = String(Math.round(value * factor) / factor);

    // if exponent return directly
    if (formatted.indexOf('e') !== -1 || value === 0) {
      return formatted;
    }

    // If tickDecimals was specified, ensure that we have exactly that
    // much precision; otherwise default to the value's own precision.
    if (decimals != null) {
      var decimalPos = formatted.indexOf(".");
      var precision = decimalPos === -1 ? 0 : formatted.length - decimalPos - 1;
      if (precision < decimals) {
        return (precision ? formatted : formatted + ".") + (String(factor)).substr(1, decimals - precision);
      }
    }

    return formatted;
  };

  kbn.toFixedScaled = function(value, decimals, scaledDecimals, additionalDecimals, ext) {
    if (scaledDecimals === null) {
      return kbn.toFixed(value, decimals) + ext;
    } else {
      return kbn.toFixed(value, scaledDecimals + additionalDecimals) + ext;
    }
  };

  kbn.roundValue = function (num, decimals) {
    if (num === null) { return null; }
    var n = Math.pow(10, decimals);
    return Math.round((n * num).toFixed(decimals))  / n;
  };

  ///// FORMAT FUNCTION CONSTRUCTORS /////

  kbn.formatBuilders = {};

  // Formatter which always appends a fixed unit string to the value. No
  // scaling of the value is performed.
  kbn.formatBuilders.fixedUnit = function(unit) {
    return function(size, decimals) {
      if (size === null) { return ""; }
      return kbn.toFixed(size, decimals) + ' ' + unit;
    };
  };

  // Formatter which scales the unit string geometrically according to the given
  // numeric factor. Repeatedly scales the value down by the factor until it is
  // less than the factor in magnitude, or the end of the array is reached.
  kbn.formatBuilders.scaledUnits = function(factor, extArray) {
    return function(size, decimals, scaledDecimals) {
      if (size === null) {
        return "";
      }

      var steps = 0;
      var limit = extArray.length;

      while (Math.abs(size) >= factor) {
        steps++;
        size /= factor;

        if (steps >= limit) { return "NA"; }
      }

      if (steps > 0 && scaledDecimals !== null) {
        decimals = scaledDecimals + (3 * steps);
      }

      return kbn.toFixed(size, decimals) + extArray[steps];
    };
  };

  // Extension of the scaledUnits builder which uses SI decimal prefixes. If an
  // offset is given, it adjusts the starting units at the given prefix; a value
  // of 0 starts at no scale; -3 drops to nano, +2 starts at mega, etc.
  kbn.formatBuilders.decimalSIPrefix = function(unit, offset) {
    var prefixes = ['n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
    prefixes = prefixes.slice(3 + (offset || 0));
    var units = prefixes.map(function(p) { return ' ' + p + unit; });
    return kbn.formatBuilders.scaledUnits(1000, units);
  };

  // Extension of the scaledUnits builder which uses SI binary prefixes. If
  // offset is given, it starts the units at the given prefix; otherwise, the
  // offset defaults to zero and the initial unit is not prefixed.
  kbn.formatBuilders.binarySIPrefix = function(unit, offset) {
    var prefixes = ['', 'Ki', 'Mi', 'Gi', 'Ti', 'Pi', 'Ei', 'Zi', 'Yi'].slice(offset);
    var units = prefixes.map(function(p) { return ' ' + p + unit; });
    return kbn.formatBuilders.scaledUnits(1024, units);
  };

  // Currency formatter for prefixing a symbol onto a number. Supports scaling
  // up to the trillions.
  kbn.formatBuilders.currency = function(symbol) {
    var units = ['', 'K', 'M', 'B', 'T'];
    var scaler = kbn.formatBuilders.scaledUnits(1000, units);
    return function(size, decimals, scaledDecimals) {
      if (size === null) { return ""; }
      var scaled = scaler(size, decimals, scaledDecimals);
      return symbol + scaled;
    };
  };

  kbn.formatBuilders.simpleCountUnit = function(symbol) {
    var units = ['', 'K', 'M', 'B', 'T'];
    var scaler = kbn.formatBuilders.scaledUnits(1000, units);
    return function(size, decimals, scaledDecimals) {
      if (size === null) { return ""; }
      var scaled = scaler(size, decimals, scaledDecimals);
      return scaled + " " + symbol;
    };
  };

  ///// VALUE FORMATS /////

  // Dimensionless Units
  kbn.valueFormats.none  = kbn.toFixed;
  kbn.valueFormats.short = kbn.formatBuilders.scaledUnits(1000, ['', ' K', ' Mil', ' Bil', ' Tri', ' Quadr', ' Quint', ' Sext', ' Sept']);
  kbn.valueFormats.dB    = kbn.formatBuilders.fixedUnit('dB');
  kbn.valueFormats.ppm   = kbn.formatBuilders.fixedUnit('ppm');

  kbn.valueFormats.percent = function(size, decimals) {
    if (size === null) { return ""; }
    return kbn.toFixed(size, decimals) + '%';
  };

  kbn.valueFormats.percentunit = function(size, decimals) {
    if (size === null) { return ""; }
    return kbn.toFixed(100*size, decimals) + '%';
  };

  /* Formats the value to hex. Uses float if specified decimals are not 0.
   * There are two options, one with 0x, and one without */

  kbn.valueFormats.hex = function(value, decimals) {
    if (value == null) { return ""; }
    return parseFloat(kbn.toFixed(value, decimals)).toString(16).toUpperCase();
  };

  kbn.valueFormats.hex0x = function(value, decimals) {
    if (value == null) { return ""; }
    var hexString = kbn.valueFormats.hex(value, decimals);
    if (hexString.substring(0,1) === "-") {
      return "-0x" + hexString.substring(1);
    }
    return "0x" + hexString;
  };

  kbn.valueFormats.sci = function(value, decimals) {
    return value.toExponential(decimals);
  };

  kbn.valueFormats.locale = function(value, decimals) {
    return value.toLocaleString(undefined, {maximumFractionDigits: decimals});
  };

  // Currencies
  kbn.valueFormats.currencyUSD = kbn.formatBuilders.currency('$');
  kbn.valueFormats.currencyGBP = kbn.formatBuilders.currency('£');
  kbn.valueFormats.currencyEUR = kbn.formatBuilders.currency('€');
  kbn.valueFormats.currencyJPY = kbn.formatBuilders.currency('¥');
  kbn.valueFormats.currencyRUB = kbn.formatBuilders.currency('₽');
  kbn.valueFormats.currencyUAH = kbn.formatBuilders.currency('₴');
  kbn.valueFormats.currencyBRL = kbn.formatBuilders.currency('R$');
  kbn.valueFormats.currencyDKK = kbn.formatBuilders.currency('kr');
  kbn.valueFormats.currencyISK = kbn.formatBuilders.currency('kr');
  kbn.valueFormats.currencyNOK = kbn.formatBuilders.currency('kr');
  kbn.valueFormats.currencySEK = kbn.formatBuilders.currency('kr');

  // Data (Binary)
  kbn.valueFormats.bits   = kbn.formatBuilders.binarySIPrefix('b');
  kbn.valueFormats.bytes  = kbn.formatBuilders.binarySIPrefix('B');
  kbn.valueFormats.kbytes = kbn.formatBuilders.binarySIPrefix('B', 1);
  kbn.valueFormats.mbytes = kbn.formatBuilders.binarySIPrefix('B', 2);
  kbn.valueFormats.gbytes = kbn.formatBuilders.binarySIPrefix('B', 3);

  // Data (Decimal)
  kbn.valueFormats.decbits   = kbn.formatBuilders.decimalSIPrefix('b');
  kbn.valueFormats.decbytes  = kbn.formatBuilders.decimalSIPrefix('B');
  kbn.valueFormats.deckbytes = kbn.formatBuilders.decimalSIPrefix('B', 1);
  kbn.valueFormats.decmbytes = kbn.formatBuilders.decimalSIPrefix('B', 2);
  kbn.valueFormats.decgbytes = kbn.formatBuilders.decimalSIPrefix('B', 3);

  // Data Rate
  kbn.valueFormats.pps    = kbn.formatBuilders.decimalSIPrefix('pps');
  kbn.valueFormats.bps    = kbn.formatBuilders.decimalSIPrefix('bps');
  kbn.valueFormats.Bps    = kbn.formatBuilders.decimalSIPrefix('Bps');
  kbn.valueFormats.KBs    = kbn.formatBuilders.decimalSIPrefix('Bs', 1);
  kbn.valueFormats.Kbits  = kbn.formatBuilders.decimalSIPrefix('bps', 1);
  kbn.valueFormats.MBs    = kbn.formatBuilders.decimalSIPrefix('Bs', 2);
  kbn.valueFormats.Mbits  = kbn.formatBuilders.decimalSIPrefix('bps', 2);
  kbn.valueFormats.GBs    = kbn.formatBuilders.decimalSIPrefix('Bs', 3);
  kbn.valueFormats.Gbits  = kbn.formatBuilders.decimalSIPrefix('bps', 3);

  // Throughput
  kbn.valueFormats.ops  = kbn.formatBuilders.simpleCountUnit('ops');
  kbn.valueFormats.rps  = kbn.formatBuilders.simpleCountUnit('rps');
  kbn.valueFormats.wps  = kbn.formatBuilders.simpleCountUnit('wps');
  kbn.valueFormats.iops = kbn.formatBuilders.simpleCountUnit('iops');
  kbn.valueFormats.opm = kbn.formatBuilders.simpleCountUnit('opm');
  kbn.valueFormats.rpm = kbn.formatBuilders.simpleCountUnit('rpm');
  kbn.valueFormats.wpm = kbn.formatBuilders.simpleCountUnit('wpm');

  // Energy
  kbn.valueFormats.watt         = kbn.formatBuilders.decimalSIPrefix('W');
  kbn.valueFormats.kwatt        = kbn.formatBuilders.decimalSIPrefix('W', 1);
  kbn.valueFormats.voltamp      = kbn.formatBuilders.decimalSIPrefix('VA');
  kbn.valueFormats.kvoltamp     = kbn.formatBuilders.decimalSIPrefix('VA', 1);
  kbn.valueFormats.voltampreact = kbn.formatBuilders.decimalSIPrefix('var');
  kbn.valueFormats.kvoltampreact = kbn.formatBuilders.decimalSIPrefix('var', 1);
  kbn.valueFormats.watth        = kbn.formatBuilders.decimalSIPrefix('Wh');
  kbn.valueFormats.kwatth       = kbn.formatBuilders.decimalSIPrefix('Wh', 1);
  kbn.valueFormats.joule        = kbn.formatBuilders.decimalSIPrefix('J');
  kbn.valueFormats.ev           = kbn.formatBuilders.decimalSIPrefix('eV');
  kbn.valueFormats.amp          = kbn.formatBuilders.decimalSIPrefix('A');
  kbn.valueFormats.kamp         = kbn.formatBuilders.decimalSIPrefix('A', 1);
  kbn.valueFormats.volt         = kbn.formatBuilders.decimalSIPrefix('V');
  kbn.valueFormats.kvolt        = kbn.formatBuilders.decimalSIPrefix('V', 1);
  kbn.valueFormats.dBm          = kbn.formatBuilders.decimalSIPrefix('dBm');

  // Temperature
  kbn.valueFormats.celsius   = kbn.formatBuilders.fixedUnit('°C');
  kbn.valueFormats.farenheit = kbn.formatBuilders.fixedUnit('°F');
  kbn.valueFormats.kelvin    = kbn.formatBuilders.fixedUnit('K');
  kbn.valueFormats.humidity  = kbn.formatBuilders.fixedUnit('%H');

  // Pressure
  kbn.valueFormats.pressurebar  = kbn.formatBuilders.decimalSIPrefix('bar');
  kbn.valueFormats.pressurembar = kbn.formatBuilders.decimalSIPrefix('bar', -1);
  kbn.valueFormats.pressurekbar = kbn.formatBuilders.decimalSIPrefix('bar', 1);
  kbn.valueFormats.pressurehpa  = kbn.formatBuilders.fixedUnit('hPa');
  kbn.valueFormats.pressurehg   = kbn.formatBuilders.fixedUnit('"Hg');
  kbn.valueFormats.pressurepsi  = kbn.formatBuilders.scaledUnits(1000, [' psi', ' ksi', ' Mpsi']);

  // Force
  kbn.valueFormats.forceNm  = kbn.formatBuilders.decimalSIPrefix('Nm');
  kbn.valueFormats.forcekNm = kbn.formatBuilders.decimalSIPrefix('Nm', 1);
  kbn.valueFormats.forceN   = kbn.formatBuilders.decimalSIPrefix('N');
  kbn.valueFormats.forcekN  = kbn.formatBuilders.decimalSIPrefix('N', 1);

  // Length
  kbn.valueFormats.lengthm  = kbn.formatBuilders.decimalSIPrefix('m');
  kbn.valueFormats.lengthmm = kbn.formatBuilders.decimalSIPrefix('m', -1);
  kbn.valueFormats.lengthkm = kbn.formatBuilders.decimalSIPrefix('m', 1);
  kbn.valueFormats.lengthmi = kbn.formatBuilders.fixedUnit('mi');

  // Mass
  kbn.valueFormats.massmg  = kbn.formatBuilders.decimalSIPrefix('g', -1);
  kbn.valueFormats.massg = kbn.formatBuilders.decimalSIPrefix('g');
  kbn.valueFormats.masskg = kbn.formatBuilders.decimalSIPrefix('g', 1);
  kbn.valueFormats.masst = kbn.formatBuilders.fixedUnit('t');

  // Velocity
  kbn.valueFormats.velocityms   = kbn.formatBuilders.fixedUnit('m/s');
  kbn.valueFormats.velocitykmh  = kbn.formatBuilders.fixedUnit('km/h');
  kbn.valueFormats.velocitymph  = kbn.formatBuilders.fixedUnit('mph');
  kbn.valueFormats.velocityknot = kbn.formatBuilders.fixedUnit('kn');

  // Volume
  kbn.valueFormats.litre  = kbn.formatBuilders.decimalSIPrefix('L');
  kbn.valueFormats.mlitre = kbn.formatBuilders.decimalSIPrefix('L', -1);
  kbn.valueFormats.m3     = kbn.formatBuilders.decimalSIPrefix('m3');
  kbn.valueFormats.dm3    = kbn.formatBuilders.decimalSIPrefix('dm3');
  kbn.valueFormats.gallons  = kbn.formatBuilders.fixedUnit('gal');

  // Flow
  kbn.valueFormats.flowgpm  = kbn.formatBuilders.fixedUnit('gpm');
  kbn.valueFormats.flowcms  = kbn.formatBuilders.fixedUnit('cms');
  kbn.valueFormats.flowcfs  = kbn.formatBuilders.fixedUnit('cfs');
  kbn.valueFormats.flowcfm  = kbn.formatBuilders.fixedUnit('cfm');

  // Time
  kbn.valueFormats.hertz = kbn.formatBuilders.decimalSIPrefix('Hz');

  kbn.valueFormats.ms = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    if (Math.abs(size) < 1000) {
      return kbn.toFixed(size, decimals) + " ms";
    }
    // Less than 1 min
    else if (Math.abs(size) < 60000) {
      return kbn.toFixedScaled(size / 1000, decimals, scaledDecimals, 3, " s");
    }
    // Less than 1 hour, devide in minutes
    else if (Math.abs(size) < 3600000) {
      return kbn.toFixedScaled(size / 60000, decimals, scaledDecimals, 5, " min");
    }
    // Less than one day, devide in hours
    else if (Math.abs(size) < 86400000) {
      return kbn.toFixedScaled(size / 3600000, decimals, scaledDecimals, 7, " hour");
    }
    // Less than one year, devide in days
    else if (Math.abs(size) < 31536000000) {
      return kbn.toFixedScaled(size / 86400000, decimals, scaledDecimals, 8, " day");
    }

    return kbn.toFixedScaled(size / 31536000000, decimals, scaledDecimals, 10, " year");
  };

  kbn.valueFormats.s = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    // Less than 1 µs, devide in ns
    if (Math.abs(size) < 0.000001) {
      return kbn.toFixedScaled(size * 1.e9, decimals, scaledDecimals - decimals, -9, " ns");
    }
    // Less than 1 ms, devide in µs
    if (Math.abs(size) < 0.001) {
      return kbn.toFixedScaled(size * 1.e6, decimals, scaledDecimals - decimals, -6, " µs");
    }
    // Less than 1 second, devide in ms
    if (Math.abs(size) < 1) {
      return kbn.toFixedScaled(size * 1.e3, decimals, scaledDecimals - decimals, -3, " ms");
    }

    if (Math.abs(size) < 60) {
      return kbn.toFixed(size, decimals) + " s";
    }
    // Less than 1 hour, devide in minutes
    else if (Math.abs(size) < 3600) {
      return kbn.toFixedScaled(size / 60, decimals, scaledDecimals, 1, " min");
    }
    // Less than one day, devide in hours
    else if (Math.abs(size) < 86400) {
      return kbn.toFixedScaled(size / 3600, decimals, scaledDecimals, 4, " hour");
    }
    // Less than one week, devide in days
    else if (Math.abs(size) < 604800) {
      return kbn.toFixedScaled(size / 86400, decimals, scaledDecimals, 5, " day");
    }
    // Less than one year, devide in week
    else if (Math.abs(size) < 31536000) {
      return kbn.toFixedScaled(size / 604800, decimals, scaledDecimals, 6, " week");
    }

    return kbn.toFixedScaled(size / 3.15569e7, decimals, scaledDecimals, 7, " year");
  };

  kbn.valueFormats['µs'] = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    if (Math.abs(size) < 1000) {
      return kbn.toFixed(size, decimals) + " µs";
    }
    else if (Math.abs(size) < 1000000) {
      return kbn.toFixedScaled(size / 1000, decimals, scaledDecimals, 3, " ms");
    }
    else {
      return kbn.toFixedScaled(size / 1000000, decimals, scaledDecimals, 6, " s");
    }
  };

  kbn.valueFormats.ns = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    if (Math.abs(size) < 1000) {
      return kbn.toFixed(size, decimals) + " ns";
    }
    else if (Math.abs(size) < 1000000) {
      return kbn.toFixedScaled(size / 1000, decimals, scaledDecimals, 3, " µs");
    }
    else if (Math.abs(size) < 1000000000) {
      return kbn.toFixedScaled(size / 1000000, decimals, scaledDecimals, 6, " ms");
    }
    else if (Math.abs(size) < 60000000000){
      return kbn.toFixedScaled(size / 1000000000, decimals, scaledDecimals, 9, " s");
    }
    else {
      return kbn.toFixedScaled(size / 60000000000, decimals, scaledDecimals, 12, " min");
    }
  };

  kbn.valueFormats.m = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    if (Math.abs(size) < 60) {
      return kbn.toFixed(size, decimals) + " min";
    }
    else if (Math.abs(size) < 1440) {
      return kbn.toFixedScaled(size / 60, decimals, scaledDecimals, 2, " hour");
    }
    else if (Math.abs(size) < 10080) {
      return kbn.toFixedScaled(size / 1440, decimals, scaledDecimals, 3, " day");
    }
    else if (Math.abs(size) < 604800) {
      return kbn.toFixedScaled(size / 10080, decimals, scaledDecimals, 4, " week");
    }
    else {
      return kbn.toFixedScaled(size / 5.25948e5, decimals, scaledDecimals, 5, " year");
    }
  };

  kbn.valueFormats.h = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    if (Math.abs(size) < 24) {
      return kbn.toFixed(size, decimals) + " hour";
    }
    else if (Math.abs(size) < 168) {
      return kbn.toFixedScaled(size / 24, decimals, scaledDecimals, 2, " day");
    }
    else if (Math.abs(size) < 8760) {
      return kbn.toFixedScaled(size / 168, decimals, scaledDecimals, 3, " week");
    }
    else {
      return kbn.toFixedScaled(size / 8760, decimals, scaledDecimals, 4, " year");
    }
  };

  kbn.valueFormats.d = function(size, decimals, scaledDecimals) {
    if (size === null) { return ""; }

    if (Math.abs(size) < 7) {
      return kbn.toFixed(size, decimals) + " day";
    }
    else if (Math.abs(size) < 365) {
      return kbn.toFixedScaled(size / 7, decimals, scaledDecimals, 2, " week");
    }
    else {
      return kbn.toFixedScaled(size / 365, decimals, scaledDecimals, 3, " year");
    }
  };

  kbn.toDuration = function(size, decimals, timeScale) {
    if (size === null) { return ""; }
    if (size === 0) { return "0 " + timeScale + "s"; }
    if (size < 0) { return kbn.toDuration(-size, decimals, timeScale) + " ago"; }

    var units = [
      {short: "y",  long: "year"},
      {short: "M",  long: "month"},
      {short: "w",  long: "week"},
      {short: "d",  long: "day"},
      {short: "h",  long: "hour"},
      {short: "m",  long: "minute"},
      {short: "s",  long: "second"},
      {short: "ms", long: "millisecond"}
    ];
    // convert $size to milliseconds
    // intervals_in_seconds uses seconds (duh), convert them to milliseconds here to minimize floating point errors
    size *= kbn.intervals_in_seconds[units.find(function(e) { return e.long === timeScale; }).short] * 1000;

    var string = [];
    // after first value >= 1 print only $decimals more
    var decrementDecimals = false;
    for (var i = 0; i < units.length && decimals >= 0; i++) {
      var interval = kbn.intervals_in_seconds[units[i].short] * 1000;
      var value = size / interval;
      if (value >= 1 || decrementDecimals) {
        decrementDecimals = true;
        var floor = Math.floor(value);
        var unit = units[i].long + (floor !== 1 ? "s" : "");
        string.push(floor + " " + unit);
        size = size % interval;
        decimals--;
      }
    }

    return string.join(", ");
  };

  kbn.valueFormats.dtdurationms = function(size, decimals) {
    return kbn.toDuration(size, decimals, 'millisecond');
  };

  kbn.valueFormats.dtdurations = function(size, decimals) {
    return kbn.toDuration(size, decimals, 'second');
  };

  kbn.valueFormats.dateTimeAsIso = function(epoch) {
    var time = moment(epoch);

    if (moment().isSame(epoch, 'day')) {
      return time.format('HH:mm:ss');
    }
    return time.format('YYYY-MM-DD HH:mm:ss');
  };

  kbn.valueFormats.dateTimeAsUS = function(epoch) {
    var time = moment(epoch);

    if (moment().isSame(epoch, 'day')) {
      return time.format('h:mm:ss a');
    }
    return time.format('MM/DD/YYYY h:mm:ss a');
  };

  kbn.valueFormats.dateTimeFromNow = function(epoch) {
    return moment(epoch).fromNow();
  };

  ///// FORMAT MENU /////

  kbn.getUnitFormats = function() {
    return [
      {
        text: 'none',
        submenu: [
          {text: 'none' ,               value: 'none'       },
          {text: 'short',               value: 'short'      },
          {text: 'percent (0-100)',     value: 'percent'    },
          {text: 'percent (0.0-1.0)',   value: 'percentunit'},
          {text: 'Humidity (%H)',       value: 'humidity'   },
          {text: 'ppm',                 value: 'ppm'        },
          {text: 'decibel',             value: 'dB'         },
          {text: 'hexadecimal (0x)',    value: 'hex0x'      },
          {text: 'hexadecimal',         value: 'hex'        },
          {text: 'scientific notation', value: 'sci'        },
          {text: 'locale format',       value: 'locale'     },
        ]
      },
      {
        text: 'currency',
        submenu: [
          {text: 'Dollars ($)', value: 'currencyUSD'},
          {text: 'Pounds (£)',  value: 'currencyGBP'},
          {text: 'Euro (€)',    value: 'currencyEUR'},
          {text: 'Yen (¥)',     value: 'currencyJPY'},
          {text: 'Rubles (₽)',  value: 'currencyRUB'},
          {text: 'Hryvnias (₴)',  value: 'currencyUAH'},
          {text: 'Real (R$)', value: 'currencyBRL'},
          {text: 'Danish Krone (kr)', value: 'currencyDKK'},
          {text: 'Icelandic Krone (kr)', value: 'currencyISK'},
          {text: 'Norwegian Krone (kr)', value: 'currencyNOK'},
          {text: 'Swedish Krone (kr)', value: 'currencySEK'},
        ]
      },
      {
        text: 'time',
        submenu: [
          {text: 'Hertz (1/s)',       value: 'hertz'},
          {text: 'nanoseconds (ns)' , value: 'ns'   },
          {text: 'microseconds (µs)', value: 'µs'   },
          {text: 'milliseconds (ms)', value: 'ms'   },
          {text: 'seconds (s)',       value: 's'    },
          {text: 'minutes (m)',       value: 'm'    },
          {text: 'hours (h)',         value: 'h'    },
          {text: 'days (d)',          value: 'd'    },
          {text: 'duration (ms)',     value: 'dtdurationms' },
          {text: 'duration (s)',      value: 'dtdurations' },
        ]
      },
      {
        text: 'date & time',
        submenu: [
          {text: 'YYYY-MM-DD HH:mm:ss',   value: 'dateTimeAsIso' },
          {text: 'DD/MM/YYYY h:mm:ss a',  value: 'dateTimeAsUS' },
          {text: 'From Now',              value: 'dateTimeFromNow' },
        ]
      },
      {
        text: 'data (IEC)',
        submenu: [
          {text: 'bits',      value: 'bits'  },
          {text: 'bytes',     value: 'bytes' },
          {text: 'kibibytes', value: 'kbytes'},
          {text: 'mebibytes', value: 'mbytes'},
          {text: 'gibibytes', value: 'gbytes'},
        ]
      },
      {
        text: 'data (Metric)',
        submenu: [
          {text: 'bits',      value: 'decbits'  },
          {text: 'bytes',     value: 'decbytes' },
          {text: 'kilobytes', value: 'deckbytes'},
          {text: 'megabytes', value: 'decmbytes'},
          {text: 'gigabytes', value: 'decgbytes'},
        ]
      },
      {
        text: 'data rate',
        submenu: [
          {text: 'packets/sec', value: 'pps'},
          {text: 'bits/sec',    value: 'bps'},
          {text: 'bytes/sec',   value: 'Bps'},
          {text: 'kilobits/sec', value: 'Kbits'},
          {text: 'kilobytes/sec',    value: 'KBs'},
          {text: 'megabits/sec', value: 'Mbits'},
          {text: 'megabytes/sec',    value: 'MBs'},
          {text: 'gigabytes/sec',   value: 'GBs'},
          {text: 'gigabits/sec',   value: 'Gbits'},
        ]
      },
      {
        text: 'throughput',
        submenu: [
          {text: 'ops/sec (ops)',       value: 'ops' },
          {text: 'reads/sec (rps)',     value: 'rps' },
          {text: 'writes/sec (wps)',    value: 'wps' },
          {text: 'I/O ops/sec (iops)',  value: 'iops'},
          {text: 'ops/min (opm)',       value: 'opm' },
          {text: 'reads/min (rpm)',     value: 'rpm' },
          {text: 'writes/min (wpm)',    value: 'wpm' },
        ]
      },
      {
        text: 'length',
        submenu: [
          {text: 'millimetre (mm)', value: 'lengthmm'},
          {text: 'meter (m)',       value: 'lengthm' },
          {text: 'kilometer (km)',  value: 'lengthkm'},
          {text: 'mile (mi)',       value: 'lengthmi'},
        ]
      },
      {
        text: 'mass',
        submenu: [
          {text: 'milligram (mg)', value: 'massmg'},
          {text: 'gram (g)',       value: 'massg' },
          {text: 'kilogram (kg)',  value: 'masskg'},
          {text: 'metric ton (t)', value: 'masst' },
        ]
      },
      {
        text: 'velocity',
        submenu: [
          {text: 'm/s',       value: 'velocityms'  },
          {text: 'km/h',      value: 'velocitykmh' },
          {text: 'mph',       value: 'velocitymph' },
          {text: 'knot (kn)', value: 'velocityknot'},
        ]
      },
      {
        text: 'volume',
        submenu: [
          {text: 'millilitre',      value: 'mlitre' },
          {text: 'litre',           value: 'litre'  },
          {text: 'cubic metre',     value: 'm3'     },
          {text: 'cubic decimetre', value: 'dm3'    },
          {text: 'gallons',         value: 'gallons'},
        ]
      },
      {
        text: 'energy',
        submenu: [
          {text: 'watt (W)',                   value: 'watt'        },
          {text: 'kilowatt (kW)',              value: 'kwatt'       },
          {text: 'volt-ampere (VA)',           value: 'voltamp'     },
          {text: 'kilovolt-ampere (kVA)',      value: 'kvoltamp'    },
          {text: 'volt-ampere reactive (var)', value: 'voltampreact'},
          {text: 'kilovolt-ampere reactive (kvar)', value: 'kvoltampreact'},
          {text: 'watt-hour (Wh)',             value: 'watth'       },
          {text: 'kilowatt-hour (kWh)',        value: 'kwatth'      },
          {text: 'joule (J)',                  value: 'joule'       },
          {text: 'electron volt (eV)',         value: 'ev'          },
          {text: 'Ampere (A)',                 value: 'amp'         },
          {text: 'Kiloampere (kA)',            value: 'kamp'        },
          {text: 'Volt (V)',                   value: 'volt'        },
          {text: 'Kilovolt (kV)',              value: 'kvolt'       },
          {text: 'Decibel-milliwatt (dBm)',    value: 'dBm'         },
        ]
      },
      {
        text: 'temperature',
        submenu: [
          {text: 'Celsius (°C)',    value: 'celsius'     },
          {text: 'Farenheit (°F)',  value: 'farenheit'   },
          {text: 'Kelvin (K)',      value: 'kelvin'      },
        ]
      },
      {
        text: 'pressure',
        submenu: [
          {text: 'Millibars',         value: 'pressurembar'},
          {text: 'Bars',              value: 'pressurebar' },
          {text: 'Kilobars',          value: 'pressurekbar'},
          {text: 'Hectopascals',      value: 'pressurehpa' },
          {text: 'Inches of mercury', value: 'pressurehg'  },
          {text: 'PSI',               value: 'pressurepsi' },
        ]
      },
      {
        text: 'force',
        submenu: [
          {text: 'Newton-meters (Nm)',      value: 'forceNm'  },
          {text: 'Kilonewton-meters (kNm)', value: 'forcekNm' },
          {text: 'Newtons (N)',             value: 'forceN'   },
          {text: 'Kilonewtons (kN)',        value: 'forcekN'  },
        ]
      },
      {
        text: 'flow',
        submenu: [
          {text: 'Gallons/min (gpm)',       value: 'flowgpm'  },
          {text: 'Cubic meters/sec (cms)',  value: 'flowcms'  },
          {text: 'Cubic feet/sec (cfs)',    value: 'flowcfs'  },
          {text: 'Cubic feet/min (cfm)',    value: 'flowcfm'  },
        ]
      }
    ];
  };

  return kbn;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PALETTE_ROWS */
/* unused harmony export PALETTE_COLUMNS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ANNOTATION_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OK_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERTING_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NO_DATA_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REGION_FILL_ALPHA; });
/* unused harmony export sortColorsByHue */
/* unused harmony export hexToHsl */
/* unused harmony export hslToHex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sortedColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinycolor2__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tinycolor2__);


var PALETTE_ROWS = 4;
var PALETTE_COLUMNS = 14;
var DEFAULT_ANNOTATION_COLOR = 'rgba(0, 211, 255, 1)';
var OK_COLOR = "rgba(11, 237, 50, 1)";
var ALERTING_COLOR = "rgba(237, 46, 24, 1)";
var NO_DATA_COLOR = "rgba(150, 150, 150, 1)";
var REGION_FILL_ALPHA = 0.09;
var colors = [
    "#7EB26D", "#EAB839", "#6ED0E0", "#EF843C", "#E24D42", "#1F78C1", "#BA43A9", "#705DA0",
    "#508642", "#CCA300", "#447EBC", "#C15C17", "#890F02", "#0A437C", "#6D1F62", "#584477",
    "#B7DBAB", "#F4D598", "#70DBED", "#F9BA8F", "#F29191", "#82B5D8", "#E5A8E2", "#AEA2E0",
    "#629E51", "#E5AC0E", "#64B0C8", "#E0752D", "#BF1B00", "#0A50A1", "#962D82", "#614D93",
    "#9AC48A", "#F2C96D", "#65C5DB", "#F9934E", "#EA6460", "#5195CE", "#D683CE", "#806EB7",
    "#3F6833", "#967302", "#2F575E", "#99440A", "#58140C", "#052B51", "#511749", "#3F2B5B",
    "#E0F9D7", "#FCEACA", "#CFFAFF", "#F9E2D2", "#FCE2DE", "#BADFF4", "#F9D9F9", "#DEDAF7"
];
function sortColorsByHue(hexColors) {
    var hslColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(hexColors, hexToHsl);
    var sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(hslColors, ['h']);
    sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.chunk(sortedHSLColors, PALETTE_ROWS);
    sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sortedHSLColors, function (chunk) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(chunk, 'l');
    });
    sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flattenDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.zip.apply(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a, sortedHSLColors));
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sortedHSLColors, hslToHex);
}
function hexToHsl(color) {
    return __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(color).toHsl();
}
function hslToHex(color) {
    return __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(color).toHexString();
}
var sortedColors = sortColorsByHue(colors);
/* harmony default export */ __webpack_exports__["f"] = (colors);


/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(77);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
  'use strict';

  return {
    get: function(key) {
      return window.localStorage[key];
    },
    set: function(key, value) {
      window.localStorage[key] = value;
    },
    getBool: function(key, def) {
      if (def !== void 0 && !this.exists(key)) {
        return def;
      }
      return window.localStorage[key] === 'true';
    },
    exists: function(key) {
      return window.localStorage[key] !== void 0;
    },
    delete: function(key) {
      window.localStorage.removeItem(key);
    }

  };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonExplorer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
// Based on work https://github.com/mohsen1/json-formatter-js
// Licence MIT, Copyright (c) 2015 Mohsen Azimi


var DATE_STRING_REGEX = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
var PARTIAL_DATE_REGEX = /\d{2}:\d{2}:\d{2} GMT-\d{4}/;
var JSON_DATE_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
// When toggleing, don't animated removal or addition of more than a few items
var MAX_ANIMATED_TOGGLE_ITEMS = 10;
var requestAnimationFrame = window.requestAnimationFrame || function (cb) { cb(); return 0; };
var _defaultConfig = {
    animateOpen: true,
    animateClose: true,
    theme: null
};
/**
 * @class JsonExplorer
 *
 * JsonExplorer allows you to render JSON objects in HTML with a
 * **collapsible** navigation.
*/
var JsonExplorer = /** @class */ (function () {
    /**
     * @param {object} json The JSON object you want to render. It has to be an
     * object or array. Do NOT pass raw JSON string.
     *
     * @param {number} [open=1] his number indicates up to how many levels the
     * rendered tree should expand. Set it to `0` to make the whole tree collapsed
     * or set it to `Infinity` to expand the tree deeply
     *
     * @param {object} [config=defaultConfig] -
     *  defaultConfig = {
     *   hoverPreviewEnabled: false,
     *   hoverPreviewArrayCount: 100,
     *   hoverPreviewFieldCount: 5
     * }
     *
     * Available configurations:
     *  #####Hover Preview
     * * `hoverPreviewEnabled`:  enable preview on hover
     * * `hoverPreviewArrayCount`: number of array items to show in preview Any
     *    array larger than this number will be shown as `Array[XXX]` where `XXX`
     *    is length of the array.
     * * `hoverPreviewFieldCount`: number of object properties to show for object
     *   preview. Any object with more properties that thin number will be
     *   truncated.
     *
     * @param {string} [key=undefined] The key that this object in it's parent
     * context
    */
    function JsonExplorer(json, open, config, key) {
        if (open === void 0) { open = 1; }
        if (config === void 0) { config = _defaultConfig; }
        this.json = json;
        this.open = open;
        this.config = config;
        this.key = key;
        // Hold the open state after the toggler is used
        this._isOpen = null;
        this.skipChildren = false;
    }
    Object.defineProperty(JsonExplorer.prototype, "isOpen", {
        /*
         * is formatter open?
        */
        get: function () {
            if (this._isOpen !== null) {
                return this._isOpen;
            }
            else {
                return this.open > 0;
            }
        },
        /*
         * set open state (from toggler)
        */
        set: function (value) {
            this._isOpen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isDate", {
        /*
         * is this a date string?
        */
        get: function () {
            return (this.type === 'string') &&
                (DATE_STRING_REGEX.test(this.json) ||
                    JSON_DATE_REGEX.test(this.json) ||
                    PARTIAL_DATE_REGEX.test(this.json));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isUrl", {
        /*
         * is this a URL string?
        */
        get: function () {
            return this.type === 'string' && (this.json.indexOf('http') === 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isArray", {
        /*
         * is this an array?
        */
        get: function () {
            return Array.isArray(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isObject", {
        /*
         * is this an object?
         * Note: In this context arrays are object as well
        */
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["f" /* isObject */])(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isEmptyObject", {
        /*
         * is this an empty object with no properties?
        */
        get: function () {
            return !this.keys.length && !this.isArray;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isEmpty", {
        /*
         * is this an empty object or array?
        */
        get: function () {
            return this.isEmptyObject || (this.keys && !this.keys.length && this.isArray);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "hasKey", {
        /*
         * did we recieve a key argument?
         * This means that the formatter was called as a sub formatter of a parent formatter
        */
        get: function () {
            return typeof this.key !== 'undefined';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "constructorName", {
        /*
         * if this is an object, get constructor function name
        */
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* getObjectName */])(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "type", {
        /*
         * get type of this value
         * Possible values: all JavaScript primitive types plus "array" and "null"
        */
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getType */])(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "keys", {
        /*
         * get object keys
         * If there is an empty key we pad it wit quotes to make it visible
        */
        get: function () {
            if (this.isObject) {
                return Object.keys(this.json).map(function (key) { return key ? key : '""'; });
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles `isOpen` state
     *
    */
    JsonExplorer.prototype.toggleOpen = function () {
        this.isOpen = !this.isOpen;
        if (this.element) {
            if (this.isOpen) {
                this.appendChildren(this.config.animateOpen);
            }
            else {
                this.removeChildren(this.config.animateClose);
            }
            this.element.classList.toggle(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
        }
    };
    /**
    * Open all children up to a certain depth.
    * Allows actions such as expand all/collapse all
    *
    */
    JsonExplorer.prototype.openAtDepth = function (depth) {
        if (depth === void 0) { depth = 1; }
        if (depth < 0) {
            return;
        }
        this.open = depth;
        this.isOpen = (depth !== 0);
        if (this.element) {
            this.removeChildren(false);
            if (depth === 0) {
                this.element.classList.remove(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
            }
            else {
                this.appendChildren(this.config.animateOpen);
                this.element.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
            }
        }
    };
    JsonExplorer.prototype.isNumberArray = function () {
        return (this.json.length > 0 && this.json.length < 4) &&
            (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNumber(this.json[0]) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNumber(this.json[1]));
    };
    JsonExplorer.prototype.renderArray = function () {
        var arrayWrapperSpan = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span');
        arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'bracket', '['));
        // some pretty handling of number arrays
        if (this.isNumberArray()) {
            this.json.forEach(function (val, index) {
                if (index > 0) {
                    arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'array-comma', ','));
                }
                arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'number', val));
            });
            this.skipChildren = true;
        }
        else {
            arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'number', (this.json.length)));
        }
        arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'bracket', ']'));
        return arrayWrapperSpan;
    };
    /**
     * Renders an HTML element and installs event listeners
     *
     * @returns {HTMLDivElement}
     */
    JsonExplorer.prototype.render = function (skipRoot) {
        if (skipRoot === void 0) { skipRoot = false; }
        // construct the root element and assign it to this.element
        this.element = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('div', 'row');
        // construct the toggler link
        var togglerLink = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('a', 'toggler-link');
        var togglerIcon = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'toggler');
        // if this is an object we need a wrapper span (toggler)
        if (this.isObject) {
            togglerLink.appendChild(togglerIcon);
        }
        // if this is child of a parent formatter we need to append the key
        if (this.hasKey) {
            togglerLink.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'key', this.key + ":"));
        }
        // Value for objects and arrays
        if (this.isObject) {
            // construct the value holder element
            var value = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'value');
            // we need a wrapper span for objects
            var objectWrapperSpan = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span');
            // get constructor name and append it to wrapper span
            var constructorName = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'constructor-name', this.constructorName);
            objectWrapperSpan.appendChild(constructorName);
            // if it's an array append the array specific elements like brackets and length
            if (this.isArray) {
                var arrayWrapperSpan = this.renderArray();
                objectWrapperSpan.appendChild(arrayWrapperSpan);
            }
            // append object wrapper span to toggler link
            value.appendChild(objectWrapperSpan);
            togglerLink.appendChild(value);
            // Primitive values
        }
        else {
            // make a value holder element
            var value = this.isUrl ? Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('a') : Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span');
            // add type and other type related CSS classes
            value.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])(this.type));
            if (this.isDate) {
                value.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('date'));
            }
            if (this.isUrl) {
                value.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('url'));
                value.setAttribute('href', this.json);
            }
            // Append value content to value element
            var valuePreview = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* getValuePreview */])(this.json, this.json);
            value.appendChild(document.createTextNode(valuePreview));
            // append the value element to toggler link
            togglerLink.appendChild(value);
        }
        // construct a children element
        var children = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('div', 'children');
        // set CSS classes for children
        if (this.isObject) {
            children.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('object'));
        }
        if (this.isArray) {
            children.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('array'));
        }
        if (this.isEmpty) {
            children.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('empty'));
        }
        // set CSS classes for root element
        if (this.config && this.config.theme) {
            this.element.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])(this.config.theme));
        }
        if (this.isOpen) {
            this.element.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
        }
        // append toggler and children elements to root element
        if (!skipRoot) {
            this.element.appendChild(togglerLink);
        }
        if (!this.skipChildren) {
            this.element.appendChild(children);
        }
        else {
            // remove togglerIcon
            togglerLink.removeChild(togglerIcon);
        }
        // if formatter is set to be open call appendChildren
        if (this.isObject && this.isOpen) {
            this.appendChildren();
        }
        // add event listener for toggling
        if (this.isObject) {
            togglerLink.addEventListener('click', this.toggleOpen.bind(this));
        }
        return this.element;
    };
    /**
     * Appends all the children to children element
     * Animated option is used when user triggers this via a click
    */
    JsonExplorer.prototype.appendChildren = function (animated) {
        var _this = this;
        if (animated === void 0) { animated = false; }
        var children = this.element.querySelector("div." + Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('children'));
        if (!children || this.isEmpty) {
            return;
        }
        if (animated) {
            var index_1 = 0;
            var addAChild_1 = function () {
                var key = _this.keys[index_1];
                var formatter = new JsonExplorer(_this.json[key], _this.open - 1, _this.config, key);
                children.appendChild(formatter.render());
                index_1 += 1;
                if (index_1 < _this.keys.length) {
                    if (index_1 > MAX_ANIMATED_TOGGLE_ITEMS) {
                        addAChild_1();
                    }
                    else {
                        requestAnimationFrame(addAChild_1);
                    }
                }
            };
            requestAnimationFrame(addAChild_1);
        }
        else {
            this.keys.forEach(function (key) {
                var formatter = new JsonExplorer(_this.json[key], _this.open - 1, _this.config, key);
                children.appendChild(formatter.render());
            });
        }
    };
    /**
     * Removes all the children from children element
     * Animated option is used when user triggers this via a click
    */
    JsonExplorer.prototype.removeChildren = function (animated) {
        if (animated === void 0) { animated = false; }
        var childrenElement = this.element.querySelector("div." + Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('children'));
        if (animated) {
            var childrenRemoved_1 = 0;
            var removeAChild_1 = function () {
                if (childrenElement && childrenElement.children.length) {
                    childrenElement.removeChild(childrenElement.children[0]);
                    childrenRemoved_1 += 1;
                    if (childrenRemoved_1 > MAX_ANIMATED_TOGGLE_ITEMS) {
                        removeAChild_1();
                    }
                    else {
                        requestAnimationFrame(removeAChild_1);
                    }
                }
            };
            requestAnimationFrame(removeAChild_1);
        }
        else {
            if (childrenElement) {
                childrenElement.innerHTML = '';
            }
        }
    };
    return JsonExplorer;
}());



/***/ }),
/* 276 */,
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinycolor2__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tinycolor2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColorPalette__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpectrumPicker__ = __webpack_require__(693);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DEFAULT_COLOR = '#000000';
var ColorPickerPopover = /** @class */ (function (_super) {
    __extends(ColorPickerPopover, _super);
    function ColorPickerPopover(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tab: 'palette',
            color: _this.props.color || DEFAULT_COLOR,
            colorString: _this.props.color || DEFAULT_COLOR
        };
        return _this;
    }
    ColorPickerPopover.prototype.setPickerNavElem = function (elem) {
        this.pickerNavElem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem);
    };
    ColorPickerPopover.prototype.setColor = function (color) {
        var newColor = __WEBPACK_IMPORTED_MODULE_2_tinycolor2___default()(color);
        if (newColor.isValid()) {
            this.setState({
                color: newColor.toString(),
                colorString: newColor.toString()
            });
            this.props.onColorSelect(color);
        }
    };
    ColorPickerPopover.prototype.sampleColorSelected = function (color) {
        this.setColor(color);
    };
    ColorPickerPopover.prototype.spectrumColorSelected = function (color) {
        var rgbColor = color.toRgbString();
        this.setColor(rgbColor);
    };
    ColorPickerPopover.prototype.onColorStringChange = function (e) {
        var colorString = e.target.value;
        this.setState({
            colorString: colorString
        });
        var newColor = __WEBPACK_IMPORTED_MODULE_2_tinycolor2___default()(colorString);
        if (newColor.isValid()) {
            // Update only color state
            var newColorString = newColor.toString();
            this.setState({
                color: newColorString,
            });
            this.props.onColorSelect(newColorString);
        }
    };
    ColorPickerPopover.prototype.onColorStringBlur = function (e) {
        var colorString = e.target.value;
        this.setColor(colorString);
    };
    ColorPickerPopover.prototype.componentDidMount = function () {
        var _this = this;
        this.pickerNavElem.find('li:first').addClass('active');
        this.pickerNavElem.on('show', function (e) {
            // use href attr (#name => name)
            var tab = e.target.hash.slice(1);
            _this.setState({
                tab: tab
            });
        });
    };
    ColorPickerPopover.prototype.render = function () {
        var paletteTab = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "palette" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ColorPalette__["a" /* GfColorPalette */], { color: this.state.color, onColorSelect: this.sampleColorSelected.bind(this) })));
        var spectrumTab = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "spectrum" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SpectrumPicker__["a" /* GfSpectrumPicker */], { color: this.state.color, onColorSelect: this.spectrumColorSelected.bind(this), options: {} })));
        var currentTab = this.state.tab === 'palette' ? paletteTab : spectrumTab;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-color-picker" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: "nav nav-tabs", id: "colorpickernav", ref: this.setPickerNavElem.bind(this) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "gf-tabs-item-colorpicker" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "#palette", "data-toggle": "tab" }, "Colors")),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "gf-tabs-item-colorpicker" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "#spectrum", "data-toggle": "tab" }, "Custom"))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-color-picker__body" }, currentTab),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { className: "gf-form-input gf-form-input--small", value: this.state.colorString, onChange: this.onColorStringChange.bind(this), onBlur: this.onColorStringBlur.bind(this) }))));
    };
    return ColorPickerPopover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Emitter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eventemitter3__);
///<reference path="../../headers/common.d.ts" />

var Emitter = /** @class */ (function () {
    function Emitter() {
        this.emitter = new __WEBPACK_IMPORTED_MODULE_0_eventemitter3___default.a();
    }
    Emitter.prototype.emit = function (name, data) {
        this.emitter.emit(name, data);
    };
    Emitter.prototype.on = function (name, handler, scope) {
        var _this = this;
        this.emitter.on(name, handler);
        if (scope) {
            var unbind = scope.$on('$destroy', function () {
                _this.emitter.off(name, handler);
                unbind();
            });
        }
    };
    Emitter.prototype.removeAllListeners = function (evt) {
        this.emitter.removeAllListeners(evt);
    };
    Emitter.prototype.off = function (name, handler) {
        this.emitter.off(name, handler);
    };
    return Emitter;
}());



/***/ }),
/* 279 */,
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContextSrv", function() { return ContextSrv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contextSrv", function() { return contextSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_store__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_core_store__);
///<reference path="../../headers/common.d.ts" />




var User = /** @class */ (function () {
    function User() {
        if (__WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.bootData.user) {
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend(this, __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.bootData.user);
        }
    }
    return User;
}());

var ContextSrv = /** @class */ (function () {
    function ContextSrv() {
        this.pinned = __WEBPACK_IMPORTED_MODULE_3_app_core_store___default.a.getBool('grafana.sidemenu.pinned', false);
        if (this.pinned) {
            this.sidemenu = true;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.buildInfo) {
            __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.buildInfo = {};
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.bootData) {
            __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.bootData = { user: {}, settings: {} };
        }
        this.version = __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.buildInfo.version;
        this.user = new User();
        this.isSignedIn = this.user.isSignedIn;
        this.isGrafanaAdmin = this.user.isGrafanaAdmin;
        this.isEditor = this.hasRole('Editor') || this.hasRole('Admin');
    }
    ContextSrv.prototype.hasRole = function (role) {
        return this.user.orgRole === role;
    };
    ContextSrv.prototype.setPinnedState = function (val) {
        this.pinned = val;
        __WEBPACK_IMPORTED_MODULE_3_app_core_store___default.a.set('grafana.sidemenu.pinned', val);
    };
    ContextSrv.prototype.isGrafanaVisible = function () {
        return !!(document.visibilityState === undefined || document.visibilityState === 'visible');
    };
    ContextSrv.prototype.toggleSideMenu = function () {
        this.sidemenu = !this.sidemenu;
        if (!this.sidemenu) {
            this.setPinnedState(false);
        }
    };
    return ContextSrv;
}());

var contextSrv = new ContextSrv();

__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["default"].factory('contextSrv', function () {
    return contextSrv;
});


/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_dash_class__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_dash_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__directives_dash_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_confirm_click__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_confirm_click___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__directives_confirm_click__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_dash_edit_link__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_dash_edit_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__directives_dash_edit_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_dropdown_typeahead__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_dropdown_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__directives_dropdown_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_metric_segment__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_metric_segment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__directives_metric_segment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_misc__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_misc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__directives_misc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_on_blur__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_on_blur___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__directives_ng_model_on_blur__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_tags__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__directives_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_value_select_dropdown__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_value_select_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__directives_value_select_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_rebuild_on_change__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_give_focus__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_diff_view__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__jquery_extended__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__jquery_extended___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__jquery_extended__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__partials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_jsontree_jsontree__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_code_editor_code_editor__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_outline__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__utils_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_colorpicker_ColorPicker__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_colorpicker_SeriesColorPicker__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_colorpicker_spectrum_picker__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_grafana_app__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_sidemenu_sidemenu__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_search_search__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_info_popover__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_navbar_navbar__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__directives_array_join__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__live_live_srv__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_emitter__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_layout_selector_layout_selector__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_switch__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_dashboard_selector__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_query_part_query_part_editor__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_form_dropdown_form_dropdown__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_core_controllers_all__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_core_controllers_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_app_core_controllers_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_core_services_all__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_core_services_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_app_core_services_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_app_core_routes_routes__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__filters_filters__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__app_events__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__utils_colors__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__utils_model_utils__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__services_context_srv__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__services_keybindingSrv__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_help_help__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_PasswordStrength__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_json_explorer_json_explorer__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__nav_model_srv__ = __webpack_require__(788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayJoin", function() { return __WEBPACK_IMPORTED_MODULE_25__directives_array_join__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "coreModule", function() { return __WEBPACK_IMPORTED_MODULE_37__core_module__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "grafanaAppDirective", function() { return __WEBPACK_IMPORTED_MODULE_20__components_grafana_app__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sideMenuDirective", function() { return __WEBPACK_IMPORTED_MODULE_21__components_sidemenu_sidemenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "navbarDirective", function() { return __WEBPACK_IMPORTED_MODULE_24__components_navbar_navbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchDirective", function() { return __WEBPACK_IMPORTED_MODULE_22__components_search_search__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "liveSrv", function() { return __WEBPACK_IMPORTED_MODULE_26__live_live_srv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "layoutSelector", function() { return __WEBPACK_IMPORTED_MODULE_28__components_layout_selector_layout_selector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "switchDirective", function() { return __WEBPACK_IMPORTED_MODULE_29__components_switch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "infoPopover", function() { return __WEBPACK_IMPORTED_MODULE_23__components_info_popover__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Emitter", function() { return __WEBPACK_IMPORTED_MODULE_27__utils_emitter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "appEvents", function() { return __WEBPACK_IMPORTED_MODULE_38__app_events__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "dashboardSelector", function() { return __WEBPACK_IMPORTED_MODULE_30__components_dashboard_selector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "queryPartEditorDirective", function() { return __WEBPACK_IMPORTED_MODULE_31__components_query_part_query_part_editor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_39__utils_colors__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formDropdownDirective", function() { return __WEBPACK_IMPORTED_MODULE_32__components_form_dropdown_form_dropdown__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "assignModelProperties", function() { return __WEBPACK_IMPORTED_MODULE_40__utils_model_utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contextSrv", function() { return __WEBPACK_IMPORTED_MODULE_41__services_context_srv__["contextSrv"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "KeybindingSrv", function() { return __WEBPACK_IMPORTED_MODULE_42__services_keybindingSrv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "helpModal", function() { return __WEBPACK_IMPORTED_MODULE_43__components_help_help__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "JsonExplorer", function() { return __WEBPACK_IMPORTED_MODULE_45__components_json_explorer_json_explorer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavModelSrv", function() { return __WEBPACK_IMPORTED_MODULE_46__nav_model_srv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PasswordStrength", function() { return __WEBPACK_IMPORTED_MODULE_44__components_PasswordStrength__["a"]; });


















































/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(77);
var toSubscriber_1 = __webpack_require__(704);
var observable_1 = __webpack_require__(298);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["isValid"] = isValid;
/* harmony export (immutable) */ __webpack_exports__["parseDateMath"] = parseDateMath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
///<reference path="../../headers/common.d.ts" />


var units = ['y', 'M', 'w', 'd', 'h', 'm', 's'];
function parse(text, roundUp, timezone) {
    if (!text) {
        return undefined;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(text)) {
        return text;
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isDate(text)) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(text);
    }
    var time;
    var mathString = '';
    var index;
    var parseString;
    if (text.substring(0, 3) === 'now') {
        if (timezone === 'utc') {
            time = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc();
        }
        else {
            time = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
        }
        mathString = text.substring('now'.length);
    }
    else {
        index = text.indexOf('||');
        if (index === -1) {
            parseString = text;
            mathString = ''; // nothing else
        }
        else {
            parseString = text.substring(0, index);
            mathString = text.substring(index + 2);
        }
        // We're going to just require ISO8601 timestamps, k?
        time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(parseString, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601);
    }
    if (!mathString.length) {
        return time;
    }
    return parseDateMath(mathString, time, roundUp);
}
function isValid(text) {
    var date = parse(text);
    if (!date) {
        return false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(date)) {
        return date.isValid();
    }
    return false;
}
function parseDateMath(mathString, time, roundUp) {
    var dateTime = time;
    var i = 0;
    var len = mathString.length;
    while (i < len) {
        var c = mathString.charAt(i++);
        var type;
        var num;
        var unit;
        if (c === '/') {
            type = 0;
        }
        else if (c === '+') {
            type = 1;
        }
        else if (c === '-') {
            type = 2;
        }
        else {
            return undefined;
        }
        if (isNaN(mathString.charAt(i))) {
            num = 1;
        }
        else if (mathString.length === 2) {
            num = mathString.charAt(i);
        }
        else {
            var numFrom = i;
            while (!isNaN(mathString.charAt(i))) {
                i++;
                if (i > 10) {
                    return undefined;
                }
            }
            num = parseInt(mathString.substring(numFrom, i), 10);
        }
        if (type === 0) {
            // rounding is only allowed on whole, single, units (eg M or 1M, not 0.5M or 2M)
            if (num !== 1) {
                return undefined;
            }
        }
        unit = mathString.charAt(i++);
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(units, unit)) {
            return undefined;
        }
        else {
            if (type === 0) {
                if (roundUp) {
                    dateTime.endOf(unit);
                }
                else {
                    dateTime.startOf(unit);
                }
            }
            else if (type === 1) {
                dateTime.add(num, unit);
            }
            else if (type === 2) {
                dateTime.subtract(num, unit);
            }
        }
    }
    return dateTime;
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(280);
var Subscription_1 = __webpack_require__(296);
var Observer_1 = __webpack_require__(282);
var rxSubscriber_1 = __webpack_require__(114);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getRelativeTimesList"] = getRelativeTimesList;
/* harmony export (immutable) */ __webpack_exports__["describeTextRange"] = describeTextRange;
/* harmony export (immutable) */ __webpack_exports__["describeTimeRange"] = describeTimeRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datemath__ = __webpack_require__(292);
///<reference path="../../headers/common.d.ts" />



var spans = {
    's': { display: 'second' },
    'm': { display: 'minute' },
    'h': { display: 'hour' },
    'd': { display: 'day' },
    'w': { display: 'week' },
    'M': { display: 'month' },
    'y': { display: 'year' },
};
var rangeOptions = [
    { from: 'now/d', to: 'now/d', display: 'Today', section: 2 },
    { from: 'now/d', to: 'now', display: 'Today so far', section: 2 },
    { from: 'now/w', to: 'now/w', display: 'This week', section: 2 },
    { from: 'now/w', to: 'now', display: 'This week so far', section: 2 },
    { from: 'now/M', to: 'now/M', display: 'This month', section: 2 },
    { from: 'now/M', to: 'now', display: 'This month so far', section: 2 },
    { from: 'now/y', to: 'now/y', display: 'This year', section: 2 },
    { from: 'now/y', to: 'now', display: 'This year so far', section: 2 },
    { from: 'now-1d/d', to: 'now-1d/d', display: 'Yesterday', section: 1 },
    { from: 'now-2d/d', to: 'now-2d/d', display: 'Day before yesterday', section: 1 },
    { from: 'now-7d/d', to: 'now-7d/d', display: 'This day last week', section: 1 },
    { from: 'now-1w/w', to: 'now-1w/w', display: 'Previous week', section: 1 },
    { from: 'now-1M/M', to: 'now-1M/M', display: 'Previous month', section: 1 },
    { from: 'now-1y/y', to: 'now-1y/y', display: 'Previous year', section: 1 },
    { from: 'now-5m', to: 'now', display: 'Last 5 minutes', section: 3 },
    { from: 'now-15m', to: 'now', display: 'Last 15 minutes', section: 3 },
    { from: 'now-30m', to: 'now', display: 'Last 30 minutes', section: 3 },
    { from: 'now-1h', to: 'now', display: 'Last 1 hour', section: 3 },
    { from: 'now-3h', to: 'now', display: 'Last 3 hours', section: 3 },
    { from: 'now-6h', to: 'now', display: 'Last 6 hours', section: 3 },
    { from: 'now-12h', to: 'now', display: 'Last 12 hours', section: 3 },
    { from: 'now-24h', to: 'now', display: 'Last 24 hours', section: 3 },
    { from: 'now-2d', to: 'now', display: 'Last 2 days', section: 0 },
    { from: 'now-7d', to: 'now', display: 'Last 7 days', section: 0 },
    { from: 'now-30d', to: 'now', display: 'Last 30 days', section: 0 },
    { from: 'now-90d', to: 'now', display: 'Last 90 days', section: 0 },
    { from: 'now-6M', to: 'now', display: 'Last 6 months', section: 0 },
    { from: 'now-1y', to: 'now', display: 'Last 1 year', section: 0 },
    { from: 'now-2y', to: 'now', display: 'Last 2 years', section: 0 },
    { from: 'now-5y', to: 'now', display: 'Last 5 years', section: 0 },
];
var absoluteFormat = 'MMM D, YYYY HH:mm:ss';
var rangeIndex = {};
__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(rangeOptions, function (frame) {
    rangeIndex[frame.from + ' to ' + frame.to] = frame;
});
function getRelativeTimesList(timepickerSettings, currentDisplay) {
    var groups = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(rangeOptions, function (option) {
        option.active = option.display === currentDisplay;
        return option.section;
    });
    // _.each(timepickerSettings.time_options, (duration: string) => {
    //   let info = describeTextRange(duration);
    //   if (info.section) {
    //     groups[info.section].push(info);
    //   }
    // });
    return groups;
}
function formatDate(date) {
    return date.format(absoluteFormat);
}
// handles expressions like
// 5m
// 5m to now/d
// now/d to now
// now/d
// if no to <expr> then to now is assumed
function describeTextRange(expr) {
    var isLast = (expr.indexOf('+') !== 0);
    if (expr.indexOf('now') === -1) {
        expr = (isLast ? 'now-' : 'now') + expr;
    }
    var opt = rangeIndex[expr + ' to now'];
    if (opt) {
        return opt;
    }
    if (isLast) {
        opt = { from: expr, to: 'now' };
    }
    else {
        opt = { from: 'now', to: expr };
    }
    var parts = /^now([-+])(\d+)(\w)/.exec(expr);
    if (parts) {
        var unit = parts[3];
        var amount = parseInt(parts[2]);
        var span = spans[unit];
        if (span) {
            opt.display = isLast ? 'Last ' : 'Next ';
            opt.display += amount + ' ' + span.display;
            opt.section = span.section;
            if (amount > 1) {
                opt.display += 's';
            }
        }
    }
    else {
        opt.display = opt.from + ' to ' + opt.to;
        opt.invalid = true;
    }
    return opt;
}
function describeTimeRange(range) {
    var option = rangeIndex[range.from.toString() + ' to ' + range.to.toString()];
    if (option) {
        return option.display;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.from) && __WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.to)) {
        return formatDate(range.from) + ' to ' + formatDate(range.to);
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.from)) {
        var toMoment = __WEBPACK_IMPORTED_MODULE_2__datemath__["parse"](range.to, true);
        return formatDate(range.from) + ' to ' + toMoment.fromNow();
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.to)) {
        var from = __WEBPACK_IMPORTED_MODULE_2__datemath__["parse"](range.from, false);
        return from.fromNow() + ' to ' + formatDate(range.to);
    }
    if (range.to.toString() === 'now') {
        var res = describeTextRange(range.from);
        return res.display;
    }
    return range.from.toString() + ' to ' + range.to.toString();
}


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(297);
var isObject_1 = __webpack_require__(300);
var isFunction_1 = __webpack_require__(280);
var tryCatch_1 = __webpack_require__(705);
var errorObject_1 = __webpack_require__(281);
var UnsubscriptionError_1 = __webpack_require__(706);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(77);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Profiler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profiler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


var Profiler = /** @class */ (function () {
    function Profiler() {
    }
    Profiler.prototype.init = function (config, $rootScope) {
        var _this = this;
        this.enabled = config.buildInfo.env === 'development';
        this.timings = {};
        this.timings.appStart = { loadStart: new Date().getTime() };
        this.$rootScope = $rootScope;
        if (!this.enabled) {
            return;
        }
        $rootScope.$watch(function () {
            _this.digestCounter++;
            return false;
        }, function () { });
        $rootScope.onAppEvent('refresh', this.refresh.bind(this), $rootScope);
        $rootScope.onAppEvent('dashboard-fetch-end', this.dashboardFetched.bind(this), $rootScope);
        $rootScope.onAppEvent('dashboard-initialized', this.dashboardInitialized.bind(this), $rootScope);
        $rootScope.onAppEvent('panel-initialized', this.panelInitialized.bind(this), $rootScope);
    };
    Profiler.prototype.refresh = function () {
        var _this = this;
        this.timings.query = 0;
        this.timings.render = 0;
        setTimeout(function () {
            console.log('panel count: ' + _this.panelsInitCount);
            console.log('total query: ' + _this.timings.query);
            console.log('total render: ' + _this.timings.render);
            console.log('avg render: ' + _this.timings.render / _this.panelsInitCount);
        }, 5000);
    };
    Profiler.prototype.dashboardFetched = function () {
        this.timings.dashboardLoadStart = new Date().getTime();
        this.panelsInitCount = 0;
        this.digestCounter = 0;
        this.panelsInitCount = 0;
        this.panelsRendered = 0;
        this.timings.query = 0;
        this.timings.render = 0;
    };
    Profiler.prototype.dashboardInitialized = function () {
        var _this = this;
        setTimeout(function () {
            console.log("Dashboard::Performance Total Digests: " + _this.digestCounter);
            console.log("Dashboard::Performance Total Watchers: " + _this.getTotalWatcherCount());
            console.log("Dashboard::Performance Total ScopeCount: " + _this.scopeCount);
            var timeTaken = _this.timings.lastPanelInitializedAt - _this.timings.dashboardLoadStart;
            console.log("Dashboard::Performance All panels initialized in " + timeTaken + " ms");
            // measure digest performance
            var rootDigestStart = window.performance.now();
            for (var i = 0; i < 30; i++) {
                _this.$rootScope.$apply();
            }
            console.log("Dashboard::Performance Root Digest " + ((window.performance.now() - rootDigestStart) / 30));
        }, 3000);
    };
    Profiler.prototype.getTotalWatcherCount = function () {
        var count = 0;
        var scopes = 0;
        var root = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByTagName('body'));
        var f = function (element) {
            if (element.data().hasOwnProperty('$scope')) {
                scopes++;
                __WEBPACK_IMPORTED_MODULE_1_angular___default.a.forEach(element.data().$scope.$$watchers, function () {
                    count++;
                });
            }
            __WEBPACK_IMPORTED_MODULE_1_angular___default.a.forEach(element.children(), function (childElement) {
                f(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(childElement));
            });
        };
        f(root);
        this.scopeCount = scopes;
        return count;
    };
    Profiler.prototype.renderingCompleted = function (panelId, panelTimings) {
        // add render counter to root scope
        // used by phantomjs render.js to know when panel has rendered
        this.panelsRendered = (this.panelsRendered || 0) + 1;
        this.$rootScope.panelsRendered = this.panelsRendered;
        if (this.enabled) {
            panelTimings.renderEnd = new Date().getTime();
            this.timings.query += panelTimings.queryEnd - panelTimings.queryStart;
            this.timings.render += panelTimings.renderEnd - panelTimings.renderStart;
        }
    };
    Profiler.prototype.panelInitialized = function () {
        if (!this.enabled) {
            return;
        }
        this.panelsInitCount++;
        this.timings.lastPanelInitializedAt = new Date().getTime();
    };
    return Profiler;
}());

var profiler = new Profiler();



/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(302);

__WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */].init();


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GrafanaApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular_route__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular_route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angular_route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_sanitize__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angular_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_native_dragdrop__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_native_dragdrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular_native_dragdrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_bindonce__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_bindonce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angular_bindonce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ngreact__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ngreact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_ngreact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vendor_bootstrap_bootstrap__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vendor_bootstrap_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vendor_bootstrap_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vendor_angular_ui_ui_bootstrap_tpls__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vendor_angular_ui_ui_bootstrap_tpls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vendor_angular_ui_ui_bootstrap_tpls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vendor_angular_other_angular_strap__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vendor_angular_other_angular_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vendor_angular_other_angular_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__core_core__ = __webpack_require__(290);




















// add move to lodash for backward compatabiltiy
__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.move = function (array, fromIndex, toIndex) {
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
    return array;
};

var GrafanaApp = /** @class */ (function () {
    function GrafanaApp() {
        this.preBootModules = [];
        this.registerFunctions = {};
        this.ngModuleDependencies = [];
    }
    GrafanaApp.prototype.useModule = function (module) {
        if (this.preBootModules) {
            this.preBootModules.push(module);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(module, this.registerFunctions);
        }
        this.ngModuleDependencies.push(module.name);
        return module;
    };
    GrafanaApp.prototype.init = function () {
        var _this = this;
        var app = __WEBPACK_IMPORTED_MODULE_4_angular___default.a.module('grafana', []);
        __WEBPACK_IMPORTED_MODULE_16_moment___default.a.locale(__WEBPACK_IMPORTED_MODULE_15_app_core_config___default.a.bootData.user.locale);
        app.config(["$locationProvider", "$controllerProvider", "$compileProvider", "$filterProvider", "$httpProvider", "$provide", function ($locationProvider, $controllerProvider, $compileProvider, $filterProvider, $httpProvider, $provide) {
            // pre assing bindings before constructor calls
            $compileProvider.preAssignBindingsEnabled(true);
            if (__WEBPACK_IMPORTED_MODULE_15_app_core_config___default.a.buildInfo.env !== 'development') {
                $compileProvider.debugInfoEnabled(false);
            }
            $httpProvider.useApplyAsync(true);
            _this.registerFunctions.controller = $controllerProvider.register;
            _this.registerFunctions.directive = $compileProvider.directive;
            _this.registerFunctions.factory = $provide.factory;
            _this.registerFunctions.service = $provide.service;
            _this.registerFunctions.filter = $filterProvider.register;
            $provide.decorator("$http", ["$delegate", "$templateCache", function ($delegate, $templateCache) {
                    var get = $delegate.get;
                    $delegate.get = function (url, config) {
                        if (url.match(/\.html$/)) {
                            // some template's already exist in the cache
                            if (!$templateCache.get(url)) {
                                url += "?v=" + new Date().getTime();
                            }
                        }
                        return get(url, config);
                    };
                    return $delegate;
                }]);
        }]);
        this.ngModuleDependencies = [
            'grafana.core',
            'ngRoute',
            'ngSanitize',
            '$strap.directives',
            'ang-drag-drop',
            'grafana',
            'pasvaz.bindonce',
            'ui.bootstrap',
            'ui.bootstrap.tpls',
            'react'
        ];
        var module_types = ['controllers', 'directives', 'factories', 'services', 'filters', 'routes'];
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(module_types, function (type) {
            var moduleName = 'grafana.' + type;
            _this.useModule(__WEBPACK_IMPORTED_MODULE_4_angular___default.a.module(moduleName, []));
        });
        // makes it possible to add dynamic stuff
        this.useModule(__WEBPACK_IMPORTED_MODULE_17__core_core__["coreModule"]);
        var preBootRequires = [__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 796))];
        Promise.all(preBootRequires).then(function () {
            // disable tool tip animation
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.fn.tooltip.defaults.animation = false;
            // bootstrap the app
            __WEBPACK_IMPORTED_MODULE_4_angular___default.a.bootstrap(document, _this.ngModuleDependencies).invoke(function () {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this.preBootModules, function (module) {
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(module, _this.registerFunctions);
                });
                _this.preBootModules = null;
            });
        }).catch(function (err) {
            console.log('Application boot failed:', err);
        });
    };
    return GrafanaApp;
}());

/* harmony default export */ __webpack_exports__["a"] = (new GrafanaApp());


/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */
/***/ (function(module, exports) {

/* ===================================================
 * bootstrap-transition.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#transitions
 * ===================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


  /* CSS TRANSITION SUPPORT (http://www.modernizr.com/)
   * ======================================================= */

  $(function () {

    $.support.transition = (function () {

      var transitionEnd = (function () {

        var el = document.createElement('bootstrap')
          , transEndEventNames = {
               'WebkitTransition' : 'webkitTransitionEnd'
            ,  'MozTransition'    : 'transitionend'
            ,  'OTransition'      : 'oTransitionEnd otransitionend'
            ,  'transition'       : 'transitionend'
            }
          , name

        for (name in transEndEventNames){
          if (el.style[name] !== undefined) {
            return transEndEventNames[name]
          }
        }

      }())

      return transitionEnd && {
        end: transitionEnd
      }

    })()

  })

}(window.jQuery);/* ==========================================================
 * bootstrap-alert.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#alerts
 * ==========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;

/* ============================================================
 * bootstrap-dropdown.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#dropdowns
 * ============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


 /* DROPDOWN CLASS DEFINITION
  * ========================= */

  var toggle = '[data-toggle=dropdown]'
    , Dropdown = function (element) {
        var $el = $(element).on('click.dropdown.data-api', this.toggle)
        $('html').on('click.dropdown.data-api', function () {
          $el.parent().removeClass('open')
        })
      }

  Dropdown.prototype = {

    constructor: Dropdown

  , toggle: function (e) {
      var $this = $(this)
        , $parent
        , isActive

      if ($this.is('.disabled, :disabled')) return

      $parent = getParent($this)

      isActive = $parent.hasClass('open')

      clearMenus()

      if (!isActive) {
        if ('ontouchstart' in document.documentElement) {
          // if mobile we we use a backdrop because click events don't delegate
          $('<div class="dropdown-backdrop"/>').insertBefore($(this)).on('click', clearMenus)
        }
        $parent.toggleClass('open')
      }

      $this.focus()

      return false
    }

  , keydown: function (e) {
      var $this
        , $items
        , $active
        , $parent
        , isActive
        , index

      if (!/(38|40|27)/.test(e.keyCode)) return

      $this = $(this)

      e.preventDefault()
      e.stopPropagation()

      if ($this.is('.disabled, :disabled')) return

      $parent = getParent($this)

      isActive = $parent.hasClass('open')

      if (!isActive || (isActive && e.keyCode == 27)) {
        if (e.which == 27) $parent.find(toggle).focus()
        return $this.click()
      }

      $items = $('[role=menu] li:not(.divider):visible a', $parent)

      if (!$items.length) return

      index = $items.index($items.filter(':focus'))

      if (e.keyCode == 38 && index > 0) index--                                        // up
      if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
      if (!~index) index = 0

      $items
        .eq(index)
        .focus()
    }

  }

  function clearMenus() {
    $('.dropdown-backdrop').remove()
    $(toggle).each(function () {
      getParent($(this)).removeClass('open')
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')
      , $parent

    if (!selector) {
      selector = $this.attr('href')
      // grafana backport fix from bootstrap 3
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
    }

    $parent = selector && $(selector)

    if (!$parent || !$parent.length) $parent = $this.parent()

    return $parent
  }


  /* DROPDOWN PLUGIN DEFINITION
   * ========================== */

  var old = $.fn.dropdown

  $.fn.dropdown = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('dropdown')
      if (!data) $this.data('dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.dropdown.Constructor = Dropdown


 /* DROPDOWN NO CONFLICT
  * ==================== */

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  /* APPLY TO STANDARD DROPDOWN ELEMENTS
   * =================================== */

  $(document)
    .on('click.dropdown.data-api', clearMenus)
    .on('click.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.dropdown.data-api'  , toggle, Dropdown.prototype.toggle)
    .on('keydown.dropdown.data-api', toggle + ', [role=menu]' , Dropdown.prototype.keydown)

}(window.jQuery);
/* =========================================================
 * bootstrap-modal.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#modals
 * =========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */


!function ($) {

  "use strict"; // jshint ;_;


 /* MODAL CLASS DEFINITION
  * ====================== */

  var Modal = function (element, options) {
    this.options = options
    this.$element = $(element)
      .delegate('[data-dismiss="modal"]', 'click.dismiss.modal', $.proxy(this.hide, this))
    this.options.remote && this.$element.find('.modal-body').load(this.options.remote)
  }

  Modal.prototype = {

      constructor: Modal

    , toggle: function () {
        return this[!this.isShown ? 'show' : 'hide']()
      }

    , show: function () {
        var that = this
          , e = $.Event('show')

        this.$element.trigger(e)

        if (this.isShown || e.isDefaultPrevented()) return

        this.isShown = true

        this.escape()

        this.backdrop(function () {
          var transition = $.support.transition && that.$element.hasClass('fade')

          if (!that.$element.parent().length) {
            that.$element.appendTo(document.body) //don't move modals dom position
          }

          that.$element.show()

          if (transition) {
            that.$element[0].offsetWidth // force reflow
          }

          that.$element
            .addClass('in')
            .attr('aria-hidden', false)

          that.enforceFocus()

          transition ?
            that.$element.one($.support.transition.end, function () { that.$element.focus().trigger('shown') }) :
            that.$element.focus().trigger('shown')

        })
      }

    , hide: function (e) {
        e && e.preventDefault()

        var that = this

        e = $.Event('hide')

        this.$element.trigger(e)

        if (!this.isShown || e.isDefaultPrevented()) return

        this.isShown = false

        this.escape()

        $(document).off('focusin.modal')

        this.$element
          .removeClass('in')
          .attr('aria-hidden', true)

        $.support.transition && this.$element.hasClass('fade') ?
          this.hideWithTransition() :
          this.hideModal()
      }

    , enforceFocus: function () {
        var that = this
        $(document).on('focusin.modal', function (e) {
          if (that.$element[0] !== e.target && !that.$element.has(e.target).length) {
            that.$element.focus()
          }
        })
      }

    , escape: function () {
        var that = this
        if (this.isShown && this.options.keyboard) {
          this.$element.on('keyup.dismiss.modal', function ( e ) {
            e.which == 27 && that.hide()
          })
        } else if (!this.isShown) {
          this.$element.off('keyup.dismiss.modal')
        }
      }

    , hideWithTransition: function () {
        var that = this
          , timeout = setTimeout(function () {
              that.$element.off($.support.transition.end)
              that.hideModal()
            }, 500)

        this.$element.one($.support.transition.end, function () {
          clearTimeout(timeout)
          that.hideModal()
        })
      }

    , hideModal: function () {
        var that = this
        this.$element.hide()
        this.backdrop(function () {
          that.removeBackdrop()
          that.$element.trigger('hidden')
        })
      }

    , removeBackdrop: function () {
        this.$backdrop && this.$backdrop.remove()
        this.$backdrop = null
      }

    , backdrop: function (callback) {
        var that = this
          , animate = this.$element.hasClass('fade') ? 'fade' : ''

        if (this.isShown && this.options.backdrop) {
          var doAnimate = $.support.transition && animate

          this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
            .appendTo(document.body)

          this.$backdrop.click(
            this.options.backdrop == 'static' ?
              $.proxy(this.$element[0].focus, this.$element[0])
            : $.proxy(this.hide, this)
          )

          if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

          this.$backdrop.addClass('in')

          if (!callback) return

          doAnimate ?
            this.$backdrop.one($.support.transition.end, callback) :
            callback()

        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass('in')

          $.support.transition && this.$element.hasClass('fade')?
            this.$backdrop.one($.support.transition.end, callback) :
            callback()

        } else if (callback) {
          callback()
        }
      }
  }


 /* MODAL PLUGIN DEFINITION
  * ======================= */

  var old = $.fn.modal

  $.fn.modal = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('modal')
        , options = $.extend({}, $.fn.modal.defaults, $this.data(), typeof option == 'object' && option)
      if (!data) $this.data('modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option]()
      else if (options.show) data.show()
    })
  }

  $.fn.modal.defaults = {
      backdrop: true
    , keyboard: true
    , show: true
  }

  $.fn.modal.Constructor = Modal


 /* MODAL NO CONFLICT
  * ================= */

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


 /* MODAL DATA-API
  * ============== */

  $(document).on('click.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
      , href = $this.attr('href')
      , $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
      , option = $target.data('modal') ? 'toggle' : $.extend({ remote:!/#/.test(href) && href }, $target.data(), $this.data())

    e.preventDefault()

    $target
      .modal(option)
      .one('hide', function () {
        $this.focus()
      })
  })

}(window.jQuery);
/* ===========================================================
 * bootstrap-tooltip.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#tooltips
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ===========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TOOLTIP PUBLIC CLASS DEFINITION
  * =============================== */

  var Tooltip = function (element, options) {
    this.init('tooltip', element, options)
  }

  Tooltip.prototype = {

    constructor: Tooltip

  , init: function (type, element, options) {
      var eventIn
        , eventOut
        , triggers
        , trigger
        , i

      this.type = type
      this.$element = $(element)
      this.options = this.getOptions(options)
      this.enabled = true

      triggers = this.options.trigger.split(' ')

      for (i = triggers.length; i--;) {
        trigger = triggers[i]
        if (trigger == 'click') {
          this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
        } else if (trigger != 'manual') {
          eventIn = trigger == 'hover' ? 'mouseenter' : 'focus'
          eventOut = trigger == 'hover' ? 'mouseleave' : 'blur'
          this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
          this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
        }
      }

      this.options.selector ?
        (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
        this.fixTitle()
    }

  , getOptions: function (options) {
      options = $.extend({}, $.fn[this.type].defaults, this.$element.data(), options)

      if (options.delay && typeof options.delay == 'number') {
        options.delay = {
          show: options.delay
        , hide: options.delay
        }
      }

      return options
    }

  , enter: function (e) {
      var defaults = $.fn[this.type].defaults
        , options = {}
        , self

      this._options && $.each(this._options, function (key, value) {
        if (defaults[key] != value) options[key] = value
      }, this)

      self = $(e.currentTarget)[this.type](options).data(this.type)

      if (!self.options.delay || !self.options.delay.show) return self.show()

      clearTimeout(this.timeout)
      self.hoverState = 'in'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'in') self.show()
      }, self.options.delay.show)
    }

  , leave: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type)

      if (this.timeout) clearTimeout(this.timeout)
      if (!self.options.delay || !self.options.delay.hide) return self.hide()

      self.hoverState = 'out'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'out') self.hide()
      }, self.options.delay.hide)
    }

  , show: function () {
      var $tip
        , pos
        , actualWidth
        , actualHeight
        , placement
        , tp
        , e = $.Event('show')

      if (this.hasContent() && this.enabled) {
        this.$element.trigger(e)
        if (e.isDefaultPrevented()) return
        $tip = this.tip()
        this.setContent()

        if (this.options.animation) {
          $tip.addClass('fade')
        }

        placement = typeof this.options.placement == 'function' ?
          this.options.placement.call(this, $tip[0], this.$element[0]) :
          this.options.placement

        $tip
          .detach()
          .css({ top: 0, left: 0, display: 'block' })

        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

        pos = this.getPosition()

        actualWidth = $tip[0].offsetWidth
        actualHeight = $tip[0].offsetHeight

        switch (placement) {
          case 'bottom':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'top':
            tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'left':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth}
            break
          case 'right':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}
            break

          // extend placements (top)
          case 'topLeft':
            tp = {top: pos.top - actualHeight,  left: pos.left + pos.width / 2 - (actualWidth * .10)};
            break;
          case 'topRight':
            tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - (actualWidth * .90)};
            break;

          // extend placements (right)
          case 'rightTop':
            tp = {top: pos.top + pos.height / 2 - (actualHeight *.10), left: pos.left + pos.width};
            break;
          case 'rightBottom':
            tp = {top: pos.top + pos.height / 2 - (actualHeight * .90), left: pos.left + pos.width};
            break;

          // extend placements (bottom)
          case 'bottomLeft':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - (actualWidth * .10)};
            break;
          case 'bottomRight':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - (actualWidth * .90)};
            break;

          // extend placements (left)
          case 'leftTop':
            tp = {top: pos.top + pos.height / 2 - (actualHeight *.10), left: pos.left - actualWidth};
            break;
          case 'leftBottom':
            tp = {top: pos.top + pos.height / 2 - (actualHeight * .90), left: pos.left - actualWidth};
            break;


        }

        this.applyPlacement(tp, placement)
        this.$element.trigger('shown')
      }
    }

  , applyPlacement: function(offset, placement){
      var $tip = this.tip()
        , width = $tip[0].offsetWidth
        , height = $tip[0].offsetHeight
        , actualWidth
        , actualHeight
        , delta
        , replace

      $tip
        .offset(offset)
        .addClass(placement)
        .addClass('in')

      actualWidth = $tip[0].offsetWidth
      actualHeight = $tip[0].offsetHeight

      if (placement == 'top' && actualHeight != height) {
        offset.top = offset.top + height - actualHeight
        replace = true
      }

      if (placement == 'bottom' || placement == 'top') {
        delta = 0

        if (offset.left < 0){
          delta = offset.left * -2
          offset.left = 0
          $tip.offset(offset)
          actualWidth = $tip[0].offsetWidth
          actualHeight = $tip[0].offsetHeight
        }

        this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
      } else {
        this.replaceArrow(actualHeight - height, actualHeight, 'top')
      }

      if (replace) $tip.offset(offset)
    }

  , replaceArrow: function(delta, dimension, position){
      this
        .arrow()
        .css(position, delta ? (50 * (1 - delta / dimension) + "%") : '')
    }

  , setContent: function () {
      var $tip = this.tip()
        , title = this.getTitle()

      $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
      $tip.removeClass('fade in top bottom left right')
    }

  , hide: function () {
      var that = this
        , $tip = this.tip()
        , e = $.Event('hide')

      this.$element.trigger(e)
      if (e.isDefaultPrevented()) return

      $tip.removeClass('in')

      function removeWithAnimation() {
        var timeout = setTimeout(function () {
          $tip.off($.support.transition.end).detach()
        }, 500)

        $tip.one($.support.transition.end, function () {
          clearTimeout(timeout)
          $tip.detach()
        })
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        removeWithAnimation() :
        $tip.detach()

      this.$element.trigger('hidden')

      return this
    }

  , fixTitle: function () {
      var $e = this.$element
      if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
      }
    }

  , hasContent: function () {
      return this.getTitle()
    }

  , getPosition: function () {
      var el = this.$element[0]
      return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
        width: el.offsetWidth
      , height: el.offsetHeight
      }, this.$element.offset())
    }

  , getTitle: function () {
      var title
        , $e = this.$element
        , o = this.options

      title = $e.attr('data-original-title')
        || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

      return title
    }

  , tip: function () {
      return this.$tip = this.$tip || $(this.options.template)
    }

  , arrow: function(){
      return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }

  , validate: function () {
      if (!this.$element[0].parentNode) {
        this.hide()
        this.$element = null
        this.options = null
      }
    }

  , enable: function () {
      this.enabled = true
    }

  , disable: function () {
      this.enabled = false
    }

  , toggleEnabled: function () {
      this.enabled = !this.enabled
    }

  , toggle: function (e) {
      var self = e ? $(e.currentTarget)[this.type](this._options).data(this.type) : this
      self.tip().hasClass('in') ? self.hide() : self.show()
    }

  , destroy: function () {
      this.hide().$element.off('.' + this.type).removeData(this.type)
    }

  }


 /* TOOLTIP PLUGIN DEFINITION
  * ========================= */

  var old = $.fn.tooltip

  $.fn.tooltip = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tooltip')
        , options = typeof option == 'object' && option
      if (!data) $this.data('tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tooltip.Constructor = Tooltip

  $.fn.tooltip.defaults = {
    animation: true
  , placement: 'top'
  , selector: false
  , template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
  , trigger: 'hover focus'
  , title: ''
  , delay: 0
  , html: false
  , container: false
  }


 /* TOOLTIP NO CONFLICT
  * =================== */

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(window.jQuery);

/* ========================================================
 * bootstrap-tab.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#tabs
 * ========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TAB CLASS DEFINITION
  * ==================== */

  var Tab = function (element) {
    this.element = $(element)
  }

  Tab.prototype = {

    constructor: Tab

  , show: function () {
      var $this = this.element
        , $ul = $this.closest('ul:not(.dropdown-menu)')
        , selector = $this.attr('data-target')
        , previous
        , $target
        , e

      if (!selector) {
        selector = $this.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
      }

      if ( $this.parent('li').hasClass('active') ) return

      previous = $ul.find('.active:last a')[0]

      e = $.Event('show', {
        relatedTarget: previous
      })

      $this.trigger(e)

      if (e.isDefaultPrevented()) return

      $target = $(selector)

      this.activate($this.parent('li'), $ul)
      this.activate($target, $target.parent(), function () {
        $this.trigger({
          type: 'shown'
        , relatedTarget: previous
        })
      })
    }

  , activate: function ( element, container, callback) {
      var $active = container.find('> .active')
        , transition = callback
            && $.support.transition
            && $active.hasClass('fade')

      function next() {
        $active
          .removeClass('active')
          .find('> .dropdown-menu > .active')
          .removeClass('active')

        element.addClass('active')

        if (transition) {
          element[0].offsetWidth // reflow for transition
          element.addClass('in')
        } else {
          element.removeClass('fade')
        }

        if ( element.parent('.dropdown-menu') ) {
          element.closest('li.dropdown').addClass('active')
        }

        callback && callback()
      }

      transition ?
        $active.one($.support.transition.end, next) :
        next()

      $active.removeClass('in')
    }
  }


 /* TAB PLUGIN DEFINITION
  * ===================== */

  var old = $.fn.tab

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tab')
      if (!data) $this.data('tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tab.Constructor = Tab


 /* TAB NO CONFLICT
  * =============== */

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


 /* TAB DATA-API
  * ============ */

  $(document).on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
    e.preventDefault()
    $(this).tab('show')
  })

}(window.jQuery);/* =============================================================
 * bootstrap-typeahead.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#typeahead
 * =============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function($){

  "use strict"; // jshint ;_;


 /* TYPEAHEAD PUBLIC CLASS DEFINITION
  * ================================= */

  var Typeahead = function (element, options) {
    this.$element = $(element)
    this.options = $.extend({}, $.fn.typeahead.defaults, options)
    this.matcher = this.options.matcher || this.matcher
    this.sorter = this.options.sorter || this.sorter
    this.highlighter = this.options.highlighter || this.highlighter
    this.updater = this.options.updater || this.updater
    this.source = this.options.source
    this.$menu = $(this.options.menu)
    this.shown = false
    this.listen()
  }

  Typeahead.prototype = {

    constructor: Typeahead

  , select: function () {
    // CHANGE (rashidkpc) If nothing is selected, use existing value
      var val = this.$menu.find('.active').attr('data-value') || this.$element.val();
      this.$element
        .val(this.updater(val))
        .change()
      return this.hide()
    }

  , updater: function (item) {
      return item
    }

  , show: function () {
      var pos = $.extend({}, this.$element.position(), {
        height: this.$element[0].offsetHeight
      })

      this.$menu
        .insertAfter(this.$element)
        .css({
          top: pos.top + pos.height
        , left: pos.left
        })
        .show()

      this.shown = true
      return this
    }

  , hide: function () {
      this.$menu.hide()
      this.shown = false
      return this
    }

  , lookup: function (event) {
      var items

      this.query = this.$element.val()

      if (!this.query || this.query.length < this.options.minLength) {
        return this.shown ? this.hide() : this
      }

      items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source

      return items ? this.process(items) : this
    }

    , process: function (items) {
      var that = this

      items = $.grep(items, function (item) {
        return that.matcher(item)
      })

      items = this.sorter(items)

      if (!items.length) {
        return this.shown ? this.hide() : this
      }

      return this.render(items.slice(0, this.options.items)).show()
    }

  , matcher: function (item) {
      return ~item.toLowerCase().indexOf(this.query.toLowerCase())
    }

  , sorter: function (items) {
      var beginswith = []
        , caseSensitive = []
        , caseInsensitive = []
        , item

      while (item = items.shift()) {
        if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item)
        else if (~item.indexOf(this.query)) caseSensitive.push(item)
        else caseInsensitive.push(item)
      }

      return beginswith.concat(caseSensitive, caseInsensitive)
    }

  , highlighter: function (item) {
      var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
      if (!query) {
        return item;
      }
      return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
        return '<strong>' + match + '</strong>'
      });
    }

  , render: function (items) {
      var that = this

      items = $(items).map(function (i, item) {
        i = $(that.options.item).attr('data-value', item)
        i.find('a').html(that.highlighter(item))
        return i[0]
      })

      // CHANGE (rashidpc) Do not select first element by default
      // items.first().addClass('active')
      this.$menu.html(items)
      return this
    }

  , next: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , next = active.next()

      if (!next.length) {
        next = $(this.$menu.find('li')[0])
      }

      next.addClass('active')
    }

  , prev: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , prev = active.prev()

      if (!prev.length) {
        prev = this.$menu.find('li').last()
      }

      prev.addClass('active')
    }

  , listen: function () {
      this.$element
        .on('focus',    $.proxy(this.focus, this))
        .on('blur',     $.proxy(this.blur, this))
        .on('keypress', $.proxy(this.keypress, this))
        .on('keyup',    $.proxy(this.keyup, this))

      if (this.eventSupported('keydown')) {
        this.$element.on('keydown', $.proxy(this.keydown, this))
      }

      this.$menu
        .on('click', $.proxy(this.click, this))
        .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
        .on('mouseleave', 'li', $.proxy(this.mouseleave, this))
    },

    destroy: function () {
      this.$element.off().removeData('typeahead');
      this.$menu.off();
    }

  , eventSupported: function(eventName) {
      var isSupported = eventName in this.$element
      if (!isSupported) {
        this.$element.setAttribute(eventName, 'return;')
        isSupported = typeof this.$element[eventName] === 'function'
      }
      return isSupported
    }

  , move: function (e) {
      if (!this.shown) return

      // grafana change, shift+left parenthesis
      if (e.shiftKey && e.keyCode === 40) {
        return;
      }

      switch(e.keyCode) {
        case 9: // tab
        case 13: // enter
        case 27: // escape
          e.preventDefault()
          break

        case 38: // up arrow
          e.preventDefault()
          this.prev()
          break

        case 40: // down arrow
          e.preventDefault()
          this.next()
          break
      }

      e.stopPropagation()
    }

  , keydown: function (e) {
      this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40,38,9,13,27,57])
      this.move(e)
    }

  , keypress: function (e) {
      if (this.suppressKeyPressRepeat) return
      this.move(e)
    }

  , keyup: function (e) {
      switch(e.keyCode) {
        case 40: // down arrow
        case 38: // up arrow
        case 16: // shift
        case 17: // ctrl
        case 18: // alt
          break

        case 9: // tab
        case 13: // enter
          if (!this.shown) return
          this.select()
          break

        case 27: // escape
          if (!this.shown) return
          this.hide()
          break

        default:
          this.lookup();
      }

      if(e.keyCode === 13 && typeof this.$menu.find('.active').attr('data-value') === 'undefined') {
        // CHANGE (rashidkpc). Enter was hit, nothing was selected from typeahead, submit form
        this.$element.submit();
      } else {
        e.stopPropagation()
        e.preventDefault()
      }

  }

  , focus: function (e) {
      this.focused = true
    }

  , blur: function (e) {
      this.focused = false
      if (!this.mousedover && this.shown) this.hide()
    }

  , click: function (e) {
      e.stopPropagation()
      e.preventDefault()
      this.select()
      this.$element.focus()
    }

  , mouseenter: function (e) {
      this.mousedover = true
      this.$menu.find('.active').removeClass('active')
      $(e.currentTarget).addClass('active')
    }

  , mouseleave: function (e) {
      this.mousedover = false
      if (!this.focused && this.shown) this.hide()
    }

  }


  /* TYPEAHEAD PLUGIN DEFINITION
   * =========================== */

  var old = $.fn.typeahead

  $.fn.typeahead = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('typeahead')
        , options = typeof option == 'object' && option
      if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.typeahead.defaults = {
    source: []
  , items: 8
  , menu: '<ul class="typeahead dropdown-menu"></ul>'
  , item: '<li><a href="#"></a></li>'
  , minLength: 1
  }

  $.fn.typeahead.Constructor = Typeahead


 /* TYPEAHEAD NO CONFLICT
  * =================== */

  $.fn.typeahead.noConflict = function () {
    $.fn.typeahead = old
    return this
  }


 /* TYPEAHEAD DATA-API
  * ================== */

  $(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
    var $this = $(this)
    if ($this.data('typeahead')) return
    $this.typeahead($this.data())
  })

}(window.jQuery);
/* ==========================================================
 * bootstrap-affix.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#affix
 * ==========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* AFFIX CLASS DEFINITION
  * ====================== */

  var Affix = function (element, options) {
    this.options = $.extend({}, $.fn.affix.defaults, options)
    this.$window = $(window)
      .on('scroll.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.affix.data-api',  $.proxy(function () { setTimeout($.proxy(this.checkPosition, this), 1) }, this))
    this.$element = $(element)
    this.checkPosition()
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var scrollHeight = $(document).height()
      , scrollTop = this.$window.scrollTop()
      , position = this.$element.offset()
      , offset = this.options.offset
      , offsetBottom = offset.bottom
      , offsetTop = offset.top
      , reset = 'affix affix-top affix-bottom'
      , affix

    if (typeof offset != 'object') offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function') offsetTop = offset.top()
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom()

    affix = this.unpin != null && (scrollTop + this.unpin <= position.top) ?
      false    : offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ?
      'bottom' : offsetTop != null && scrollTop <= offsetTop ?
      'top'    : false

    if (this.affixed === affix) return

    this.affixed = affix
    this.unpin = affix == 'bottom' ? position.top - scrollTop : null

    this.$element.removeClass(reset).addClass('affix' + (affix ? '-' + affix : ''))
  }


 /* AFFIX PLUGIN DEFINITION
  * ======================= */

  var old = $.fn.affix

  $.fn.affix = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('affix')
        , options = typeof option == 'object' && option
      if (!data) $this.data('affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.affix.Constructor = Affix

  $.fn.affix.defaults = {
    offset: 0
  }


 /* AFFIX NO CONFLICT
  * ================= */

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


 /* AFFIX DATA-API
  * ============== */

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
        , data = $spy.data()

      data.offset = data.offset || {}

      data.offsetBottom && (data.offset.bottom = data.offsetBottom)
      data.offsetTop && (data.offset.top = data.offsetTop)

      $spy.affix(data)
    })
  })


}(window.jQuery);


/***/ }),
/* 522 */
/***/ (function(module, exports) {

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.13.4 - 2015-09-03
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls","ui.bootstrap.position","ui.bootstrap.dateparser","ui.bootstrap.datepicker"]);
angular.module("ui.bootstrap.tpls", ["template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html"]);
angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function($document, $window) {
    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function(element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function(element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function(element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function() {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function() {
            return hostElPos.left;
          },
          right: function() {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function() {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function() {
            return hostElPos.top;
          },
          bottom: function() {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);

angular.module('ui.bootstrap.dateparser', [])

.service('dateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  this.parsers = {};

  var formatCodeToRegex = {
    'yyyy': {
      regex: '\\d{4}',
      apply: function(value) { this.year = +value; }
    },
    'yy': {
      regex: '\\d{2}',
      apply: function(value) { this.year = +value + 2000; }
    },
    'y': {
      regex: '\\d{1,4}',
      apply: function(value) { this.year = +value; }
    },
    'MMMM': {
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
    },
    'MMM': {
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
    },
    'MM': {
      regex: '0[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'M': {
      regex: '[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'dd': {
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'd': {
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'EEEE': {
      regex: $locale.DATETIME_FORMATS.DAY.join('|')
    },
    'EEE': {
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
    },
    'HH': {
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'hh': {
      regex: '0[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'H': {
      regex: '1?[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'h': {
      regex: '[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'mm': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'm': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'sss': {
      regex: '[0-9][0-9][0-9]',
      apply: function(value) { this.milliseconds = +value; }
    },
    'ss': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    's': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    'a': {
      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
      apply: function(value) {
        if (this.hours === 12) {
          this.hours = 0;
        }

        if (value === 'PM') {
          this.hours += 12;
        }
      }
    }
  };

  function createParser(format) {
    var map = [], regex = format.split('');

    angular.forEach(formatCodeToRegex, function(data, code) {
      var index = format.indexOf(code);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + code.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({ index: index, apply: data.apply });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format);
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex);

    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i-1];
        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      if (isValid(fields.year, fields.month, fields.date)) {
        dt = new Date(fields.year, fields.month, fields.date,
          fields.hours, fields.minutes, fields.seconds,
          fields.milliseconds || 0);
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }
}]);

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])

.value('$datepickerSuppressError', false)

.constant('datepickerConfig', {
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  datepickerMode: 'day',
  minMode: 'day',
  maxMode: 'year',
  showWeeks: true,
  startingDay: 0,
  yearRange: 20,
  minDate: null,
  maxDate: null,
  shortcutPropagation: false
})

.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'datepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  // Configuration attributes
  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
  });

  // Watchable date attributes
  angular.forEach(['minDate', 'maxDate'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = value ? new Date(value) : null;
        self.refreshView();
      });
    } else {
      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
    }
  });

  angular.forEach(['minMode', 'maxMode'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = angular.isDefined(value) ? value : $attrs[key];
        $scope[key] = self[key];
        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
          $scope.datepickerMode = self[key];
        }
      });
    } else {
      self[key] = datepickerConfig[key] || null;
      $scope[key] = self[key];
    }
  });

  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  if (angular.isDefined($attrs.initDate)) {
    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
    $scope.$parent.$watch($attrs.initDate, function(initDate) {
      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
        self.activeDate = initDate;
        self.refreshView();
      }
    });
  } else {
    this.activeDate = new Date();
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = date;
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      this._refreshView();

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    return {
      date: date,
      label: dateFilter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0,
      customClass: this.customClass(date)
    };
  };

  this.isDisabled = function(date) {
    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  // Fix a hard-reprodusible bug with timezones
  // The bug depends on OS, browser, current timezone and current date
  // i.e.
  // var date = new Date(2014, 0, 1);
  // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
  // can result in "2013 11 31 23" because of the bug.
  this.fixTimeZone = function(date) {
    var hours = date.getHours();
    date.setHours(hours === 23 ? hours + 2 : 0);
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
    }
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
      return;
    }

    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
      focusElement();
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
      focusElement();
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
}])

.directive('datepicker', function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/datepicker.html';
    },
    scope: {
      datepickerMode: '=?',
      dateDisabled: '&',
      customClass: '&',
      shortcutPropagation: '&?'
    },
    require: ['datepicker', '^ngModel'],
    controller: 'DatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('daypicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/day.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      scope.showWeeks = ctrl.showWeeks;

      ctrl.step = { months: 1 };
      ctrl.element = element;

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function getDaysInMonth(year, month) {
        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
      }

      function getDates(startDate, n) {
        var dates = new Array(n), current = new Date(startDate), i = 0, date;
        while (i < n) {
          date = new Date(current);
          ctrl.fixTimeZone(date);
          dates[i++] = date;
          current.setDate(current.getDate() + 1);
        }
        return dates;
      }

      ctrl._refreshView = function() {
        var year = ctrl.activeDate.getFullYear(),
          month = ctrl.activeDate.getMonth(),
          firstDayOfMonth = new Date(year, month, 1),
          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
          firstDate = new Date(firstDayOfMonth);

        if (numDisplayedFromPreviousMonth > 0) {
          firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
        }

        // 42 is the number of days on a six-month calendar
        var days = getDates(firstDate, 42);
        for (var i = 0; i < 42; i ++) {
          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
            secondary: days[i].getMonth() !== month,
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.labels = new Array(7);
        for (var j = 0; j < 7; j++) {
          scope.labels[j] = {
            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
            full: dateFilter(days[j].date, 'EEEE')
          };
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
        scope.rows = ctrl.split(days, 7);

        if (scope.showWeeks) {
          scope.weekNumbers = [];
          var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
              numWeeks = scope.rows.length;
          for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
            scope.weekNumbers.push(
              getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
          }
        }
      };

      ctrl.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      function getISO8601WeekNumber(date) {
        var checkDate = new Date(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
        var time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
      }

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getDate();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 7;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 7;
        } else if (key === 'pageup' || key === 'pagedown') {
          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setMonth(month, 1);
          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
        } else if (key === 'home') {
          date = 1;
        } else if (key === 'end') {
          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
        }
        ctrl.activeDate.setDate(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('monthpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/month.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      ctrl.step = { years: 1 };
      ctrl.element = element;

      ctrl._refreshView = function() {
        var months = new Array(12),
            year = ctrl.activeDate.getFullYear(),
            date;

        for (var i = 0; i < 12; i++) {
          date = new Date(year, i, 1);
          ctrl.fixTimeZone(date);
          months[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatMonth), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
        scope.rows = ctrl.split(months, 3);
      };

      ctrl.compare = function(date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getMonth();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 3;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 3;
        } else if (key === 'pageup' || key === 'pagedown') {
          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setFullYear(year);
        } else if (key === 'home') {
          date = 0;
        } else if (key === 'end') {
          date = 11;
        }
        ctrl.activeDate.setMonth(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('yearpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/year.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      var range = ctrl.yearRange;

      ctrl.step = { years: range };
      ctrl.element = element;

      function getStartingYear( year ) {
        return parseInt((year - 1) / range, 10) * range + 1;
      }

      ctrl._refreshView = function() {
        var years = new Array(range), date;

        for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
          date = new Date(start + i, 0, 1);
          ctrl.fixTimeZone(date);
          years[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatYear), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = [years[0].label, years[range - 1].label].join(' - ');
        scope.rows = ctrl.split(years, 5);
      };

      ctrl.compare = function(date1, date2) {
        return date1.getFullYear() - date2.getFullYear();
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getFullYear();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 5;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 5;
        } else if (key === 'pageup' || key === 'pagedown') {
          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
        } else if (key === 'home') {
          date = getStartingYear(ctrl.activeDate.getFullYear());
        } else if (key === 'end') {
          date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
        }
        ctrl.activeDate.setFullYear(date);
      };

      ctrl.refreshView();
    }
  };
}])

.constant('datepickerPopupConfig', {
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  currentText: 'Today',
  clearText: 'Clear',
  closeText: 'Done',
  closeOnDateSelection: true,
  appendToBody: false,
  showButtonBar: true,
  onOpenFocus: true
})

.directive('datepickerPopup', ['$compile', '$parse', '$document', '$rootScope', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', '$timeout',
function($compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&',
      customClass: '&'
    },
    link: function(scope, element, attrs, ngModel) {
      var dateFormat,
          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody,
          onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus,
          datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl,
          datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl,
          cache = {};

      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

      scope.getText = function(key) {
        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };

      scope.isDisabled = function(date) {
        if (date === 'today') {
          date = new Date();
        }

        return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
          (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
      };

      scope.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      var isHtml5DateInput = false;
      if (datepickerPopupConfig.html5Types[attrs.type]) {
        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
        isHtml5DateInput = true;
      } else {
        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
        attrs.$observe('datepickerPopup', function(value, oldValue) {
            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
            // Invalidate the $modelValue to ensure that formatters re-run
            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
            if (newDateFormat !== dateFormat) {
              dateFormat = newDateFormat;
              ngModel.$modelValue = null;

              if (!dateFormat) {
                throw new Error('datepickerPopup must have a date format specified.');
              }
            }
        });
      }

      if (!dateFormat) {
        throw new Error('datepickerPopup must have a date format specified.');
      }

      if (isHtml5DateInput && attrs.datepickerPopup) {
        throw new Error('HTML5 date input types do not support custom formats.');
      }

      // popup element used to display calendar
      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
      popupEl.attr({
        'ng-model': 'date',
        'ng-change': 'dateSelection(date)',
        'template-url': datepickerPopupTemplateUrl
      });

      function cameltoDash(string) {
        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
      }

      // datepicker element
      var datepickerEl = angular.element(popupEl.children()[0]);
      datepickerEl.attr('template-url', datepickerTemplateUrl);

      if (isHtml5DateInput) {
        if (attrs.type === 'month') {
          datepickerEl.attr('datepicker-mode', '"month"');
          datepickerEl.attr('min-mode', 'month');
        }
      }

      if (attrs.datepickerOptions) {
        var options = scope.$parent.$eval(attrs.datepickerOptions);
        if (options && options.initDate) {
          scope.initDate = options.initDate;
          datepickerEl.attr('init-date', 'initDate');
          delete options.initDate;
        }
        angular.forEach(options, function(value, option) {
          datepickerEl.attr( cameltoDash(option), value );
        });
      }

      scope.watchData = {};
      angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
        if (attrs[key]) {
          var getAttribute = $parse(attrs[key]);
          scope.$parent.$watch(getAttribute, function(value) {
            scope.watchData[key] = value;
            if (key === 'minDate' || key === 'maxDate') {
              cache[key] = new Date(value);
            }
          });
          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

          // Propagate changes from datepicker to outside
          if (key === 'datepickerMode') {
            var setAttribute = getAttribute.assign;
            scope.$watch('watchData.' + key, function(value, oldvalue) {
              if (angular.isFunction(setAttribute) && value !== oldvalue) {
                setAttribute(scope.$parent, value);
              }
            });
          }
        }
      });
      if (attrs.dateDisabled) {
        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
      }

      if (attrs.showWeeks) {
        datepickerEl.attr('show-weeks', attrs.showWeeks);
      }

      if (attrs.customClass) {
        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
      }

      function parseDate(viewValue) {
        if (angular.isNumber(viewValue)) {
          // presumably timestamp to date object
          viewValue = new Date(viewValue);
        }

        if (!viewValue) {
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var date = dateParser.parse(viewValue, dateFormat, scope.date);
          if (isNaN(date)) {
            return undefined;
          } else {
            return date;
          }
        } else {
          return undefined;
        }
      }

      function validator(modelValue, viewValue) {
        var value = modelValue || viewValue;

        if (!attrs.ngRequired && !value) {
          return true;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }
        if (!value) {
          return true;
        } else if (angular.isDate(value) && !isNaN(value)) {
          return true;
        } else if (angular.isString(value)) {
          var date = dateParser.parse(value, dateFormat);
          return !isNaN(date);
        } else {
          return false;
        }
      }

      if (!isHtml5DateInput) {
        // Internal API to maintain the correct ng-invalid-[key] class
        ngModel.$$parserName = 'date';
        ngModel.$validators.date = validator;
        ngModel.$parsers.unshift(parseDate);
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
        });
      } else {
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return value;
        });
      }

      // Inner change
      scope.dateSelection = function(dt) {
        if (angular.isDefined(dt)) {
          scope.date = dt;
        }
        var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
        element.val(date);
        ngModel.$setViewValue(date);

        if (closeOnDateSelection) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      // Detect changes in the view from the text box
      ngModel.$viewChangeListeners.push(function() {
        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
      });

      var documentClickBind = function(event) {
        if (scope.isOpen && !(element[0].contains(event.target) || popupEl[0].contains(event.target))) {
          scope.$apply(function() {
            scope.isOpen = false;
          });
        }
      };

      var inputKeydownBind = function(evt) {
        if (evt.which === 27 && scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = false;
          });
          element[0].focus();
        } else if (evt.which === 40 && !scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = true;
          });
        }
      };
      element.bind('keydown', inputKeydownBind);

      scope.keydown = function(evt) {
        if (evt.which === 27) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      scope.$watch('isOpen', function(value) {
        if (value) {
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top = scope.position.top + element.prop('offsetHeight');

          $timeout(function() {
            if (onOpenFocus) {
              scope.$broadcast('datepicker.focus');
            }
            $document.bind('click', documentClickBind);
          }, 0, false);
        } else {
          $document.unbind('click', documentClickBind);
        }
      });

      scope.select = function(date) {
        if (date === 'today') {
          var today = new Date();
          if (angular.isDate(scope.date)) {
            date = new Date(scope.date);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        scope.dateSelection(date);
      };

      scope.close = function() {
        scope.isOpen = false;
        element[0].focus();
      };

      var $popup = $compile(popupEl)(scope);
      // Prevent jQuery cache memory leak (template is now redundant after linking)
      popupEl.remove();

      if (appendToBody) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }

      scope.$on('$destroy', function() {
        if (scope.isOpen === true) {
          if (!$rootScope.$$phase) {
            scope.$apply(function() {
              scope.isOpen = false;
            });
          }
        }

        $popup.remove();
        element.unbind('keydown', inputKeydownBind);
        $document.unbind('click', documentClickBind);
      });
    }
  };
}])

.directive('datepickerPopupWrap', function() {
  return {
    restrict:'EA',
    replace: true,
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/popup.html';
    }
  };
});


angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
    "</div>");
}]);

angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/popup.html",
    "<ul class=\"dropdown-menu\" ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "	<li ng-transclude></li>\n" +
    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
    "		<span class=\"btn-group pull-left\">\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
    "		</span>\n" +
    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);



/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * AngularStrap - Twitter Bootstrap directives for AngularJS
 * @version v0.7.5 - 2013-07-21
 * @link http://mgcrea.github.com/angular-strap
 * @author Olivier Louvignes <olivier@mg-crea.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
angular.module('$strap.config', []).value('$strapConfig', {});
angular.module('$strap.filters', ['$strap.config']);
angular.module('$strap.directives', ['$strap.config']);
angular.module('$strap', [
  '$strap.filters',
  '$strap.directives',
  '$strap.config'
]);
'use strict';
angular.module('$strap.directives').factory('$modal', [
  '$rootScope',
  '$compile',
  '$http',
  '$timeout',
  '$q',
  '$templateCache',
  '$strapConfig',
  function ($rootScope, $compile, $http, $timeout, $q, $templateCache, $strapConfig) {
    var ModalFactory = function ModalFactory(config) {
      function Modal(config) {
        var options = angular.extend({ show: true }, $strapConfig.modal, config);
        var scope = options.scope ? options.scope : $rootScope.$new()
        var templateUrl = options.template;
        return $q.when(options.templateHtml || $templateCache.get(templateUrl) || $http.get(templateUrl, { cache: true }).then(function (res) {
          return res.data;
        })).then(function onSuccess(template) {
          var id = scope.$id;
          if (templateUrl) {
            id += templateUrl.replace('.html', '').replace(/[\/|\.|:]/g, '-');
          }
          // grafana change, removed fade
          var $modal = $('<div class="modal hide" tabindex="-1"></div>').attr('id', id).html(template);
          if (options.modalClass)
            $modal.addClass(options.modalClass);
          $('body').append($modal);
          $timeout(function () {
            $compile($modal)(scope);
          });
          scope.$modal = function (name) {
            $modal.modal(name);
          };
          angular.forEach([
            'show',
            'hide'
          ], function (name) {
            scope[name] = function () {
              $modal.modal(name);
            };
          });
          scope.dismiss = scope.hide;
          angular.forEach([
            'show',
            'shown',
            'hide',
            'hidden'
          ], function (name) {
            $modal.on(name, function (ev) {
              scope.$emit('modal-' + name, ev);
            });
          });
          $modal.on('shown', function (ev) {
            $('input[autofocus], textarea[autofocus]', $modal).first().trigger('focus');
          });
          $modal.on('hidden', function (ev) {
            if (!options.persist)
              scope.$destroy();
          });
          scope.$on('$destroy', function () {
            $modal.remove();
          });
          $modal.modal(options);
          return $modal;
        });
      }
      return new Modal(config);
    };
    return ModalFactory;
  }
])

'use strict';
angular.module('$strap.directives').directive('bsTooltip', [
  '$parse',
  '$compile',
  function ($parse, $compile) {
    return {
      restrict: 'A',
      scope: true,
      link: function postLink(scope, element, attrs, ctrl) {
        var getter = $parse(attrs.bsTooltip), setter = getter.assign, value = getter(scope);
        scope.$watch(attrs.bsTooltip, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            value = newValue;
          }
        });
        // Grafana change, always hide other tooltips
        if (true) {
          element.on('show', function (ev) {
            $('.tooltip.in').each(function () {
              var $this = $(this), tooltip = $this.data('tooltip');
              if (tooltip && !tooltip.$element.is(element)) {
                $this.tooltip('hide');
              }
            });
          });
        }
        element.tooltip({
          title: function () {
            return angular.isFunction(value) ? value.apply(null, arguments) : value;
          },
          html: true,
          container: 'body', // Grafana change
        });
        var tooltip = element.data('tooltip');
        tooltip.show = function () {
          var r = $.fn.tooltip.Constructor.prototype.show.apply(this, arguments);
          this.tip().data('tooltip', this);
          return r;
        };
        scope._tooltip = function (event) {
          element.tooltip(event);
        };
        scope.hide = function () {
          element.tooltip('hide');
        };
        scope.show = function () {
          element.tooltip('show');
        };
        scope.dismiss = scope.hide;
      }
    };
  }
]);

'use strict';
angular.module('$strap.directives').directive('bsTypeahead', [
  '$parse',
  function ($parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function postLink(scope, element, attrs, controller) {
        var getter = $parse(attrs.bsTypeahead), setter = getter.assign, value = getter(scope);
        scope.$watch(attrs.bsTypeahead, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            value = newValue;
          }
        });
        element.attr('data-provide', 'typeahead');
        element.typeahead({
          source: function (query) {
            return angular.isFunction(value) ? value.apply(null, arguments) : value;
          },
          minLength: attrs.minLength || 1,
          items: attrs.items,
          updater: function (value) {
            if (controller) {
              scope.$apply(function () {
                controller.$setViewValue(value);
              });
            }
            scope.$emit('typeahead-updated', value);
            return value;
          }
        });
        var typeahead = element.data('typeahead');
        typeahead.lookup = function (ev) {
          var items;
          this.query = this.$element.val() || '';
          if (this.query.length < this.options.minLength) {
            return this.shown ? this.hide() : this;
          }
          items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source;
          return items ? this.process(items) : this;
        };
        if (!!attrs.matchAll) {
          typeahead.matcher = function (item) {
            return true;
          };
        }
        if (attrs.minLength === '0') {
          setTimeout(function () {
            element.on('focus', function () {
              element.val().length === 0 && setTimeout(element.typeahead.bind(element, 'lookup'), 200);
            });
          });
        }
      }
    };
  }
]);


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(4),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
  "use strict";

  return function Settings (options) {
    var defaults = {
      datasources                   : {},
      window_title_prefix           : 'Grafana - ',
      panels                        : {},
      new_panel_title: 'Panel Title',
      playlist_timespan: "1m",
      unsaved_changes_warning: true,
      appSubUrl: ""
    };

    return _.extend({}, defaults, options);
  };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 525 */,
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(4),
  __webpack_require__(10),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, coreModule) {
  'use strict';

  coreModule.default.directive('dashClass', function() {
    return {
      link: function($scope, elem) {

        $scope.onAppEvent('panel-fullscreen-enter', function() {
          elem.toggleClass('panel-in-fullscreen', true);
        });

        $scope.onAppEvent('panel-fullscreen-exit', function() {
          elem.toggleClass('panel-in-fullscreen', false);
        });

        var lastHideControlsVal;
        $scope.$watch('dashboard.hideControls', function() {
          if (!$scope.dashboard) {
            return;
          }

          var hideControls = $scope.dashboard.hideControls;
          if (lastHideControlsVal !== hideControls) {
            elem.toggleClass('hide-controls', hideControls);
            lastHideControlsVal = hideControls;
          }
        });

        $scope.$watch('playlistSrv.isPlaying', function(newValue) {
          elem.toggleClass('playlist-active', newValue === true);
        });
      }
    };
  });

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (coreModule) {
  'use strict';

  coreModule.default.directive('confirmClick', function() {
    return {
      restrict: 'A',
      link: function(scope, elem, attrs) {
        elem.bind('click', function() {
          var message = attrs.confirmation || "Are you sure you want to do that?";
          if (window.confirm(message)) {
            var action = attrs.confirmClick;
            if (action) {
              scope.$apply(scope.$eval(action));
            }
          }
        });
      },
    };
  });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(10),
  __webpack_require__(8),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, coreModule) {
  'use strict';

  var editViewMap = {
    'settings':    { src: 'public/app/features/dashboard/partials/settings.html'},
    'annotations': { src: 'public/app/features/annotations/partials/editor.html'},
    'templating':  { src: 'public/app/features/templating/partials/editor.html'},
    'history':     { html: '<gf-dashboard-history dashboard="dashboard"></gf-dashboard-history>'},
    'timepicker':  { src: 'public/app/features/dashboard/timepicker/dropdown.html' },
    'import':      { html: '<dash-import></dash-import>' }
  };

  coreModule.default.directive('dashEditorView', ["$compile", "$location", "$rootScope", function($compile, $location, $rootScope) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        var editorScope;
        var lastEditView;

        function hideEditorPane(hideToShowOtherView) {
          if (editorScope) {
            editorScope.dismiss(hideToShowOtherView);
          }
        }

        function showEditorPane(evt, options) {
          if (options.editview) {
            options.src = editViewMap[options.editview].src;
            options.html = editViewMap[options.editview].html;
          }

          if (lastEditView && lastEditView === options.editview) {
            hideEditorPane(false);
            return;
          }

          hideEditorPane(true);

          lastEditView = options.editview;
          editorScope = options.scope ? options.scope.$new() : scope.$new();

          editorScope.dismiss = function(hideToShowOtherView) {
            editorScope.$destroy();
            lastEditView = null;
            editorScope = null;
            elem.removeClass('dash-edit-view--open');

            if (!hideToShowOtherView) {
              setTimeout(function() {
                elem.empty();
              }, 250);
            }

            if (options.editview) {
              var urlParams = $location.search();
              if (options.editview === urlParams.editview) {
                delete urlParams.editview;

                // even though we always are in apply phase here
                // some angular bug is causing location search updates to
                // not happen always so this is a hack fix or that
                setTimeout(function() {
                  $rootScope.$apply(function() {
                    $location.search(urlParams);
                  });
                });
              }
            }
          };

          if (options.editview === 'import') {
            var modalScope = $rootScope.$new();
            modalScope.$on("$destroy", function() {
              editorScope.dismiss();
            });

            $rootScope.appEvent('show-modal', {
              templateHtml: '<dash-import></dash-import>',
              scope: modalScope,
              backdrop: 'static'
            });

            return;
          }

          var view;
          if (options.src)  {
            view = angular.element(document.createElement('div'));
            view.html('<div class="tabbed-view" ng-include="' + "'" + options.src + "'" + '"></div>');
          } else {
            view = angular.element(document.createElement('div'));
            view.addClass('tabbed-view');
            view.html(options.html);
          }

          $compile(view)(editorScope);

          setTimeout(function() {
            elem.empty();
            elem.append(view);
            setTimeout(function() {
              elem.addClass('dash-edit-view--open');
            }, 10);
          }, 10);
        }

        scope.$watch("dashboardViewState.state.editview", function(newValue, oldValue) {
          if (newValue) {
            showEditorPane(null, {editview: newValue});
          } else if (oldValue) {
            if (lastEditView === oldValue) {
              hideEditorPane();
            }
          }
        });

        scope.$on("$destroy", hideEditorPane);

        scope.onAppEvent('hide-dash-editor', function() {
          hideEditorPane(false);
        });

        scope.onAppEvent('show-dash-editor', showEditorPane);

        scope.onAppEvent('panel-fullscreen-enter', function() {
          scope.appEvent('hide-dash-editor');
        });
      }
    };
  }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(4),
  __webpack_require__(10),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, coreModule) {
  'use strict';

  coreModule.default.directive('dropdownTypeahead', ["$compile", function($compile) {

    var inputTemplate = '<input type="text"'+
      ' class="gf-form-input input-medium tight-form-input"' +
      ' spellcheck="false" style="display:none"></input>';

    var buttonTemplate = '<a  class="gf-form-label tight-form-func dropdown-toggle"' +
      ' tabindex="1" gf-dropdown="menuItems" data-toggle="dropdown"' +
      ' data-placement="top"><i class="fa fa-plus"></i></a>';

    return {
      scope: {
        menuItems: "=dropdownTypeahead",
        dropdownTypeaheadOnSelect: "&dropdownTypeaheadOnSelect",
        model: '=ngModel'
      },
      link: function($scope, elem, attrs) {
        var $input = $(inputTemplate);
        var $button = $(buttonTemplate);
        $input.appendTo(elem);
        $button.appendTo(elem);

        if (attrs.linkText) {
          $button.html(attrs.linkText);
        }

        if (attrs.ngModel) {
          $scope.$watch('model', function(newValue) {
            _.each($scope.menuItems, function(item) {
              _.each(item.submenu, function(subItem) {
                if (subItem.value === newValue) {
                  $button.html(subItem.text);
                }
              });
            });
          });
        }

        var typeaheadValues = _.reduce($scope.menuItems, function(memo, value, index) {
          if (!value.submenu) {
            value.click = 'menuItemSelected(' + index + ')';
            memo.push(value.text);
          } else {
            _.each(value.submenu, function(item, subIndex) {
              item.click = 'menuItemSelected(' + index + ',' + subIndex + ')';
              memo.push(value.text + ' ' + item.text);
            });
          }
          return memo;
        }, []);

        $scope.menuItemSelected = function(index, subIndex) {
          var menuItem = $scope.menuItems[index];
          var payload = {$item: menuItem};
          if (menuItem.submenu && subIndex !== void 0) {
            payload.$subItem = menuItem.submenu[subIndex];
          }
          $scope.dropdownTypeaheadOnSelect(payload);
        };

        $input.attr('data-provide', 'typeahead');
        $input.typeahead({
          source: typeaheadValues,
          minLength: 1,
          items: 10,
          updater: function (value) {
            var result = {};
            _.each($scope.menuItems, function(menuItem) {
              _.each(menuItem.submenu, function(submenuItem) {
                if (value === (menuItem.text + ' ' + submenuItem.text)) {
                  result.$subItem = submenuItem;
                  result.$item = menuItem;
                }
              });
            });

            if (result.$item) {
              $scope.$apply(function() {
                $scope.dropdownTypeaheadOnSelect(result);
              });
            }

            $input.trigger('blur');
            return '';
          }
        });

        $button.click(function() {
          $button.hide();
          $input.show();
          $input.focus();
        });

        $input.keyup(function() {
          elem.toggleClass('open', $input.val() === '');
        });

        $input.blur(function() {
          $input.hide();
          $input.val('');
          $button.show();
          $button.focus();
          // clicking the function dropdown menu wont
          // work if you remove class at once
          setTimeout(function() {
            elem.removeClass('open');
          }, 200);
        });

        $compile(elem.contents())($scope);
      }
    };
  }]);

  coreModule.default.directive('dropdownTypeahead2', ["$compile", function($compile) {

    var inputTemplate = '<input type="text"'+
      ' class="gf-form-input"' +
      ' spellcheck="false" style="display:none"></input>';

    var buttonTemplate = '<a class="gf-form-input dropdown-toggle"' +
      ' tabindex="1" gf-dropdown="menuItems" data-toggle="dropdown"' +
      ' data-placement="top"><i class="fa fa-plus"></i></a>';

    return {
      scope: {
        menuItems: "=dropdownTypeahead2",
        dropdownTypeaheadOnSelect: "&dropdownTypeaheadOnSelect",
        model: '=ngModel'
      },
      link: function($scope, elem, attrs) {
        var $input = $(inputTemplate);
        var $button = $(buttonTemplate);
        $input.appendTo(elem);
        $button.appendTo(elem);

        if (attrs.linkText) {
          $button.html(attrs.linkText);
        }

        if (attrs.ngModel) {
          $scope.$watch('model', function(newValue) {
            _.each($scope.menuItems, function(item) {
              _.each(item.submenu, function(subItem) {
                if (subItem.value === newValue) {
                  $button.html(subItem.text);
                }
              });
            });
          });
        }

        var typeaheadValues = _.reduce($scope.menuItems, function(memo, value, index) {
          if (!value.submenu) {
            value.click = 'menuItemSelected(' + index + ')';
            memo.push(value.text);
          } else {
            _.each(value.submenu, function(item, subIndex) {
              item.click = 'menuItemSelected(' + index + ',' + subIndex + ')';
              memo.push(value.text + ' ' + item.text);
            });
          }
          return memo;
        }, []);

        $scope.menuItemSelected = function(index, subIndex) {
          var menuItem = $scope.menuItems[index];
          var payload = {$item: menuItem};
          if (menuItem.submenu && subIndex !== void 0) {
            payload.$subItem = menuItem.submenu[subIndex];
          }
          $scope.dropdownTypeaheadOnSelect(payload);
        };

        $input.attr('data-provide', 'typeahead');
        $input.typeahead({
          source: typeaheadValues,
          minLength: 1,
          items: 10,
          updater: function (value) {
            var result = {};
            _.each($scope.menuItems, function(menuItem) {
              _.each(menuItem.submenu, function(submenuItem) {
                if (value === (menuItem.text + ' ' + submenuItem.text)) {
                  result.$subItem = submenuItem;
                  result.$item = menuItem;
                }
              });
            });

            if (result.$item) {
              $scope.$apply(function() {
                $scope.dropdownTypeaheadOnSelect(result);
              });
            }

            $input.trigger('blur');
            return '';
          }
        });

        $button.click(function() {
          $button.hide();
          $input.show();
          $input.focus();
        });

        $input.keyup(function() {
          elem.toggleClass('open', $input.val() === '');
        });

        $input.blur(function() {
          $input.hide();
          $input.val('');
          $button.show();
          $button.focus();
          // clicking the function dropdown menu wont
          // work if you remove class at once
          setTimeout(function() {
            elem.removeClass('open');
          }, 200);
        });

        $compile(elem.contents())($scope);
      }
    };
  }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(4),
  __webpack_require__(10),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, coreModule) {
  'use strict';

  coreModule.default.directive('metricSegment', ["$compile", "$sce", function($compile, $sce) {
    var inputTemplate = '<input type="text" data-provide="typeahead" ' +
      ' class="gf-form-input input-medium"' +
      ' spellcheck="false" style="display:none"></input>';

    var linkTemplate = '<a class="gf-form-label" ng-class="segment.cssClass" ' +
      'tabindex="1" give-focus="segment.focus" ng-bind-html="segment.html"></a>';

    var selectTemplate = '<a class="gf-form-input gf-form-input--dropdown" ng-class="segment.cssClass" ' +
      'tabindex="1" give-focus="segment.focus" ng-bind-html="segment.html"></a>';

    return {
      scope: {
        segment: "=",
        getOptions: "&",
        onChange: "&",
      },
      link: function($scope, elem) {
        var $input = $(inputTemplate);
        var segment = $scope.segment;
        var $button = $(segment.selectMode ? selectTemplate : linkTemplate);
        var options = null;
        var cancelBlur = null;
        var linkMode = true;

        $input.appendTo(elem);
        $button.appendTo(elem);

        $scope.updateVariableValue = function(value) {
          if (value === '' || segment.value === value) {
            return;
          }

          value = _.unescape(value);

          $scope.$apply(function() {
            var selected = _.find($scope.altSegments, {value: value});
            if (selected) {
              segment.value = selected.value;
              segment.html = selected.html || selected.value;
              segment.fake = false;
              segment.expandable = selected.expandable;
            }
            else if (segment.custom !== 'false') {
              segment.value = value;
              segment.html = $sce.trustAsHtml(value);
              segment.expandable = true;
              segment.fake = false;
            }

            $scope.onChange();
          });
        };

        $scope.switchToLink = function(fromClick) {
          if (linkMode && !fromClick) { return; }

          clearTimeout(cancelBlur);
          cancelBlur = null;
          linkMode = true;
          $input.hide();
          $button.show();
          $scope.updateVariableValue($input.val());
        };

        $scope.inputBlur = function() {
          // happens long before the click event on the typeahead options
          // need to have long delay because the blur
          cancelBlur = setTimeout($scope.switchToLink, 200);
        };

        $scope.source = function(query, callback) {
          $scope.$apply(function() {
            $scope.getOptions({ $query: query }).then(function(altSegments) {
              $scope.altSegments = altSegments;
              options = _.map($scope.altSegments, function(alt) {
                return _.escape(alt.value);
              });

              // add custom values
              if (segment.custom !== 'false') {
                if (!segment.fake && _.indexOf(options, segment.value) === -1) {
                  options.unshift(segment.value);
                }
              }

              callback(options);
            });
          });
        };

        $scope.updater = function(value) {
          if (value === segment.value) {
            clearTimeout(cancelBlur);
            $input.focus();
            return value;
          }

          $input.val(value);
          $scope.switchToLink(true);

          return value;
        };

        $scope.matcher = function(item) {
          var str = this.query;
          if (str[0] === '/') { str = str.substring(1); }
          if (str[str.length - 1] === '/') { str = str.substring(0, str.length-1); }
          try {
            return item.toLowerCase().match(str.toLowerCase());
          } catch(e) {
            return false;
          }
        };

        $input.attr('data-provide', 'typeahead');
        $input.typeahead({ source: $scope.source, minLength: 0, items: 10000, updater: $scope.updater, matcher: $scope.matcher });

        var typeahead = $input.data('typeahead');
        typeahead.lookup = function () {
          this.query = this.$element.val() || '';
          var items = this.source(this.query, $.proxy(this.process, this));
          return items ? this.process(items) : items;
        };

        $button.keydown(function(evt) {
          // trigger typeahead on down arrow or enter key
          if (evt.keyCode === 40 || evt.keyCode === 13) {
            $button.click();
          }
        });

        $button.click(function() {
          options = null;
          $input.css('width', (Math.max($button.width(), 80) + 16) + 'px');

          $button.hide();
          $input.show();
          $input.focus();

          linkMode = false;

          var typeahead = $input.data('typeahead');
          if (typeahead) {
            $input.val('');
            typeahead.lookup();
          }
        });

        $input.blur($scope.inputBlur);

        $compile(elem.contents())($scope);
      }
    };
  }]);

  coreModule.default.directive('metricSegmentModel', ["uiSegmentSrv", "$q", function(uiSegmentSrv, $q) {
    return {
      template: '<metric-segment segment="segment" get-options="getOptionsInternal()" on-change="onSegmentChange()"></metric-segment>',
      restrict: 'E',
      scope: {
        property: "=",
        options: "=",
        getOptions: "&",
        onChange: "&",
      },
      link: {
        pre: function postLink($scope, elem, attrs) {
          var cachedOptions;

          $scope.valueToSegment = function(value) {
            var option = _.find($scope.options, {value: value});
            var segment = {
              cssClass: attrs.cssClass,
              custom: attrs.custom,
              value: option ? option.text : value,
              selectMode: attrs.selectMode,
            };

            return uiSegmentSrv.newSegment(segment);
          };

          $scope.getOptionsInternal = function() {
            if ($scope.options) {
              cachedOptions = $scope.options;
              return $q.when(_.map($scope.options, function(option) {
                return {value: option.text};
              }));
            } else {
              return $scope.getOptions().then(function(options) {
                cachedOptions = options;
                return  _.map(options, function(option) {
                  if (option.html) {
                    return option;
                  }
                  return {value: option.text};
                });
              });
            }
          };

          $scope.onSegmentChange = function() {
            if (cachedOptions) {
              var option = _.find(cachedOptions, {text: $scope.segment.value});
              if (option && option.value !== $scope.property) {
                $scope.property = option.value;
              } else if (attrs.custom !== 'false') {
                $scope.property = $scope.segment.value;
              }
            } else {
              $scope.property = $scope.segment.value;
            }

            // needs to call this after digest so
            // property is synced with outerscope
            $scope.$$postDigest(function() {
              $scope.$apply(function() {
                $scope.onChange();
              });
            });
          };

          $scope.segment = $scope.valueToSegment($scope.property);
        }
      }
    };
  }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__,
  __webpack_require__(2),
  __webpack_require__(109),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, require, coreModule, kbn) {
  'use strict';

  coreModule.default.directive('tip', ["$compile", function($compile) {
    return {
      restrict: 'E',
      link: function(scope, elem, attrs) {
        var _t = '<i class="grafana-tip fa fa-'+(attrs.icon||'question-circle')+'" bs-tooltip="\''+
          kbn.addslashes(elem.text())+'\'"></i>';
        _t = _t.replace(/{/g, '\\{').replace(/}/g, '\\}');
        elem.replaceWith($compile(angular.element(_t))(scope));
      }
    };
  }]);

  coreModule.default.directive('clipboardButton', function() {
    return {
      scope: {
        getText: '&clipboardButton'
      },
      link: function(scope, elem) {
        new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(274)]; (function(Clipboard) {
          scope.clipboard = new Clipboard(elem[0], {
            text: function() {
              return scope.getText();
            }
          });
        }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);

        scope.$on('$destroy', function() {
          if (scope.clipboard) {
            scope.clipboard.destroy();
          }
        });
      }
    };
  });

  coreModule.default.directive('compile', ["$compile", function($compile) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        scope.$watch(function(scope) {
          return scope.$eval(attrs.compile);
        }, function(value) {
          element.html(value);
          $compile(element.contents())(scope);
        });
      }
    };
  }]);

  coreModule.default.directive('watchChange', function() {
    return {
      scope: { onchange: '&watchChange' },
      link: function(scope, element) {
        element.on('input', function() {
          scope.$apply(function () {
            scope.onchange({ inputValue: element.val() });
          });
        });
      }
    };
  });

  coreModule.default.directive('editorOptBool', ["$compile", function($compile) {
    return {
      restrict: 'E',
      link: function(scope, elem, attrs) {
        var ngchange = attrs.change ? (' ng-change="' + attrs.change + '"') : '';
        var tip = attrs.tip ? (' <tip>' + attrs.tip + '</tip>') : '';
        var showIf = attrs.showIf ? (' ng-show="' + attrs.showIf + '" ') : '';

        var template = '<div class="editor-option gf-form-checkbox text-center"' + showIf + '>' +
          ' <label for="' + attrs.model + '" class="small">' +
          attrs.text + tip + '</label>' +
          '<input class="cr1" id="' + attrs.model + '" type="checkbox" ' +
          '       ng-model="' + attrs.model + '"' + ngchange +
          '       ng-checked="' + attrs.model + '"></input>' +
          ' <label for="' + attrs.model + '" class="cr1"></label>';
        elem.replaceWith($compile(angular.element(template))(scope));
      }
    };
  }]);

  coreModule.default.directive('editorCheckbox', ["$compile", "$interpolate", function($compile, $interpolate) {
    return {
      restrict: 'E',
      link: function(scope, elem, attrs) {
        var text = $interpolate(attrs.text)(scope);
        var model = $interpolate(attrs.model)(scope);
        var ngchange = attrs.change ? (' ng-change="' + attrs.change + '"') : '';
        var tip = attrs.tip ? (' <tip>' + attrs.tip + '</tip>') : '';
        var label = '<label for="' + scope.$id + model + '" class="checkbox-label">' +
          text + tip + '</label>';

        var template =
        '<input class="cr1" id="' + scope.$id + model + '" type="checkbox" ' +
        '       ng-model="' + model + '"' + ngchange +
        '       ng-checked="' + model + '"></input>' +
        ' <label for="' + scope.$id + model + '" class="cr1"></label>';

        template = template + label;
        elem.addClass('gf-form-checkbox');
        elem.html($compile(angular.element(template))(scope));
      }
    };
  }]);

  coreModule.default.directive('gfDropdown', ["$parse", "$compile", "$timeout", function ($parse, $compile, $timeout) {
    function buildTemplate(items, placement) {
      var upclass = placement === 'top' ? 'dropup' : '';
      var ul = [
        '<ul class="dropdown-menu ' + upclass + '" role="menu" aria-labelledby="drop1">',
        '</ul>'
      ];

      angular.forEach(items, function (item, index) {
        if (item.divider) {
          return ul.splice(index + 1, 0, '<li class="divider"></li>');
        }

        var li = '<li' + (item.submenu && item.submenu.length ? ' class="dropdown-submenu"' : '') + '>' +
          '<a tabindex="-1" ng-href="' + (item.href || '') + '"' + (item.click ? ' ng-click="' + item.click + '"' : '') +
          (item.target ? ' target="' + item.target + '"' : '') + (item.method ? ' data-method="' + item.method + '"' : '') +
            '>' + (item.text || '') + '</a>';

        if (item.submenu && item.submenu.length) {
          li += buildTemplate(item.submenu).join('\n');
        }

        li += '</li>';
        ul.splice(index + 1, 0, li);
      });
      return ul;
    }

    return {
      restrict: 'EA',
      scope: true,
      link: function postLink(scope, iElement, iAttrs) {
        var getter = $parse(iAttrs.gfDropdown), items = getter(scope);
        $timeout(function () {
          var placement = iElement.data('placement');
          var dropdown = angular.element(buildTemplate(items, placement).join(''));
          dropdown.insertAfter(iElement);
          $compile(iElement.next('ul.dropdown-menu'))(scope);
        });

        iElement.addClass('dropdown-toggle').attr('data-toggle', 'dropdown');
      }
    };
  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(2),
  __webpack_require__(109),
  __webpack_require__(295),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (coreModule, kbn, rangeUtil) {
  'use strict';

  coreModule.default.directive('ngModelOnblur', function() {
    return {
      restrict: 'A',
      priority: 1,
      require: 'ngModel',
      link: function(scope, elm, attr, ngModelCtrl) {
        if (attr.type === 'radio' || attr.type === 'checkbox') {
          return;
        }

        elm.off('input keydown change');
        elm.bind('blur', function() {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(elm.val());
          });
        });
      }
    };
  });

  coreModule.default.directive('emptyToNull', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        ctrl.$parsers.push(function (viewValue) {
          if(viewValue === "") { return null; }
          return viewValue;
        });
      }
    };
  });

  coreModule.default.directive('validTimeSpan', function() {
    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        ctrl.$validators.integer = function(modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            return true;
          }
          if (viewValue.indexOf('$') === 0 || viewValue.indexOf('+$') === 0) {
            return true; // allow template variable
          }
          var info = rangeUtil.describeTextRange(viewValue);
          return info.invalid !== true;
        };
      }
    };
  });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(10),
  __webpack_require__(2),
  __webpack_require__(541),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, $, coreModule) {
  'use strict';

  function djb2(str) {
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i); /* hash * 33 + c */
    }
    return hash;
  }

  function setColor(name, element) {
    var hash = djb2(name.toLowerCase());
    var colors = [
      "#E24D42","#1F78C1","#BA43A9","#705DA0","#466803",
      "#508642","#447EBC","#C15C17","#890F02","#757575",
      "#0A437C","#6D1F62","#584477","#629E51","#2F4F4F",
      "#BF1B00","#806EB7","#8a2eb8", "#699e00","#000000",
      "#3F6833","#2F575E","#99440A","#E0752D","#0E4AB4",
      "#58140C","#052B51","#511749","#3F2B5B",
    ];
    var borderColors = [
      "#FF7368","#459EE7","#E069CF","#9683C6","#6C8E29",
      "#76AC68","#6AA4E2","#E7823D","#AF3528","#9B9B9B",
      "#3069A2","#934588","#7E6A9D","#88C477","#557575",
      "#E54126","#A694DD","#B054DE", "#8FC426","#262626",
      "#658E59","#557D84","#BF6A30","#FF9B53","#3470DA",
      "#7E3A32","#2B5177","#773D6F","#655181",
    ];
    var color = colors[Math.abs(hash % colors.length)];
    var borderColor = borderColors[Math.abs(hash % borderColors.length)];
    element.css("background-color", color);
    element.css("border-color", borderColor);
  }

  coreModule.default.directive('tagColorFromName', function() {
    return {
      scope: { tagColorFromName: "=" },
      link: function (scope, element) {
        setColor(scope.tagColorFromName, element);
      }
    };
  });

  coreModule.default.directive('bootstrapTagsinput', function() {

    function getItemProperty(scope, property) {
      if (!property) {
        return undefined;
      }

      if (angular.isFunction(scope.$parent[property])) {
        return scope.$parent[property];
      }

      return function(item) {
        return item[property];
      };
    }

    return {
      restrict: 'EA',
      scope: {
        model: '=ngModel',
        onTagsUpdated: "&",
      },
      template: '<select multiple></select>',
      replace: false,
      link: function(scope, element, attrs) {

        if (!angular.isArray(scope.model)) {
          scope.model = [];
        }

        var select = $('select', element);

        if (attrs.placeholder) {
          select.attr('placeholder', attrs.placeholder);
        }

        select.tagsinput({
          typeahead: {
            source: angular.isFunction(scope.$parent[attrs.typeaheadSource]) ? scope.$parent[attrs.typeaheadSource] : null
          },
          widthClass: attrs.widthClass,
          itemValue: getItemProperty(scope, attrs.itemvalue),
          itemText : getItemProperty(scope, attrs.itemtext),
          tagClass : angular.isFunction(scope.$parent[attrs.tagclass]) ?
            scope.$parent[attrs.tagclass] : function() { return attrs.tagclass; }
        });

        select.on('itemAdded', function(event) {
          if (scope.model.indexOf(event.item) === -1) {
            scope.model.push(event.item);
            if (scope.onTagsUpdated) {
              scope.onTagsUpdated();
            }
          }
          var tagElement = select.next().children("span").filter(function() { return $(this).text() === event.item; });
          setColor(event.item, tagElement);
        });

        select.on('itemRemoved', function(event) {
          var idx = scope.model.indexOf(event.item);
          if (idx !== -1) {
            scope.model.splice(idx, 1);
            if (scope.onTagsUpdated) {
              scope.onTagsUpdated();
            }
          }
        });

        scope.$watch("model", function() {
          if (!angular.isArray(scope.model)) {
            scope.model = [];
          }

          select.tagsinput('removeAll');

          for (var i = 0; i < scope.model.length; i++) {
            select.tagsinput('add', scope.model[i]);
          }

        }, true);
      }
    };
  });

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 541 */
/***/ (function(module, exports) {

(function ($) {
  "use strict";

  var defaultOptions = {
    tagClass: function(item) {
      return 'label label-info';
    },
    itemValue: function(item) {
      return item ? item.toString() : item;
    },
    itemText: function(item) {
      return this.itemValue(item);
    },
    freeInput: true,
    maxTags: undefined,
    confirmKeys: [13],
    onTagExists: function(item, $tag) {
      $tag.hide().fadeIn();
    }
  };

  /**
   * Constructor function
   */
  function TagsInput(element, options) {
    this.itemsArray = [];

    this.$element = $(element);
    this.$element.hide();

    this.widthClass = options.widthClass || 'width-9';
    this.isSelect = (element.tagName === 'SELECT');
    this.multiple = (this.isSelect && element.hasAttribute('multiple'));
    this.objectItems = options && options.itemValue;
    this.placeholderText = element.hasAttribute('placeholder') ? this.$element.attr('placeholder') : '';

    this.$container = $('<div class="bootstrap-tagsinput"></div>');
    this.$input = $('<input class="gf-form-input ' + this.widthClass + '" type="text" placeholder="' + this.placeholderText + '"/>').appendTo(this.$container);

    this.$element.after(this.$container);

    this.build(options);
  }

  TagsInput.prototype = {
    constructor: TagsInput,

    /**
     * Adds the given item as a new tag. Pass true to dontPushVal to prevent
     * updating the elements val()
     */
    add: function(item, dontPushVal) {
      var self = this;

      if (self.options.maxTags && self.itemsArray.length >= self.options.maxTags)
        return;

      // Ignore falsey values, except false
      if (item !== false && !item)
        return;

      // Throw an error when trying to add an object while the itemValue option was not set
      if (typeof item === "object" && !self.objectItems)
        throw("Can't add objects when itemValue option is not set");

      // Ignore strings only containg whitespace
      if (item.toString().match(/^\s*$/))
        return;

      // If SELECT but not multiple, remove current tag
      if (self.isSelect && !self.multiple && self.itemsArray.length > 0)
        self.remove(self.itemsArray[0]);

      if (typeof item === "string" && this.$element[0].tagName === 'INPUT') {
        var items = item.split(',');
        if (items.length > 1) {
          for (var i = 0; i < items.length; i++) {
            this.add(items[i], true);
          }

          if (!dontPushVal)
            self.pushVal();
          return;
        }
      }

      var itemValue = self.options.itemValue(item),
          itemText = self.options.itemText(item),
          tagClass = self.options.tagClass(item);

      // Ignore items allready added
      var existing = $.grep(self.itemsArray, function(item) { return self.options.itemValue(item) === itemValue; } )[0];
      if (existing) {
        // Invoke onTagExists
        if (self.options.onTagExists) {
          var $existingTag = $(".tag", self.$container).filter(function() { return $(this).data("item") === existing; });
          self.options.onTagExists(item, $existingTag);
        }
        return;
      }

      // register item in internal array and map
      self.itemsArray.push(item);

      // add a tag element
      var $tag = $('<span class="tag ' + htmlEncode(tagClass) + '">' + htmlEncode(itemText) + '<span data-role="remove"></span></span>');
      $tag.data('item', item);
      self.findInputWrapper().before($tag);
      $tag.after(' ');

      // add <option /> if item represents a value not present in one of the <select />'s options
      if (self.isSelect && !$('option[value="' + escape(itemValue) + '"]',self.$element)[0]) {
        var $option = $('<option selected>' + htmlEncode(itemText) + '</option>');
        $option.data('item', item);
        $option.attr('value', itemValue);
        self.$element.append($option);
      }

      if (!dontPushVal)
        self.pushVal();

      // Add class when reached maxTags
      if (self.options.maxTags === self.itemsArray.length)
        self.$container.addClass('bootstrap-tagsinput-max');

      self.$element.trigger($.Event('itemAdded', { item: item }));
    },

    /**
     * Removes the given item. Pass true to dontPushVal to prevent updating the
     * elements val()
     */
    remove: function(item, dontPushVal) {
      var self = this;

      if (self.objectItems) {
        if (typeof item === "object")
          item = $.grep(self.itemsArray, function(other) { return self.options.itemValue(other) ==  self.options.itemValue(item); } )[0];
        else
          item = $.grep(self.itemsArray, function(other) { return self.options.itemValue(other) ==  item; } )[0];
      }

      if (item) {
        $('.tag', self.$container).filter(function() { return $(this).data('item') === item; }).remove();
        $('option', self.$element).filter(function() { return $(this).data('item') === item; }).remove();
        self.itemsArray.splice($.inArray(item, self.itemsArray), 1);
      }

      if (!dontPushVal)
        self.pushVal();

      // Remove class when reached maxTags
      if (self.options.maxTags > self.itemsArray.length)
        self.$container.removeClass('bootstrap-tagsinput-max');

      self.$element.trigger($.Event('itemRemoved',  { item: item }));
    },

    /**
     * Removes all items
     */
    removeAll: function() {
      var self = this;

      $('.tag', self.$container).remove();
      $('option', self.$element).remove();

      while(self.itemsArray.length > 0)
        self.itemsArray.pop();

      self.pushVal();

      if (self.options.maxTags && !this.isEnabled())
        this.enable();
    },

    /**
     * Refreshes the tags so they match the text/value of their corresponding
     * item.
     */
    refresh: function() {
      var self = this;
      $('.tag', self.$container).each(function() {
        var $tag = $(this),
            item = $tag.data('item'),
            itemValue = self.options.itemValue(item),
            itemText = self.options.itemText(item),
            tagClass = self.options.tagClass(item);

          // Update tag's class and inner text
          $tag.attr('class', null);
          $tag.addClass('tag ' + htmlEncode(tagClass));
          $tag.contents().filter(function() {
            return this.nodeType == 3;
          })[0].nodeValue = htmlEncode(itemText);

          if (self.isSelect) {
            var option = $('option', self.$element).filter(function() { return $(this).data('item') === item; });
            option.attr('value', itemValue);
          }
      });
    },

    /**
     * Returns the items added as tags
     */
    items: function() {
      return this.itemsArray;
    },

    /**
     * Assembly value by retrieving the value of each item, and set it on the
     * element.
     */
    pushVal: function() {
      var self = this,
          val = $.map(self.items(), function(item) {
            return self.options.itemValue(item).toString();
          });

      self.$element.val(val, true).trigger('change');
    },

    /**
     * Initializes the tags input behaviour on the element
     */
    build: function(options) {
      var self = this;

      self.options = $.extend({}, defaultOptions, options);
      var typeahead = self.options.typeahead || {};

      // When itemValue is set, freeInput should always be false
      if (self.objectItems)
        self.options.freeInput = false;

      makeOptionItemFunction(self.options, 'itemValue');
      makeOptionItemFunction(self.options, 'itemText');
      makeOptionItemFunction(self.options, 'tagClass');

      // for backwards compatibility, self.options.source is deprecated
      if (self.options.source)
        typeahead.source = self.options.source;

      if (typeahead.source && $.fn.typeahead) {
        makeOptionFunction(typeahead, 'source');

        self.$input.typeahead({
          source: function (query, process) {
            function processItems(items) {
              var texts = [];

              for (var i = 0; i < items.length; i++) {
                var text = self.options.itemText(items[i]);
                map[text] = items[i];
                texts.push(text);
              }
              process(texts);
            }

            this.map = {};
            var map = this.map,
                data = typeahead.source(query);

            if ($.isFunction(data.success)) {
              // support for Angular promises
              data.success(processItems);
            } else {
              // support for functions and jquery promises
              $.when(data)
               .then(processItems);
            }
          },
          updater: function (text) {
            self.add(this.map[text]);
          },
          matcher: function (text) {
            return (text.toLowerCase().indexOf(this.query.trim().toLowerCase()) !== -1);
          },
          sorter: function (texts) {
            return texts.sort();
          },
          highlighter: function (text) {
            var regex = new RegExp( '(' + this.query + ')', 'gi' );
            return text.replace( regex, "<strong>$1</strong>" );
          }
        });
      }

      self.$container.on('click', $.proxy(function(event) {
        self.$input.focus();
      }, self));

      self.$container.on('blur', 'input', $.proxy(function(event) {
        var $input = $(event.target);
        self.add($input.val());
        $input.val('');
        event.preventDefault();
      }, self));

      self.$container.on('keydown', 'input', $.proxy(function(event) {
        var $input = $(event.target),
            $inputWrapper = self.findInputWrapper();

        switch (event.which) {
          // BACKSPACE
          case 8:
            if (doGetCaretPosition($input[0]) === 0) {
              var prev = $inputWrapper.prev();
              if (prev) {
                self.remove(prev.data('item'));
              }
            }
            break;

          // DELETE
          case 46:
            if (doGetCaretPosition($input[0]) === 0) {
              var next = $inputWrapper.next();
              if (next) {
                self.remove(next.data('item'));
              }
            }
            break;

          // LEFT ARROW
          case 37:
            // Try to move the input before the previous tag
            var $prevTag = $inputWrapper.prev();
            if ($input.val().length === 0 && $prevTag[0]) {
              $prevTag.before($inputWrapper);
              $input.focus();
            }
            break;
          // RIGHT ARROW
          case 39:
            // Try to move the input after the next tag
            var $nextTag = $inputWrapper.next();
            if ($input.val().length === 0 && $nextTag[0]) {
              $nextTag.after($inputWrapper);
              $input.focus();
            }
            break;
         default:
            // When key corresponds one of the confirmKeys, add current input
            // as a new tag
            if (self.options.freeInput && $.inArray(event.which, self.options.confirmKeys) >= 0) {
              self.add($input.val());
              $input.val('');
              event.preventDefault();
            }
        }

        // Reset internal input's size
        $input.attr('size', Math.max(this.inputSize, $input.val().length));
      }, self));

      // Remove icon clicked
      self.$container.on('click', '[data-role=remove]', $.proxy(function(event) {
        self.remove($(event.target).closest('.tag').data('item'));
        // Grafana mod, if tags input used in popover the click event will bubble up and hide popover
        event.stopPropagation();
      }, self));

      // Only add existing value as tags when using strings as tags
      if (self.options.itemValue === defaultOptions.itemValue) {
        if (self.$element[0].tagName === 'INPUT') {
            self.add(self.$element.val());
        } else {
          $('option', self.$element).each(function() {
            self.add($(this).attr('value'), true);
          });
        }
      }
    },

    /**
     * Removes all tagsinput behaviour and unregsiter all event handlers
     */
    destroy: function() {
      var self = this;

      // Unbind events
      self.$container.off('keypress', 'input');
      self.$container.off('click', '[role=remove]');

      self.$container.remove();
      self.$element.removeData('tagsinput');
      self.$element.show();
    },

    /**
     * Sets focus on the tagsinput
     */
    focus: function() {
      this.$input.focus();
    },

    /**
     * Returns the internal input element
     */
    input: function() {
      return this.$input;
    },

    /**
     * Returns the element which is wrapped around the internal input. This
     * is normally the $container, but typeahead.js moves the $input element.
     */
    findInputWrapper: function() {
      var elt = this.$input[0],
          container = this.$container[0];
      while(elt && elt.parentNode !== container)
        elt = elt.parentNode;

      return $(elt);
    }
  };

  /**
   * Register JQuery plugin
   */
  $.fn.tagsinput = function(arg1, arg2) {
    var results = [];

    this.each(function() {
      var tagsinput = $(this).data('tagsinput');

      // Initialize a new tags input
      if (!tagsinput) {
        tagsinput = new TagsInput(this, arg1);
        $(this).data('tagsinput', tagsinput);
        results.push(tagsinput);

        if (this.tagName === 'SELECT') {
          $('option', $(this)).attr('selected', 'selected');
        }

        // Init tags from $(this).val()
        $(this).val($(this).val());
      } else {
        // Invoke function on existing tags input
        var retVal = tagsinput[arg1](arg2);
        if (retVal !== undefined)
          results.push(retVal);
      }
    });

    if ( typeof arg1 == 'string') {
      // Return the results from the invoked function calls
      return results.length > 1 ? results : results[0];
    } else {
      return results;
    }
  };

  $.fn.tagsinput.Constructor = TagsInput;

  /**
   * Most options support both a string or number as well as a function as
   * option value. This function makes sure that the option with the given
   * key in the given options is wrapped in a function
   */
  function makeOptionItemFunction(options, key) {
    if (typeof options[key] !== 'function') {
      var propertyName = options[key];
      options[key] = function(item) { return item[propertyName]; };
    }
  }
  function makeOptionFunction(options, key) {
    if (typeof options[key] !== 'function') {
      var value = options[key];
      options[key] = function() { return value; };
    }
  }
  /**
   * HtmlEncodes the given value
   */
  var htmlEncodeContainer = $('<div />');
  function htmlEncode(value) {
    if (value) {
      return htmlEncodeContainer.text(value).html();
    } else {
      return '';
    }
  }

  /**
   * Returns the position of the caret in the given input field
   * http://flightschool.acylt.com/devnotes/caret-position-woes/
   */
  function doGetCaretPosition(oField) {
    var iCaretPos = 0;
    if (document.selection) {
      oField.focus ();
      var oSel = document.selection.createRange();
      oSel.moveStart ('character', -oField.value.length);
      iCaretPos = oSel.text.length;
    } else if (oField.selectionStart || oField.selectionStart == '0') {
      iCaretPos = oField.selectionStart;
    }
    return (iCaretPos);
  }

  /**
   * Initialize tagsinput behaviour on inputs and selects which have
   * data-role=tagsinput
   */
  $(function() {
    $("input[data-role=tagsinput], select[multiple][data-role=tagsinput]").tagsinput();
  });
})(window.jQuery);


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(4),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, coreModule) {
  'use strict';

  coreModule.default.controller('ValueSelectDropdownCtrl', ["$q", function($q) {
    var vm = this;

    vm.show = function() {
      vm.oldVariableText = vm.variable.current.text;
      vm.highlightIndex = -1;

      vm.options = vm.variable.options;
      vm.selectedValues = _.filter(vm.options, {selected: true});

      vm.tags = _.map(vm.variable.tags, function(value) {
        var tag = { text: value, selected: false };
        _.each(vm.variable.current.tags, function(tagObj) {
          if (tagObj.text === value) {
            tag = tagObj;
          }
        });
        return tag;
      });

      vm.search = {
        query: '',
        options: vm.options.slice(0, Math.min(vm.options.length, 1000))
      };

      vm.dropdownVisible = true;
    };

    vm.updateLinkText = function() {
      var current = vm.variable.current;

      if (current.tags && current.tags.length) {
        // filer out values that are in selected tags
        var selectedAndNotInTag = _.filter(vm.variable.options, function(option) {
          if (!option.selected) { return false; }
          for (var i = 0; i < current.tags.length; i++)  {
            var tag = current.tags[i];
            if (_.indexOf(tag.values, option.value) !== -1) {
              return false;
            }
          }
          return true;
        });

        // convert values to text
        var currentTexts = _.map(selectedAndNotInTag, 'text');

        // join texts
        vm.linkText = currentTexts.join(' + ');
        if (vm.linkText.length > 0) {
          vm.linkText += ' + ';
        }
      } else {
        vm.linkText = vm.variable.current.text;
      }
    };

    vm.clearSelections = function() {
      _.each(vm.options, function(option) {
        option.selected = false;
      });

      vm.selectionsChanged(false);
    };

    vm.selectTag = function(tag) {
      tag.selected = !tag.selected;
      var tagValuesPromise;
      if (!tag.values) {
        tagValuesPromise = vm.variable.getValuesForTag(tag.text);
      } else {
        tagValuesPromise = $q.when(tag.values);
      }

      tagValuesPromise.then(function(values) {
        tag.values = values;
        tag.valuesText = values.join(' + ');
        _.each(vm.options, function(option) {
          if (_.indexOf(tag.values, option.value) !== -1) {
            option.selected = tag.selected;
          }
        });

        vm.selectionsChanged(false);
      });
    };

    vm.keyDown = function (evt) {
      if (evt.keyCode === 27) {
        vm.hide();
      }
      if (evt.keyCode === 40) {
        vm.moveHighlight(1);
      }
      if (evt.keyCode === 38) {
        vm.moveHighlight(-1);
      }
      if (evt.keyCode === 13) {
        if (vm.search.options.length === 0) {
          vm.commitChanges();
        } else {
          vm.selectValue(vm.search.options[vm.highlightIndex], {}, true, false);
        }
      }
      if (evt.keyCode === 32) {
        vm.selectValue(vm.search.options[vm.highlightIndex], {}, false, false);
      }
    };

    vm.moveHighlight = function(direction) {
      vm.highlightIndex = (vm.highlightIndex + direction) % vm.search.options.length;
    };

    vm.selectValue = function(option, event, commitChange, excludeOthers) {
      if (!option) { return; }

      option.selected = vm.variable.multi ? !option.selected: true;

      commitChange = commitChange || false;
      excludeOthers = excludeOthers || false;

      var setAllExceptCurrentTo = function(newValue) {
        _.each(vm.options, function(other) {
          if (option !== other) { other.selected = newValue; }
        });
      };

      // commit action (enter key), should not deselect it
      if (commitChange) {
        option.selected = true;
      }

      if (option.text === 'All' || excludeOthers) {
        setAllExceptCurrentTo(false);
        commitChange = true;
      }
      else if (!vm.variable.multi) {
        setAllExceptCurrentTo(false);
        commitChange = true;
      } else if (event.ctrlKey || event.metaKey || event.shiftKey) {
        commitChange = true;
        setAllExceptCurrentTo(false);
      }

      vm.selectionsChanged(commitChange);
    };

    vm.selectionsChanged = function(commitChange) {
      vm.selectedValues = _.filter(vm.options, {selected: true});

      if (vm.selectedValues.length > 1) {
        if (vm.selectedValues[0].text === 'All') {
          vm.selectedValues[0].selected = false;
          vm.selectedValues = vm.selectedValues.slice(1, vm.selectedValues.length);
        }
      }

      // validate selected tags
      _.each(vm.tags, function(tag) {
        if (tag.selected)  {
          _.each(tag.values, function(value) {
            if (!_.find(vm.selectedValues, {value: value})) {
              tag.selected = false;
            }
          });
        }
      });

      vm.selectedTags = _.filter(vm.tags, {selected: true});
      vm.variable.current.value = _.map(vm.selectedValues, 'value');
      vm.variable.current.text = _.map(vm.selectedValues, 'text').join(' + ');
      vm.variable.current.tags = vm.selectedTags;

      if (!vm.variable.multi) {
        vm.variable.current.value = vm.selectedValues[0].value;
      }

      if (commitChange) {
        vm.commitChanges();
      }
    };

    vm.commitChanges = function() {
      // if we have a search query and no options use that
      if (vm.search.options.length === 0 && vm.search.query.length > 0) {
        vm.variable.current = {text: vm.search.query, value: vm.search.query};
      }
      else if (vm.selectedValues.length === 0) {
        // make sure one option is selected
        vm.options[0].selected = true;
        vm.selectionsChanged(false);
      }

      vm.dropdownVisible = false;
      vm.updateLinkText();

      if (vm.variable.current.text !== vm.oldVariableText) {
        vm.onUpdated();
      }
    };

    vm.queryChanged = function() {
      vm.highlightIndex = -1;
      vm.search.options = _.filter(vm.options, function(option) {
        return option.text.toLowerCase().indexOf(vm.search.query.toLowerCase()) !== -1;
      });

      vm.search.options = vm.search.options.slice(0, Math.min(vm.search.options.length, 1000));
    };

    vm.init = function() {
      vm.selectedTags = vm.variable.current.tags || [];
      vm.updateLinkText();
    };

  }]);

  coreModule.default.directive('valueSelectDropdown', ["$compile", "$window", "$timeout", "$rootScope", function($compile, $window, $timeout, $rootScope) {
    return {
      scope: { variable: "=", onUpdated: "&"},
      templateUrl: 'public/app/partials/valueSelectDropdown.html',
      controller: 'ValueSelectDropdownCtrl',
      controllerAs: 'vm',
      bindToController: true,
      link: function(scope, elem) {
        var bodyEl = angular.element($window.document.body);
        var linkEl = elem.find('.variable-value-link');
        var inputEl = elem.find('input');

        function openDropdown() {
          inputEl.css('width', Math.max(linkEl.width(), 80) + 'px');

          inputEl.show();
          linkEl.hide();

          inputEl.focus();
          $timeout(function() { bodyEl.on('click', bodyOnClick); }, 0, false);
        }

        function switchToLink() {
          inputEl.hide();
          linkEl.show();
          bodyEl.off('click', bodyOnClick);
        }

        function bodyOnClick (e) {
          if (elem.has(e.target).length === 0) {
            scope.$apply(function() {
              scope.vm.commitChanges();
            });
          }
        }

        scope.$watch('vm.dropdownVisible', function(newValue) {
          if (newValue) {
            openDropdown();
          } else {
            switchToLink();
          }
        });

        var cleanUp = $rootScope.$on('template-variable-value-updated', function() {
          scope.vm.updateLinkText();
        });

        scope.$on("$destroy", function() {
          cleanUp();
        });

        scope.vm.init();
      },
    };
  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
rebuildOnChange.$inject = ["$animate"];var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(2);


function getBlockNodes(nodes) {
    var node = nodes[0];
    var endNode = nodes[nodes.length - 1];
    var blockNodes;
    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
        if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) {
                blockNodes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()([].slice.call(nodes, 0, i));
            }
            blockNodes.push(node);
        }
    }
    return blockNodes || nodes;
}
/** @ngInject **/
function rebuildOnChange($animate) {
    return {
        multiElement: true,
        terminal: true,
        transclude: true,
        priority: 600,
        restrict: 'E',
        link: function (scope, elem, attrs, ctrl, transclude) {
            var block, childScope, previousElements;
            function cleanUp() {
                if (previousElements) {
                    previousElements.remove();
                    previousElements = null;
                }
                if (childScope) {
                    childScope.$destroy();
                    childScope = null;
                }
                if (block) {
                    previousElements = getBlockNodes(block.clone);
                    $animate.leave(previousElements).then(function () {
                        previousElements = null;
                    });
                    block = null;
                }
            }
            scope.$watch(attrs.property, function rebuildOnChangeAction(value, oldValue) {
                if (childScope && value !== oldValue) {
                    cleanUp();
                }
                if (!childScope && (value || attrs.showNull)) {
                    transclude(function (clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end rebuild on change ');
                        block = { clone: clone };
                        $animate.enter(clone, elem.parent(), elem);
                    });
                }
                else {
                    cleanUp();
                }
            });
        }
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["default"].directive('rebuildOnChange', rebuildOnChange);


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />

__WEBPACK_IMPORTED_MODULE_0__core_module__["default"].directive('giveFocus', function () {
    return function (scope, element, attrs) {
        element.click(function (e) {
            e.stopPropagation();
        });
        scope.$watch(attrs.giveFocus, function (newValue) {
            if (!newValue) {
                return;
            }
            setTimeout(function () {
                element.focus();
                var domEl = element[0];
                if (domEl.setSelectionRange) {
                    var pos = element.val().length * 2;
                    domEl.setSelectionRange(pos, pos);
                }
            }, 200);
        }, true);
    };
});
/* unused harmony default export */ var _unused_webpack_default_export = ({});


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DeltaCtrl */
/* unused harmony export delta */
/* unused harmony export LinkJSONCtrl */
/* unused harmony export linkJson */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />


var DeltaCtrl = /** @class */ (function () {
    /** @ngInject */
    DeltaCtrl.$inject = ["$rootScope"];
    function DeltaCtrl($rootScope) {
        var _this = this;
        this.$rootScope = $rootScope;
        var waitForCompile = function (mutations) {
            if (mutations.length === 1) {
                _this.$rootScope.appEvent('json-diff-ready');
            }
        };
        this.observer = new MutationObserver(waitForCompile);
        var observerConfig = {
            attributes: true,
            attributeFilter: ['class'],
            characterData: false,
            childList: true,
            subtree: false,
        };
        this.observer.observe(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.element('.delta-html')[0], observerConfig);
    }
    DeltaCtrl.prototype.$onDestroy = function () {
        this.observer.disconnect();
    };
    return DeltaCtrl;
}());

function delta() {
    return {
        controller: DeltaCtrl,
        replace: false,
        restrict: 'A',
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["default"].directive('diffDelta', delta);
// Link to JSON line number
var LinkJSONCtrl = /** @class */ (function () {
    /** @ngInject */
    LinkJSONCtrl.$inject = ["$scope", "$rootScope", "$anchorScroll"];
    function LinkJSONCtrl($scope, $rootScope, $anchorScroll) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$anchorScroll = $anchorScroll;
    }
    LinkJSONCtrl.prototype.goToLine = function (line) {
        var _this = this;
        var unbind;
        var scroll = function () {
            _this.$anchorScroll("l" + line);
            unbind();
        };
        this.$scope.switchView().then(function () {
            unbind = _this.$rootScope.$on('json-diff-ready', scroll.bind(_this));
        });
    };
    return LinkJSONCtrl;
}());

function linkJson() {
    return {
        controller: LinkJSONCtrl,
        controllerAs: 'ctrl',
        replace: true,
        restrict: 'E',
        scope: {
            line: '@lineDisplay',
            link: '@lineLink',
            switchView: '&',
        },
        template: "<a class=\"diff-linenum btn btn-inverse btn-small\" ng-click=\"ctrl.goToLine(link)\">Line {{ line }}</a>"
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["default"].directive('diffLinkJson', linkJson);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(8), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, _) {
  'use strict';

  var $win = $(window);

  $.fn.place_tt = (function () {
    var defaults = {
      offset: 5,
    };

    return function (x, y, opts) {
      opts = $.extend(true, {}, defaults, opts);

      return this.each(function () {
        var $tooltip = $(this), width, height;

        $tooltip.addClass('grafana-tooltip');

        $("#tooltip").remove();
        $tooltip.appendTo(document.body);

        if (opts.compile) {
          angular.element(document).injector().invoke(["$compile", "$rootScope", function($compile, $rootScope) {
            var tmpScope = $rootScope.$new(true);
            _.extend(tmpScope, opts.scopeData);

            $compile($tooltip)(tmpScope);
            tmpScope.$digest();
            tmpScope.$destroy();
          }]);
        }

        width = $tooltip.outerWidth(true);
        height = $tooltip.outerHeight(true);

        $tooltip.css('left', x + opts.offset + width > $win.width() ? x - opts.offset - width : x + opts.offset);
        $tooltip.css('top', y + opts.offset + height > $win.height() ? y - opts.offset - height : y + opts.offset);
      });
    };
  })();

  return $;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var templates = __webpack_require__(548);
templates.keys().forEach(function (key) {
    templates(key);
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./core/components/help/help.html": 549,
	"./core/components/navbar/navbar.html": 550,
	"./core/components/search/search.html": 551,
	"./core/components/sidemenu/sidemenu.html": 552,
	"./features/admin/partials/admin_home.html": 553,
	"./features/admin/partials/edit_org.html": 554,
	"./features/admin/partials/edit_user.html": 555,
	"./features/admin/partials/new_user.html": 556,
	"./features/admin/partials/orgs.html": 557,
	"./features/admin/partials/settings.html": 558,
	"./features/admin/partials/stats.html": 559,
	"./features/admin/partials/users.html": 560,
	"./features/alerting/partials/alert_howto.html": 561,
	"./features/alerting/partials/alert_list.html": 562,
	"./features/alerting/partials/alert_tab.html": 563,
	"./features/alerting/partials/notification_edit.html": 564,
	"./features/alerting/partials/notifications_list.html": 565,
	"./features/annotations/partials/editor.html": 566,
	"./features/annotations/partials/event_editor.html": 567,
	"./features/dashboard/dashnav/dashnav.html": 568,
	"./features/dashboard/export/export_modal.html": 569,
	"./features/dashboard/export_data/export_data_modal.html": 570,
	"./features/dashboard/history/history.html": 571,
	"./features/dashboard/import/dash_import.html": 572,
	"./features/dashboard/partials/addAnnotationModal.html": 573,
	"./features/dashboard/partials/inspector.html": 574,
	"./features/dashboard/partials/settings.html": 575,
	"./features/dashboard/partials/shareModal.html": 576,
	"./features/dashboard/row/add_panel.html": 577,
	"./features/dashboard/row/options.html": 578,
	"./features/dashboard/row/row.html": 579,
	"./features/dashboard/submenu/submenu.html": 580,
	"./features/dashboard/timepicker/dropdown.html": 581,
	"./features/dashboard/timepicker/settings.html": 582,
	"./features/dashboard/timepicker/timepicker.html": 583,
	"./features/dashlinks/editor.html": 584,
	"./features/org/partials/add_user.html": 585,
	"./features/org/partials/apikeyModal.html": 586,
	"./features/org/partials/change_password.html": 587,
	"./features/org/partials/invite.html": 588,
	"./features/org/partials/newOrg.html": 589,
	"./features/org/partials/orgApiKeys.html": 590,
	"./features/org/partials/orgDetails.html": 591,
	"./features/org/partials/orgUsers.html": 592,
	"./features/org/partials/profile.html": 593,
	"./features/org/partials/select_org.html": 594,
	"./features/panel/partials/metrics_tab.html": 595,
	"./features/panel/partials/panelTime.html": 596,
	"./features/panel/partials/query_editor_row.html": 597,
	"./features/panel/partials/soloPanel.html": 598,
	"./features/panellinks/module.html": 599,
	"./features/playlist/partials/playlist.html": 600,
	"./features/playlist/partials/playlist_search.html": 601,
	"./features/playlist/partials/playlists.html": 602,
	"./features/plugins/import_list/import_list.html": 603,
	"./features/plugins/partials/ds_edit.html": 604,
	"./features/plugins/partials/ds_http_settings.html": 605,
	"./features/plugins/partials/ds_list.html": 606,
	"./features/plugins/partials/plugin_edit.html": 607,
	"./features/plugins/partials/plugin_list.html": 608,
	"./features/plugins/partials/plugin_page.html": 609,
	"./features/plugins/partials/update_instructions.html": 610,
	"./features/snapshot/partials/snapshots.html": 611,
	"./features/styleguide/styleguide.html": 612,
	"./features/templating/partials/editor.html": 613,
	"./partials/confirm_modal.html": 614,
	"./partials/dashboard.html": 615,
	"./partials/edit_json.html": 616,
	"./partials/error.html": 617,
	"./partials/login.html": 618,
	"./partials/modal.html": 619,
	"./partials/panelgeneral.html": 620,
	"./partials/reset_password.html": 621,
	"./partials/signup_invited.html": 622,
	"./partials/signup_step2.html": 623,
	"./partials/valueSelectDropdown.html": 624,
	"./plugins/app/testdata/partials/query.editor.html": 625,
	"./plugins/datasource/cloudwatch/partials/annotations.editor.html": 626,
	"./plugins/datasource/cloudwatch/partials/config.html": 627,
	"./plugins/datasource/cloudwatch/partials/query.editor.html": 628,
	"./plugins/datasource/cloudwatch/partials/query.parameter.html": 629,
	"./plugins/datasource/elasticsearch/partials/annotations.editor.html": 630,
	"./plugins/datasource/elasticsearch/partials/bucket_agg.html": 631,
	"./plugins/datasource/elasticsearch/partials/config.html": 632,
	"./plugins/datasource/elasticsearch/partials/metric_agg.html": 633,
	"./plugins/datasource/elasticsearch/partials/query.editor.html": 634,
	"./plugins/datasource/grafana-live/partials/query.editor.html": 635,
	"./plugins/datasource/grafana/partials/annotations.editor.html": 636,
	"./plugins/datasource/grafana/partials/query.editor.html": 637,
	"./plugins/datasource/graphite/partials/annotations.editor.html": 638,
	"./plugins/datasource/graphite/partials/config.html": 639,
	"./plugins/datasource/graphite/partials/query.editor.html": 640,
	"./plugins/datasource/influxdb/partials/annotations.editor.html": 641,
	"./plugins/datasource/influxdb/partials/config.html": 642,
	"./plugins/datasource/influxdb/partials/query.editor.html": 643,
	"./plugins/datasource/mysql/partials/annotations.editor.html": 644,
	"./plugins/datasource/mysql/partials/config.html": 645,
	"./plugins/datasource/mysql/partials/query.editor.html": 646,
	"./plugins/datasource/opentsdb/partials/annotations.editor.html": 647,
	"./plugins/datasource/opentsdb/partials/config.html": 648,
	"./plugins/datasource/opentsdb/partials/query.editor.html": 649,
	"./plugins/datasource/postgres/partials/annotations.editor.html": 650,
	"./plugins/datasource/postgres/partials/config.html": 651,
	"./plugins/datasource/postgres/partials/query.editor.html": 652,
	"./plugins/datasource/prometheus/partials/annotations.editor.html": 653,
	"./plugins/datasource/prometheus/partials/config.html": 654,
	"./plugins/datasource/prometheus/partials/query.editor.html": 655,
	"./plugins/panel/alertlist/editor.html": 656,
	"./plugins/panel/alertlist/module.html": 657,
	"./plugins/panel/dashlist/editor.html": 658,
	"./plugins/panel/dashlist/module.html": 659,
	"./plugins/panel/gettingstarted/editor.html": 660,
	"./plugins/panel/gettingstarted/module.html": 661,
	"./plugins/panel/graph/axes_editor.html": 662,
	"./plugins/panel/graph/tab_display.html": 663,
	"./plugins/panel/graph/tab_legend.html": 664,
	"./plugins/panel/heatmap/module.html": 665,
	"./plugins/panel/heatmap/partials/axes_editor.html": 666,
	"./plugins/panel/heatmap/partials/display_editor.html": 667,
	"./plugins/panel/pluginlist/editor.html": 668,
	"./plugins/panel/pluginlist/module.html": 669,
	"./plugins/panel/singlestat/editor.html": 670,
	"./plugins/panel/singlestat/mappings.html": 671,
	"./plugins/panel/singlestat/module.html": 672,
	"./plugins/panel/table/column_options.html": 673,
	"./plugins/panel/table/editor.html": 674,
	"./plugins/panel/table/module.html": 675,
	"./plugins/panel/text/editor.html": 676,
	"./plugins/panel/text/module.html": 677,
	"./plugins/panel/unknown/module.html": 678
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 548;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/help/help.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-keyboard-o\"></i>\n\t\t\t<span class=p-l-1>Shortcuts</span>\n\t\t</h2>\n\n\t\t<!-- <ul class=\"gf&#45;tabs\"> -->\n\t\t<!-- \t<li class=\"gf&#45;tabs&#45;item\" ng&#45;repeat=\"tab in ['Shortcuts']\"> -->\n\t\t<!-- \t\t<a class=\"gf&#45;tabs&#45;link\" ng&#45;click=\"ctrl.tabindex = $index\" ng&#45;class=\"{active: ctrl.tabIndex === $index}\"> -->\n\t\t<!-- \t\t\t{{::tab}} -->\n\t\t<!-- \t\t</a> -->\n\t\t<!-- \t</li> -->\n\t\t<!-- </ul> -->\n\n\t\t<a class=modal-header-close ng-click=ctrl.dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=\"modal-content help-modal\">\n\n\t\t<p class=small style=position:absolute;top:13px;right:44px>\n\t\t\t<span class=shortcut-table-key>mod</span> =\n\t\t\t<span class=muted>CTRL on windows or linux and CMD key on Mac</span>\n\t\t</p>\n\n\t\t<div ng-repeat=\"(category, shortcuts) in ctrl.shortcuts\" class=shortcut-category>\n\t\t\t<table class=shortcut-table>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=shortcut-table-category-header colspan=2>{{category}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr ng-repeat=\"shortcut in shortcuts\">\n\t\t\t\t\t\t<td class=shortcut-table-keys>\n              <span class=shortcut-table-key ng-repeat=\"key in shortcut.keys track by $index\" ng-bind-html=key>\n              </span>\n            </td>\n\t\t\t\t\t\t<td class=shortcut-table-description>{{shortcut.description}}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tbody>\n\t\t\t</tbody></tbody></table>\n\t\t</div>\n\n\t\t<div class=clearfix></div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 550 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/navbar/navbar.html';
var html = "<div class=navbar-inner>\n\t<a class=\"navbar-brand-btn pointer\" ng-click=ctrl.toggleSideMenu()>\n\t\t<span class=navbar-brand-btn-background>\n\t\t\t<img src=public/img/grafana_icon.svg>\n\t\t</span>\n\t\t<i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n\t\t<i class=\"fa fa-caret-down\"></i>\n\t\t<i class=\"fa fa-chevron-left\"></i>\n\t</a>\n\n  <!-- <a class=\"navbar&#45;page&#45;btn navbar&#45;page&#45;btn&#45;&#45;search\" ng&#45;click=\"ctrl.showSearch()\"> -->\n\t<!-- \t<i class=\"fa fa&#45;search\"></i> -->\n\t<!-- </a> -->\n\n\t<div ng-if=::!ctrl.hasMenu>\n\t\t<a href={{::ctrl.section.url}} class=navbar-page-btn>\n      <i class={{::ctrl.section.icon}} ng-show=::ctrl.section.icon></i>\n      <img ng-src={{::ctrl.section.iconUrl}} ng-show=::ctrl.section.iconUrl>\n      {{::ctrl.section.title}}\n    </a>\n\t</div>\n\n  <div class=\"dropdown navbar-section-wrapper\" ng-if=::ctrl.hasMenu>\n    <a href={{::ctrl.section.url}} class=navbar-page-btn data-toggle=dropdown>\n      <i class={{::ctrl.section.icon}} ng-show=::ctrl.section.icon></i>\n      <img ng-src={{::ctrl.section.iconUrl}} ng-show=::ctrl.section.iconUrl>\n      {{::ctrl.section.title}}\n      <i class=\"fa fa-caret-down\"></i>\n    </a>\n    <ul class=\"dropdown-menu dropdown-menu--navbar\">\n      <li ng-repeat=\"navItem in ::ctrl.model.menu\" ng-class=\"{active: navItem.active}\">\n        <a class=pointer ng-href={{::navItem.url}} ng-click=\"ctrl.navItemClicked(navItem, $event)\">\n          <i class={{::navItem.icon}} ng-show=::navItem.icon></i>\n          {{::navItem.title}}\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <div ng-transclude></div>\n</div>\n\n<dashboard-search></dashboard-search>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/search/search.html';
var html = "\n<div class=search-backdrop ng-if=ctrl.isOpen></div>\n\n<div class=search-container ng-if=ctrl.isOpen>\n\n\t<div class=search-field-wrapper>\n\t\t<div class=\"search-field-icon pointer\" ng-click=ctrl.closeSearch()>\n\t\t\t<i class=\"fa fa-search\"></i>\n\t\t</div>\n\n\t\t<input type=text placeholder=\"Find dashboards by name\" give-focus=ctrl.giveSearchFocus tabindex=1 ng-keydown=ctrl.keyDown($event) ng-model=ctrl.query.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.search() ng-blur=ctrl.searchInputBlur() />\n\n\t\t<div class=search-switches>\n\t\t\t<i class=\"fa fa-filter\"></i>\n\t\t\t<a class=pointer href=\"javascript:void 0;\" ng-click=ctrl.showStarred() tabindex=2>\n\t\t\t\t<i class=\"fa fa-remove\" ng-show=ctrl.query.starred></i>\n\t\t\t\tstarred\n\t\t\t</a> |\n\t\t\t<a class=pointer href=\"javascript:void 0;\" ng-click=ctrl.getTags() tabindex=3>\n\t\t\t\t<i class=\"fa fa-remove\" ng-show=ctrl.tagsMode></i>\n\t\t\t\ttags\n\t\t\t</a>\n\t\t\t<span ng-if=ctrl.query.tag.length>\n\t\t\t\t|\n\t\t\t\t<span ng-repeat=\"tagName in ctrl.query.tag\">\n\t\t\t\t\t<a ng-click=\"ctrl.removeTag(tagName, $event)\" tag-color-from-name=tagName class=\"label label-tag\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t{{tagName}}\n\t\t\t\t\t</a>\n\t\t\t\t</span>\n\t\t\t</span>\n\t\t</div>\n\n\t\t<div class=search-field-spacer></div>\n\t</div>\n\n\t<div class=search-dropdown ng-class=\"{'search-dropdown--fade-in': ctrl.openCompleted}\">\n\t\t<div class=search-results-container ng-if=ctrl.tagsMode>\n\t\t\t<div ng-repeat=\"tag in ctrl.results\" class=pointer style=width:180px;float:left ng-class=\"{'selected': $index === ctrl.selectedIndex }\" ng-click=\"ctrl.filterByTag(tag.term, $event)\">\n\t\t\t\t<a class=\"search-result-tag label label-tag\" tag-color-from-name=tag.term>\n\t\t\t\t\t<i class=\"fa fa-tag\"></i>\n\t\t\t\t\t<span>{{tag.term}} &nbsp;({{tag.count}})</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=search-results-container ng-if=!ctrl.tagsMode>\n\t\t\t<h6 ng-hide=ctrl.results.length>No dashboards matching your query were found.</h6>\n\n\t\t\t<a class=\"search-item pointer search-item-{{row.type}}\" bindonce ng-repeat=\"row in ctrl.results\" ng-class=\"{'selected': $index == ctrl.selectedIndex}\" ng-href={{row.url}}>\n\n\t\t\t\t<span class=search-result-tags>\n\t\t\t\t\t<span ng-click=\"ctrl.filterByTag(tag, $event)\" ng-repeat=\"tag in row.tags\" tag-color-from-name=tag class=\"label label-tag\">\n\t\t\t\t\t\t{{tag}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<i class=fa ng-class=\"{'fa-star': row.isStarred, 'fa-star-o': !row.isStarred}\"></i>\n\t\t\t\t</span>\n\n\t\t\t\t<span class=search-result-link>\n\t\t\t\t\t<i class=\"fa search-result-icon\"></i>\n\t\t\t\t\t<span bo-text=row.title></span>\n\t\t\t\t</span>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class=search-button-row>\n\t\t\t<a class=\"btn btn-secondary\" href=dashboard/new ng-show=ctrl.contextSrv.isEditor ng-click=\"ctrl.isOpen = false;\">\n\t\t\t\t<i class=\"fa fa-plus\"></i>&nbsp; New Dashboard\n\t\t\t</a>\n\n\t\t\t<a class=\"btn btn-inverse\" href=\"dashboard/new/?editview=import\" ng-show=ctrl.contextSrv.isEditor ng-click=\"ctrl.isOpen = false;\">\n\t\t\t\t<i class=\"fa fa-upload\"></i>&nbsp; Import Dashboard\n\t\t\t</a>\n\n\t\t\t<a class=search-button-row-explore-link target=_blank href=\"https://grafana.com/dashboards?utm_source=grafana_search\">\n\t\t\t\tFind <img src=public/img/icn-dashboard-tiny.svg width=14 /> dashboards on Grafana.com\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/sidemenu/sidemenu.html';
var html = "<ul class=sidemenu>\n\n\t<li class=sidemenu-org-section ng-if=::ctrl.isSignedIn class=dropdown>\n\t\t<a class=sidemenu-org href=profile>\n\t\t\t<div class=sidemenu-org-avatar>\n\t\t\t\t<img ng-src={{::ctrl.user.gravatarUrl}}>\n\t\t\t\t<span class=sidemenu-org-avatar--missing>\n\t\t\t\t\t<i class=\"fa fa-fw fa-user\"></i>\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class=sidemenu-org-details>\n\t\t\t\t<span class=\"sidemenu-org-user sidemenu-item-text\">{{::ctrl.user.name}}</span>\n\t\t\t\t<span class=\"sidemenu-org-name sidemenu-item-text\">{{::ctrl.user.orgName}}</span>\n\t\t\t</div>\n\t\t</a>\n\t\t<i class=\"fa fa-caret-right\"></i>\n\t\t<ul class=dropdown-menu role=menu>\n\t\t\t<li ng-repeat=\"menuItem in ctrl.orgMenu\" ng-class=::menuItem.cssClass>\n\t\t\t\t<span ng-show=::menuItem.section>{{::menuItem.section}}</span>\n\t\t\t\t<a href={{::menuItem.url}} ng-show=::menuItem.url target={{::menuItem.target}}>\n\t\t\t\t\t<i class={{::menuItem.icon}} ng-show=::menuItem.icon></i>\n\t\t\t\t\t{{::menuItem.text}}\n\t\t\t\t</a>\n\t\t\t</li>\n            <li ng-show=\"ctrl.orgs.length > ctrl.maxShownOrgs\" style=margin-left:10px;width:90%>\n                <span class=sidemenu-item-text>Max shown : {{::ctrl.maxShownOrgs}}</span>\n                <input ng-model=::ctrl.orgFilter style=padding-left:5px type=text ng-change=::ctrl.loadOrgsItems(); class=\"gf-input-small width-12\" placeholder=Filter>\n            </li>\n            <li ng-repeat=\"orgItem in ctrl.orgItems\" ng-class=::orgItem.cssClass>\n\t\t\t\t<a href={{::orgItem.url}} ng-show=::orgItem.url target={{::orgItem.target}}>\n\t\t\t\t\t<i class={{::orgItem.icon}} ng-show=::orgItem.icon></i>\n\t\t\t\t\t{{::orgItem.text}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</li>\n\n\t<li ng-repeat=\"item in ::ctrl.mainLinks\" class=dropdown>\n\t\t<a href={{::item.url}} class=\"sidemenu-item sidemenu-main-link\" target={{::item.target}}>\n\t\t\t<span class=\"icon-circle sidemenu-icon\">\n\t\t\t\t<i class={{::item.icon}} ng-show=::item.icon></i>\n\t\t\t\t<img ng-src={{::item.img}} ng-show=::item.img>\n\t\t\t</span>\n\t\t\t<span class=sidemenu-item-text>{{::item.text}}</span>\n\t\t\t<span class=\"fa fa-caret-right\" ng-if=::item.children></span>\n\t\t</a>\n\t\t<ul class=dropdown-menu role=menu ng-if=::item.children>\n\t\t\t<li ng-repeat=\"child in ::item.children\" ng-class=\"{divider: child.divider}\">\n\t\t\t\t<a href={{::child.url}}>\n\t\t\t\t\t<i class={{::child.icon}} ng-show=::child.icon></i>\n\t\t\t\t\t{{::child.text}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</li>\n\n\t<li ng-show=::!ctrl.isSignedIn>\n    <a href={{ctrl.loginUrl}} class=sidemenu-item target=_self>\n\t\t\t<span class=\"icon-circle sidemenu-icon\"><i class=\"fa fa-fw fa-sign-in\"></i></span>\n\t\t\t<span class=sidemenu-item-text>Sign in</span>\n\t\t</a>\n\t</li>\n\n\t<li>\n\t\t<a class=sidemenu-item target=_self ng-hide=ctrl.contextSrv.pinned ng-click=ctrl.contextSrv.setPinnedState(true)>\n\t\t\t<span class=\"icon-circle sidemenu-icon\"><i class=\"fa fa-fw fa-thumb-tack\"></i></span>\n\t\t\t<span class=sidemenu-item-text>Pin</span>\n\t\t</a>\n\t</li>\n</ul>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/admin_home.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>\n\t\t\tServer Administration\n\t\t</h1>\n\t</div>\n\n\t<a class=\"btn btn-inverse\" href=admin/users>\n\t\tManage Users\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=admin/orgs>\n\t\tManage Organizations\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=admin/settings>\n\t\tView Server Settings\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=admin/stats>\n\t\tView Server Stats\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=styleguide>\n\t  Style guide\n\t</a>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/edit_org.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Edit Organization</h1>\n\t</div>\n\n\t<form name=orgDetailsForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t<input type=text required ng-model=org.name class=\"gf-form-input max-width-14\">\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=update() ng-show=!createMode>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Organization Users</h3>\n\n\t<table class=grafana-options-table>\n\t\t<tr>\n\t\t\t<th>Username</th>\n\t\t\t<th>Email</th>\n\t\t\t<th>Role</th>\n\t\t\t<th></th>\n\t\t</tr>\n\t\t<tr ng-repeat=\"orgUser in orgUsers\">\n\t\t\t<td>{{orgUser.login}}</td>\n\t\t\t<td>{{orgUser.email}}</td>\n\t\t\t<td>\n\t\t\t\t<select type=text ng-model=orgUser.role class=\"gf-form-input max-width-8\" ng-options=\"f for f in ['Viewer', 'Editor', 'Read Only Editor', 'Admin']\" ng-change=updateOrgUser(orgUser)>\n\t\t\t\t</select>\n\t\t\t</td>\n\t\t\t<td style=width:1%>\n\t\t\t\t<a ng-click=removeOrgUser(orgUser) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/edit_user.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Edit User</h1>\n\t</div>\n\n\t<form name=userForm class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t\t<input type=text required ng-model=user.name class=\"gf-form-input max-width-25\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Email</span>\n\t\t\t\t<input type=email ng-model=user.email class=\"gf-form-input max-width-25\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Username</span>\n\t\t\t\t<input type=text ng-model=user.login class=\"gf-form-input max-width-25\">\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=update() ng-show=!createMode>Update</button>\n\t\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Change password</h3>\n\n\t<form name=passwordForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">New password</span>\n\t\t\t\t<input type=password required ng-minlength=4 ng-model=password class=\"gf-form-input max-width-25\">\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=setPassword()>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Permissions</h3>\n\n\t<form name=passwordForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<gf-form-switch class=gf-form label=\"Grafana Admin\" checked=permissions.isGrafanaAdmin switch-class=max-width-6></gf-form-switch>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=updatePermissions()>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Organizations</h3>\n\n\t<form name=addOrgForm class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-12\">Add organization</span>\n\t\t\t\t<input type=text ng-model=newOrg.name bs-typeahead=searchOrgs required class=\"gf-form-input max-width-20\" placeholder=\"organization name\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Role</span>\n\t\t\t\t<select type=text ng-model=newOrg.role class=\"gf-form-input width-10\" ng-options=\"f for f in ['Viewer', 'Editor', 'Read Only Editor', 'Admin']\"></select>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn btn-success gf-form-btn\" ng-click=addOrgUser()>Add</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t<table class=grafana-options-table>\n\t\t<tr>\n\t\t\t<th>Name</th>\n\t\t\t<th>Role</th>\n\t\t\t<th></th>\n\t\t</tr>\n\t\t<tr ng-repeat=\"org in orgs\">\n\t\t\t<td>\n\t\t\t\t{{org.name}} <span class=\"label label-info\" ng-show=\"org.orgId === user.orgId\">Current</span>\n\t\t\t</td>\n\t\t\t<td>\n\t\t\t\t<select type=text ng-model=org.role class=\"gf-form-input max-width-12\" ng-options=\"f for f in ['Viewer', 'Editor', 'Read Only Editor', 'Admin']\" ng-change=updateOrgUser(org)>\n\t\t\t\t</select>\n\t\t\t</td>\n\t\t\t<td style=width:1%>\n\t\t\t\t<a ng-click=removeOrgUser(org) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 556 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/new_user.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Add new user</h1>\n\t</div>\n\n\t<form name=userForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t<input type=text required ng-model=user.name class=\"gf-form-input max-width-20\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Email</span>\n\t\t\t<input type=email ng-model=user.email class=\"gf-form-input max-width-20\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Username</span>\n\t\t\t<input type=text ng-model=user.login class=\"gf-form-input max-width-20\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Password</span>\n\t\t\t<input type=password required ng-model=user.password class=\"gf-form-input max-width-20\">\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=create()>Create</button>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/orgs.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Organizations</h1>\n\t</div>\n\n\t<table class=\"filter-table form-inline\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Id</th>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th></th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"org in orgs\">\n\t\t\t\t<td>{{org.id}}</td>\n\t\t\t\t<td>{{org.name}}</td>\n\t\t\t\t<td class=text-right>\n\t\t\t\t\t<a href=admin/orgs/edit/{{org.id}} class=\"btn btn-inverse btn-small\">\n\t\t\t\t\t\t<i class=\"fa fa-edit\"></i>\n\t\t\t\t\t\tEdit\n\t\t\t\t\t</a>\n\t\t\t\t\t&nbsp;&nbsp;\n\t\t\t\t\t<a ng-click=deleteOrg(org) class=\"btn btn-danger btn-small\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 558 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/settings.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Server settings</h1>\n\t</div>\n\n\t\t<div class=\"grafana-info-box span8\" style=\"margin:20px 0 25px 0\">\n\t\t\tThese system settings are defined in grafana.ini or custom.ini (or overridden in ENV variables).\n\t\t\tTo change these you currently need to restart grafana.\n\t\t</div>\n\n\t\t<table class=grafana-options-table>\n\t\t\t<tr ng-repeat-start=\"(secName, secValue) in settings\">\n\t\t\t\t<td class=admin-settings-section>{{secName}}</td>\n\t\t\t\t<td></td>\n\t\t\t</tr>\n\t\t\t<tr ng-repeat=\"(keyName, keyValue) in secValue\" ng-repeat-end>\n\t\t\t\t<td style=padding-left:25px>{{keyName}}</td>\n\t\t\t\t<td>{{keyValue}}</td>\n\t\t\t</tr>\n\t\t</table>\n</div>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 559 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/stats.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Stats</h1>\n\t</div>\n\n\t<table class=\"filter-table form-inline\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>Value</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr>\n\t\t\t\t<td>Total dashboards</td>\n\t\t\t\t<td>{{ctrl.stats.dashboards}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total users</td>\n\t\t\t\t<td>{{ctrl.stats.users}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Active users (seen last 14 days)</td>\n\t\t\t\t<td>{{ctrl.stats.activeUsers}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total organizations</td>\n\t\t\t\t<td>{{ctrl.stats.orgs}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total datasources</td>\n\t\t\t\t<td>{{ctrl.stats.datasources}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total playlists</td>\n\t\t\t\t<td>{{ctrl.stats.playlists}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total snapshots</td>\n\t\t\t\t<td>{{ctrl.stats.snapshots}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total dashboard tags</td>\n\t\t\t\t<td>{{ctrl.stats.tags}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total starred dashboards</td>\n\t\t\t\t<td>{{ctrl.stats.stars}}</td>\n\t\t\t</tr>\n      <tr>\n\t\t\t\t<td>Total alerts</td>\n\t\t\t\t<td>{{ctrl.stats.alerts}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/users.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n  <div class=page-header>\n    <h1>Users</h1>\n\n    <a class=\"btn btn-success\" href=admin/users/create>\n      <i class=\"fa fa-plus\"></i>\n      Add new user\n    </a>\n  </div>\n\n  <div class=\"gf-form pull-right gf-form-group\">\n\t\t<label class=gf-form-label>Search</label>\n    <span style=position:relative>\n      <input class=\"gf-form-input width-15\" type=text placeholder=\"Find user by name/login/email\" tabindex=1 give-focus=true ng-model=ctrl.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.getUsers() />\n    </span>\n  </div>\n\n  <div class=admin-list-table>\n    <table class=\"filter-table form-inline\">\n      <thead>\n        <tr>\n          <th>Id</th>\n          <th>Name</th>\n          <th>Login</th>\n          <th>Email</th>\n          <th>\n\t\t\t\t\t\tSeen\n\t\t\t\t\t\t<tip>Time since user was seen using Grafana</tip>\n\t\t\t\t\t</th>\n          <th></th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"user in ctrl.users\">\n          <td>{{user.id}}</td>\n          <td>{{user.name}}</td>\n          <td>{{user.login}}</td>\n          <td>{{user.email}}</td>\n          <td>\n\t\t\t\t\t\t{{user.lastSeenAtAge}}\n\t\t\t\t\t</td>\n          <td>\n\t\t\t\t\t\t<i class=\"fa fa-shield\" ng-show=user.isAdmin bs-tooltip=\"'Grafana Admin'\"></i>\n\t\t\t\t\t</td>\n          <td class=text-right>\n            <a href=admin/users/edit/{{user.id}} class=\"btn btn-inverse btn-small\">\n              <i class=\"fa fa-edit\"></i>\n              Edit\n            </a>\n            &nbsp;&nbsp;\n            <a ng-click=ctrl.deleteUser(user) class=\"btn btn-danger btn-small\">\n              <i class=\"fa fa-remove\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n\n    </table>\n  </div>\n\n  <div class=admin-list-paging ng-if=ctrl.showPaging>\n    <ol>\n      <li ng-repeat=\"page in ctrl.pages\">\n        <button class=\"btn btn-small\" ng-class=\"{'btn-secondary': page.current, 'btn-inverse': !page.current}\" ng-click=ctrl.navigateToPage(page)>{{page.page}}</button>\n      </li>\n    </ol>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/alert_howto.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-info-circle\"></i>\n\t\t\t<span class=p-l-1>Adding an Alert</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\n\t<div class=modal-content>\n\t\t<div class=text-center>\n\t\t\t<img src=public/img/alert_howto_new.png>\n\t\t</div>\n\t\t<p class=\"p-a-2 text-center offset-lg-1 col-lg-10\">\n\t\t\tAlerts are added and configured in the <strong>Alert Tab</strong> of any dashboard\n\t\t\tgraph panel, letting you build and visualize an alert using existing queries.\n\t\t\t<br> <br>\n\t\t\tTo persist your alert rule changes remember to save the dashboard.\n\t\t\t<br>\n\t\t\t<br>\n\t\t\t<a href={{appSubUrl}} class=external-link ng-click=dismiss()>Go to Home Dashboard</a>\n\t\t</p>\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/alert_list.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n  <div class=page-header>\n    <h1>Alert List</h1>\n    <a class=\"btn btn-inverse\" ng-click=ctrl.openHowTo()>\n      <i class=\"fa fa-info-circle\"></i>\n      How to add an alert\n    </a>\n\n    <a class=\"btn btn-inverse\" href=alerting/notifications>\n      <i class=\"fa fa-cog\"></i>\n      Configure notifications\n    </a>\n  </div>\n\n  <div class=gf-form-group>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=gf-form-label>Filter by state</label>\n        <div class=\"gf-form-select-wrapper width-13\">\n          <select class=gf-form-input ng-model=ctrl.filters.state ng-options=\"f.value as f.text for f in ctrl.stateFilters\" ng-change=ctrl.filtersChanged()>\n          </select>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <section class=\"card-section card-list-layout-list\">\n\n    <ol class=card-list>\n      <li class=card-item-wrapper ng-repeat=\"alert in ctrl.alerts\">\n        <div class=\"card-item card-item--alert\">\n          <div class=card-item-header>\n            <div class=card-item-type>\n              <a class=card-item-cog bs-tooltip=\"'Pausing an alert rule prevents it from executing'\" ng-click=ctrl.pauseAlertRule(alert.id)>\n                <i ng-show=\"alert.state !== 'paused'\" class=\"fa fa-pause\"></i>\n                <i ng-show=\"alert.state === 'paused'\" class=\"fa fa-play\"></i>\n              </a>\n              <a class=card-item-cog href=\"dashboard/{{alert.dashboardUri}}?panelId={{alert.panelId}}&fullscreen&edit&tab=alert\" bs-tooltip=\"'Edit alert rule'\">\n                <i class=\"icon-gf icon-gf-settings\"></i>\n              </a>\n            </div>\n          </div>\n          <div class=card-item-body>\n            <div class=card-item-details>\n              <div class=card-item-name>\n                <a href=\"dashboard/{{alert.dashboardUri}}?panelId={{alert.panelId}}&fullscreen&edit&tab=alert\">\n                  {{alert.name}}\n                </a>\n              </div>\n              <div class=card-item-sub-name>\n                <span class=\"alert-list-item-state {{alert.stateModel.stateClass}}\">\n                  <i class={{alert.stateModel.iconClass}}></i>\n                  {{alert.stateModel.text}} <span class=\"small muted\" ng-show=alert.no_data>(due to no data)</span>\n                </span> for {{alert.newStateDateAgo}}\n              </div>\n              <div class=\"small muted\" ng-show=\"alert.executionError !== ''\">\n                Error: \"{{alert.executionError}}\"\n              </div>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ol>\n  </section>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 563 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/alert_tab.html';
var html = "<div class=edit-tab-with-sidemenu ng-if=ctrl.alert>\n\t<aside class=edit-sidemenu-aside>\n\t\t<ul class=edit-sidemenu>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 0}\">\n\t\t\t\t<a ng-click=ctrl.changeTabIndex(0)>Alert Config</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 1}\">\n\t\t\t\t<a ng-click=ctrl.changeTabIndex(1)>\n\t\t\t\t\tNotifications <span class=muted>({{ctrl.alertNotifications.length}})</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 2}\">\n\t\t\t\t<a ng-click=ctrl.changeTabIndex(2)>State history</a>\n\t\t\t</li>\n      \t\t\t<li>\n\t\t\t\t<a ng-click=ctrl.delete()>Delete</a>\n\t\t\t</li>\n\t\t</ul>\n\t</aside>\n\n\t<div class=edit-tab-content>\n\t\t<div ng-if=\"ctrl.subTabIndex === 0\">\n\t\t\t<div class=\"alert alert-error m-b-2\" ng-show=ctrl.error>\n\t\t\t\t<i class=\"fa fa-warning\"></i> {{ctrl.error}}\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<h5 class=section-heading>Alert Config</h5>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-6\">Name</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-20\" ng-model=ctrl.alert.name>\n\t\t\t\t\t<span class=gf-form-label>Evaluate every</span>\n\t\t\t\t\t<input class=\"gf-form-input max-width-5\" type=text ng-model=ctrl.alert.frequency>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<h5 class=section-heading>Conditions</h5>\n\t\t\t\t<div class=gf-form-inline ng-repeat=\"conditionModel in ctrl.conditionModels\">\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<metric-segment-model css-class=\"query-keyword width-5\" ng-if=$index property=conditionModel.operator.type options=ctrl.evalOperators custom=false></metric-segment-model>\n\t\t\t\t\t\t<span class=\"gf-form-label query-keyword width-5\" ng-if=\"$index===0\">WHEN</span>\n\t\t\t\t\t</div>\n          \t\t\t<div class=gf-form>\n\t\t\t\t\t\t<query-part-editor class=\"gf-form-label query-part width-9\" part=conditionModel.reducerPart handle-event=\"ctrl.handleReducerPartEvent(conditionModel, $event)\">\n\t\t\t\t\t\t</query-part-editor>\n            \t\t\t<span class=\"gf-form-label query-keyword\">OF</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<query-part-editor class=\"gf-form-label query-part\" part=conditionModel.queryPart handle-event=\"ctrl.handleQueryPartEvent(conditionModel, $event)\">\n\t\t\t\t\t\t</query-part-editor>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<metric-segment-model property=conditionModel.evaluator.type options=ctrl.evalFunctions custom=false css-class=query-keyword on-change=ctrl.evaluatorTypeChanged(conditionModel.evaluator)></metric-segment-model>\n\t\t\t\t\t\t<input class=\"gf-form-input max-width-9\" type=number step=any ng-hide=\"conditionModel.evaluator.params.length === 0\" ng-model=conditionModel.evaluator.params[0] ng-change=ctrl.evaluatorParamsChanged()>\n            \t\t\t<label class=\"gf-form-label query-keyword\" ng-show=\"conditionModel.evaluator.params.length === 2\">TO</label>\n            \t\t\t<input class=\"gf-form-input max-width-9\" type=number step=any ng-if=\"conditionModel.evaluator.params.length === 2\" ng-model=conditionModel.evaluator.params[1] ng-change=ctrl.evaluatorParamsChanged()>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t\t\t<a class=pointer tabindex=1 ng-click=ctrl.removeCondition($index)>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label dropdown\">\n\t\t\t\t\t\t<a class=\"pointer dropdown-toggle\" data-toggle=dropdown>\n\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<ul class=dropdown-menu role=menu>\n\t\t\t\t\t\t\t<li ng-repeat=\"ct in ctrl.conditionTypes\" role=menuitem>\n\t\t\t\t\t\t\t\t<a ng-click=ctrl.addCondition(ct.value);>{{ct.text}}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<div class=gf-form>\n          \t\t\t<span class=\"gf-form-label width-18\">If no data or all values are null</span>\n          \t\t\t<span class=\"gf-form-label query-keyword\">SET STATE TO</span>\n\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.alert.noDataState ng-options=\"f.value as f.text for f in ctrl.noDataModes\">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n          \t\t\t<span class=\"gf-form-label width-18\">If execution error or timeout</span>\n          \t\t\t<span class=\"gf-form-label query-keyword\">SET STATE TO</span>\n\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.alert.executionErrorState ng-options=\"f.value as f.text for f in ctrl.executionErrorModes\">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<button class=\"btn btn-inverse\" ng-click=ctrl.test()>\n\t\t\t\t\t\tTest Rule\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group ng-if=ctrl.testing>\n\t\t\t\tEvaluating rule <i class=\"fa fa-spinner fa-spin\"></i>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group ng-if=ctrl.testResult>\n\t\t\t\t<json-tree root-name=result object=ctrl.testResult start-expanded=true></json-tree>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group ng-if=\"ctrl.subTabIndex === 1\">\n\t\t\t<h5 class=section-heading>Notifications</h5>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=\"gf-form max-width-30\">\n\t\t\t\t\t<span class=\"gf-form-label width-8\">Send to</span>\n\t\t\t\t\t<span class=gf-form-label ng-repeat=\"nc in ctrl.alertNotifications\" ng-style=\"{'background-color': nc.bgColor }\">\n\t\t\t\t\t\t<i class={{nc.iconClass}}></i>&nbsp;{{nc.name}}&nbsp;\n\t\t\t\t\t\t<i class=\"fa fa-remove pointer muted\" ng-click=ctrl.removeNotification($index) ng-if=\"nc.isDefault === false\"></i>\n\t\t\t\t\t</span>\n\t\t\t\t\t<metric-segment segment=ctrl.addNotificationSegment get-options=ctrl.getNotifications() on-change=ctrl.notificationAdded()></metric-segment>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form gf-form--v-stretch\">\n\t\t\t\t<span class=\"gf-form-label width-8\">Message</span>\n\t\t\t\t<textarea class=gf-form-input rows=10 ng-model=ctrl.alert.message placeholder=\"Notification message details...\"></textarea>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group style=max-width:720px ng-if=\"ctrl.subTabIndex === 2\">\n\t\t\t<button class=\"btn btn-mini btn-danger pull-right\" ng-click=ctrl.clearHistory()><i class=\"fa fa-trash\"></i>&nbsp;Clear history</button>\n      \t\t<h5 class=section-heading style=whitespace:nowrap>\n\t\t\t\tState history <span class=\"muted small\">(last 50 state changes)</span>\n\t\t\t</h5>\n\n\t\t\t<div ng-show=\"ctrl.alertHistory.length === 0\">\n\t\t\t\t<br>\n\t\t\t\t<i>No state changes recorded</i>\n\t\t\t</div>\n\n\t\t\t<section class=\"card-section card-list-layout-list\">\n\t\t\t\t<ol class=card-list>\n\t\t\t\t\t<li class=card-item-wrapper ng-repeat=\"ah in ctrl.alertHistory\">\n\t\t\t\t\t\t<div class=\"alert-list card-item card-item--alert\">\n\t\t\t\t\t\t\t<div class=alert-list-body>\n\t\t\t\t\t\t\t\t<div class=\"alert-list-icon alert-list-item-state {{ah.stateModel.stateClass}}\">\n\t\t\t\t\t\t\t\t\t<i class={{ah.stateModel.iconClass}}></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"alert-list-main alert-list-text\">\n\t\t\t\t\t\t\t\t\t<span class=\"alert-list-state {{ah.stateModel.stateClass}}\">{{ah.stateModel.text}}</span>\n\t\t\t\t\t\t\t\t\t<span class=alert-list-info>{{ah.info}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"alert-list-footer alert-list-text\">\n\t\t\t\t\t\t\t\t<span>{{ah.time}}</span>\n\t\t\t\t\t\t\t\t<span><!--Img Link--></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</section>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group ng-if=!ctrl.alert>\n\t<div class=gf-form-button-row>\n\t\t<button class=\"btn btn-inverse\" ng-click=ctrl.enable()>\n\t\t\t<i class=\"icon-gf icon-gf-alert\"></i>\n\t\t\tCreate Alert\n\t\t</button>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/notification_edit.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n  <div class=page-header>\n    <h1 ng-show=ctrl.model.id>Edit Channel</h1>\n    <h1 ng-show=!ctrl.model.id>New Channel</h1>\n  </div>\n\n  <form name=ctrl.theForm ng-if=ctrl.notifiers>\n    <div class=gf-form-group>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-12\">Name</span>\n        <input type=text required class=\"gf-form-input max-width-15\" ng-model=ctrl.model.name required>\n      </div>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-12\">Type</span>\n        <div class=\"gf-form-select-wrapper width-15\">\n          <select class=gf-form-input ng-model=ctrl.model.type ng-options=\"t.type as t.name for t in ctrl.notifiers\" ng-change=\"ctrl.typeChanged(notification, $index)\">\n          </select>\n        </div>\n      </div>\n      <gf-form-switch class=gf-form label=\"Send on all alerts\" label-class=width-12 checked=ctrl.model.isDefault tooltip=\"Use this notification for all alerts\">\n      </gf-form-switch>\n      <gf-form-switch class=gf-form label=\"Include image\" label-class=width-12 checked=ctrl.model.settings.uploadImage tooltip=\"Captures an image and include it in the notification\">\n      </gf-form-switch>\n    </div>\n\n    <div class=gf-form-group ng-include src=ctrl.notifierTemplateId>\n    </div>\n\n    <div class=gf-form-group>\n      <div class=gf-form-inline>\n        <div class=\"gf-form width-8\">\n          <button type=submit ng-click=ctrl.save() class=\"btn btn-success width-7\">Save</button>\n        </div>\n        <div class=\"gf-form width-8\">\n          <button type=submit ng-click=ctrl.testNotification() class=\"btn btn-secondary width-7\">Send Test</button>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 565 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/notifications_list.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Notification channels</h1>\n    <a href=alerting/notification/new class=\"btn btn-success pull-right\">\n      <i class=\"fa fa-plus\"></i>\n      New Channel\n    </a>\n  </div>\n\n\t<table class=grafana-options-table>\n\t\t<thead>\n\t\t\t<th style=min-width:200px><strong>Name</strong></th>\n\t\t\t<th style=min-width:100px>Type</th>\n\t\t\t<th style=width:1%></th>\n\t\t</thead>\n\t\t<tr ng-repeat=\"notification in ctrl.notifications\">\n\t\t\t<td>\n\t\t\t\t<a href=alerting/notification/{{notification.id}}/edit>\n\t\t\t\t\t{{notification.name}}\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t\t<td>\n\t\t\t\t{{notification.type}}\n\t\t\t</td>\n\t\t\t<td class=text-right>\n\t\t\t\t<span class=\"btn btn-secondary btn-small\" ng-show=\"notification.isDefault == true\">\n\t\t\t\t\tdefault\n\t\t\t\t</span>\n\t\t\t\t<a href=alerting/notification/{{notification.id}}/edit class=\"btn btn-inverse btn-small\">\n\t\t\t\t\t<i class=\"fa fa-edit\"></i>\n\t\t\t\t\tedit\n\t\t\t\t</a>\n\t\t\t\t<a ng-click=ctrl.deleteNotification(notification.id) class=\"btn btn-danger btn-small\">\n          <i class=\"fa fa-remove\"></i>\n        </a>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

var path = 'public/app/features/annotations/partials/editor.html';
var html = "<div ng-controller=AnnotationsEditorCtrl>\n\t<div class=tabbed-view-header>\n\t\t<h2 class=tabbed-view-title>\n\t\t\tAnnotations\n\t\t</h2>\n\n\t\t<ul class=gf-tabs>\n\t\t\t<li class=gf-tabs-item>\n\t\t\t\t<a class=gf-tabs-link ng-click=\"ctrl.mode = 'list';\" ng-class=\"{active: ctrl.mode === 'list'}\">\n\t\t\t\t\tQueries\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li class=gf-tabs-item ng-show=\"ctrl.mode === 'edit'\">\n\t\t\t\t<a class=gf-tabs-link ng-class=\"{active: ctrl.mode === 'edit'}\">\n\t\t\t\t\tEdit Query\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li class=gf-tabs-item ng-show=\"ctrl.mode === 'new'\">\n\t\t\t\t<span class=\"active gf-tabs-link\">New Query</span>\n\t\t\t</li>\n\n\t\t\t<li class=gf-tabs-item>\n        <a class=gf-tabs-link ng-click=\"ctrl.mode = 'help';\" ng-class=\"{active: ctrl.mode === 'help'}\">\n          Help\n        </a>\n      </li>\n\t\t</ul>\n\n\t\t<button class=tabbed-view-close-btn ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</button>\n\t</div>\n\n\t<div class=tabbed-view-body>\n\n\t\t<div ng-show=\"ctrl.mode === 'help'\">\n\t\t\t<div class=\"grafana-info-box col-lg-8\">\n\t\t\t\t<h5>What are Annotations?</h5>\n\t\t\t\t<p>\n\t\t\t\t\tAnnotations provide a way to integrate event data into your graphs. They are visualized as vertical lines and icons\n\t\t\t\t\ton all graph panels. When you hover over an annotation icon you can get title, tags, and text information for the event.\n\t\t\t\t\tIn the <i>Queries</i> tab you can add queries that return annotation events.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tYou can add annotations directly from grafana by holding CTRL or CMD + click on graph (or drag region). These will be stored in Grafana's annotation database.\n\t\t\t\t</p>\n\t\t\t\tCheckout the <a class=external-link target=_blank href=http://docs.grafana.org/reference/annotations/ >Annotations documentation</a> for more information.\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"editor-row row\" ng-if=\"ctrl.mode === 'list'\">\n\t\t\t<div ng-if=\"ctrl.annotations.length === 0\">\n\t\t\t\t<em>No annotation queries defined</em>\n\t\t\t</div>\n\t\t\t<table class=grafana-options-table>\n\t\t\t\t<tr ng-repeat=\"annotation in ctrl.annotations\">\n\t\t\t\t\t<td style=width:90% ng-hide=annotation.builtIn>\n\t\t\t\t\t\t<i class=\"fa fa-comment\" style=color:{};></i> &nbsp;\n\t\t\t\t\t\t{{annotation.name}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=width:90% ng-show=annotation.builtIn>\n\t\t\t\t\t\t<i class=\"fa fa-comment\"></i> &nbsp;\n\t\t\t\t\t\t<em class=muted>{{annotation.name}} (Built-in)</em>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=width:1%><i ng-click=_.move(ctrl.annotations,$index,$index-1) ng-hide=$first class=\"pointer fa fa-arrow-up\"></i></td>\n\t\t\t\t\t<td style=width:1%><i ng-click=_.move(ctrl.annotations,$index,$index+1) ng-hide=$last class=\"pointer fa fa-arrow-down\"></i></td>\n\t\t\t\t\t<td style=width:1%>\n\t\t\t\t\t\t<a ng-click=ctrl.edit(annotation) class=\"btn btn-inverse btn-mini\">\n\t\t\t\t\t\t\t<i class=\"fa fa-edit\"></i>\n\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=width:1%>\n\t\t\t\t\t\t<a ng-click=ctrl.removeAnnotation(annotation) class=\"btn btn-danger btn-mini\" ng-hide=annotation.builtIn>\n\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=gf-form ng-show=\"ctrl.mode === 'list'\">\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<a type=button class=\"btn gf-form-button btn-success\" ng-click=ctrl.setupNew()><i class=\"fa fa-plus\"></i>&nbsp;&nbsp;New</a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=annotations-basic-settings ng-if=\"ctrl.mode === 'edit' || ctrl.mode === 'new'\">\n\t\t\t<div>\n\t\t\t\t<div class=gf-form-group>\n\t\t\t\t\t<h5 class=section-heading>General</h5>\n\t\t\t\t\t<div class=gf-form-inline>\n\t\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t\t\t\t\t<input type=text class=\"gf-form-input width-20\" ng-model=ctrl.currentAnnotation.name placeholder=name>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t\t<span class=\"gf-form-label width-7\">Data source</span>\n\t\t\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.currentAnnotation.datasource ng-options=\"f.name as f.name for f in ctrl.datasources\" ng-change=ctrl.datasourceChanged()></select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-group>\n\t\t\t\t\t<div class=gf-form-inline>\n\t\t\t\t\t\t<gf-form-switch class=gf-form label=Enabled checked=ctrl.currentAnnotation.enable on-change=ctrl.annotationEnabledChange() label-class=width-7>\n\t\t\t\t\t\t</gf-form-switch>\n\t\t\t\t\t\t<gf-form-switch class=gf-form label=Hidden tooltip=\"Hides the annotation query toggle from showing at the top of the dashboard\" checked=ctrl.currentAnnotation.hide on-change=ctrl.annotationHiddenChanged() label-class=width-7>\n\t\t\t\t\t\t</gf-form-switch>\n\t\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t\t<label class=\"gf-form-label width-9\">Color</label>\n\t\t\t\t\t\t\t<span class=gf-form-label>\n\t\t\t\t\t\t\t\t<color-picker color=ctrl.currentAnnotation.iconColor onchange=ctrl.onColorChange></color-picker>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<h5 class=section-heading>Query</h5>\n\t\t\t<rebuild-on-change property=ctrl.currentDatasource>\n\t\t\t\t<plugin-component type=annotations-query-ctrl>\n\t\t\t\t</plugin-component>\n\t\t\t</rebuild-on-change>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<div class=\"gf-form-button-row p-y-0\">\n\t\t\t\t\t<button ng-show=\"ctrl.mode === 'new'\" type=button class=\"btn gf-form-button btn-success\" ng-click=ctrl.add()>Add</button>\n\t\t\t\t\t<button ng-show=\"ctrl.mode === 'edit'\" type=button class=\"btn btn-success pull-left\" ng-click=ctrl.update()>Update</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

var path = 'public/app/features/annotations/partials/event_editor.html';
var html = "\n<div class=graph-annotation>\n\t<div class=graph-annotation__header>\n\t\t<div class=graph-annotation__user bs-tooltip=\"'Created by {{ctrl.login}}'\">\n\t\t</div>\n\n\t\t<div class=graph-annotation__title>\n\t\t\t<span ng-if=!ctrl.event.id>Add Annotation</span>\n\t\t\t<span ng-if=ctrl.event.id>Edit Annotation</span>\n\t\t</div>\n\n    <div class=graph-annotation__time>{{ctrl.timeFormated}}</div>\n\t</div>\n\n\t<form name=ctrl.form class=\"graph-annotation__body text-center\">\n\t\t<div style=display:inline-block>\n\t\t\t<div class=\"gf-form gf-form--v-stretch\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Description</span>\n\t\t\t\t<textarea class=\"gf-form-input width-20\" rows=2 ng-model=ctrl.event.text placeholder=Description></textarea>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Tags</span>\n\t\t\t\t<bootstrap-tagsinput ng-model=ctrl.event.tags tagclass=\"label label-tag\" placeholder=\"add tags\">\n\t\t\t\t</bootstrap-tagsinput>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.save()>Save</button>\n\t\t\t\t<button ng-if=ctrl.event.id type=submit class=\"btn btn-danger\" ng-click=ctrl.delete()>Delete</button>\n\t\t\t\t<a class=btn-text ng-click=ctrl.close();>Cancel</a>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 568 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/dashnav/dashnav.html';
var html = "<div class=navbar>\n\t<div class=navbar-inner>\n\t\t<a class=\"navbar-brand-btn pointer\" ng-click=ctrl.toggleSideMenu()>\n\t\t\t<span class=navbar-brand-btn-background>\n\t\t\t\t<img src=public/img/grafana_icon.svg>\n\t\t\t</span>\n\t\t\t<i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n\t\t\t<i class=\"fa fa-caret-down\"></i>\n\t\t\t<i class=\"fa fa-chevron-left\"></i>\n\t\t</a>\n\n\t\t<div class=navbar-section-wrapper>\n\t\t\t<a class=navbar-page-btn ng-click=ctrl.showSearch()>\n\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>\n\t\t\t\t{{ctrl.dashboard.title}}\n\t\t\t\t<i class=\"fa fa-caret-down\"></i>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<ul class=\"nav dash-playlist-actions\" ng-if=ctrl.playlistSrv.isPlaying>\n\t\t\t<li>\n\t\t\t\t<a ng-click=ctrl.playlistSrv.prev()><i class=\"fa fa-step-backward\"></i></a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a ng-click=ctrl.playlistSrv.stop()><i class=\"fa fa-stop\"></i></a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a ng-click=ctrl.playlistSrv.next()><i class=\"fa fa-step-forward\"></i></a>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<ul class=\"nav pull-left dashnav-action-icons\">\n\t\t\t<li ng-show=::ctrl.dashboard.meta.canStar>\n\t\t\t\t<a class=pointer ng-click=ctrl.starDashboard()>\n\t\t\t\t\t<i class=fa ng-class=\"{'fa-star-o': !ctrl.dashboard.meta.isStarred, 'fa-star': ctrl.dashboard.meta.isStarred}\" style=color:orange></i>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li ng-show=::ctrl.dashboard.meta.canShare class=dropdown>\n\t\t\t\t<a class=pointer ng-click=ctrl.hideTooltip($event) bs-tooltip=\"'Share dashboard'\" data-placement=bottom data-toggle=dropdown><i class=\"fa fa-share-square-o\"></i></a>\n\t\t\t\t<ul class=dropdown-menu>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a class=pointer ng-click=ctrl.shareDashboard(0)>\n\t\t\t\t\t\t\t<i class=\"fa fa-link\"></i> Link to Dashboard\n\t\t\t\t\t\t\t<div class=dropdown-desc>Share an internal link to the current dashboard. Some configuration options available.</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a class=pointer ng-click=ctrl.shareDashboard(1)>\n\t\t\t\t\t\t\t<i class=\"icon-gf icon-gf-snapshot\"></i>Snapshot\n\t\t\t\t\t\t\t<div class=dropdown-desc>Interactive, publically accessible dashboard. Sensitive data is stripped out.</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a class=pointer ng-click=ctrl.shareDashboard(2)>\n\t\t\t\t\t\t\t<i class=\"fa fa-cloud-upload\"></i>Export\n\t\t\t\t\t\t\t<div class=dropdown-desc>Export the dashboard to a JSON file for others and to share on Grafana.com</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</li>\n\t\t\t<li ng-show=::ctrl.dashboard.meta.canSave>\n\t\t\t\t<a ng-click=ctrl.saveDashboard() bs-tooltip=\"'Save dashboard <br> CTRL+S'\" data-placement=bottom><i class=\"fa fa-save\"></i></a>\n\t\t\t</li>\n\t\t\t<li ng-if=::ctrl.dashboard.snapshot.originalUrl>\n\t\t\t\t<a ng-href={{ctrl.dashboard.snapshot.originalUrl}} bs-tooltip=\"'Open original dashboard'\" data-placement=bottom><i class=\"fa fa-link\"></i></a>\n\t\t\t</li>\n\t\t\t<li class=dropdown>\n\t\t\t\t<a class=pointer data-toggle=dropdown>\n\t\t\t\t\t<i class=\"fa fa-cog\"></i>\n\t\t\t\t</a>\n\t\t\t\t<ul class=\"dropdown-menu dropdown-menu--navbar\">\n\t\t\t\t\t<li ng-repeat=\"navItem in ::ctrl.navModel.menu\" ng-class=\"{active: navItem.active}\">\n\t\t\t\t\t\t<a class=pointer ng-href={{::navItem.url}} ng-click=\"ctrl.navItemClicked(navItem, $event)\">\n\t\t\t\t\t\t\t<i class={{::navItem.icon}} ng-show=::navItem.icon></i>\n\t\t\t\t\t\t\t{{::navItem.title}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<ul class=\"nav pull-right\">\n\t\t\t<li ng-show=ctrl.dashboard.meta.fullscreen class=dashnav-back-to-dashboard>\n\t\t\t\t<a ng-click=ctrl.exitFullscreen()>\n\t\t\t\t\tBack to dashboard\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<gf-time-picker dashboard=ctrl.dashboard></gf-time-picker>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>\n\n<dashboard-search></dashboard-search>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/export/export_modal.html';
var html = "\n<!-- <p> -->\n<!-- \tExporting will export a cleaned sharable dashboard that can be imported -->\n<!-- \tinto another Grafana instance. -->\n<!-- </p> -->\n\n<div class=share-modal-header>\n\t<div class=share-modal-big-icon>\n\t\t<i class=\"fa fa-cloud-upload\"></i>\n\t</div>\n\t<div>\n\t\t<p class=share-modal-info-text>\n\t\t\tExport the dashboard to a JSON file. The exporter will templatize the\n\t\t\tdashboard's data sources to make it easy for others to import and reuse.\n\t\t\tYou can share dashboards on <a class=external-link href=https://grafana.com>Grafana.com</a>\n\t\t</p>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=button class=\"btn gf-form-btn width-10 btn-success\" ng-click=ctrl.save()>\n\t\t\t\t<i class=\"fa fa-save\"></i> Save to file\n\t\t\t</button>\n\t\t\t<button type=button class=\"btn gf-form-btn width-10 btn-secondary\" ng-click=ctrl.saveJson()>\n\t\t\t\t<i class=\"fa fa-file-text-o\"></i> View JSON\n\t\t\t</button>\n\t\t\t<a class=\"btn btn-link\" ng-click=ctrl.dismiss()>Cancel</a>\n\t\t</div>\n\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/export_data/export_data_modal.html';
var html = "<div class=modal-body>\n  <div class=modal-header>\n    <h2 class=modal-header-title>\n      Export CSV\n    </h2>\n\n    <a class=modal-header-close ng-click=ctrl.dismiss();>\n      <i class=\"fa fa-remove\"></i>\n    </a>\n  </div>\n\n  <div class=modal-content>\n    <div class=p-t-2>\n      <div class=gf-form ng-hide=\"ctrl.panel === 'table'\">\n        <label class=\"gf-form-label width-10\">Mode</label>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.asRows ng-options=\"f.value as f.text for f in [{text: 'Series as rows', value: true}, {text: 'Series as columns', value: false}]\">\n          </select>\n        </div>\n      </div>\n      <div class=gf-form ng-hide=\"ctrl.panel === 'table'\">\n        <label class=\"gf-form-label width-10\">Date Time Format</label>\n        <input type=text class=gf-form-input ng-model=ctrl.dateTimeFormat>\n      </div>\n      <gf-form-switch class=gf-form label=\"Excel CSV Dialect\" label-class=width-10 switch-class=max-width-6 checked=ctrl.excel>\n      </gf-form-switch>\n    </div>\n\n    <div class=\"gf-form-button-row text-center\">\n      <a class=\"btn btn-success\" ng-click=ctrl.export();>Export</a>\n      <a class=btn-text ng-click=ctrl.dismiss();>Cancel</a>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 571 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/history/history.html';
var html = "<div class=tabbed-view-header>\n\t<h2 class=tabbed-view-title>\n\t\tVersion history\n\t</h2>\n\n\t<ul class=gf-tabs>\n\t\t<li class=gf-tabs-item>\n\t\t\t<a class=gf-tabs-link ng-click=\"ctrl.switchMode('list');\" ng-class=\"{active: ctrl.mode === 'list'}\">\n\t\t\t\tList\n\t\t\t</a>\n\t\t</li>\n\t\t<li class=gf-tabs-item ng-show=\"ctrl.mode === 'compare'\">\n\t\t\t<span class=\"active gf-tabs-link\">\n\t\t\t\tVersion Comparison\n\t\t\t</span>\n\t\t</li>\n\t</ul>\n\n\t<button class=tabbed-view-close-btn ng-click=ctrl.dismiss();>\n\t\t<i class=\"fa fa-remove\"></i>\n\t</button>\n</div>\n\n<div class=tabbed-view-body>\n\n\t<div ng-if=\"ctrl.mode === 'list'\">\n\t\t<div ng-if=ctrl.loading>\n\t\t\t<i class=\"fa fa-spinner fa-spin\"></i>\n\t\t\t<em>Fetching history list&hellip;</em>\n\t\t</div>\n\n\t\t<div ng-if=!ctrl.loading>\n      <div class=gf-form-group>\n        <table class=filter-table>\n          <thead>\n            <tr>\n              <th class=width-4></th>\n              <th class=width-4>Version</th>\n              <th class=width-14>Date</th>\n              <th class=width-10>Updated By</th>\n              <th>Notes</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"revision in ctrl.revisions\">\n              <td class=filter-table__switch-cell bs-tooltip=\"!revision.checked && ctrl.canCompare ? 'You can only compare 2 versions at a time' : ''\" data-placement=right>\n                <gf-form-switch switch-class=gf-form-switch--table-cell checked=revision.checked on-change=ctrl.revisionSelectionChanged() ng-disabled=\"!revision.checked && ctrl.canCompare\">\n                </gf-form-switch>\n              </td>\n              <td class=text-center>{{revision.version}}</td>\n              <td>{{revision.createdDateString}}</td>\n              <td>{{revision.createdBy}}</td>\n              <td>{{revision.message}}</td>\n              <td class=text-right>\n                <a class=\"btn btn-inverse btn-small\" ng-show=\"revision.version !== ctrl.dashboard.version\" ng-click=ctrl.restore(revision.version)>\n                  <i class=\"fa fa-history\"></i>&nbsp;&nbsp;Restore\n                </a>\n                <a class=\"btn btn-outline-disabled btn-small\" ng-show=\"revision.version === ctrl.dashboard.version\">\n                  <i class=\"fa fa-check\"></i>&nbsp;&nbsp;Latest\n                </a>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <div ng-if=ctrl.appending>\n          <i class=\"fa fa-spinner fa-spin\"></i>\n          <em>Fetching more entries&hellip;</em>\n        </div>\n\n        <div class=gf-form-group ng-show=\"ctrl.mode === 'list'\">\n          <div class=gf-form-button-row>\n            <button type=button class=\"btn gf-form-button btn-secondary\" ng-if=\"ctrl.revisions.length > 1\" ng-disabled=!ctrl.canCompare ng-click=ctrl.getDiff(ctrl.diff) bs-tooltip=\"ctrl.canCompare ? '' : 'Select 2 versions to start comparing'\" data-placement=bottom>\n              <i class=\"fa fa-code-fork\"></i>&nbsp;&nbsp;Compare versions\n            </button>\n            <button type=button class=\"btn gf-form-button btn-inverse\" ng-if=\"ctrl.revisions.length >= ctrl.limit\" ng-click=ctrl.addToLog() ng-disabled=ctrl.isLastPage()>\n              Show more versions\n            </button>\n          </div>\n        </div>\n      </div>\n\t\t</div>\n\t</div>\n\n\t<div class=edit-tab-with-sidemenu ng-if=\"ctrl.mode === 'compare'\">\n    <aside class=edit-sidemenu-aside>\n      <ul class=edit-sidemenu>\n        <li ng-class=\"{active: ctrl.diff === 'basic'}\"><a ng-click=\"ctrl.getDiff('basic')\" href=\"\">Change Summary</a></li>\n        <li ng-class=\"{active: ctrl.diff === 'html'}\"><a ng-click=\"ctrl.getDiff('json')\" href=\"\">JSON Diff</a></li>\n      </ul>\n    </aside>\n\n    <div class=edit-tab-content>\n      <div ng-if=ctrl.loading>\n        <i class=\"fa fa-spinner fa-spin\"></i>\n        <em>Fetching changes&hellip;</em>\n      </div>\n\n      <div ng-if=!ctrl.loading>\n        <a type=button class=\"btn gf-form-button btn-secondary pull-right\" ng-click=ctrl.restore(ctrl.baseInfo.version) ng-if=ctrl.isNewLatest>\n          <i class=\"fa fa-history\"></i>&nbsp;&nbsp;Restore to version {{ctrl.baseInfo.version}}\n        </a>\n        <h4>\n          Comparing Version {{ctrl.baseInfo.version}}\n          <i class=\"fa fa-arrows-h\"></i>\n\t\t\t\t\tVersion {{ctrl.newInfo.version}}\n          <cite class=muted ng-if=ctrl.isNewLatest>(Latest)</cite>\n        </h4>\n        <section>\n          <p class=\"small muted\">\n          <strong>Version {{ctrl.newInfo.version}}</strong> updated by\n          <span>{{ctrl.newInfo.createdBy}} </span>\n          <span>{{ctrl.newInfo.ageString}}</span>\n          <span> - {{ctrl.newInfo.message}}</span>\n          </p>\n          <p class=\"small muted\">\n          <strong>Version {{ctrl.baseInfo.version}}</strong> updated by\n          <span>{{ctrl.baseInfo.createdBy}} </span>\n          <span>{{ctrl.baseInfo.ageString}}</span>\n          <span> - {{ctrl.baseInfo.message}}</span>\n          </p>\n        </section>\n        <div id=delta diff-delta>\n          <div class=delta-basic ng-show=\"ctrl.diff === 'basic'\" compile=ctrl.delta.basic></div>\n          <div class=delta-html ng-show=\"ctrl.diff === 'json'\" compile=ctrl.delta.json></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 572 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/import/dash_import.html';
var html = "<div class=modal-body>\n\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-upload\"></i>\n\t\t\t<span class=p-l-1>Import Dashboard</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content ng-cloak>\n\t\t<div ng-if=\"ctrl.step === 1\">\n\n\t\t\t<form class=gf-form-group>\n\t\t\t\t<dash-upload on-upload=ctrl.onUpload(dash)></dash-upload>\n\t\t\t</form>\n\n\t\t\t<h5 class=section-heading>Grafana.com Dashboard</h5>\n\n      <div class=gf-form-group>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.gnetUrl placeholder=\"Paste Grafana.com dashboard url or id\" ng-blur=ctrl.checkGnetDashboard()>\n\t\t\t\t</div>\n        <div class=gf-form ng-if=ctrl.gnetError>\n          <label class=\"gf-form-label text-warning\">\n            <i class=\"fa fa-warning\"></i>\n            {{ctrl.gnetError}}\n          </label>\n        </div>\n      </div>\n\n      <h5 class=section-heading>Or paste JSON</h5>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<textarea rows=7 data-share-panel-url=\"\" class=gf-form-input ng-model=ctrl.jsonText></textarea>\n\t\t\t\t</div>\n\t\t\t\t<button type=button class=\"btn btn-secondary\" ng-click=ctrl.loadJsonText()>\n\t\t\t\t\t<i class=\"fa fa-paste\"></i>\n\t\t\t\t\tLoad\n\t\t\t\t</button>\n\t\t\t\t<span ng-if=ctrl.parseError class=\"text-error p-l-1\">\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t\t{{ctrl.parseError}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\n    <div ng-if=\"ctrl.step === 2\">\n\t\t\t<div class=gf-form-group ng-if=ctrl.dash.gnetId>\n        <h3 class=section-heading>\n          Importing Dashboard from\n          <a href=https://grafana.com/dashboards/{{ctrl.dash.gnetId}} class=external-link target=_blank>Grafana.com</a>\n        </h3>\n\n        <div class=gf-form>\n          <label class=\"gf-form-label width-15\">Published by</label>\n          <label class=\"gf-form-label width-15\">{{ctrl.gnetInfo.orgName}}</label>\n        </div>\n        <div class=gf-form>\n          <label class=\"gf-form-label width-15\">Updated on</label>\n          <label class=\"gf-form-label width-15\">{{ctrl.gnetInfo.updatedAt | date : 'yyyy-MM-dd HH:mm:ss'}}</label>\n        </div>\n      </div>\n\n      <h3 class=section-heading>\n        Options\n      </h3>\n\n      <div class=gf-form-group>\n        <div class=gf-form-inline>\n          <div class=\"gf-form gf-form--grow\">\n            <label class=\"gf-form-label width-15\">Name</label>\n            <input type=text class=gf-form-input ng-model=ctrl.dash.title give-focus=true ng-change=ctrl.titleChanged() ng-class=\"{'validation-error': ctrl.nameExists || !ctrl.dash.title}\">\n            <label class=\"gf-form-label text-success\" ng-if=\"!ctrl.nameExists && ctrl.dash.title\">\n              <i class=\"fa fa-check\"></i>\n            </label>\n          </div>\n        </div>\n\n        <div class=gf-form-inline ng-if=ctrl.nameExists>\n          <div class=\"gf-form offset-width-15 gf-form--grow\">\n            <label class=\"gf-form-label text-warning gf-form-label--grow\">\n              <i class=\"fa fa-warning\"></i>\n              A Dashboard with the same name already exists\n            </label>\n          </div>\n        </div>\n\n        <div class=gf-form-inline ng-if=!ctrl.dash.title>\n          <div class=\"gf-form offset-width-15 gf-form--grow\">\n            <label class=\"gf-form-label text-warning gf-form-label--grow\">\n              <i class=\"fa fa-warning\"></i>\n              A Dashboard should have a name\n            </label>\n          </div>\n        </div>\n\n        <div ng-repeat=\"input in ctrl.inputs\">\n          <div class=gf-form>\n            <label class=\"gf-form-label width-15\">\n              {{input.label}}\n              <info-popover mode=right-normal>\n                {{input.info}}\n              </info-popover>\n            </label>\n            <!-- Data source input -->\n            <div class=gf-form-select-wrapper style=width:100% ng-if=\"input.type === 'datasource'\">\n              <select class=gf-form-input ng-model=input.value ng-options=\"v.value as v.text for v in input.options\" ng-change=ctrl.inputValueChanged()>\n                <option value=\"\" ng-hide=input.value>{{input.info}}</option>\n              </select>\n            </div>\n            <!-- Constant input -->\n            <input ng-if=\"input.type === 'constant'\" type=text class=gf-form-input ng-model=input.value placeholder={{input.default}} ng-change=ctrl.inputValueChanged()>\n            <label class=\"gf-form-label text-success\" ng-show=input.value>\n              <i class=\"fa fa-check\"></i>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=gf-form-button-row>\n        <button type=button class=\"btn gf-form-btn btn-success width-12\" ng-click=ctrl.saveDashboard() ng-hide=ctrl.nameExists ng-disabled=!ctrl.inputsValid>\n          <i class=\"fa fa-save\"></i> Import\n        </button>\n        <button type=button class=\"btn gf-form-btn btn-danger width-12\" ng-click=ctrl.saveDashboard() ng-show=ctrl.nameExists ng-disabled=!ctrl.inputsValid>\n          <i class=\"fa fa-save\"></i> Import (Overwrite)\n        </button>\n        <a class=\"btn btn-link\" ng-click=dismiss()>Cancel</a>\n        <a class=\"btn btn-link\" ng-click=ctrl.back()>Back</a>\n      </div>\n\n    </div>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/addAnnotationModal.html';
var html = "<div class=modal-body ng-controller=AddAnnotationModalCtrl>\n\n  <div class=modal-header>\n    <h2 class=modal-header-title>\n      Add Annotation\n    </h2>\n\n    <a class=modal-header-close ng-click=ctrl.close()>\n      <i class=\"fa fa-remove\"></i>\n    </a>\n  </div>\n\n\n  <div class=modal-content>\n    <div class=share-modal-body>\n      <div class=share-modal-header>\n\n        <div class=share-modal-big-icon>\n          <i class=\"fa fa-tag\"></i>\n        </div>\n\n        <div class=share-modal-content>\n\n          <div class=\"gf-form-group share-modal-options\">\n            <p class=share-modal-info-text>\n              Add annotation details.\n            </p>\n\n            <div class=gf-form>\n              <span class=\"gf-form-label width-8\">Title</span>\n              <input type=text ng-model=ctrl.annotation.title class=\"gf-form-input max-width-20\">\n            </div>\n            <div class=gf-form>\n              <span class=\"gf-form-label width-8\" ng-if=!ctrl.annotation.timeTo>Time</span>\n              <span class=\"gf-form-label width-8\" ng-if=ctrl.annotation.timeTo>Time Start</span>\n              <input type=text ng-model=ctrl.annotation.time class=\"gf-form-input max-width-20\">\n            </div>\n            <div class=gf-form ng-if=ctrl.annotation.timeTo>\n              <span class=\"gf-form-label width-8\">Time Stop</span>\n              <input type=text ng-model=ctrl.annotation.timeTo class=\"gf-form-input max-width-20\">\n            </div>\n          </div>\n\n          <div>\n            <h6>Description</h6>\n          </div>\n          <div class=\"gf-form-group share-modal-options\">\n            <div class=gf-form>\n              <textarea rows=3 class=\"gf-form-input width-27\" ng-model=ctrl.annotation.text></textarea>\n            </div>\n          </div>\n\n          <div class=gf-form-button-row>\n            <button class=\"btn gf-form-btn width-10 btn-success\" ng-click=ctrl.addAnnotation()>\n              <i class=\"fa fa-pencil\"></i>\n              Add Annotation\n            </button>\n          </div>\n        </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 574 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/inspector.html';
var html = "<div class=modal-body ng-controller=InspectCtrl ng-init=init()>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-info-circle\"></i>\n\t\t\t<span class=p-l-1>Inspector</span>\n\t\t</h2>\n\n\t\t<ul class=gf-tabs>\n\t\t\t<li class=gf-tabs-item ng-repeat=\"tab in ['Panel Description', 'Request', 'Response', 'JS Error']\">\n\t\t\t\t<a class=gf-tabs-link ng-click=\"editor.index = $index\" ng-class=\"{active: editor.index === $index}\">\n\t\t\t\t\t{{::tab}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\t\t<div ng-if=\"editor.index == 0\" ng-bind-html=panelInfoHtml>\n\t\t</div>\n\n\t\t<div ng-if=\"editor.index == 1\">\n\t\t\t<h5 class=section-heading>Request details</h5>\n\t\t\t<table class=\"filter-table gf-form-group\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td>Url</td>\n\t\t\t\t\t<td>{{inspector.error.config.url}}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>Method</td>\n\t\t\t\t\t<td>{{inspector.error.config.method}}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"(key, value) in inspector.error.config.headers\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{key}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{value}}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\n\t\t\t<h5 class=section-heading>Request parameters</h5>\n\t\t\t<table class=filter-table>\n\t\t\t\t<tr ng-repeat=\"param in request_parameters\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{param.key}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{param.value}}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div ng-if=\"editor.index == 2\">\n\t\t\t<h5 ng-show=message>{{message}}</h5>\n \t\t\t<pre class=small>\n{{response}}\n\t\t\t</pre>\n\t\t</div>\n\n\t\t<div ng-if=\"editor.index == 3\">\n\n\t\t\t<label>Message:</label>\n<pre>\n{{message}}\n</pre>\n\n\t\t\t<label>Stack trace:</label>\n<pre>\n{{stack_trace}}\n</pre>\n\n\t\t</div>\n\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/settings.html';
var html = "<div class=tabbed-view-header>\n\t<h2 class=tabbed-view-title>\n\t\tSettings\n\t</h2>\n\n\t<ul class=gf-tabs>\n\t\t<li class=gf-tabs-item ng-repeat=\"tab in ::['General', 'Rows', 'Links', 'Time picker', 'Metadata']\">\n\t\t\t<a class=gf-tabs-link ng-click=\"editor.index = $index\" ng-class=\"{active: editor.index === $index}\">\n\t\t\t\t{{::tab}}\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\n\t<button class=tabbed-view-close-btn ng-click=dismiss();>\n\t\t<i class=\"fa fa-remove\"></i>\n\t</button>\n</div>\n\n<div class=tabbed-view-body>\n\t<div ng-if=\"editor.index == 0\">\n\n\t\t<div class=\"gf-form-group section\">\n      <h5 class=section-heading>Details</h5>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">Name</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-30\" ng-model=dashboard.title>\n\t\t\t</div>\n      <div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">Description</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-30\" ng-model=dashboard.description>\n\t\t\t</div>\n      <div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">\n          Tags\n          <info-popover mode=right-normal>Press enter to add a tag</info-popover>\n        </label>\n\t\t\t\t<bootstrap-tagsinput ng-model=dashboard.tags tagclass=\"label label-tag\" placeholder=\"add tags\">\n\t\t\t\t</bootstrap-tagsinput>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">Timezone</label>\n\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t<select ng-model=dashboard.timezone class=gf-form-input ng-options=\"f.value as f.text for f in [{value: '', text: 'Default'}, {value: 'browser', text: 'Local browser time'},{value: 'utc', text: 'UTC'}]\" ng-change=timezoneChanged()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n    <div class=section>\n      <h5 class=section-heading>Toggles</h5>\n      <div class=gf-form-group>\n        <gf-form-switch class=gf-form label=Editable tooltip=\"Uncheck, then save and reload to disable all dashboard editing\" checked=dashboard.editable label-class=width-11>\n        </gf-form-switch>\n\t\t\t\t<gf-form-switch class=gf-form label=\"Hide Controls\" tooltip=\"Hide row controls. Shortcut: CTRL+H or CMD+H\" checked=dashboard.hideControls label-class=width-11>\n        </gf-form-switch>\n      </div>\n    </div>\n\n    <div class=section>\n      <h5 class=section-heading>Panel Options</h5>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-11\">\n          Graph Tooltip\n          <info-popover mode=right-normal>\n            Cycle between options using Shortcut: CTRL+O or CMD+O\n          </info-popover>\n        </label>\n        <div class=gf-form-select-wrapper>\n          <select ng-model=dashboard.graphTooltip class=gf-form-input ng-options=\"f.value as f.text for f in [{value: 0, text: 'Default'}, {value: 1, text: 'Shared crosshair'},{value: 2, text: 'Shared Tooltip'}]\"></select>\n        </div>\n      </div>\n    </div>\n\n\t</div>\n\n\t<div ng-if=\"editor.index == 1\">\n\t\t<h5 class=section-heading>Rows settings</h5>\n\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form-inline ng-repeat=\"row in dashboard.rows\">\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=gf-form-label>Title</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=row.title>\n\t\t\t\t</div>\n\t\t\t\t<gf-form-switch class=gf-form label=\"Show title\" checked=row.showTitle switch-class=max-width-6></gf-form-switch>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<button class=\"btn btn-inverse gf-form-btn width-3\" ng-click=_.move(dashboard.rows,$index,$index-1)>\n\t\t\t\t\t\t<i ng-class=\"{'invisible': $first}\" class=\"fa fa-arrow-up\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-inverse gf-form-btn width-3\" ng-click=_.move(dashboard.rows,$index,$index+1)>\n\t\t\t\t\t\t<i ng-class=\"{'invisible': $last}\" class=\"fa fa-arrow-down\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-inverse gf-form-btn width-3\" ng-click=\"dashboard.rows = _.without(dashboard.rows,row)\">\n\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"editor.index == 2\">\n\t\t<dash-links-editor></dash-links-editor>\n\t</div>\n\n\t<div ng-if=\"editor.index == 3\">\n\t\t<gf-time-picker-settings dashboard=dashboard></gf-time-picker-settings>\n\t</div>\n\n\t<div ng-if=\"editor.index == 4\">\n\t\t<h5 class=section-heading>Dashboard info</h5>\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Last updated at:</span>\n\t\t\t\t<span class=\"gf-form-label width-18\">{{dashboard.formatDate(dashboardMeta.updated)}}</span>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Last updated by:</span>\n\t\t\t\t<span class=\"gf-form-label width-18\">{{dashboardMeta.updatedBy}}&nbsp;</span>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Created at:</span>\n\t\t\t\t<span class=\"gf-form-label width-18\">{{dashboard.formatDate(dashboardMeta.created)}}&nbsp;</span>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Created by:</span>\n\t\t\t\t<span class=\"gf-form-label width-18\">{{dashboardMeta.createdBy}}&nbsp;</span>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Current version:</span>\n\t\t\t\t<span class=\"gf-form-label width-18\">{{dashboardMeta.version}}&nbsp;</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 576 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/shareModal.html';
var html = "<div class=modal-body ng-controller=ShareModalCtrl ng-init=init()>\n\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t{{modalTitle}}\n\t\t</h2>\n\n\t\t<ul class=gf-tabs>\n\t\t\t<li class=gf-tabs-item ng-repeat=\"tab in tabs\">\n\t\t\t\t<a class=gf-tabs-link ng-click=\"editor.index = $index\" ng-class=\"{active: editor.index === $index}\">\n\t\t\t\t\t{{::tab.title}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content ng-repeat=\"tab in tabs\" ng-if=\"editor.index == $index\">\n\t\t<div ng-include src=tab.src class=share-modal-body></div>\n\t</div>\n\n</div>\n\n<script type=text/ng-template id=shareEmbed.html>\n\t<div class=\"share-modal-header\">\n\t\t<div class=\"share-modal-big-icon\">\n\t\t\t<i class=\"fa fa-code\"></i>\n\t\t</div>\n\t\t<div class=\"share-modal-content\">\n\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\tThe html code below can be pasted and included in another web page. Unless anonymous access\n\t\t\t\tis enabled the user viewing that page need to be signed into grafana for the graph to load.\n\t\t\t</p>\n\n\t\t\t<div ng-include src=\"'shareLinkOptions.html'\"></div>\n\n\t\t\t<div class=\"gf-form-group gf-form--grow\">\n\t\t\t\t<div class=\"gf-form\">\n\t\t\t\t\t<textarea rows=\"5\" data-share-panel-url class=\"gf-form-input\" ng-model='iframeHtml'></textarea>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</script>\n\n<script type=text/ng-template id=shareExport.html>\n\t<dash-export-modal dismiss=\"dismiss()\"></dash-export-modal>\n</script>\n\n<script type=text/ng-template id=shareLinkOptions.html>\n\t<div class=\"gf-form-group\">\n\t\t<gf-form-switch class=\"gf-form\"\n\t\t\tlabel=\"Current time range\" label-class=\"width-12\" switch-class=\"max-width-6\"\n\t\t\tchecked=\"options.forCurrent\" on-change=\"buildUrl()\">\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=\"gf-form\"\n\t\t\tlabel=\"Template variables\" label-class=\"width-12\" switch-class=\"max-width-6\"\n\t\t\tchecked=\"options.includeTemplateVars\" on-change=\"buildUrl()\">\n\t\t</gf-form-switch>\n\t\t<div class=\"gf-form\">\n\t\t\t<span class=\"gf-form-label width-12\">Theme</span>\n\t\t\t<div class=\"gf-form-select-wrapper width-6\">\n\t\t\t\t<select class=\"gf-form-input\" ng-model=\"options.theme\" ng-options=\"f as f for f in ['current', 'dark', 'light']\" ng-change=\"buildUrl()\"></select>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</script>\n\n<script type=text/ng-template id=shareLink.html>\n\t<div class=\"share-modal-header\">\n\t\t<div class=\"share-modal-big-icon\">\n\t\t\t<i class=\"fa fa-link\"></i>\n\t\t</div>\n\t\t<div class=\"share-modal-content\">\n\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\tCreate a direct link to this dashboard or panel, customized with the options below.\n\t\t\t</p>\n\t\t\t<div ng-include src=\"'shareLinkOptions.html'\"></div>\n\t\t\t<div>\n\t\t\t\t<div class=\"gf-form-group\">\n\t\t\t\t\t<div class=\"gf-form-inline\">\n\t\t\t\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t\t\t\t<input type=\"text\" data-share-panel-url class=\"gf-form-input\" ng-model=\"shareUrl\"></input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"gf-form\">\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse\" clipboard-button=\"getShareUrl()\"><i class=\"fa fa-clipboard\"></i> Copy</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form\" ng-show=\"modeSharePanel\">\n\t\t\t\t<a href=\"{{imageUrl}}\" target=\"_blank\"><i class=\"fa fa-camera\"></i> Direct link rendered image</a>\n\t\t\t</div>\n\t\t</div>\n</script>\n\n<script type=text/ng-template id=shareSnapshot.html>\n\t<div class=\"ng-cloak\" ng-cloak ng-controller=\"ShareSnapshotCtrl\" ng-init=\"init()\">\n\t\t<div class=\"share-modal-header\">\n\t\t\t<div class=\"share-modal-big-icon\">\n\t\t\t\t<i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i>\n\t\t\t\t<i ng-if=\"!loading\" class=\"icon-gf icon-gf-snapshot\"></i>\n\t\t\t</div>\n      <div class=\"share-modal-content\">\n        <div ng-if=\"step === 1\">\n          <p class=\"share-modal-info-text\">\n            A snapshot is an instant way to share an interactive dashboard publicly.\n            When created, we <strong>strip sensitive data</strong> like queries (metric, template and annotation) and panel links,\n            leaving only the visible metric data and series names embedded into your dashboard.\n          </p>\n          <p class=\"share-modal-info-text\">\n            Keep in mind, your <strong>snapshot can be viewed by anyone</strong> that has the link and can reach the URL.\n            Share wisely.\n          </p>\n        </div>\n\n\t\t\t\t<div class=\"share-modal-header\" ng-if=\"step === 3\">\n\t\t\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\t\t\tThe snapshot has now been deleted. If it you have already accessed it once, It might take up to an hour before it is removed from\n\t\t\t\t\t\tbrowser caches or CDN caches.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"gf-form-group share-modal-options\">\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 1\">\n\t\t\t\t\t\t<span class=\"gf-form-label width-12\">Snapshot name</span>\n\t\t\t\t\t\t<input type=\"text\" ng-model=\"snapshot.name\" class=\"gf-form-input max-width-15\" >\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 1\">\n\t\t\t\t\t\t<span class=\"gf-form-label width-12\">Expire</span>\n\t\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t\t\t\t<select class=\"gf-form-input\" ng-model=\"snapshot.expires\" ng-options=\"f.value as f.text for f in expireOptions\"></select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 2\" style=\"margin-top: 40px\">\n\t\t\t\t\t\t<div class=\"gf-form-row\">\n\t\t\t\t\t\t\t<a href=\"{{snapshotUrl}}\" class=\"large share-modal-link\" target=\"_blank\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-external-link-square\"></i>\n\t\t\t\t\t\t\t\t{{snapshotUrl}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse\" clipboard-button=\"getSnapshotUrl()\"><i class=\"fa fa-clipboard\"></i> Copy Link</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if=\"step === 1\">\n\t\t\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\t\t\tYou may need to configure the timeout value if it takes a long time to collect your dashboard's metrics.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"gf-form-group share-modal-options\">\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 1\">\n\t\t\t\t\t\t<span class=\"gf-form-label width-12\">Timeout (seconds)</span>\n\t\t\t\t\t\t<input type=\"number\" ng-model=\"snapshot.timeoutSeconds\" class=\"gf-form-input max-width-15\" >\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if=\"step === 1\" class=\"gf-form-button-row\">\n\t\t\t\t\t<button class=\"btn gf-form-btn width-10 btn-success\" ng-click=\"createSnapshot()\" ng-disabled=\"loading\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t\tLocal Snapshot\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn gf-form-btn width-16 btn-secondary\" ng-if=\"externalEnabled\" ng-click=\"createSnapshot(true)\" ng-disabled=\"loading\">\n\t\t\t\t\t\t<i class=\"fa fa-cloud-upload\"></i>\n\t\t\t\t\t\t{{sharingButtonText}}\n\t\t\t\t\t</button>\n\t\t\t\t\t<a class=\"btn btn-link\" ng-click=\"dismiss()\">Cancel</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"pull-right\" ng-if=\"step === 2\" style=\"padding: 5px\">\n\t\t\t\t\tDid you make a mistake? <a class=\"pointer\" ng-click=\"deleteSnapshot()\" target=\"_blank\">delete snapshot.</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n</script>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 577 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/row/add_panel.html';
var html = "<div class=dash-row-dropview>\n\t<a class=\"dash-row-dropview-close pointer\" ng-click=ctrl.rowCtrl.closeDropView();>\n\t\t<i class=\"fa fa-remove\"></i>\n\t</a>\n\n\t<div class=\"gf-form width-10\">\n\t\t<input type=text class=\"gf-form-input width-10\" ng-model=ctrl.panelSearch give-focus=true ng-keydown=ctrl.keyDown($event) ng-change=ctrl.panelSearchChanged() placeholder=\"panel search filter\">\n\t</div>\n\n\t<div class=add-panel-panels>\n\t\t<div class=add-panel-item ng-repeat=\"panel in ctrl.panelHits\" ng-class=\"{active: $index === ctrl.activeIndex}\" ng-click=ctrl.addPanel(panel) ui-draggable=true drag=panel.id title={{panel.name}}>\n\t\t\t<img class=add-panel-item-img ng-src={{panel.info.logos.small}}>\n\t\t\t<div class=add-panel-item-name>{{panel.name}}</div>\n\t\t</div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 578 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/row/options.html';
var html = "<div class=dash-row-dropview>\n\t<a class=\"dash-row-dropview-close pointer\" ng-click=ctrl.rowCtrl.closeDropView();>\n\t\t<i class=\"fa fa-remove\"></i>\n\t</a>\n\n\t<div>\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-6\">Title</span>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=ctrl.row.title>\n\t\t\t</div>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label width-6\">Size</label>\n\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t<select class=\"input-small gf-form-input\" ng-model=ctrl.row.titleSize ng-options=\"f for f in ctrl.fontSizes\"></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<gf-form-switch class=gf-form label=Show checked=ctrl.row.showTitle>\n\t\t\t\t</gf-form-switch>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Height</span>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=ctrl.row.height>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Repeat for</span>\n\t\t\t\t<dash-repeat-option model=ctrl.row></dash-repeat-option>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/row/row.html';
var html = "<div class=dash-row-header ng-if=\"ctrl.row.showTitle || ctrl.row.collapse\">\n\t<a class=dash-row-header-title ng-click=ctrl.toggleCollapse()>\n\t\t<span class=\"dash-row-collapse-toggle pointer\">\n\t\t\t<i class=\"fa fa-chevron-down\" ng-show=!ctrl.row.collapse></i>\n\t\t\t<i class=\"fa fa-chevron-right\" ng-show=ctrl.row.collapse></i>\n\t\t</span>\n\t\t<span ng-class=ctrl.row.titleSize>{{ctrl.row.title | interpolateTemplateVars:this}}</span>\n\t</a>\n</div>\n\n<div ng-if=\"ctrl.dropView === 1\">\n\t<dash-row-add-panel row-ctrl=ctrl></dash-row-add-panel>\n</div>\n\n<div ng-if=\"ctrl.dropView === 2\">\n\t<dash-row-options row-ctrl=ctrl></dash-row-options>\n</div>\n\n<div class=panels-wrapper ng-if=!ctrl.row.collapse>\n  <div class=dash-row-menu-container data-click-hide ng-hide=ctrl.dashboard.meta.fullscreen>\n    <ul class=dash-row-menu role=menu>\n      <li>\n        <a ng-click=ctrl.toggleCollapse()>\n          <i class=\"fa fa-minus\"></i> Collapse\n        </a>\n      </li>\n      <li ng-show=ctrl.dashboard.meta.canEdit>\n        <a ng-click=ctrl.onMenuAddPanel()>\n          <i class=\"fa fa-plus\"></i> Add Panel\n        </a>\n      </li>\n      <li ng-show=ctrl.dashboard.meta.canEdit>\n        <a ng-click=ctrl.onMenuRowOptions()>\n          <i class=\"fa fa-cog\"></i> Row Options\n        </a>\n      </li>\n      <li ng-show=ctrl.dashboard.meta.canEdit>\n        <a ng-click=ctrl.moveRow(-1)>\n          <i class=\"fa fa-arrow-up\"></i> Move Up\n        </a>\n      </li>\n      <li ng-show=ctrl.dashboard.meta.canEdit>\n        <a ng-click=ctrl.moveRow(1)>\n          <i class=\"fa fa-arrow-down\"></i> Move Down\n        </a>\n      </li>\n      <li ng-show=ctrl.dashboard.meta.canEdit>\n        <a ng-click=ctrl.onMenuDeleteRow()>\n          <i class=\"fa fa-trash\"></i> Remove\n        </a>\n      </li>\n    </ul>\n    <div class=dash-row-menu-grip>\n      <i class=\"fa fa-ellipsis-v\"></i>\n    </div>\n  </div>\n\n  <div ng-repeat=\"panel in ctrl.row.panels track by panel.id\" class=panel ui-draggable=!ctrl.dashboard.meta.fullscreen drag=panel.id ui-on-drop=\"ctrl.onDrop($data, panel)\" drag-handle-class=drag-handle panel-width>\n    <plugin-component type=panel class=panel-margin>\n    </plugin-component>\n  </div>\n\n  <div panel-drop-zone class=\"panel panel-drop-zone\" ui-on-drop=ctrl.onDrop($data) data-drop=true>\n    <div class=panel-margin>\n      <div class=panel-container>\n        <div class=panel-drop-zone-text></div>\n      </div>\n    </div>\n  </div>\n\n  <div class=clearfix></div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 580 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/submenu/submenu.html';
var html = "<div class=submenu-controls>\n\n  <div ng-repeat=\"variable in ctrl.variables\" ng-hide=\"variable.hide === 2\" class=\"submenu-item gf-form-inline\">\n    <div class=gf-form>\n      <label class=\"gf-form-label template-variable\" ng-hide=\"variable.hide === 1\">\n        {{variable.label || variable.name}}\n      </label>\n      <value-select-dropdown ng-if=\"variable.type !== 'adhoc'\" variable=variable on-updated=ctrl.variableUpdated(variable)></value-select-dropdown>\n    </div>\n    <ad-hoc-filters ng-if=\"variable.type === 'adhoc'\" variable=variable></ad-hoc-filters>\n  </div>\n\n  <div ng-if=\"ctrl.dashboard.annotations.list.length > 0\">\n    <div ng-repeat=\"annotation in ctrl.dashboard.annotations.list\" ng-hide=annotation.hide class=submenu-item ng-class=\"{'annotation-disabled': !annotation.enable}\">\n\t\t\t<gf-form-switch class=gf-form label={{annotation.name}} checked=annotation.enable on-change=ctrl.annotationStateChanged()></gf-form-switch>\n    </div>\n  </div>\n\n  <div class=\"gf-form gf-form--grow\">\n  </div>\n\n  <div ng-if=\"ctrl.dashboard.links.length > 0\">\n    <dash-links-container links=ctrl.dashboard.links class=gf-form-inline></dash-links-container>\n  </div>\n\n  <div class=clearfix></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/timepicker/dropdown.html';
var html = "<div class=\"row pull-right\">\n\t<form name=timeForm class=gf-timepicker-absolute-section>\n\t\t<h3>Time range</h3>\n\n\t\t<label class=small>From:</label>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<input type=text class=\"gf-form-input input-large\" ng-model=ctrl.editTimeRaw.from input-datetime>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn gf-form-btn btn-primary\" type=button ng-click=\"openFromPicker=!openFromPicker\">\n\t\t\t\t\t<i class=\"fa fa-calendar\"></i>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=openFromPicker>\n\t\t\t<datepicker ng-model=ctrl.absolute.fromJs class=gf-timepicker-component show-weeks=false starting-day=ctrl.firstDayOfWeek ng-change=ctrl.absoluteFromChanged()></datepicker>\n\t\t</div>\n\n\n\t\t<label class=small>To:</label>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<input type=text class=\"gf-form-input input-large\" ng-model=ctrl.editTimeRaw.to input-datetime>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn gf-form-btn btn-primary\" type=button ng-click=\"openToPicker=!openToPicker\">\n\t\t\t\t\t<i class=\"fa fa-calendar\"></i>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=openToPicker>\n\t\t\t<datepicker ng-model=ctrl.absolute.toJs class=gf-timepicker-component show-weeks=false starting-day=ctrl.firstDayOfWeek ng-change=ctrl.absoluteToChanged()></datepicker>\n\t\t</div>\n\n\t\t<label class=small>Refreshing every:</label>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<select ng-model=ctrl.refresh.value class=\"gf-form-input input-medium\" ng-options=\"f.value as f.text for f in ctrl.refresh.options\"></select>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button type=submit class=\"btn gf-form-btn btn-secondary\" ng-click=ctrl.applyCustom(); ng-disabled=!timeForm.$valid>Apply</button>\n\t\t\t</div>\n\t\t</div>\n\n\t</form>\n\n\t<div class=gf-timepicker-relative-section>\n\t\t<h3>Quick ranges</h3>\n\t\t<ul ng-repeat=\"group in ctrl.timeOptions\">\n\t\t\t<li bindonce ng-repeat=\"option in group\" ng-class=\"{active: option.active}\">\n\t\t\t\t<a ng-click=ctrl.setRelativeFilter(option) bo-text=option.display></a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n</div>\n<div class=clearfix></div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 582 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/timepicker/settings.html';
var html = "<div class=editor-row>\n<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">Auto-refresh</span>\n\t\t<input type=text class=\"gf-form-input max-width-25\" ng-model=ctrl.panel.refresh_intervals array-join>\n\t</div>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">Now delay now-</span>\n\t\t<input type=text class=\"gf-form-input max-width-25\" ng-model=ctrl.panel.nowDelay placeholder=0m valid-time-span bs-tooltip=\"'Enter 1m to ignore the last minute (because it can contain incomplete metrics)'\" data-placement=right>\n\t</div>\n</div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/timepicker/timepicker.html';
var html = "<ul class=\"nav gf-timepicker-nav\">\n\n\t<li class=\"dashnav-move-timeframe gf-timepicker-time-control\" bs-tooltip=\"'Shift time backward <br> (left arrow key)'\" data-placement=bottom>\n\t\t<a ng-click=ctrl.move(-1)><i class=\"fa fa-chevron-left\"></i></a>\n\t</li>\n\t<li class=\"dashnav-zoom-out gf-timepicker-time-control\" bs-tooltip=\"'Time range zoom out <br> CTRL+Z'\" data-placement=bottom>\n\t\t<a ng-click=ctrl.zoom(2)>Zoom Out</a></li>\n\t\n\t<li class=\"dashnav-move-timeframe gf-timepicker-time-control\" bs-tooltip=\"'Shift time forward <br> (right arrow key)'\" data-placement=bottom>\n\t\t<a ng-click=ctrl.move(1)><i class=\"fa fa-chevron-right\"></i></a>\n\t</li>\n\n\t<li>\n\t\t<a bs-tooltip=ctrl.tooltip data-placement=bottom ng-click=ctrl.openDropdown() class=gf-timepicker-nav-btn>\n\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t\t<span ng-bind=ctrl.rangeString></span>\n\t\t\t<span ng-show=ctrl.isUtc class=gf-timepicker-utc>\n\t\t\t\tUTC\n\t\t\t</span>\n\n\t\t\t<span ng-show=ctrl.dashboard.refresh class=text-warning>\n\t\t\t\t&nbsp;\n\t\t\t\tRefresh every {{ctrl.dashboard.refresh}}\n\t\t\t</span>\n\t\t</a>\n\t</li>\n\n\t<li class=dashnav-refresh-action>\n\t\t<a ng-click=ctrl.timeSrv.refreshDashboard()>\n\t\t\t<i class=\"fa fa-refresh\"></i>\n\t\t</a>\n\t</li>\n\n</ul>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 584 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashlinks/editor.html';
var html = "<div class=editor-row>\n\t<h5 class=section-heading>Links and Dash Navigation</h5>\n\n\t<div ng-repeat=\"link in dashboard.links\">\n\n\t\t<div class=\"gf-form-group gf-form-inline\">\n\t\t\t<div class=section>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-8\">Type</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper width-10\">\n\t\t\t\t\t\t<select class=gf-form-input ng-model=link.type ng-options=\"f for f in ['dashboards','link']\" ng-change=updated()></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form ng-show=\"link.type === 'dashboards'\">\n\t\t\t\t\t<span class=\"gf-form-label width-8\">With tags</span>\n\t\t\t\t\t<bootstrap-tagsinput ng-model=link.tags class=width-10 tagclass=\"label label-tag\" placeholder=\"add tags\" style=margin-right:.25rem></bootstrap-tagsinput>\n\t\t\t\t</div>\n\t\t\t\t<gf-form-switch ng-show=\"link.type === 'dashboards'\" class=gf-form label=\"As dropdown\" checked=link.asDropdown switch-class=max-width-4 label-class=width-8></gf-form-switch>\n\t\t\t\t<div class=gf-form ng-show=\"link.type === 'dashboards' && link.asDropdown\">\n\t\t\t\t\t<span class=\"gf-form-label width-8\">Title</span>\n\t\t\t\t\t<input type=text ng-model=link.title class=\"gf-form-input max-width-10\" ng-model-onblur ng-change=updated()>\n\t\t\t\t</div>\n\t\t\t\t<div ng-show=\"link.type === 'link'\">\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<li class=\"gf-form-label width-8\">Url</li>\n\t\t\t\t\t\t<input type=text ng-model=link.url class=\"gf-form-input width-20\" ng-model-onblur ng-change=updated()>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<span class=\"gf-form-label width-8\">Title</span>\n\t\t\t\t\t\t<input type=text ng-model=link.title class=\"gf-form-input width-20\" ng-model-onblur ng-change=updated()>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<span class=\"gf-form-label width-8\">Tooltip</span>\n\t\t\t\t\t\t<input type=text ng-model=link.tooltip class=\"gf-form-input width-20\" placeholder=\"Open dashboard\" ng-model-onblur ng-change=updated()>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<span class=\"gf-form-label width-8\">Icon</span>\n\t\t\t\t\t\t<div class=\"gf-form-select-wrapper width-20\">\n\t\t\t\t\t\t\t\t<select class=gf-form-input ng-model=link.icon ng-options=\"k as k for (k, v) in iconMap\" ng-change=updated()></select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"section gf-form-inline\" style=display:flex>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<span class=\"gf-form-label width-6\">Include</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<gf-form-switch class=gf-form label=\"Time range\" checked=link.keepTime switch-class=max-width-6 label-class=width-9></gf-form-switch>\n\t\t\t\t\t<gf-form-switch class=gf-form label=\"Variable values\" checked=link.includeVars switch-class=max-width-6 label-class=width-9></gf-form-switch>\n\t\t\t\t\t<gf-form-switch class=gf-form label=\"Open in new tab\" checked=link.targetBlank switch-class=max-width-6 label-class=width-9></gf-form-switch>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div style=display:flex;flex-direction:column;justify-content:flex-start>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<button class=\"btn btn-inverse gf-form-btn width-4\" ng-click=deleteLink($index)>\n\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<button class=\"btn btn-inverse gf-form-btn width-4\" ng-click=\"moveLink($index, -1)\" ng-hide=$first><i class=\"fa fa-arrow-up\"></i></button>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<button class=\"btn btn-inverse gf-form-btn width-4\" ng-click=\"moveLink($index, 1)\" ng-hide=$last><i class=\"fa fa-arrow-down\"></i></button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n\n\n<button class=\"btn btn-inverse\" ng-click=addLink()><i class=\"fa fa-plus\"></i> Add link</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/add_user.html';
var html = "<div class=modal-body ng-controller=UserInviteCtrl ng-init=init()>\n\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\tAdd Users\n\t\t</h2>\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\n\t\t<div class=\"modal-tagline p-b-2\">\n\t\t\tAdd existing Grafana users to the organization\n\t\t\t<span class=highlight-word>{{contextSrv.user.orgName}}</span>\n\t\t</div>\n\n\t\t<form name=inviteForm>\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<div class=gf-form-inline ng-repeat=\"invite in invites\">\n\t\t\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t\t\t<span class=gf-form-label>Email or Username</span>\n\t\t\t\t\t\t<input type=text ng-model=invite.loginOrEmail required class=gf-form-input placeholder=email@test.com>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form max-width-10\">\n\t\t\t\t\t\t<span class=gf-form-label>Role</span>\n\t\t\t\t\t\t<select ng-model=invite.role class=gf-form-input ng-options=\"f for f in ['Viewer', 'Editor', 'Read Only Editor', 'Admin']\">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form gf-size-auto\">\n\t\t\t\t\t\t<a class=\"gf-form-label pointer\" tabindex=1 ng-click=removeInvite(invite)>\n\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form-inline gf-form-group\">\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<a class=\"btn btn-inverse btn-small\" ng-click=addInvite()>\n\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\tAdd another\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=sendInvites();>Add Users</button>\n\t\t\t\t<a class=btn-text ng-click=dismiss()>Cancel</a>\n\t\t\t</div>\n\t\t\t<div class=clearfix></div>\n\t\t</form>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/apikeyModal.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-key\"></i>\n\t\t\t<span class=p-l-1>API Key Created</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Key</span>\n\t\t\t\t<span class=gf-form-label>{{key}}</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=grafana-info-box style=border:0>\n\t\t\tYou will only be able to view this key here once! It is not stored in this form. So be sure to copy it now.\n\t\t\t<br>\n\t\t\t<br>\n\t\t\tYou can authenticate request using the Authorization HTTP header, example:\n\t\t\t<br>\n\t\t\t<br>\n\t\t\t<pre class=small>\ncurl -H \"Authorization: Bearer {{key}}\" {{rootPath}}/api/dashboards/home\n\t\t\t</pre>\n\t\t</div>\n\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/change_password.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Change password</h1>\n\t</div>\n\n\t<div ng-if=\"ldapEnabled || authProxyEnabled\">\n\t\tYou cannot change password when ldap or auth proxy authentication is enabled.\n\t\t<br>\n\t\t<br>\n\t\t<a class=btn-text href=profile>Back to profile</a>\n\t</div>\n\n\t<form name=userForm class=gf-form-group ng-hide=\"ldapEnabled || authProxyEnabled\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Old Password</span>\n\t\t\t<input class=\"gf-form-input max-width-21\" type=password required ng-model=command.oldPassword>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">New Password</span>\n\t\t\t<input class=\"gf-form-input max-width-21\" type=password required ng-minlength=4 ng-model=command.newPassword>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Confirm Password</span>\n\t\t\t<input class=\"gf-form-input max-width-21\" type=password required ng-minlength=4 ng-model=command.confirmNew>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=changePassword()>Change Password</button>\n\t\t\t<a class=btn-text href=profile>Cancel</a>\n\t\t</div>\n\t</form>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/invite.html';
var html = "<div class=modal-body ng-controller=UserInviteCtrl ng-init=init()>\n\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\tInvite Users\n\t\t</h2>\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\n\t\t<div class=\"modal-tagline p-b-2\">\n\t\t\tSend invite or add existing Grafana users to the organization\n\t\t\t<span class=highlight-word>{{contextSrv.user.orgName}}</span>\n\t\t</div>\n\n\t\t<form name=inviteForm>\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<div class=gf-form-inline ng-repeat=\"invite in invites\">\n\t\t\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t\t\t<span class=gf-form-label>Email or Username</span>\n\t\t\t\t\t\t<input type=text ng-model=invite.loginOrEmail required class=gf-form-input placeholder=email@test.com>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form max-width-14\">\n\t\t\t\t\t\t<span class=gf-form-label>Name</span>\n\t\t\t\t\t\t<input type=text ng-model=invite.name class=gf-form-input placeholder=\"name (optional)\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form max-width-10\">\n\t\t\t\t\t\t<span class=gf-form-label>Role</span>\n\t\t\t\t\t\t<select ng-model=invite.role class=gf-form-input ng-options=\"f for f in ['Viewer', 'Editor', 'Read Only Editor', 'Admin']\">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form gf-size-auto\">\n\t\t\t\t\t\t<a class=\"gf-form-label pointer\" tabindex=1 ng-click=removeInvite(invite)>\n\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form-inline gf-form-group\">\n\t\t\t\t<div class=gf-form style=margin-right:.25rem>\n\t\t\t\t\t<a class=\"btn btn-inverse gf-form-button\" ng-click=addInvite()>\n\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\tInvite another\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t\t<gf-form-switch class=gf-form label=\"Skip sending invite email\" checked=options.skipEmails switch-class=max-width-6></gf-form-switch>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=sendInvites();>Invite Users</button>\n\t\t\t\t<a class=btn-text ng-click=dismiss()>Cancel</a>\n\t\t\t</div>\n\t\t\t<div class=clearfix></div>\n\t\t</form>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/newOrg.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container ng-form=playlistEditForm>\n\t<div class=page-header>\n\t\t<h1>New Organization</h1>\n\t</div>\n\n\t<p class=playlist-description>Each organization contains their own dashboards, data sources and configuration, and cannot be shared between orgs. While users may belong to more than one, mutiple organization are most frequently used in multi-tenant deployments. </p>\n\n\t<form>\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Org. name</span>\n\t\t\t\t<input type=text ng-model=newOrg.name required class=\"gf-form-input max-width-21\" placeholder=\"organization name\">\n\t\t\t</div>\n\t\t\t<br>\n\t\t\t<div class=gf-form-buttons-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=createOrg()>Create</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 590 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/orgApiKeys.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>API Keys</h1>\n\t</div>\n\n\t<h3 class=page-heading>Add new</h3>\n\t<form name=addTokenForm class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t<span class=gf-form-label>Add a key</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=token.name placeholder=Name>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Role</span>\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=token.role ng-options=\"r for r in roleTypes\"></select>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn gf-form-btn btn-success\" ng-click=addToken()>Add</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Existing Keys</h3>\n\t<table class=filter-table>\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>Role</th>\n\t\t\t\t<th style=width:34px></th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"t in tokens\">\n\t\t\t\t<td>{{t.name}}</td>\n\t\t\t\t<td>{{t.role}}</td>\n\t\t\t\t<td>\n\t\t\t\t\t<a ng-click=removeToken(t.id) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 591 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/orgDetails.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Org Preferences</h1>\n\t</div>\n\n\t<h3 class=page-heading>General</h3>\n\t<form name=orgForm class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-6\">Name</span>\n\t\t\t\t<input class=gf-form-input type=text required ng-model=org.name>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button type=submit class=\"btn gf-form-btn btn-success\" ng-click=update()>Update</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t<prefs-control mode=org></prefs-control>\n\n\t<h3 class=page-heading>Address</h3>\n\n\t<form name=addressForm class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Address1</span>\n\t\t\t\t<input class=gf-form-input type=text ng-model=address.address1>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Address2</span>\n\t\t\t\t<input class=gf-form-input type=text ng-model=address.address2>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-7\">City</span>\n\t\t\t\t<input class=gf-form-input type=text ng-model=address.city>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Postal code</span>\n\t\t\t\t<input class=gf-form-input type=text ng-model=address.zipCode>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-7\">State</span>\n\t\t\t\t<input class=gf-form-input type=text ng-model=address.state>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form max-width-28\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Country</span>\n\t\t\t\t<input class=gf-form-input type=text ng-model=address.country>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=updateAddress()>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Admin Pages</h3>\n\t<div class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<a href=org/users class=\"btn gf-form-btn btn-inverse\">Users &amp; Roles</a>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t<a href=org/apikeys class=\"btn gf-form-btn btn-inverse\">API Keys</a>\n\t\t</div>\n\t</div>\n</div>\n\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/orgUsers.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Organization users</h1>\n\n\t\t<div class=page-header-tabs>\n\n\t\t\t<button class=\"btn btn-success\" ng-click=ctrl.openAddUsersView() ng-hide=ctrl.externalUserMngLinkUrl>\n\t\t\t\t<i class=\"fa fa-plus\"></i>\n        <span>{{ctrl.addUsersBtnName}}</span>\n\t\t\t</button>\n\n      <a class=\"btn btn-inverse\" ng-href={{ctrl.externalUserMngLinkUrl}} target=_blank ng-if=ctrl.externalUserMngLinkUrl>\n\t\t\t\t<i class=\"fa fa-external-link-square\"></i>\n        {{ctrl.addUsersBtnName}}\n      </a>\n\n\t\t\t<ul class=gf-tabs>\n\t\t\t\t<li class=gf-tabs-item>\n\t\t\t\t\t<a class=gf-tabs-link ng-click=\"ctrl.editor.index = 0\" ng-class=\"{active: ctrl.editor.index === 0}\">\n\t\t\t\t\t\tUsers ({{ctrl.users.length}})\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=gf-tabs-item ng-show=ctrl.pendingInvites.length>\n\t\t\t\t\t<a class=gf-tabs-link ng-click=\"ctrl.editor.index = 1\" ng-class=\"{active: ctrl.editor.index === 1}\">\n\t\t\t\t\t\tPending Invitations ({{ctrl.pendingInvites.length}})\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\n  <div class=grafana-info-box ng-if=ctrl.externalUserMngInfo>\n    <span ng-bind-html=ctrl.externalUserMngInfo></span>\n  </div>\n\n  <div ng-if=\"ctrl.editor.index === 0\" class=tab-content>\n    <table class=\"filter-table form-inline\">\n      <thead>\n        <tr>\n          <th>Login</th>\n          <th>Email</th>\n\t\t\t\t\t<th>\n\t\t\t\t\t\tSeen\n\t\t\t\t\t\t<tip>Time since user was seen using Grafana</tip>\n\t\t\t\t\t</th>\n          <th>Role</th>\n          <th style=width:34px></th>\n        </tr>\n      </thead>\n      <tr ng-repeat=\"user in ctrl.users\">\n        <td>{{user.login}}</td>\n        <td><span class=ellipsis>{{user.email}}</span></td>\n\t\t\t\t<td>{{user.lastSeenAtAge}}</td>\n        <td>\n          <select type=text ng-model=user.role class=input-medium ng-options=\"f for f in ['Viewer', 'Editor', 'Read Only Editor', 'Admin']\" ng-change=ctrl.updateOrgUser(user)>\n          </select>\n        </td>\n        <td>\n          <a ng-click=ctrl.removeUser(user) class=\"btn btn-danger btn-mini\">\n            <i class=\"fa fa-remove\"></i>\n          </a>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div ng-if=\"ctrl.editor.index === 1\">\n    <table class=\"filter-table form-inline\">\n      <thead>\n        <tr>\n          <th>Email</th>\n          <th>Name</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody ng-repeat=\"invite in ctrl.pendingInvites\">\n        <tr ng-click=\"invite.expanded = !invite.expanded\" ng-class=\"{'expanded': invite.expanded}\">\n          <td>{{invite.email}}</td>\n          <td>{{invite.name}}</td>\n          <td class=text-right>\n            <button class=\"btn btn-inverse btn-mini\" clipboard-button=ctrl.getInviteUrl(invite) ng-click=ctrl.copyInviteToClipboard($event)>\n              <i class=\"fa fa-clipboard\"></i> Copy Invite\n            </button>\n            &nbsp;\n            <button class=\"btn btn-inverse btn-mini\">\n              Details\n              <i ng-show=!invite.expanded class=\"fa fa-caret-right\"></i>\n              <i ng-show=invite.expanded class=\"fa fa-caret-down\"></i>\n            </button>\n          </td>\n        </tr>\n        <tr ng-show=invite.expanded>\n          <td colspan=3>\n            <a href={{invite.url}}>{{invite.url}}</a><br><br>\n            &nbsp;\n            <button class=\"btn btn-inverse btn-mini\" ng-click=\"ctrl.revokeInvite(invite, $event)\">\n              <i class=\"fa fa-remove\" style=color:red></i> Revoke invite\n            </button>\n            <span style=padding-left:15px>\n              Invited: <em> {{invite.createdOn | date: 'shortDate'}} by {{invite.invitedBy}} </em>\n            </span>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/profile.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>User Profile</h1>\n\t</div>\n\n\t<form name=ctrl.userForm class=gf-form-group>\n\t\t<h3 class=page-heading>Information</h3>\n\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-8\">Name</span>\n\t\t\t<input class=\"gf-form-input max-width-22\" type=text required ng-model=ctrl.user.name>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-8\">Email</span>\n\t\t\t<input class=\"gf-form-input max-width-22\" type=email ng-readonly=ctrl.readonlyLoginFields required ng-model=ctrl.user.email>\n      <i ng-if=ctrl.readonlyLoginFields class=\"fa fa-lock gf-form-icon--right-absolute\" bs-tooltip=\"'Login Details Locked - managed in another system.'\"></i>\n    </div>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-8\">Username</span>\n      <input class=\"gf-form-input max-width-22\" type=text ng-readonly=ctrl.readonlyLoginFields required ng-model=ctrl.user.login>\n      <i ng-if=ctrl.readonlyLoginFields class=\"fa fa-lock gf-form-icon--right-absolute\" bs-tooltip=\"'Login Details Locked - managed in another system.'\"></i>\n    </div>\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.update()>Update</button>\n\t\t</div>\n\t</form>\n\n\t<prefs-control mode=user></prefs-control>\n\n\t<h3 class=page-heading>Password</h3>\n\t<div class=gf-form-group>\n\t\t<a href=profile/password class=\"btn btn-inverse\">Change Password</a>\n\t</div>\n\n\t<h3 class=page-heading ng-show=ctrl.showOrgsList>Organizations</h3>\n  <div class=gf-form-group ng-show=ctrl.showOrgsList>\n\t\t<table class=\"filter-table form-inline\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Name</th>\n\t\t\t\t\t<th>Role</th>\n\t\t\t\t\t<th></th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"org in ctrl.orgs\">\n\t\t\t\t\t<td>{{org.name}}</td>\n\t\t\t\t\t<td>{{org.role}}</td>\n\t\t\t\t\t<td class=text-right>\n\t\t\t\t\t\t<span class=\"btn btn-primary btn-mini\" ng-show=\"org.orgId === contextSrv.user.orgId\">\n\t\t\t\t\t\t\tCurrent\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<a ng-click=ctrl.setUsingOrg(org) class=\"btn btn-inverse btn-mini\" ng-show=\"org.orgId !== contextSrv.user.orgId\">\n\t\t\t\t\t\t\tSelect\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/select_org.html';
var html = "<div class=container>\n\n\t<div class=signup-page-background>\n\t</div>\n\n\t<div class=login-box>\n\n\t\t<div class=login-box-logo>\n\t\t\t<img src=img/logo_transparent_200x75.png>\n\t\t</div>\n\n    <div class=invite-box>\n\t\t\t<h3>\n\t\t\t\t<i class=\"fa fa-users\"></i>&nbsp;\n\t\t\t\tChange active organization\n\t\t\t</h3>\n\n\t\t\t<div class=modal-tagline>\n\t\t\t\tYou have been added to another Organization <br>\n\t\t\t\tdue to an open invitation!\n\t\t\t\t<br><br>\n\n\t\t\t\tPlease select which organization you want to <br>\n\t\t\t\tuse right now (you can change this later at any time).\n\t\t\t</div>\n\n\t\t\t<div style=\"display:inline-block;width:400px;margin:30px 0\">\n\t\t\t\t<table class=grafana-options-table>\n\t\t\t\t\t<tr ng-repeat=\"org in orgs\">\n\t\t\t\t\t\t<td class=\"nobg max-width-btns\">\n\t\t\t\t\t\t\t<a ng-click=setUsingOrg(org) class=\"btn btn-inverse\">\n\t\t\t\t\t\t\t\t{{org.name}} ({{org.role}})\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\n\t\t</div>\n\n\n\t\t<div class=row style=margin-top:50px>\n\t\t\t<div class=\"version-footer text-center small\">\n\t\t\t\tGrafana version: {{buildInfo.version}}, commit: {{buildInfo.commit}},\n\t\t\t\tbuild date: {{buildInfo.buildstamp | date: 'yyyy-MM-dd HH:mm:ss' }}\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 595 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/metrics_tab.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label gf-query-ds-label\">\n\t\t\t\t<i class=\"icon-gf icon-gf-datasources\"></i>\n\t\t\t</label>\n      <label class=gf-form-label>Data Source</label>\n\n      <gf-form-dropdown model=ctrl.panelDsValue css-class=gf-size-auto lookup-text=true get-options=ctrl.getOptions(true) on-change=ctrl.datasourceChanged($option)>\n      </gf-form-dropdown>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label gf-form-label--grow\"></label>\n\t\t</div>\n\t\t<div class=gf-form ng-if=ctrl.queryOptions>\n\t\t\t<a class=gf-form-label ng-click=ctrl.toggleOptions()>\n\t\t\t\t<i class=\"fa fa-fw fa-caret-right\" ng-hide=ctrl.optionsOpen></i><i class=\"fa fa-fw fa-caret-down\" ng-show=ctrl.optionsOpen></i>Options\n\t\t\t</a>\n\t\t</div>\n\t\t<div class=gf-form ng-if=ctrl.hasQueryHelp>\n\t\t\t<button class=gf-form-label ng-click=ctrl.toggleHelp()>\n\t\t\t\t<i class=\"fa fa-fw fa-caret-right\" ng-hide=ctrl.helpOpen></i><i class=\"fa fa-fw fa-caret-down\" ng-show=ctrl.helpOpen></i>Help\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<button class=gf-form-label ng-click=ctrl.toggleQueryTroubleshooter() bs-tooltip=\"'Display query request & response'\">\n\t\t\t\t<i class=\"fa fa-fw fa-caret-right\" ng-hide=ctrl.queryTroubleshooterOpen></i><i class=\"fa fa-fw fa-caret-down\" ng-show=ctrl.queryTroubleshooterOpen></i>Query Inspector\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<div>\n\t\t<div ng-if=ctrl.optionsOpen>\n\t\t\t<div class=\"gf-form gf-form--flex-end\" ng-if=ctrl.queryOptions.minInterval>\n\t\t\t\t<label class=gf-form-label>Min time interval</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-6\" placeholder={{ctrl.panelCtrl.interval}} ng-model=ctrl.panel.interval spellcheck=false ng-model-onblur ng-change=ctrl.panelCtrl.refresh() />\n\t\t\t\t<info-popover mode=right-absolute>\n\t\t\t\t\tA lower limit for the auto group by time interval. Recommended to be set to write frequency,\n\t\t\t\t\tfor example <code>1m</code> if your data is written every minute. Access auto interval via variable <code>$__interval</code> for time range\n\t\t\t\t\tstring and <code>$__interval_ms</code> for numeric variable that can be used in math expressions.\n\t\t\t\t</info-popover>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form gf-form--flex-end\" ng-if=ctrl.queryOptions.cacheTimeout>\n\t\t\t\t<label class=\"gf-form-label width-9\">Cache timeout</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-6\" placeholder=60 ng-model=ctrl.panel.cacheTimeout ng-model-onblur ng-change=ctrl.panelCtrl.refresh() spellcheck=false />\n\t\t\t\t<info-popover mode=right-absolute>\n\t\t\t\t\tIf your time series store has a query cache this option can override the default\n\t\t\t\t\tcache timeout. Specify a numeric value in seconds.\n\t\t\t\t</info-popover>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form gf-form--flex-end\" ng-if=ctrl.queryOptions.maxDataPoints>\n\t\t\t\t<label class=\"gf-form-label width-9\">Max data points</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-6\" placeholder=auto ng-model-onblur ng-change=ctrl.panelCtrl.refresh() ng-model=ctrl.panel.maxDataPoints spellcheck=false />\n\t\t\t\t<info-popover mode=right-absolute>\n\t\t\t\t\tThe maximum data points the query should return. For graphs this\n\t\t\t\t\tis automatically set to one data point per pixel.\n\t\t\t\t</info-popover>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=grafana-info-box ng-if=ctrl.helpOpen>\n\t\t\t<div class=markdown-html ng-bind-html=ctrl.helpHtml></div>\n\t\t\t<a class=grafana-info-box__close ng-click=ctrl.toggleHelp()>\n\t\t\t\t<i class=\"fa fa-chevron-up\"></i>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<query-troubleshooter panel-ctrl=ctrl.panelCtrl is-open=ctrl.queryTroubleshooterOpen></query-troubleshooter>\n\t</div>\n</div>\n\n<div class=\"query-editor-rows gf-form-group\" ng-if=ctrl.datasourceInstance>\n\t<div ng-repeat=\"target in ctrl.panel.targets\" ng-class=\"{'gf-form-disabled': target.hide}\">\n\t\t<rebuild-on-change property=\"ctrl.panel.datasource || target.datasource\" show-null=true>\n\t\t\t<plugin-component type=query-ctrl>\n\t\t\t</plugin-component>\n\t\t</rebuild-on-change>\n\t</div>\n\n\t<div class=gf-form-query>\n\t\t<div class=\"gf-form gf-form-query-letter-cell\">\n\t\t\t<label class=gf-form-label>\n\t\t\t\t<span class=gf-form-query-letter-cell-carret>\n\t\t\t\t\t<i class=\"fa fa-caret-down\"></i>\n\t\t\t\t</span>\n\t\t\t\t<span class=gf-form-query-letter-cell-letter>{{ctrl.panelCtrl.nextRefId}}</span>\n\t\t\t</label>\n\t\t\t<button class=\"btn btn-secondary gf-form-btn\" ng-click=ctrl.addQuery() ng-hide=ctrl.datasourceInstance.meta.mixed>\n\t\t\t\tAdd Query\n\t\t\t</button>\n\n\t\t\t<div class=dropdown ng-if=ctrl.datasourceInstance.meta.mixed>\n\t\t\t\t<gf-form-dropdown model=ctrl.addQueryDropdown get-options=ctrl.getOptions(false) on-change=ctrl.addMixedQuery($option)>\n\t\t\t\t</gf-form-dropdown>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 596 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/panelTime.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=gf-form-label>\n\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t</span>\n\n\t\t<span class=\"gf-form-label width-12\">Override relative time</span>\n\t\t<span class=\"gf-form-label width-6\">Last</span>\n\n\t\t<input type=text class=\"gf-form-input max-width-8\" placeholder=1h empty-to-null ng-model=ctrl.panel.timeFrom valid-time-span ng-change=ctrl.refresh() ng-model-onblur>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<span class=gf-form-label>\n\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t</span>\n\t\t<span class=\"gf-form-label width-12\">Add time shift</span>\n\t\t<span class=\"gf-form-label width-6\">Amount</span>\n\t\t<input type=text class=\"gf-form-input max-width-8\" placeholder=1h empty-to-null ng-model=ctrl.panel.timeShift valid-time-span ng-change=ctrl.refresh() ng-model-onblur>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>\n\t\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t\t</span>\n\t\t</div>\n\t\t<gf-form-switch class=\"gf-form max-width-30\" label=\"Hide time override info\" label-class=width-12 checked=ctrl.panel.hideTimeOverride switch-class=max-width-6 on-change=ctrl.refresh()>\n\t\t</gf-form-switch>\n\t</div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 597 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/query_editor_row.html';
var html = "\n<div class=gf-form-query>\n\t<div class=\"gf-form gf-form-query-letter-cell\">\n    <label class=gf-form-label>\n      <a class=pointer tabindex=1 ng-click=ctrl.toggleCollapse()>\n        <span ng-class=\"{muted: !ctrl.canCollapse}\" class=gf-form-query-letter-cell-carret>\n          <i class=\"fa fa-caret-down\" ng-hide=ctrl.collapsed></i>\n          <i class=\"fa fa-caret-right\" ng-show=ctrl.collapsed></i>\n        </span>\n        <span class=gf-form-query-letter-cell-letter>{{ctrl.target.refId}}</span>\n        <em class=gf-form-query-letter-cell-ds ng-show=ctrl.target.datasource>({{ctrl.target.datasource}})</em>\n      </a>\n\t\t</label>\n  </div>\n\n\t<div class=\"gf-form-query-content gf-form-query-content--collapsed\" ng-if=ctrl.collapsed>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label pointer gf-form-label--grow\" ng-click=ctrl.toggleCollapse()>\n\t\t\t\t{{ctrl.collapsedText}}\n\t\t\t</label>\n\t\t</div>\n\t</div>\n\n\t<div ng-transclude class=gf-form-query-content ng-if=!ctrl.collapsed>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label dropdown\">\n\t\t\t<a class=\"pointer dropdown-toggle\" data-toggle=dropdown tabindex=1>\n\t\t\t\t<i class=\"fa fa-bars\"></i>\n\t\t\t</a>\n\t\t\t<ul class=\"dropdown-menu pull-right\" role=menu>\n\t\t\t\t<li role=menuitem ng-if=ctrl.hasTextEditMode>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.toggleEditorMode()>Toggle Edit Mode</a>\n\t\t\t\t</li>\n\t\t\t\t<li role=menuitem>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.duplicateQuery()>Duplicate</a>\n\t\t\t\t</li>\n\t\t\t\t<li role=menuitem>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.moveQuery(-1)>Move up</a>\n\t\t\t\t</li>\n\t\t\t\t<li role=menuitem>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.moveQuery(1)>Move down</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</label>\n    <label class=gf-form-label>\n\t\t\t<a ng-click=ctrl.toggleHideQuery() role=menuitem>\n\t\t\t\t<i class=\"fa fa-eye\"></i>\n\t\t\t</a>\n\t\t</label>\n\t\t<label class=gf-form-label>\n\t\t\t<a class=pointer tabindex=1 ng-click=ctrl.removeQuery(ctrl.target)>\n\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t</a>\n\t\t</label>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 598 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/soloPanel.html';
var html = "<div class=\"panel panel--solo\" ng-if=panel style=width:100%>\n\t<plugin-component type=panel>\n\t</plugin-component>\n</div>\n<div class=clearfix></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 599 */
/***/ (function(module, exports) {

var path = 'public/app/features/panellinks/module.html';
var html = "<div class=editor-row>\n\t<h5 class=section-heading>\n\t\tDrilldown / detail link<tip>These links appear in the dropdown menu in the panel menu. </tip></h5>\n\t\n\n\t<div class=gf-form-group ng-repeat=\"link in panel.links\">\n\t\t<div class=section>\n\t\t\t<div class=\"gf-form max-width-25\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Type</span>\n\t\t\t\t<div class=\"gf-form-select-wrapper gf-form--grow\">\n\t\t\t\t\t<select class=gf-form-input ng-model=link.type ng-options=\"f for f in ['dashboard','absolute']\"></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form max-width-25\">\n\t\t\t\t<span class=\"gf-form-label width-7\" ng-show=\"link.type === 'dashboard'\">Dashboard</span>\n\t\t\t\t<input ng-show=\"link.type === 'dashboard'\" type=text ng-model=link.dashboard bs-typeahead=searchDashboards class=gf-form-input ng-blur=dashboardChanged(link)>\n\n\t\t\t\t<span class=\"gf-form-label width-7\" ng-show=\"link.type === 'absolute'\">Url</span>\n\t\t\t\t<input ng-show=\"link.type === 'absolute'\" type=text ng-model=link.url class=\"gf-form-input max-width-14\">\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form max-width-25\">\n\t\t\t\t<div class=\"gf-form-label width-7\">Title</div>\n\t\t\t\t<input type=text ng-model=link.title class=gf-form-input>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Url params</span>\n\t\t\t\t<input type=text ng-model=link.params class=\"gf-form-input width-10\">\n\t\t\t</div>\n\n\t\t\t<gf-form-switch class=gf-form label-class=width-10 label=\"Include time range\" checked=link.keepTime></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label-class=width-10 label=\"Include variables\" checked=link.includeVars></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label-class=width-10 label=\"Open in new tab \" checked=link.targetBlank></gf-form-switch>\n\t\t</div>\n\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn btn-inverse gf-form-btn\" ng-click=deleteLink(link)><i class=\"fa fa-trash\"></i> Remove Link</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=editor-row>\n\t<button class=\"btn btn-inverse\" ng-click=addLink()><i class=\"fa fa-plus\"></i> Add link</button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 600 */
/***/ (function(module, exports) {

var path = 'public/app/features/playlist/partials/playlist.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container ng-form=playlistEditForm>\n\t<div class=page-header>\n\t\t<h1 ng-show=ctrl.isNew()>New Playlist</h1>\n\t\t<h1 ng-show=!ctrl.isNew()>Edit Playlist</h1>\n\t</div>\n\n\t<p class=playlist-description>A playlist rotates through a pre-selected list of Dashboards. A Playlist can be a great way to build situational awareness, or just show off your metrics to your team or visitors.</p>\n\n\t<div class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t<input type=text required ng-model=ctrl.playlist.name class=\"gf-form-input max-width-21\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Interval</span>\n\t\t\t<input type=text required ng-model=ctrl.playlist.interval placeholder=5m class=\"gf-form-input max-width-21\">\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-group>\n\t\t<h3 class=page-headering>Dashboards</h3>\n\t</div>\n\n\t<div class=row>\n\t\t<div class=col-lg-6>\n\t\t\t<div class=playlist-search-containerwrapper>\n\t\t\t\t<div class=max-width-32>\n\t\t\t\t\t<h5 class=\"page-headering playlist-column-header\">Available</h5>\n\t\t\t\t\t<div style=\"\">\n\t\t\t\t\t\t<playlist-search class=playlist-search-container search-started=ctrl.searchStarted(promise)></playlist-search>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div ng-if=\"ctrl.filteredDashboards.length > 0\">\n\t\t\t\t<table class=\"grafana-options-table playlist-available-list\">\n\t\t\t\t\t<tr ng-repeat=\"playlistItem in ctrl.filteredDashboards\">\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>\n\t\t\t\t\t\t\t&nbsp;&nbsp;{{playlistItem.title}}\n\t\t\t\t\t\t\t<i class=\"fa fa-star\" ng-show=playlistItem.isStarred></i>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=add-dashboard>\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini pull-right\" ng-click=ctrl.addPlaylistItem(playlistItem)>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t\t\tAdd to playlist\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t\t<div class=playlist-search-results-container ng-if=\"ctrl.filteredTags.length > 0;\">\n\t\t\t\t<table class=\"grafana-options-table playlist-available-list\">\n\t\t\t\t\t<tr ng-repeat=\"tag in ctrl.filteredTags\">\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<a class=\"search-result-tag label label-tag\" tag-color-from-name=tag.term>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-tag\"></i>\n\t\t\t\t\t\t\t\t<span>{{tag.term}} &nbsp;({{tag.count}})</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=add-dashboard>\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini pull-right\" ng-click=ctrl.addTagPlaylistItem(tag)>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t\t\tAdd to playlist\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=col-lg-6>\n\t\t\t<h5 class=\"page headering playlist-column-header\">Selected</h5>\n\t\t\t<table class=\"grafana-options-table playlist-available-list\">\n\t\t\t\t<tr ng-repeat=\"playlistItem in ctrl.playlistItems\">\n\t\t\t\t\t<td ng-if=\"playlistItem.type === 'dashboard_by_id'\">\n\t\t\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>&nbsp;&nbsp;{{playlistItem.title}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td ng-if=\"playlistItem.type === 'dashboard_by_tag'\">\n\t\t\t\t\t\t<a class=\"search-result-tag label label-tag\" tag-color-from-name=playlistItem.title>\n\t\t\t\t\t\t\t<i class=\"fa fa-tag\"></i>\n\t\t\t\t\t\t\t<span>{{playlistItem.title}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\n\t\t\t\t\t<td class=selected-playlistitem-settings>\n\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini\" ng-hide=$first ng-click=ctrl.movePlaylistItemUp(playlistItem)>\n\t\t\t\t\t\t\t<i class=\"fa fa-arrow-up\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini\" ng-hide=$last ng-click=ctrl.movePlaylistItemDown(playlistItem)>\n\t\t\t\t\t\t\t<i class=\"fa fa-arrow-down\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini\" ng-click=ctrl.removePlaylistItem(playlistItem)>\n\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n\n\t<div class=clearfix></div>\n\n\t<div class=gf-form-button-row>\n\t\t<a class=\"btn btn-success\" ng-show=ctrl.isNew() ng-disabled=\"ctrl.playlistEditForm.$invalid || ctrl.isPlaylistEmpty()\" ng-click=\"ctrl.savePlaylist(ctrl.playlist, ctrl.playlistItems)\">Create new playlist</a>\n\t\t<a class=\"btn btn-success\" ng-show=!ctrl.isNew() ng-disabled=\"ctrl.playlistEditForm.$invalid || ctrl.isPlaylistEmpty()\" ng-click=\"ctrl.savePlaylist(ctrl.playlist, ctrl.playlistItems)\">Save</a>\n\t\t<a class=btn-text ng-click=ctrl.backToList()>Cancel</a>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 601 */
/***/ (function(module, exports) {

var path = 'public/app/features/playlist/partials/playlist_search.html';
var html = "<div class=playlist-search-field-wrapper>\n  <span style=position:relative>\n    <input type=text placeholder=\"Find dashboards by name\" tabindex=1 ng-keydown=ctrl.keyDown($event) ng-model=ctrl.query.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.searchDashboards() />\n\t\t<div class=playlist-search-switches>\n\t\t\t<i class=\"fa fa-filter\"></i>\n\t\t\t<a class=pointer href=\"javascript:void 0;\" ng-click=ctrl.showStarred() tabindex=2>\n\t\t\t\t<i class=\"fa fa-remove\" ng-show=ctrl.query.starred></i>\n\t\t\t\tstarred\n\t\t\t</a> |\n\t\t\t<a class=pointer href=\"javascript:void 0;\" ng-click=ctrl.getTags() tabindex=3>\n\t\t\t\t<i class=\"fa fa-remove\" ng-show=ctrl.tagsMode></i>\n\t\t\t\ttags\n\t\t\t</a>\n\t\t\t<span ng-if=ctrl.query.tag.length>\n\t\t\t\t|\n\t\t\t\t<span ng-repeat=\"tagName in ctrl.query.tag\">\n\t\t\t\t\t<a ng-click=\"ctrl.removeTag(tagName, $event)\" tag-color-from-name=ctrl.tagName class=\"label label-tag\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t{{tagName}}\n\t\t\t\t\t</a>\n\t\t\t\t</span>\n\t\t\t</span>\n\t\t</div>\n\t</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 602 */
/***/ (function(module, exports) {

var path = 'public/app/features/playlist/partials/playlists.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n  <div class=page-header>\n    <h1>Saved playlists</h1>\n    <a class=\"btn btn-success pull-right\" href=playlists/create>\n      <i class=\"fa fa-plus\"></i>\n      New Playlist\n    </a>\n  </div>\n\n  <table class=filter-table style=margin-top:20px>\n    <thead>\n      <th><strong>Name</strong></th>\n      <th><strong>Start url</strong></th>\n      <th style=width:78px></th>\n      <th style=width:78px></th>\n      <th style=width:25px></th>\n    </thead>\n    <tr ng-repeat=\"playlist in ctrl.playlists\">\n      <td>\n\t\t\t\t<a href=playlists/edit/{{playlist.id}}>{{playlist.name}}</a>\n      </td>\n      <td>\n\t\t\t\t<a href=playlists/play/{{playlist.id}}>playlists/play/{{playlist.id}}</a>\n      </td>\n      <td class=text-center>\n        <a href=playlists/play/{{playlist.id}} class=\"btn btn-inverse btn-small\">\n          <i class=\"fa fa-play\"></i>\n          Play\n        </a>\n      </td>\n      <td class=text-right>\n        <a href=playlists/edit/{{playlist.id}} class=\"btn btn-inverse btn-small\">\n          <i class=\"fa fa-edit\"></i>\n          Edit\n        </a>\n      </td>\n      <td class=text-right>\n        <a ng-click=ctrl.removePlaylist(playlist) class=\"btn btn-danger btn-small\">\n          <i class=\"fa fa-remove\"></i>\n        </a>\n      </td>\n    </tr>\n  </table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 603 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/import_list/import_list.html';
var html = "<div class=gf-form-group ng-if=ctrl.dashboards.length>\n\t<table class=filter-table>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"dash in ctrl.dashboards\">\n\t\t\t\t<td class=width-1>\n\t\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<a href=dashboard/{{dash.importedUri}} ng-show=dash.imported>\n\t\t\t\t\t\t{{dash.title}}\n\t\t\t\t\t</a>\n\t\t\t\t\t<span ng-show=!dash.imported>\n\t\t\t\t\t\t{{dash.title}}\n\t\t\t\t\t</span>\n\t\t\t\t</td>\n\t\t\t\t<td>\n          <span>\n            Revision: {{dash.revision}}\n            <span ng-if=dash.imported class=small>(Imported: {{dash.importedRevision}})</span>\n          <span>\n\t\t\t\t</span></span></td>\n\t\t\t\t<td style=text-align:right>\n\t\t\t\t\t<button class=\"btn btn-secondary btn-small\" ng-click=\"ctrl.import(dash, false)\" ng-show=!dash.imported>\n\t\t\t\t\t\tImport\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-secondary btn-small\" ng-click=\"ctrl.import(dash, true)\" ng-show=dash.imported>\n            <span ng-if=\"dash.revision !== dash.importedRevision\">Update</span>\n            <span ng-if=\"dash.revision === dash.importedRevision\">Re-import</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-danger btn-small\" ng-click=ctrl.remove(dash) ng-show=dash.imported>\n\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 604 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_edit.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\n  \t<div class=page-header>\n\t\t<h1 ng-show=ctrl.isNew>Add data source</h1>\n\t\t<h1 ng-hide=ctrl.isNew>Edit data source</h1>\n\n\t\t<div class=page-header-tabs ng-show=ctrl.hasDashboards>\n\t\t\t<ul class=gf-tabs>\n\t\t\t\t<li class=gf-tabs-item>\n\t\t\t\t\t<a class=gf-tabs-link ng-click=\"ctrl.tabIndex = 0\" ng-class=\"{active: ctrl.tabIndex === 0}\">\n\t\t\t\t\t  Config\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=gf-tabs-item>\n\t\t\t\t\t<a class=gf-tabs-link ng-click=\"ctrl.tabIndex = 1\" ng-class=\"{active: ctrl.tabIndex === 1}\">\n\t\t\t\t\t  Dashboards\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\n  \t<div ng-if=\"ctrl.tabIndex === 0\" class=tab-content>\n\n    \t<form name=ctrl.editForm ng-if=ctrl.current>\n      \t\t<div class=gf-form-group>\n        \t\t<div class=gf-form-inline>\n\t\t\t\t\t<div class=\"gf-form max-width-30\">\n\t\t\t\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t\t\t\t<input class=\"gf-form-input max-width-23\" type=text ng-model=ctrl.current.name placeholder=name required>\n\t\t\t\t\t\t<info-popover offset=\"0px -135px\" mode=right-absolute>\n\t\t\t\t\t\t\tThe name is used when you select the data source in panels.\n\t\t\t\t\t\t\tThe <em>Default</em> data source is preselected in new\n\t\t\t\t\t\t\tpanels.\n\t\t\t\t\t\t</info-popover>\n\t\t\t\t\t</div>\n\t\t\t\t\t<gf-form-switch class=gf-form label=Default checked=ctrl.current.isDefault switch-class=max-width-6></gf-form-switch>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"gf-form max-width-30\">\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Type</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-23\">\n\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.current.type ng-options=\"v.id as v.name for v in ctrl.types\" ng-change=ctrl.userChangedType()></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"alert alert-info gf-form-group\" ng-if=\"ctrl.datasourceMeta.state === 'alpha'\">\n\t\t\t\tThis plugin is marked as being in alpha state, which means it is in early development phase and\n\t\t\t\tupdates will include breaking changes.\n\t\t\t</div>\n\n\t\t\t<rebuild-on-change property=ctrl.datasourceMeta.id>\n\t\t\t<plugin-component type=datasource-config-ctrl>\n\t\t\t</plugin-component>\n\t\t\t</rebuild-on-change>\n\n\t\t\t<div ng-if=ctrl.testing class=gf-form-group>\n\t\t\t\t<h5 ng-show=!ctrl.testing.done>Testing.... <i class=\"fa fa-spiner fa-spin\"></i></h5>\n\t\t\t\t<div class=\"alert-{{ctrl.testing.status}} alert\" ng-show=ctrl.testing.done>\n\t\t\t\t\t<div class=alert-icon>\n\t\t\t\t\t\t<i class=\"fa fa-exclamation-triangle\" ng-show=\"ctrl.testing.status === 'error'\"></i>\n\t\t\t\t\t\t<i class=\"fa fa-check\" ng-show=\"ctrl.testing.status !== 'error'\"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=alert-body>\n\t\t\t\t\t\t<div class=alert-title>{{ctrl.testing.message}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success width-6\" ng-show=ctrl.isNew ng-click=ctrl.saveChanges()>Add</button>\n\t\t\t\t<button type=submit class=\"btn btn-success width-8\" ng-show=!ctrl.isNew ng-click=ctrl.saveChanges()>Save &amp; Test</button>\n\t\t\t\t<button type=submit class=\"btn btn-danger width-6\" ng-show=!ctrl.isNew ng-click=ctrl.delete()>\n\t\t\t\t\tDelete\n\t\t\t\t</button>\n\t\t\t\t<a class=\"btn btn-link\" href=datasources>Cancel</a>\n\t\t\t</div>\n\n\t\t</form>\n\t</div>\n\n\t<div ng-if=\"ctrl.tabIndex === 1\" class=tab-content>\n\t\t<dashboard-import-list plugin=ctrl.datasourceMeta datasource=ctrl.current></dashboard-import-list>\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 605 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_http_settings.html';
var html = "\n\n<div class=gf-form-group>\n  <h3 class=page-heading>HTTP settings</h3>\n  <div class=gf-form-group>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-30\">\n        <span class=\"gf-form-label width-7\">URL</span>\n        <input class=gf-form-input type=text ng-model=current.url placeholder={{suggestUrl}} bs-typeahead=getSuggestUrls min-length=0 ng-pattern=\"/^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?$/\" required>\n        <info-popover mode=right-absolute>\n          <p>Specify a complete HTTP URL (for example http://your_server:8080)</p>\n          <span ng-show=\"current.access === 'direct'\">\n            Your access method is <em>Direct</em>, this means the URL\n            needs to be accessible from the browser.\n          </span>\n          <span ng-show=\"current.access === 'proxy'\">\n            Your access method is currently <em>Proxy</em>, this means the URL\n            needs to be accessible from the grafana backend.\n          </span>\n        </info-popover>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-30\">\n        <span class=\"gf-form-label width-7\">Access</span>\n        <div class=\"gf-form-select-wrapper gf-form-select-wrapper--has-help-icon max-width-24\">\n          <select class=gf-form-input ng-model=current.access ng-options=\"f for f in ['direct', 'proxy']\"></select>\n          <info-popover mode=right-absolute>\n            Direct = URL is used directly from browser<br>\n            Proxy = Grafana backend will proxy the request\n          </info-popover>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <h3 class=page-heading>HTTP Auth</h3>\n    <div class=gf-form-group>\n      <div class=gf-form-inline>\n        <gf-form-switch class=gf-form label=\"Basic Auth\" checked=current.basicAuth label-class=width-8 switch-class=max-width-6></gf-form-switch>\n        <gf-form-switch class=gf-form label=\"With Credentials\" tooltip=\"Whether credentials such as cookies or auth headers should be sent with cross-site requests.\" checked=current.withCredentials label-class=width-11 switch-class=max-width-6></gf-form-switch>\n      </div>\n      <div class=gf-form-inline>\n        <gf-form-switch class=gf-form ng-if=\"current.access=='proxy'\" label=\"TLS Client Auth\" label-class=width-8 checked=current.jsonData.tlsAuth switch-class=max-width-6></gf-form-switch>\n        <gf-form-switch class=gf-form ng-if=\"current.access=='proxy'\" label=\"With CA Cert\" tooltip=\"Needed for verifing self-signed TLS Certs\" checked=current.jsonData.tlsAuthWithCACert label-class=width-11 switch-class=max-width-6></gf-form-switch>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <gf-form-switch class=gf-form ng-if=\"current.access=='proxy'\" label=\"Skip TLS Verification (Insecure)\" label-class=width-16 checked=current.jsonData.tlsSkipVerify switch-class=max-width-6></gf-form-switch>\n    </div>\n  </div>\n\n\n<div class=gf-form-group ng-if=current.basicAuth>\n  <h6>Basic Auth Details</h6>\n\t<div class=gf-form ng-if=current.basicAuth>\n\t\t<span class=\"gf-form-label width-7\">\n\t\t\tUser\n\t\t</span>\n\t\t<input class=\"gf-form-input max-width-21\" type=text ng-model=current.basicAuthUser placeholder=user required>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-7\">\n\t\t\tPassword\n\t\t</span>\n\t\t<input class=\"gf-form-input max-width-21\" type=password ng-model=current.basicAuthPassword placeholder=password required>\n\t</div>\n</div>\n\n<div class=gf-form-group ng-if=\"(current.jsonData.tlsAuth || current.jsonData.tlsAuthWithCACert) && current.access=='proxy'\">\n  <div class=gf-form>\n    <h6>TLS Auth Details</h6>\n    <info-popover mode=header>TLS Certs are encrypted and stored in the Grafana database.</info-popover>\n  </div>\n  <div ng-if=current.jsonData.tlsAuthWithCACert>\n    <div class=gf-form-inline>\n      <div class=\"gf-form gf-form--v-stretch\">\n        <label class=\"gf-form-label width-7\">CA Cert</label>\n      </div>\n      <div class=\"gf-form gf-form--grow\" ng-if=!current.secureJsonFields.tlsCACert>\n        <textarea rows=7 class=\"gf-form-input gf-form-textarea\" ng-model=current.secureJsonData.tlsCACert placeholder=\"Begins with -----BEGIN CERTIFICATE-----\"></textarea>\n      </div>\n\n      <div class=gf-form ng-if=current.secureJsonFields.tlsCACert>\n        <input type=text class=\"gf-form-input max-width-12\" disabled=disabled value=configured>\n        <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"current.secureJsonFields.tlsCACert = false\">reset</a>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=current.jsonData.tlsAuth>\n    <div class=gf-form-inline>\n      <div class=\"gf-form gf-form--v-stretch\">\n        <label class=\"gf-form-label width-7\">Client Cert</label>\n      </div>\n      <div class=\"gf-form gf-form--grow\" ng-if=!current.secureJsonFields.tlsClientCert>\n        <textarea rows=7 class=\"gf-form-input gf-form-textarea\" ng-model=current.secureJsonData.tlsClientCert placeholder=\"Begins with -----BEGIN CERTIFICATE-----\" required></textarea>\n      </div>\n      <div class=gf-form ng-if=current.secureJsonFields.tlsClientCert>\n        <input type=text class=\"gf-form-input max-width-12\" disabled=disabled value=configured>\n        <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"current.secureJsonFields.tlsClientCert = false\">reset</a>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=\"gf-form gf-form--v-stretch\">\n        <label class=\"gf-form-label width-7\">Client Key</label>\n      </div>\n      <div class=\"gf-form gf-form--grow\" ng-if=!current.secureJsonFields.tlsClientKey>\n        <textarea rows=7 class=\"gf-form-input gf-form-textarea\" ng-model=current.secureJsonData.tlsClientKey placeholder=\"Begins with -----BEGIN RSA PRIVATE KEY-----\" required></textarea>\n      </div>\n      <div class=gf-form ng-if=current.secureJsonFields.tlsClientKey>\n        <input type=text class=\"gf-form-input max-width-12\" disabled=disabled value=configured>\n        <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"current.secureJsonFields.tlsClientKey = false\">reset</a>\n      </div>\n    </div>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_list.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Data Sources</h1>\n\t\t<a class=\"btn btn-success\" href=datasources/new>\n\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\tAdd data source\n\t\t</a>\n\t</div>\n\n\t<section class=card-section layout-mode>\n    <layout-selector></layout-selector>\n\n\t\t<ol class=card-list>\n\t\t\t<li class=card-item-wrapper ng-repeat=\"ds in ctrl.datasources\">\n\t\t\t\t<a class=card-item href=datasources/edit/{{ds.id}}/ >\n\t\t\t\t\t<div class=card-item-header>\n\t\t\t\t\t\t<div class=card-item-type>\n\t\t\t\t\t\t\t{{ds.type}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=card-item-body>\n\t\t\t\t\t\t<figure class=card-item-figure>\n\t\t\t\t\t\t\t<img ng-src={{ds.typeLogoUrl}}>\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t<div class=card-item-details>\n\t\t\t\t\t\t\t<div class=card-item-name>\n\t\t\t\t\t\t\t\t{{ds.name}}\n\t\t\t\t\t\t\t\t<span ng-if=ds.isDefault>\n\t\t\t\t\t\t\t\t\t<span class=\"btn btn-secondary btn-mini\">default</span>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=card-item-sub-name>\n\t\t\t\t\t\t\t\t{{ds.url}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ol>\n\t</section>\n\n\t<div ng-if=\"ctrl.datasources.length === 0\">\n\t\t<em>No data sources defined</em>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 607 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/plugin_edit.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container ng-init=ctrl.init()>\n  <div class=page-header>\n    <div class=plugin-header>\n      <span class=plugin-header-logo>\n        <img ng-src={{ctrl.model.info.logos.large}}>\n      </span>\n\n      <div class=plugin-header-info-block>\n        <h1 class=plugin-header-name>{{ctrl.model.name}}</h1>\n        <div class=plugin-header-author>By {{ctrl.model.info.author.name}}</div>\n        <div class=plugin-header-stamps>\n          <span class=plugin-header-stamps-type>\n            <i class={{ctrl.pluginIcon}}></i> {{ctrl.model.type}}\n          </span>\n        </div>\n      </div>\n    </div>\n\n    <ul class=gf-tabs>\n      <li class=gf-tabs-item ng-repeat=\"tab in ctrl.tabs\">\n        <a class=gf-tabs-link ng-click=\"ctrl.tabIndex = $index\" ng-class=\"{active: ctrl.tabIndex === $index}\">\n          {{::tab}}\n        </a>\n      </li>\n    </ul>\n\n  </div>\n\n  <div class=page-body>\n    <div class=\"tab-content page-content-with-sidebar\" ng-if=\"ctrl.tabs[ctrl.tabIndex] === 'Readme'\">\n      <div ng-bind-html=ctrl.readmeHtml class=markdown-html>\n      </div>\n    </div>\n\n    <div class=\"tab-content page-content-with-sidebar\" ng-if=\"ctrl.tabs[ctrl.tabIndex] === 'Config'\">\n      <div ng-if=ctrl.model.id>\n        <plugin-component type=app-config-ctrl></plugin-component>\n\n\t      <div class=gf-form-button-row>\n\t\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.enable() ng-show=!ctrl.model.enabled>Enable</button>\n\t\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.update() ng-show=ctrl.model.enabled>Update</button>\n\t\t\t\t\t<button type=submit class=\"btn btn-danger\" ng-click=ctrl.disable() ng-show=ctrl.model.enabled>Disable</button>\n\t\t\t\t</div>\n      </div>\n    </div>\n\n    <div class=\"tab-content page-content-with-sidebar\" ng-if=\"ctrl.tabs[ctrl.tabIndex] === 'Dashboards'\">\n\t\t\t<dashboard-import-list plugin=ctrl.model></dashboard-import-list>\n    </div>\n\n    <aside class=page-sidebar>\n      <section class=page-sidebar-section>\n        <h4>Version</h4>\n        <span>{{ctrl.model.info.version}}</span>\n\t\t\t\t<div ng-show=ctrl.model.hasUpdate>\n          <a ng-click=ctrl.updateAvailable() bs-tooltip=ctrl.model.latestVersion>Update Available!</a>\n\t\t\t\t</div>\n      </section>\n      <section class=page-sidebar-section ng-show=\"ctrl.model.type === 'app'\">\n        <h5>Includes\n        <ul class=\"ui-list plugin-info-list\">\n          <li ng-repeat=\"plug in ctrl.includes\" class=plugin-info-list-item>\n            <i class={{plug.icon}}></i>\n            {{plug.name}}\n          </li>\n        </ul>\n      </h5></section>\n      <section class=page-sidebar-section>\n        <h5>Dependencies\n        <ul class=\"ui-list plugin-info-list\">\n          <li class=plugin-info-list-item>\n            <img src=public/img/grafana_icon.svg>\n            Grafana {{ctrl.model.dependencies.grafanaVersion}}\n          </li>\n          <li ng-repeat=\"plugDep in ctrl.model.dependencies.plugins\" class=plugin-info-list-item>\n            <i class={{plugDep.icon}}></i>\n            {{plugDep.name}} {{plugDep.version}}\n          </li>\n        </ul>\n      </h5></section>\n      <section class=page-sidebar-section>\n        <h5>Links\n        <ul class=ui-list>\n          <li ng-repeat=\"link in ctrl.model.info.links\">\n            <a href={{link.url}} class=external-link target=_blank>{{link.name}}</a>\n          </li>\n        </ul>\n      </h5></section>\n    </aside>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 608 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/plugin_list.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n  <div class=page-header>\n    <h1>\n\t\t\tPlugins <span class=\"muted small\">(currently installed)</span>\n\t\t</h1>\n\n\t\t<div class=page-header-tabs>\n\t\t\t<ul class=gf-tabs>\n\t\t\t\t<li class=gf-tabs-item>\n\t\t\t\t\t<a class=gf-tabs-link href=\"plugins?type=panel\" ng-class=\"{active: ctrl.tabIndex === 0}\">\n\t\t\t\t\t\tPanels\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=gf-tabs-item>\n\t\t\t\t\t<a class=gf-tabs-link href=\"plugins?type=datasource\" ng-class=\"{active: ctrl.tabIndex === 1}\">\n\t\t\t\t\t\tData sources\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=gf-tabs-item>\n\t\t\t\t\t<a class=gf-tabs-link href=\"plugins?type=app\" ng-class=\"{active: ctrl.tabIndex === 2}\">\n\t\t\t\t\t\tApps\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\n      <a class=get-more-plugins-link href=\"https://grafana.com/plugins?utm_source=grafana_plugin_list\" target=_blank>\n        Find more <img src=public/img/icn-plugins-tiny.svg />plugins on Grafana.com\n      </a>\n    </div>\n  </div>\n\n  <section class=card-section layout-mode>\n    <layout-selector></layout-selector>\n\n    <ol class=card-list>\n      <li class=card-item-wrapper ng-repeat=\"plugin in ctrl.plugins\">\n        <a class=card-item href=plugins/{{plugin.id}}/edit>\n          <div class=card-item-header>\n            <div class=card-item-type>\n              <i class=\"icon-gf icon-gf-{{plugin.type}}\"></i>\n              {{plugin.type}}\n            </div>\n            <div class=card-item-notice ng-show=plugin.hasUpdate>\n              <span bs-tooltip=plugin.latestVersion>Update available!</span>\n            </div>\n          </div>\n          <div class=card-item-body>\n            <figure class=card-item-figure>\n              <img ng-src={{plugin.info.logos.small}}>\n            </figure>\n            <div class=card-item-details>\n              <div class=card-item-name>{{plugin.name}}</div>\n              <div class=card-item-sub-name>By {{plugin.info.author.name}}</div>\n            </div>\n          </div>\n        </a>\n      </li>\n    </ol>\n  </section>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/plugin_page.html';
var html = "<navbar model=ctrl.navModel ng-if=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div ng-if=ctrl.page>\n\t\t<plugin-component type=app-page>\n\t\t</plugin-component>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/update_instructions.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-cloud-download\"></i>\n\t\t\t<span class=p-l-1>Update Plugin</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\t\t<div class=gf-form-group>\n\t\t\t<p>Type the following on the command line to update {{plugin.name}}.</p>\n\t\t\t<pre><code>grafana-cli plugins update {{plugin.id}}</code></pre>\n\t\t\t<span class=small>Check out {{plugin.name}} on <a href=https://grafana.com/plugins/{{plugin.id}}>Grafana.com</a> for README and changelog. If you do not have access to the command line, ask your Grafana administator.</span>\n\t\t</div>\n\t\t<p class=pluginlist-none-installed><img class=pluginlist-inline-logo src=public/img/grafana_icon.svg><strong>Pro tip</strong>: To update all plugins at once, type <code class=code--small>grafana-cli plugins update-all</code> on the command line.</p></div>\n\t</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

var path = 'public/app/features/snapshot/partials/snapshots.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n  <div class=page-header>\n    <h1>Available snapshots</h1>\n  </div>\n\n\n   <table class=filter-table style=margin-top:20px>\n    <thead>\n      <th><strong>Name</strong></th>\n      <th><strong>Snapshot url</strong></th>\n      <th style=width:70px></th>\n      <th style=width:25px></th>\n\n   </thead>\n\n    <tr ng-repeat=\"snapshot in ctrl.snapshots\">\n      <td>\n\t\t\t\t<a href=dashboard/snapshot/{{snapshot.key}}>{{snapshot.name}}</a>\n      </td>\n      <td>\n        <a href=dashboard/snapshot/{{snapshot.key}}>dashboard/snapshot/{{snapshot.key}}</a>\n      </td>\n      <td class=text-center>\n        <a href=dashboard/snapshot/{{snapshot.key}} class=\"btn btn-inverse btn-mini\">\n          <i class=\"fa fa-eye\"></i>\n          View\n        </a>\n      </td>\n      <td class=text-right>\n        <a ng-click=ctrl.removeSnapshot(snapshot) class=\"btn btn-danger btn-mini\">\n          <i class=\"fa fa-remove\"></i>\n        </a>\n      </td>\n    </tr>\n  </table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

var path = 'public/app/features/styleguide/styleguide.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>Style Guide</h1>\n\n\t\t<a class=\"btn btn-success\" ng-click=ctrl.switchTheme()>\n\t\t\t<i class=\"fa fa-random\"></i>\n\t\t\tSwitch theme\n\t\t</a>\n\n\t\t<div class=page-header-tabs>\n\t\t\t<ul class=gf-tabs>\n\t\t\t\t<li class=gf-tabs-item ng-repeat=\"page in ctrl.pages\">\n\t\t\t\t\t<a class=gf-tabs-link href=styleguide/{{page}} ng-class=\"{active: ctrl.page[page]}\">{{page}}</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\n\t</div>\n\n\t<div class=tab-pane ng-if=ctrl.page.colors>\n\t\t<ul>\n\t\t\t<li class=style-guide-color-card ng-repeat=\"color in ctrl.colors\" style=background-color:{};>\n\t\t\t\t<strong>${{color.name}}</strong>\n\t\t\t\t<em>{{color.value}}</em>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class=tab-pane ng-if=ctrl.page.buttons>\n\t\t<div ng-repeat=\"variant in ctrl.buttonVariants\" class=row>\n\t\t\t<div ng-repeat=\"btnSize in ctrl.buttonSizes\" class=\"style-guide-button-list p-a-2 col-md-4\">\n\t\t\t\t<button ng-repeat=\"buttonName in ctrl.buttonNames\" class=\"btn btn{{variant}}{{buttonName}} {{btnSize}}\">\n\t\t\t\t\tbtn{{variant}}{{buttonName}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"tab-pane style-guide-icon-list\" ng-if=ctrl.page.icons>\n\t\t<div class=row>\n\t\t\t<div ng-repeat=\"icon in ctrl.icons\" class=\"col-md-2 col-sm-3 col-xs-4\">\n\t\t\t\t<i class=\"icon-gf icon-gf-{{icon}}\" bs-tooltip=\"'icon-gf icon-gf-{{icon}}'\"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"tab-pane style-guide-plugin-authoring\" ng-if=ctrl.page.plugins>\n\t\t<p>From grafana 3.0 it's very easy to develop your own plugins and share them with other grafana users.</p>\n\t\t<p>More information about plugin development can be found at <a href=http://docs.grafana.org/plugins/developing/development/ target=_blank>docs.grafana.org</a></p>\n\t</div>\n\n\t<div class=tab-pane ng-if=ctrl.page.forms>\n\t\tforms\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 613 */
/***/ (function(module, exports) {

var path = 'public/app/features/templating/partials/editor.html';
var html = "<div ng-controller=VariableEditorCtrl ng-init=init()>\n  <div class=tabbed-view-header>\n    <h2 class=tabbed-view-title>\n      Templating\n    </h2>\n\n    <ul class=gf-tabs>\n      <li class=gf-tabs-item>\n        <a class=gf-tabs-link ng-click=\"mode = 'list';\" ng-class=\"{active: mode === 'list'}\">\n          Variables\n        </a>\n      </li>\n      <li class=gf-tabs-item ng-show=\"mode === 'edit'\">\n        <a class=gf-tabs-link ng-class=\"{active: mode === 'edit'}\">\n          Edit\n        </a>\n      </li>\n      <li class=gf-tabs-item ng-show=\"mode === 'new'\">\n        <span class=\"active gf-tabs-link\">New</span>\n      </li>\n\t\t\t<li class=gf-tabs-item>\n        <a class=gf-tabs-link ng-click=\"mode = 'help';\" ng-class=\"{active: mode === 'help'}\">\n          Help\n        </a>\n      </li>\n    </ul>\n\n    <button class=tabbed-view-close-btn ng-click=dismiss();>\n      <i class=\"fa fa-remove\"></i>\n    </button>\n  </div>\n\n  <div class=tabbed-view-body>\n\n    <div ng-if=\"mode === 'list'\">\n      <div ng-if=\"variables.length === 0\">\n        <em>No template variables defined</em>\n        <br/> <br/>\n\t\t\t</div>\n      <table class=grafana-options-table>\n        <tr ng-repeat=\"variable in variables\">\n          <td style=width:1%>\n            <span class=template-variable>\n              ${{variable.name}}\n            </span>\n          </td>\n          <td class=max-width style=max-width:200px>\n            {{variable.query}}\n          </td>\n\n          <td style=width:1%><i ng-click=_.move(variables,$index,$index-1) ng-hide=$first class=\"pointer fa fa-arrow-up\"></i></td>\n          <td style=width:1%><i ng-click=_.move(variables,$index,$index+1) ng-hide=$last class=\"pointer fa fa-arrow-down\"></i></td>\n          <td style=width:1%>\n            <a ng-click=duplicate(variable) class=\"btn btn-inverse btn-mini\">\n              Duplicate\n            </a>\n          </td>\n          <td style=width:1%>\n            <a ng-click=edit(variable) class=\"btn btn-inverse btn-mini\">\n              <i class=\"fa fa-edit\"></i>\n              Edit\n            </a>\n          </td>\n          <td style=width:1%>\n            <a ng-click=removeVariable(variable) class=\"btn btn-danger btn-mini\">\n              <i class=\"fa fa-remove\"></i>\n            </a>\n          </td>\n        </tr>\n      </table>\n    </div>\n\n    <div ng-show=\"mode === 'help'\">\n\t\t\t<div class=\"grafana-info-box col-lg-8\">\n\t\t\t\t<h5>What does templating do?</h5>\n\t\t\t\t<p>Templating allows for more interactive and dynamic dashboards. Instead of hard-coding things like server, application\n\t\t\t\tand sensor name in you metric queries you can use variables in their place. Variables are shown as dropdown select boxes at the top of\n\t\t\t\tthe dashboard. These dropdowns make it easy to change the data being displayed in your dashboard.\n\t\t\t\t<br>\n\t\t\t\t<br>\n\n\t\t\t\tCheckout the <a class=external-link target=_blank href=http://docs.grafana.org/reference/templating/ >Templating documentation</a> for more information.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n    <div class=gf-form ng-show=\"mode === 'list'\">\n      <div class=gf-form-button-row>\n        <a type=button class=\"btn gf-form-button btn-success\" ng-click=\"mode = 'new';\"><i class=\"fa fa-plus\"></i>&nbsp;&nbsp;New</a>\n      </div>\n    </div>\n\n    <form ng-if=\"mode === 'edit' || mode === 'new'\" name=ctrl.form>\n      <h5 class=section-heading>Variable</h5>\n      <div class=gf-form-group>\n\t\t\t\t<div class=gf-form-inline>\n          <div class=\"gf-form max-width-19\">\n            <span class=\"gf-form-label width-6\">Name</span>\n            <input type=text class=gf-form-input name=name placeholder=name ng-model=current.name required ng-pattern=namePattern>\n          </div>\n          <div class=\"gf-form max-width-19\">\n            <span class=\"gf-form-label width-6\">\n              Type\n              <info-popover mode=right-normal>\n                {{variableTypes[current.type].description}}\n              </info-popover>\n            </span>\n            <div class=\"gf-form-select-wrapper max-width-17\">\n              <select class=gf-form-input ng-model=current.type ng-options=\"k as v.name for (k, v) in variableTypes\" ng-change=typeChanged()></select>\n            </div>\n          </div>\n        </div>\n\n\t\t\t\t<div class=gf-form ng-show=ctrl.form.name.$error.pattern>\n          <span class=\"gf-form-label gf-form-label--error\">Template names cannot begin with '__' that's reserved for Grafanas global variables</span>\n        </div>\n\n        <div class=gf-form-inline>\n          <div class=\"gf-form max-width-19\">\n            <span class=\"gf-form-label width-6\">Label</span>\n            <input type=text class=gf-form-input ng-model=current.label placeholder=\"optional display name\">\n          </div>\n          <div class=\"gf-form max-width-19\">\n            <span class=\"gf-form-label width-6\">Hide</span>\n            <div class=\"gf-form-select-wrapper max-width-15\">\n              <select class=gf-form-input ng-model=current.hide ng-options=\"f.value as f.text for f in hideOptions\"></select>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div ng-if=\"current.type === 'interval'\" class=gf-form-group>\n        <h5 class=section-heading>Interval Options</h5>\n\n        <div class=gf-form>\n          <span class=\"gf-form-label width-9\">Values</span>\n          <input type=text class=gf-form-input placeholder=name ng-model=current.query placeholder=1m,10m,1h,6h,1d,7d ng-model-onblur ng-change=runQuery() required>\n        </div>\n\n        <div class=gf-form-inline>\n          <gf-form-switch class=gf-form label=\"Auto Option\" label-class=width-9 checked=current.auto on-change=runQuery()>\n          </gf-form-switch>\n\n          <div class=gf-form>\n            <span class=\"gf-form-label width-9\" ng-show=current.auto>\n              Step count <tip>How many times should the current time range be divided to calculate the value</tip>\n            </span>\n            <div class=\"gf-form-select-wrapper max-width-10\" ng-show=current.auto>\n              <select class=gf-form-input ng-model=current.auto_count ng-options=\"f for f in [1,2,3,4,5,10,20,30,40,50,100,200,300,400,500]\" ng-change=runQuery()></select>\n            </div>\n          </div>\n          <div class=gf-form>\n            <span class=gf-form-label ng-show=current.auto>\n              Min interval <tip>The calculated value will not go below this threshold</tip>\n            </span>\n            <input type=text class=\"gf-form-input max-width-10\" ng-show=current.auto ng-model=current.auto_min ng-change=runQuery() placeholder=10s>\n          </div>\n        </div>\n      </div>\n\n      <div ng-if=\"current.type === 'custom'\" class=gf-form-group>\n        <h5 class=section-heading>Custom Options</h5>\n        <div class=gf-form>\n          <span class=\"gf-form-label width-14\">Values separated by comma</span>\n          <input type=text class=gf-form-input ng-model=current.query ng-blur=runQuery() placeholder=\"1, 10, 20, myvalue\" required>\n        </div>\n      </div>\n\n      <div ng-if=\"current.type === 'constant'\" class=gf-form-group>\n        <h5 class=section-heading>Constant options</h5>\n        <div class=gf-form>\n          <span class=gf-form-label>Value</span>\n          <input type=text class=gf-form-input ng-model=current.query ng-blur=runQuery() placeholder=\"your metric prefix\">\n        </div>\n      </div>\n\n      <div ng-if=\"current.type === 'query'\" class=gf-form-group>\n        <h5 class=section-heading>Query Options</h5>\n\n        <div class=gf-form-inline>\n          <div class=\"gf-form max-width-21\">\n            <span class=\"gf-form-label width-7\">Data source</span>\n            <div class=\"gf-form-select-wrapper max-width-14\">\n              <select class=gf-form-input ng-model=current.datasource ng-options=\"f.value as f.name for f in datasources\" required>\n                <option value=\"\" ng-if=false></option>\n              </select>\n            </div>\n          </div>\n          <div class=\"gf-form max-width-21\">\n            <span class=\"gf-form-label width-7\">\n              Refresh\n              <info-popover mode=right-normal>\n                When to update the values of this variable.\n              </info-popover>\n            </span>\n            <div class=\"gf-form-select-wrapper max-width-14\">\n              <select class=gf-form-input ng-model=current.refresh ng-options=\"f.value as f.text for f in refreshOptions\"></select>\n            </div>\n          </div>\n        </div>\n        <div class=gf-form>\n          <span class=\"gf-form-label width-7\">Query</span>\n          <input type=text class=gf-form-input ng-model=current.query placeholder=\"metric name or tags query\" ng-model-onblur ng-change=runQuery() required>\n        </div>\n        <div class=gf-form>\n          <span class=\"gf-form-label width-7\">\n            Regex\n            <info-popover mode=right-normal>\n              Optional, if you want to extract part of a series name or metric node segment.\n            </info-popover>\n          </span>\n          <input type=text class=gf-form-input ng-model=current.regex placeholder=/.*-(.*)-.*/ ng-model-onblur ng-change=runQuery()>\n        </div>\n        <div class=\"gf-form max-width-21\">\n          <span class=\"gf-form-label width-7\">\n            Sort\n            <info-popover mode=right-normal>\n              How to sort the values of this variable.\n            </info-popover>\n          </span>\n          <div class=\"gf-form-select-wrapper max-width-14\">\n            <select class=gf-form-input ng-model=current.sort ng-options=\"f.value as f.text for f in sortOptions\" ng-change=runQuery()></select>\n          </div>\n        </div>\n      </div>\n\n      <div ng-show=\"current.type === 'datasource'\" class=gf-form-group>\n        <h5 class=section-heading>Data source options</h5>\n\n        <div class=gf-form>\n          <label class=\"gf-form-label width-12\">Type</label>\n          <div class=\"gf-form-select-wrapper max-width-18\">\n            <select class=gf-form-input ng-model=current.query ng-options=\"f.value as f.text for f in datasourceTypes\" ng-change=runQuery()></select>\n          </div>\n        </div>\n\n        <div class=gf-form>\n          <label class=\"gf-form-label width-12\">\n            Instance name filter\n            <info-popover mode=right-normal>\n              Regex filter for which data source instances to choose from in\n              the variable value dropdown. Leave empty for all.\n              <br><br>\n              Example: <code>/^prod/</code>\n\n            </info-popover>\n          </label>\n          <input type=text class=\"gf-form-input max-width-18\" ng-model=current.regex placeholder=/.*-(.*)-.*/ ng-model-onblur ng-change=runQuery()>\n        </div>\n      </div>\n\n      <div ng-if=\"current.type === 'adhoc'\" class=gf-form-group>\n        <h5 class=section-heading>Options</h5>\n        <div class=\"gf-form max-width-21\">\n          <span class=\"gf-form-label width-8\">Data source</span>\n          <div class=\"gf-form-select-wrapper max-width-14\">\n            <select class=gf-form-input ng-model=current.datasource ng-options=\"f.value as f.name for f in datasources\" required ng-change=validate()>\n              <option value=\"\" ng-if=false></option>\n            </select>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"section gf-form-group\" ng-show=variableTypes[current.type].supportsMulti>\n        <h5 class=section-heading>Selection Options</h5>\n        <div class=section>\n          <gf-form-switch class=gf-form label=Multi-value label-class=width-10 tooltip=\"Enables multiple values to be selected at the same time\" checked=current.multi on-change=runQuery()>\n          </gf-form-switch>\n          <gf-form-switch class=gf-form label=\"Include All option\" label-class=width-10 checked=current.includeAll on-change=runQuery()>\n          </gf-form-switch>\n        </div>\n        <div class=gf-form ng-if=current.includeAll>\n          <span class=\"gf-form-label width-10\">Custom all value</span>\n          <input type=text class=\"gf-form-input max-width-15\" ng-model=current.allValue placeholder=\"blank = auto\">\n        </div>\n      </div>\n\n      <div class=gf-form-group ng-if=\"current.type === 'query'\">\n        <h5>Value groups/tags (Experimental feature)</h5>\n        <gf-form-switch class=gf-form label=Enabled label-class=width-10 checked=current.useTags on-change=runQuery()>\n        </gf-form-switch>\n        <div class=\"gf-form last\" ng-if=current.useTags>\n          <span class=\"gf-form-label width-10\">Tags query</span>\n          <input type=text class=gf-form-input ng-model=current.tagsQuery placeholder=\"metric name or tags query\" ng-model-onblur>\n        </div>\n        <div class=gf-form ng-if=current.useTags>\n          <li class=\"gf-form-label width-10\">Tag values query</li>\n          <input type=text class=gf-form-input ng-model=current.tagValuesQuery placeholder=apps.$tag.* ng-model-onblur>\n        </div>\n      </div>\n\n      <div class=gf-form-group ng-show=current.options.length>\n        <h5>Preview of values (shows max 20)</h5>\n        <div class=gf-form-inline>\n          <div class=gf-form ng-repeat=\"option in current.options | limitTo: 20\">\n            <span class=gf-form-label>{{option.text}}</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"alert alert-info gf-form-group\" ng-if=infoText>\n        {{infoText}}\n      </div>\n\n      <div class=\"gf-form-button-row p-y-0\">\n        <button type=submit class=\"btn btn-success\" ng-show=\"mode === 'edit'\" ng-click=update();>Update</button>\n        <button type=submit class=\"btn btn-success\" ng-show=\"mode === 'new'\" ng-click=add();>Add</button>\n      </div>\n\n    </form>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

var path = 'public/app/partials/confirm_modal.html';
var html = "<div class=modal-body ng-cloak>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa {{icon}}\"></i>\n\t\t\t<span class=p-l-1>\n\t\t\t\t{{title}}\n\t\t\t</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=\"modal-content text-center\">\n\n\t\t<div class=confirm-modal-text>\n\t\t\t{{text}}\n\t\t\t<div class=confirm-modal-text2 ng-show=text2>\n\t\t\t\t{{text2}}\n\t\t\t</div>\n\t\t</div>\n\n\n\t\t<div class=modal-content-confirm-text ng-if=confirmText>\n\t\t\t<input type=text class=\"gf-form-input width-16\" style=display:inline-block placeholder=\"Type {{confirmText}} to confirm\" ng-model=confirmInput ng-change=updateConfirmText(confirmInput)>\n\t\t</div>\n\n\t\t<div class=confirm-modal-buttons>\n\t\t\t<button type=button class=\"btn btn-inverse\" ng-click=dismiss()>{{noText}}</button>\n\t\t\t<button type=button class=\"btn btn-danger\" ng-click=onConfirm();dismiss(); ng-disabled=!confirmTextValid give-focus=true>{{yesText}}</button>\n\t\t\t<button ng-show=onAltAction type=button class=\"btn btn-success\" ng-click=dismiss();onAltAction();>{{altActionText}}</button>\n\t\t</div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

var path = 'public/app/partials/dashboard.html';
var html = "<div dash-class ng-if=dashboard>\n\t<dashnav dashboard=dashboard></dashnav>\n\n\t<div class=dashboard-container>\n\t\t<div dash-editor-view class=dash-edit-view></div>\n\t\t<div class=clearfix></div>\n\n\t\t<dashboard-submenu ng-if=dashboard.meta.submenuEnabled dashboard=dashboard></dashboard-submenu>\n\n\t\t<div class=clearfix></div>\n\n    <dash-row class=dash-row ng-repeat=\"row in dashboard.rows\" row=row dashboard=dashboard>\n    </dash-row>\n\n    <div ng-show=\"dashboard.meta.canEdit && !dashboard.meta.fullscreen\" class=add-row-panel-hint>\n      <div class=span12 style=text-align:left>\n        <span style=margin-left:12px ng-click=addRowDefault() class=\"pointer btn btn-inverse btn-small\">\n          <span><i class=\"fa fa-plus\"></i> ADD ROW</span>\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 616 */
/***/ (function(module, exports) {

var path = 'public/app/partials/edit_json.html';
var html = "<div ng-controller=JsonEditorCtrl>\n\t<div class=tabbed-view-header>\n\t\t<h2 class=tabbed-view-title>\n\t\t\tJSON\n\t\t</h2>\n\n\t\t<button class=tabbed-view-close-btn ng-click=dismiss()>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</button>\n\t</div>\n\n\t<div class=tabbed-view-body>\n\t\t<div class=gf-form>\n\t\t\t<textarea class=gf-form-input ng-model=json rows=20 spellcheck=false></textarea>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=button class=\"btn btn-success\" ng-show=canUpdate ng-click=\"update(); dismiss();\">Update</button>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

var path = 'public/app/partials/error.html';
var html = "<navbar model=navModel></navbar>\n\n<div class=page-container>\n\n  <div class=page-header>\n    <h1>\n\t\tPage not found (404)\n\t</h1>\n\t</div>\n\t<div class=error-row>\n\t\t<div class=dash-row-menu-grip><i class=\"fa fa-ellipsis-v\"></i></div>\n\t\t<div class=\"panel-container error-row\">\n\t\t\t<div class=\"error-column graph-box\">\n\t\t\t\t<div class=error-row>\n\t\t\t\t\t<div class=\"error-column error-space-between graph-percentage\">\n\t\t\t\t\t\t<p>100%</p>\n\t\t\t\t\t\t<p>80%</p>\n\t\t\t\t\t\t<p>60%</p>\n\t\t\t\t\t\t<p>40%</p>\n\t\t\t\t\t\t<p>20%</p>\n\t\t\t\t\t\t<p>0%</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"error-column image-box\">\n\t\t\t\t\t\t<img src=public/img/graph404.svg width=100%>\n\t\t\t\t\t\t<div class=\"error-row error-space-between\">\n\t\t\t\t\t\t\t<p class=graph-text>Then</p>\n\t\t\t\t\t\t\t<p class=graph-text>Now</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"error-column info-box\">\n\t\t\t\t<div class=\"error-row current-box\">\n\t\t\t\t\t<p class=current-text>current</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=error-row style=flex:1>\n\t\t\t\t\t<i class=\"fa fa-minus error-minus\"></i>\n\t\t\t\t\t<div class=\"error-column error-space-between\">\n\t\t\t\t\t\t<div class=\"error-row error-space-between\">\n\t\t\t\t\t\t\t<p>Chances you are on the page you are looking for.</p>\n\t\t\t\t\t\t\t<p class=left-margin>0%</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<h3>Sorry for the inconvenience</h3>\n\t\t\t\t\t\t\t<p>Please go back to your <a href={{appSubUrl}}/ class=error-link>home dashboard</a> and try again.</p>\n\t\t\t\t\t\t\t<p>If the error persists, seek help on the <a href=https://community.grafana.com target=_blank class=error-link>community site</a>.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<span class=\"resize-panel-handle icon-gf icon-gf-grabber\" style=cursor:default></span>\n\t\t</div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

var path = 'public/app/partials/login.html';
var html = "<div class=\"login-container container\">\n\n\t<div class=login-box>\n\n\t\t<div class=login-box-logo>\n\t\t\t<img class=logo-icon src=public/img/grafana_icon.svg><br>\n\t\t\t<i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n\t\t</div>\n\n    <div class=login-inner-box>\n\t\t\t<div class=login-tab-header>\n\t\t\t\t<button class=btn-login-tab ng-click=\"loginMode = true;\" ng-class=\"{active: loginMode}\">\n\t\t\t\t\tLog in\n\t\t\t\t</button>\n\t\t\t\t<button class=btn-login-tab ng-click=\"loginMode = false;\" ng-class=\"{active: !loginMode}\" ng-show=!disableUserSignUp>\n\t\t\t\t\tSign up\n\t\t\t\t</button>\n\t\t\t</div>\n\n      <form name=loginForm class=\"login-form gf-form-group\" ng-hide=disableLoginForm>\n\t\t\t\t<div class=gf-form ng-if=loginMode>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t\t\t<input type=text name=username class=\"gf-form-input max-width-14\" required ng-model=formModel.user placeholder={{loginHint}}>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form ng-if=loginMode>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t\t\t<input type=password name=password class=\"gf-form-input max-width-14\" required ng-model=formModel.password id=inputPassword placeholder=password>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form ng-if=!loginMode>\n\t\t\t\t\t\t<span class=\"gf-form-label width-7\">Email</span>\n\t\t\t\t\t\t<input type=email class=\"gf-form-input max-width-14\" required ng-model=formModel.email placeholder=email>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<button type=submit class=\"btn btn-large p-x-3\" ng-click=submit(); ng-class=\"{'btn-inverse': !loginForm.$valid, 'btn-primary': loginForm.$valid}\">\n\t\t\t\t\t\t{{submitBtnText}}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\n\t\t\t<div ng-if=loginMode>\n\t\t\t\t<div class=\"text-center login-divider\" ng-show=oauthEnabled>\n\t\t\t\t\t<div class=login-divider-line>\n\t\t\t\t\t\t<span class=login-divider-text>\n\t\t\t\t\t\t\t<span ng-hide=disableLoginForm>Or</span> Login With\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=clearfix></div>\n\n\t\t\t\t<div class=\"login-oauth text-center\" ng-show=oauthEnabled>\n\t\t\t\t\t<a class=\"btn btn-large btn-google\" href=login/google target=_self ng-if=oauth.google>\n\t\t\t\t\t\t<i class=\"fa fa-google\"></i>\n\t\t\t\t\t\tGoogle\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class=\"btn btn-large btn-github\" href=login/github target=_self ng-if=oauth.github>\n\t\t\t\t\t\t<i class=\"fa fa-github\"></i>\n\t\t\t\t\t\tGitHub\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class=\"btn btn-large btn-grafana-com\" href=login/grafana_com target=_self ng-if=oauth.grafana_com>\n\t\t\t\t\t\t<img src=public/img/grafana_com_auth_icon.svg>\n\t\t\t\t\t\t<span>Grafana.com</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class=\"btn btn-large btn-generic-oauth\" href=login/generic_oauth target=_self ng-if=oauth.generic_oauth>\n\t\t\t\t\t\t<i class=\"fa fa-gear\"></i>\n\t\t\t\t\t\t{{oauth.generic_oauth.name}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=clearfix></div>\n\n\t\t<div class=\"text-center password-recovery\" ng-hide=disableLoginForm>\n\t\t\t<div class=text-center>\n\t\t\t\t<a href=user/password/send-reset-email>\n\t\t\t\t\tForgot your password?\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

var path = 'public/app/partials/modal.html';
var html = "<div class=modal-header>\n  <button type=button class=close data-dismiss=modal aria-hidden=true>×</button>\n  <h3>{{modal.title}}</h3>\n</div>\n<div class=modal-body>\n\n  <div ng-bind-html=modal.body></div>\n\n</div>\n<div class=modal-footer>\n  <button type=button class=\"btn btn-danger\" ng-click=dismiss()>Close</button>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

var path = 'public/app/partials/panelgeneral.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Info</h5>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Title</span>\n\t\t\t<input type=text class=\"gf-form-input width-25\" ng-model=ctrl.panel.title>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--v-stretch\">\n\t\t\t<span class=\"gf-form-label width-7\">Description</span>\n\t\t\t<textarea class=\"gf-form-input width-25\" rows=3 ng-model=ctrl.panel.description placeholder=\"Panel description, supports markdown & links\"></textarea>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Dimensions</h5>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Span</span>\n\t\t\t<select class=\"gf-form-input width-6\" ng-model=ctrl.panel.span ng-options=\"f for f in [0,1,2,3,4,5,6,7,8,9,10,11,12]\"></select>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Height</span>\n\t\t\t<input type=text class=\"gf-form-input width-6\" ng-model=ctrl.panel.height placeholder=100px>\n\t\t</div>\n\t\t<gf-form-switch class=gf-form label-class=width-7 switch-class=max-width-6 label=Transparent checked=ctrl.panel.transparent on-change=ctrl.render()></gf-form-switch>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Templating</h5>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-8\">Repeat Panel</span>\n\t\t\t<dash-repeat-option model=ctrl.panel></dash-repeat-option>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-8\">Min span</span>\n\t\t\t<select class=gf-form-input ng-model=ctrl.panel.minSpan ng-options=\"f for f in [1,2,3,4,5,6,7,8,9,10,11,12]\">\n\t\t\t\t<option value=\"\"></option>\n\t\t\t</select>\n\t\t</div>\n\t</div>\n\t</div>\n\n\t<panel-links-editor panel=ctrl.panel></panel-links-editor>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

var path = 'public/app/partials/reset_password.html';
var html = "<div class=\"login-container container\">\n\n\t<div class=login-box>\n\n\t\t<div class=login-box-logo>\n\t\t\t<img class=logo-icon src=public/img/grafana_icon.svg><br>\n\t\t\t<i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n\t\t</div>\n\n\t\t<div class=login-inner-box>\n\t\t\t<div class=login-tab-header>\n\t\t\t\t<button class=btn-login-tab class=active>\n\t\t\t\t\tReset password\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t\t<form name=sendResetForm class=\"login-form gf-form-group\" ng-show=\"mode === 'send'\">\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t\t\t\t<input type=text name=username class=\"gf-form-input max-width-14\" required ng-model=formModel.userOrEmail placeholder=\"email or username\">\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<br/>\n\t\t\t\t\t<br/>\n\t\t\t\t\t<button type=submit class=\"btn btn-large\" ng-click=sendResetEmail(); ng-class=\"{'btn-inverse': !sendResetForm.$valid, 'btn-primary': sendResetForm.$valid}\">\n\t\t\t\t\t\tReset Password\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\n\n\t\t\t<div style=text-align:center;padding:20px ng-if=\"mode === 'email-sent'\">\n\t\t\t\tAn email with a reset link as been sent to the email address. <br>\n\t\t\t\tYou should receive it shortly.\n\t\t\t</div>\n\n\t\t\t<br/>\n\t\t\t<br/>\n\n\t\t\t<form name=resetForm class=\"login-form gf-form-group\" ng-show=\"mode === 'reset'\">\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-10\">New Password</span>\n\t\t\t\t\t<input type=password name=NewPassword class=\"gf-form-input max-width-14\" required ng-minlength=4 ng-model=formModel.newPassword placeholder=password watch-change=\"formModel.newPassword = inputValue;\">\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-10\">Confirm Password</span>\n\t\t\t\t\t<input type=password name=ConfirmPassword class=\"gf-form-input max-width-14\" required ng-minlength=4 ng-model=formModel.confirmPassword placeholder=\"confirm password\">\n\t\t\t\t</div>\n\n\t\t\t\t<div style=margin-left:141px;width:207px>\n\t\t\t\t\t<password-strength password=formModel.newPassword></password-strength>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<button type=submit class=btn ng-click=submitReset(); ng-class=\"{'btn-inverse': !resetForm.$valid, 'btn-primary': resetForm.$valid}\">\n\t\t\t\t\t\tReset Password\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\n\t\t<div class=row style=margin-top:20px>\n\t\t\t<div class=text-center>\n\t\t\t\t<a href=login>Back to login</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

var path = 'public/app/partials/signup_invited.html';
var html = "<div class=container>\n\n\t<div class=signup-page-background>\n\t</div>\n\n\t<div class=login-box>\n\n\t\t<div class=login-box-logo>\n\t\t\t<img class=logo-icon src=public/img/grafana_icon.svg><br>\n\t\t\t<i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n\t\t</div>\n\n    <div class=invite-box>\n\t\t\t<h3>\n\t\t\t\tHello {{greeting}}.\n\t\t\t</h3>\n\n\t\t\t<div class=\"modal-tagline p-b-2\">\n\t\t\t\t<em>{{invitedBy}}</em> has invited you to join Grafana and the organization <span class=highlight-word>{{contextSrv.user.orgName}}</span><br>Please complete the following to accept your invitation and continue:\n\t\t\t</div>\n\n\t\t\t<form name=inviteForm class=\"login-form gf-form-group\">\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Email</span>\n\t\t\t\t\t<input type=email name=email class=\"gf-form-input max-width-21\" required ng-model=formModel.email placeholder=Email>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t\t\t<input type=text name=name class=\"gf-form-input max-width-21\" ng-model=formModel.name placeholder=\"Name (optional)\">\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Username</span>\n\t\t\t\t\t<input type=text name=username class=\"gf-form-input max-width-21\" required ng-model=formModel.username placeholder=Username>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t\t\t<input type=password name=password class=\"gf-form-input max-width-21\" required ng-model=formModel.password id=inputPassword placeholder=password>\n\t\t\t\t</div>\n\n\t\t\t\t<div style=margin-left:7.5rem;width:254px>\n\t\t\t\t\t<password-strength password=formModel.password></password-strength>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<button type=submit class=\"btn btn-inverse\" ng-click=submit(); ng-class=\"{'btn-inverse': !inviteForm.$valid, 'btn-primary': inviteForm.$valid}\">\n\t\t\t\t\t\tContinue\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\n\t\t</div>\n\t</div>\n\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

var path = 'public/app/partials/signup_step2.html';
var html = "<div class=container>\n\n\t<div class=signup-page-background>\n\t</div>\n\n\t<div class=login-box>\n\n\t\t<div class=login-box-logo>\n\t\t\t<img class=logo-icon src=public/img/grafana_icon.svg><br>\n\t\t\t<i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n\t\t</div>\n\n    <div class=invite-box>\n\t\t\t<h3>\n\t\t\t\tYou're almost there.\n\t\t\t</h3>\n\n\t\t\t<div class=modal-tagline>\n\t\t\t\tWe just need a couple of more bits of<br> information to finish creating your account.\n\t\t\t</div>\n\n\t\t\t<div style=display:inline-block;margin-top:25px;width:300px>\n\t\t\t\t\t<div class=editor-option>\n\t\t\t\t\t\t<label class=small>Your email:</label>\n\t\t\t\t\t\t<span class=large>{{formModel.email}}</span>\n\t\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<br>\n\t\t\t<br>\n\n\t\t\t<form name=signUpForm class=\"login-form gf-form-group\">\n\n\t\t\t\t<div class=gf-form ng-if=verifyEmailEnabled>\n\t\t\t\t\t<span class=\"gf-form-label width-9\">\n\t\t\t\t\t\tEmail code<tip>Email verification code (sent to your email)</tip>\n\t\t\t\t\t</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=formModel.code required>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form ng-if=!autoAssignOrg>\n\t\t\t\t\t<span class=\"gf-form-label width-9\">Org. name</span>\n\t\t\t\t\t<input type=text name=orgName class=\"gf-form-input max-width-14\" ng-model=formModel.orgName placeholder=\"Name your organization\">\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-9\">Your name</span>\n\t\t\t\t\t<input type=text name=name class=\"gf-form-input max-width-14\" ng-model=formModel.name placeholder=(optional)>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-9\">Username</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input max-width-14\" required ng-model=formModel.username placeholder=Username autocomplete=off>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-9\">Password</span>\n\t\t\t\t\t<input type=password class=\"gf-form-input max-width-14\" required ng-model=formModel.password id=inputPassword placeholder=password autocomplete=off>\n\t\t\t\t</div>\n\n\t\t\t\t<div style=margin-left:9rem;width:194px>\n\t\t\t\t\t<password-strength password=formModel.password></password-strength>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<button type=submit class=btn ng-click=ctrl.submit(); ng-class=\"{'btn-inverse': !signUpForm.$valid, 'btn-primary': signUpForm.$valid}\">\n\t\t\t\t\t\tContinue\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\n\t</div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

var path = 'public/app/partials/valueSelectDropdown.html';
var html = "<div class=variable-link-wrapper>\n\t<a ng-click=vm.show() class=\"gf-form-label variable-value-link\">\n\t\t{{vm.linkText}}\n\t\t<span ng-repeat=\"tag in vm.selectedTags\" bs-tooltip=tag.valuesText data-placement=bottom>\n\t\t\t<span class=label-tag tag-color-from-name=tag.text>\n\t\t\t\t&nbsp;&nbsp;<i class=\"fa fa-tag\"></i>&nbsp;\n\t\t\t\t{{tag.text}}\n\t\t\t</span>\n\t\t</span>\n\t\t<i class=\"fa fa-caret-down\"></i>\n\t</a>\n\n\t<input type=text class=gf-form-input style=display:none ng-keydown=vm.keyDown($event) ng-model=vm.search.query ng-change=vm.queryChanged()>\n\n\t<div class=variable-value-dropdown ng-if=vm.dropdownVisible ng-class=\"{'multi': vm.variable.multi, 'single': !vm.variable.multi}\">\n\t\t<div class=variable-options-wrapper>\n\t\t\t<div class=variable-options-column>\n\t\t\t\t<a class=variable-options-column-header ng-if=vm.variable.multi ng-class=\"{'many-selected': vm.selectedValues.length > 1}\" bs-tooltip=\"'Clear selections'\" data-placement=top ng-click=vm.clearSelections()>\n\t\t\t\t\t<span class=variable-option-icon></span>\n\t\t\t\t\tSelected ({{vm.selectedValues.length}})\n\t\t\t\t</a>\n\t\t\t\t<a class=\"variable-option pointer\" ng-repeat=\"option in vm.search.options\" ng-class=\"{'selected': option.selected, 'highlighted': $index === vm.highlightIndex}\" ng-click=\"vm.selectValue(option, $event)\">\n\t\t\t\t\t<span class=variable-option-icon></span>\n\t\t\t\t\t<span>{{option.text}}</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class=variable-options-column ng-if=vm.tags.length>\n\t\t\t\t<div class=\"variable-options-column-header text-center\">\n\t\t\t\t\tTags\n\t\t\t\t</div>\n\t\t\t\t<a class=\"variable-option-tag pointer\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.selectTag(tag, $event)\" ng-class=\"{'selected': tag.selected}\">\n\t\t\t\t\t<span class=\"fa fa-fw variable-option-icon\"></span>\n\t\t\t\t\t<span class=label-tag tag-color-from-name=tag.text>{{tag.text}}&nbsp;&nbsp;<i class=\"fa fa-tag\"></i>&nbsp;</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/app/testdata/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl has-text-edit-mode=false>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Scenario</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.target.scenarioId ng-options=\"v.id as v.name for v in ctrl.scenarioList\" ng-change=ctrl.scenarioChanged()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form gf-form--grow\" ng-if=ctrl.scenario.stringInput>\n\t\t\t<label class=\"gf-form-label query-keyword\">String Input</label>\n      <input type=text class=gf-form-input placeholder={{ctrl.scenario.stringInput}} ng-model=ctrl.target.stringInput ng-change=ctrl.refresh() ng-model-onblur>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Alias</label>\n\t\t\t<input type=text class=\"gf-form-input max-width-7\" placeholder=optional ng-model=ctrl.target.alias ng-change=ctrl.refresh() ng-model-onblur>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/annotations.editor.html';
var html = "<cloudwatch-query-parameter target=ctrl.annotation datasource=ctrl.datasource></cloudwatch-query-parameter>\n\n<div class=editor-row style=\"padding:2rem 0\">\n\t<div class=section>\n\t\t<h5>Prefix matching</h5>\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Enable checked=ctrl.annotation.prefixMatching switch-class=max-width-6></gf-form-switch>\n\t\t\t<div class=gf-form ng-if=ctrl.annotation.prefixMatching>\n\t\t\t\t<span class=gf-form-label>Action</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.actionPrefix>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-if=ctrl.annotation.prefixMatching>\n\t\t\t\t<span class=gf-form-label>Alarm Name</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.alarmNamePrefix>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/config.html';
var html = "<h3 class=page-heading>CloudWatch details</h3>\n\n<div class=\"gf-form-group max-width-30\">\n  <div class=gf-form>\n    <label class=\"gf-form-label width-13\">Auth Provider</label>\n    <select class=\"gf-form-input gf-max-width-13\" ng-model=ctrl.current.jsonData.authType ng-options=\"f.value as f.name for f in ctrl.authTypes\"></select>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"credentials\"'>\n    <label class=\"gf-form-label width-13\">Credentials profile name</label>\n    <input type=text class=\"gf-form-input max-width-18\" ng-model=ctrl.current.database placeholder=default>\n    <info-popover mode=right-absolute>\n      Credentials profile name, as specified in ~/.aws/credentials, leave blank for default\n    </info-popover>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"keys\"'>\n    <label class=\"gf-form-label width-13\">Access key ID </label>\n    <label class=\"gf-form-label width-13\" ng-show=ctrl.accessKeyExist>Configured</label>\n    <a class=\"btn btn-secondary gf-form-btn\" type=submit ng-click=ctrl.resetAccessKey() ng-show=ctrl.accessKeyExist>Reset</a>\n    <input type=text class=\"gf-form-input max-width-18\" ng-hide=ctrl.accessKeyExist ng-model=ctrl.current.secureJsonData.accessKey>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"keys\"'>\n    <label class=\"gf-form-label width-13\">Secret access key</label>\n    <label class=\"gf-form-label width-13\" ng-show=ctrl.secretKeyExist>Configured</label>\n    <a class=\"btn btn-secondary gf-form-btn\" type=submit ng-click=ctrl.resetSecretKey() ng-show=ctrl.secretKeyExist>Reset</a>\n    <input type=text class=\"gf-form-input max-width-18\" ng-hide=ctrl.secretKeyExist ng-model=ctrl.current.secureJsonData.secretKey>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"arn\"'>\n    <label class=\"gf-form-label width-13\">Assume Role ARN</label>\n    <input type=text class=\"gf-form-input max-width-18\" ng-model=ctrl.current.jsonData.assumeRoleArn placeholder=arn:aws:iam:*>\n    <info-popover mode=right-absolute>\n      ARN of Assume Role\n    </info-popover>\n  </div>\n\n  <div class=gf-form>\n    <label class=\"gf-form-label width-13\">Default Region</label>\n    <div class=\"gf-form-select-wrapper max-width-18 gf-form-select-wrapper--has-help-icon\">\n      <select class=gf-form-input ng-model=ctrl.current.jsonData.defaultRegion ng-options=\"region for region in ['ap-northeast-1', 'ap-northeast-2', 'ap-southeast-1', 'ap-southeast-2', 'ap-south-1', 'ca-central-1', 'cn-north-1', 'eu-central-1', 'eu-west-1', 'eu-west-2', 'sa-east-1', 'us-east-1', 'us-east-2', 'us-gov-west-1', 'us-west-1', 'us-west-2']\"></select>\n      <info-popover mode=right-absolute>\n        Specify the region, such as for US West (Oregon) use ` us-west-2 ` as the region.\n      </info-popover>\n    </div>\n  </div>\n  <div class=gf-form>\n    <label class=\"gf-form-label width-13\">Custom Metrics</label>\n    <input type=text class=\"gf-form-input max-width-18\" ng-model=ctrl.current.jsonData.customMetricsNamespaces placeholder=Namespace1,Namespace2>\n    <info-popover mode=right-absolute>\n      Namespaces of Custom Metrics\n    </info-popover>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<cloudwatch-query-parameter target=ctrl.target datasource=ctrl.datasource on-change=ctrl.refresh()></cloudwatch-query-parameter>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 629 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/query.parameter.html';
var html = "<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">Metric</label>\n\n\t\t<metric-segment segment=regionSegment get-options=getRegions() on-change=regionChanged()></metric-segment>\n\t\t<metric-segment segment=namespaceSegment get-options=getNamespaces() on-change=namespaceChanged()></metric-segment>\n\t\t<metric-segment segment=metricSegment get-options=getMetrics() on-change=metricChanged()></metric-segment>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword\">Stats</label>\n\t</div>\n\n\t<div class=gf-form ng-repeat=\"segment in statSegments\">\n\t\t<metric-segment segment=segment get-options=\"getStatSegments(segment, $index)\" on-change=\"statSegmentChanged(segment, $index)\"></metric-segment>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t</div>\n</div>\n\n<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">Dimensions</label>\n\t\t<metric-segment ng-repeat=\"segment in dimSegments\" segment=segment get-options=\"getDimSegments(segment, $index)\" on-change=\"dimSegmentChanged(segment, $index)\"></metric-segment>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t</div>\n</div>\n\n<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\tPeriod\n\t\t\t<info-popover mode=right-normal>Interval between points in seconds</info-popover>\n\t\t</label>\n\t\t<input type=text class=gf-form-input ng-model=target.period spellcheck=false placeholder=auto ng-model-onblur ng-change=onChange() />\n\t</div>\n\t<div class=\"gf-form max-width-30\">\n\t\t<label class=\"gf-form-label query-keyword width-7\">Alias</label>\n\t\t<input type=text class=gf-form-input ng-model=target.alias spellcheck=false ng-model-onblur ng-change=onChange()>\n\t\t<info-popover mode=right-absolute>\n\t\t\tAlias replacement variables:\n\t\t\t<ul ng-non-bindable>\n\t\t\t\t<li>{{metric}}</li>\n\t\t\t\t<li>{{stat}}</li>\n\t\t\t\t<li>{{namespace}}</li>\n\t\t\t\t<li>{{region}}</li>\n\t\t\t\t<li>{{YOUR_DIMENSION_NAME}}</li>\n\t\t\t</ul>\n\t\t</info-popover>\n\t</div>\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form ng-if=ctrl.annotation.index>\n\t\t<span class=\"gf-form-label width-14\">Index name</span>\n\t\t<input type=text class=\"gf-form-input max-width-20\" ng-model=ctrl.annotation.index placeholder=events-*>\n\t</div>\n\t<div class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.query placeholder=\"Elasticsearch lucene query\">\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<h6>Field mappings</h6>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Time</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=ctrl.annotation.timeField placeholder=@timestamp>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Text</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=ctrl.annotation.textField placeholder=\"\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Tags</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.tagsField placeholder=tags>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.annotation.titleField>\n\t\t\t<span class=gf-form-label>Title <em class=muted>(depricated)</em></span>\n\t\t\t<input type=text class=\"gf-form-input max-width-16\" ng-model=ctrl.annotation.titleField placeholder=desc>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/bucket_agg.html';
var html = "<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\t<span ng-show=isFirst>Group by</span>\n\t\t\t<span ng-hide=isFirst>Then by</span>\n\t\t</label>\n\n\t\t<gf-form-dropdown model=agg.type lookup-text=true get-options=getBucketAggTypes() on-change=onTypeChanged() allow-custom=false label-mode=true css-class=width-10>\n\t\t</gf-form-dropdown>\n\t\t<gf-form-dropdown ng-if=agg.field model=agg.field get-options=getFieldsInternal() on-change=onChange() allow-custom=false label-mode=true css-class=width-12>\n\t\t</gf-form-dropdown>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<label class=\"gf-form-label gf-form-label--grow\">\n\t\t\t<a ng-click=toggleOptions()>\n\t\t\t\t<i class=\"fa fa-caret-down\" ng-show=showOptions></i>\n\t\t\t\t<i class=\"fa fa-caret-right\" ng-hide=showOptions></i>\n\t\t\t\t{{settingsLinkText}}\n\t\t\t</a>\n\t\t</label>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=gf-form-label ng-if=isFirst>\n\t\t\t<a class=pointer ng-click=addBucketAgg()><i class=\"fa fa-plus\"></i></a>\n\t\t</label>\n\t\t<label class=gf-form-label ng-if=\"bucketAggCount > 1\">\n\t\t\t<a class=pointer ng-click=removeBucketAgg()><i class=\"fa fa-minus\"></i></a>\n\t\t</label>\n\t</div>\n</div>\n\n<div class=gf-form-group ng-if=showOptions>\n\t<div ng-if=\"agg.type === 'date_histogram'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Interval</label>\n\t\t\t<gf-form-dropdown model=agg.settings.interval get-options=getIntervalOptions() on-change=onChangeInternal() allow-custom=true label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Min Doc Count</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.min_doc_count ng-blur=onChangeInternal()>\n\t\t</div>\n\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">\n\t\t\t\tTrim edges\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tTrim the edges on the timeseries datapoints\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\t\t\t<input class=\"gf-form-input max-width-12\" type=number ng-model=agg.settings.trimEdges ng-change=onChangeInternal()>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'histogram'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Interval</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.interval ng-blur=onChangeInternal()>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Min Doc Count</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.min_doc_count ng-blur=onChangeInternal()>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'terms'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Order</label>\n\t\t\t<gf-form-dropdown model=agg.settings.order lookup-text=true get-options=getOrderOptions() on-change=onChangeInternal() label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Size</label>\n\t\t\t<gf-form-dropdown model=agg.settings.size lookup-text=true get-options=getSizeOptions() on-change=onChangeInternal() label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Min Doc Count</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.min_doc_count ng-blur=onChangeInternal()>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Order By</label>\n\t\t\t<gf-form-dropdown model=agg.settings.orderBy lookup-text=true get-options=getOrderByOptions() on-change=onChangeInternal() label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">\n\t\t\t\tMissing\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tThe missing parameter defines how documents that are missing a value should be treated. By default they will be ignored but it is also possible to treat them as if they had a value\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\t\t\t<input type=text class=\"gf-form-input max-width-12\" empty-to-null ng-model=agg.settings.missing ng-blur=onChangeInternal() spellcheck=false>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'filters'\">\n\t\t<div class=\"gf-form-inline offset-width-7\" ng-repeat=\"filter in agg.settings.filters\">\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-10\">Query {{$index + 1}}</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-12\" ng-model=filter.query spellcheck=false placeholder=\"Lucene query\" ng-blur=onChangeInternal()>\n\t\t\t\t<label class=\"gf-form-label width-10\">Label {{$index + 1}}</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-12\" ng-model=filter.label spellcheck=false placeholder=Label ng-blur=onChangeInternal()>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=gf-form-label ng-if=$first>\n\t\t\t\t\t<a class=pointer ng-click=addFiltersQuery()><i class=\"fa fa-plus\"></i></a>\n\t\t\t\t</label>\n\t\t\t\t<label class=gf-form-label ng-if=!$first>\n\t\t\t\t\t<a class=pointer ng-click=removeFiltersQuery(filter)><i class=\"fa fa-minus\"></i></a>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'geohash_grid'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Precision</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.precision spellcheck=false placeholder=3 ng-blur=onChangeInternal()>\n\t\t</div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:9200>\n</datasource-http-settings>\n\n<h3 class=page-heading>Elasticsearch details</h3>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-25\">\n\t\t\t<span class=\"gf-form-label width-9\">Index name</span>\n\t\t\t<input class=gf-form-input type=text ng-model=ctrl.current.database placeholder=\"\" required>\n\t\t</div>\n\n\t\t<div class=\"gf-form width-14\">\n\t\t\t<span class=\"gf-form-label width-9\">Pattern</span>\n\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.interval ng-options=\"f.value as f.name for f in ctrl.indexPatternTypes\" ng-change=ctrl.indexPatternTypeChanged()></select>\n\t\t</div>\n\t</div>\n\n\t<div class=\"gf-form max-width-25\">\n\t\t<span class=\"gf-form-label width-9\">Time field name</span>\n\t\t<input class=gf-form-input type=text ng-model=ctrl.current.jsonData.timeField placeholder=\"\" required ng-init=\"\">\n\t</div>\n\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-9\">Version</span>\n\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.esVersion ng-options=\"f.value as f.name for f in ctrl.esVersions\"></select>\n\t</div>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-9\">Min interval</span>\n\t\t\t<input type=text class=\"gf-form-input width-6\" ng-model=ctrl.current.jsonData.timeInterval spellcheck=false placeholder=10s>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tA lower limit for the auto group by time interval. Recommended to be set to write frequency,\n\t\t\t\tfor example <code>1m</code> if your data is written every minute.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 633 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/metric_agg.html';
var html = "<div class=gf-form-inline ng-class=\"{'gf-form-disabled': agg.hide}\">\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\tMetric\n\t\t\t&nbsp;\n\t\t\t<a ng-click=toggleShowMetric() bs-tooltip=\"'Click to toggle show / hide metric'\">\n\t\t\t\t<i class=\"fa fa-eye\" ng-hide=agg.hide></i>\n\t\t\t\t<i class=\"fa fa-eye-slash\" ng-show=agg.hide></i>\n\t\t\t</a>\n\t\t</label>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<metric-segment-model property=agg.type options=metricAggTypes on-change=onTypeChange() custom=false css-class=width-10></metric-segment-model>\n\t\t<metric-segment-model ng-if=aggDef.requiresField property=agg.field get-options=getFieldsInternal() on-change=onChange() css-class=width-12></metric-segment-model>\n\t\t<metric-segment-model ng-if=aggDef.isPipelineAgg property=agg.pipelineAgg options=pipelineAggOptions on-change=onChangeInternal() custom=false css-class=width-12></metric-segment-model>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<label class=\"gf-form-label gf-form-label--grow\">\n\t\t\t<a ng-click=toggleOptions() ng-if=settingsLinkText>\n\t\t\t\t<i class=\"fa fa-caret-down\" ng-show=showOptions></i>\n\t\t\t\t<i class=\"fa fa-caret-right\" ng-hide=showOptions></i>\n\t\t\t\t\t{{settingsLinkText}}\n\t\t\t</a>\n\t\t</label>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=gf-form-label ng-if=isFirst>\n\t\t\t<a class=pointer ng-click=addMetricAgg()><i class=\"fa fa-plus\"></i></a>\n\t\t</label>\n\t\t<label class=gf-form-label ng-if=!isSingle>\n\t\t\t<a class=pointer ng-click=removeMetricAgg()><i class=\"fa fa-minus\"></i></a>\n\t\t</label>\n\t</div>\n</div>\n\n<div class=gf-form-group ng-if=showOptions>\n\t<div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'derivative'\">\n\t\t<label class=\"gf-form-label width-10\">Unit</label>\n\t\t<input type=text class=\"gf-form-input max-width-12\" ng-model=agg.settings.unit ng-blur=onChangeInternal() spellcheck=false>\n\t</div>\n\n  <div ng-if=\"agg.type === 'moving_avg'\">\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Model</label>\n      <metric-segment-model property=agg.settings.model options=movingAvgModelTypes on-change=onChangeClearInternal() custom=false css-class=width-12></metric-segment-model>\n    </div>\n\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Window</label>\n      <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.window ng-blur=onChangeInternal() spellcheck=false>\n    </div>\n\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Predict</label>\n      <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.predict ng-blur=onChangeInternal() spellcheck=false>\n    </div>\n\n\n    <div class=\"gf-form offset-width-7\" ng-repeat=\"setting in modelSettings\">\n      <label class=\"gf-form-label width-10\">{{setting.text}}</label>\n      <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.settings[setting.value] ng-blur=onChangeInternal() spellcheck=false>\n    </div>\n\n    <gf-form-switch ng-if=\"agg.settings.model == 'holt_winters'\" class=\"gf-form offset-width-7\" label=Pad label-class=width-10 checked=agg.settings.settings.pad on-change=onChangeInternal()></gf-form-switch>\n    <gf-form-switch ng-if=\"agg.settings.model.match('ewma|holt_winters|holt') !== null\" class=\"gf-form offset-width-7\" label=Minimize label-class=width-10 checked=agg.settings.minimize on-change=onChangeInternal()></gf-form-switch>\n  </div>\n\n  <div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'percentiles'\">\n    <label class=\"gf-form-label width-10\">Percentiles</label>\n    <input type=text class=\"gf-form-input max-width-12\" ng-model=agg.settings.percents array-join ng-blur=onChange()>\n  </div>\n  <div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'raw_document'\">\n    <label class=\"gf-form-label width-10\">Size</label>\n    <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.size ng-blur=onChange()>\n  </div>\n\n\n  <div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'cardinality'\">\n    <label class=\"gf-form-label width-10\">Precision threshold</label>\n    <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.precision_threshold ng-blur=onChange()>\n  </div>\n\n  <div ng-if=\"agg.type === 'extended_stats'\">\n    <gf-form-switch ng-repeat=\"stat in extendedStats\" class=\"gf-form offset-width-7\" label={{stat.text}} label-class=width-10 checked=agg.meta[stat.value] on-change=onChangeInternal()></gf-form-switch>\n\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Sigma</label>\n      <input type=number class=\"gf-form-input max-width-12\" placeholder=3 ng-model=agg.settings.sigma ng-blur=onChange()>\n    </div>\n  </div>\n\n  <div class=\"gf-form offset-width-7\" ng-if=aggDef.supportsInlineScript>\n    <label class=\"gf-form-label width-10\">Script</label>\n    <input type=text class=\"gf-form-input max-width-12\" empty-to-null ng-model=agg.inlineScript ng-blur=onChangeInternal() spellcheck=false placeholder=\"_value * 1\">\n  </div>\n\n  <div class=\"gf-form offset-width-7\" ng-if=aggDef.supportsMissing>\n\t\t<label class=\"gf-form-label width-10\">\n\t\t\tMissing\n\t\t\t<tip>The missing parameter defines how documents that are missing a value should be treated. By default they will be ignored but it is also possible to treat them as if they had a value</tip>\n\t\t</label>\n\t\t<input type=number class=\"gf-form-input max-width-12\" empty-to-null ng-model=agg.settings.missing ng-blur=onChangeInternal() spellcheck=false>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=true>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label query-keyword width-7\">Query</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.query spellcheck=false placeholder=\"Lucene query\" ng-blur=ctrl.refresh()>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<label class=\"gf-form-label query-keyword\">Alias</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"alias patterns\" ng-blur=ctrl.refresh()>\n\t\t</div>\n\t</div>\n\n\t<div ng-repeat=\"agg in ctrl.target.metrics\">\n\t\t<elastic-metric-agg target=ctrl.target index=$index get-fields=ctrl.getFields($fieldType) on-change=ctrl.queryUpdated() es-version=ctrl.esVersion>\n\t\t</elastic-metric-agg>\n\t</div>\n\n\t<div ng-repeat=\"agg in ctrl.target.bucketAggs\">\n\t\t<elastic-bucket-agg target=ctrl.target index=$index get-fields=ctrl.getFields($fieldType) on-change=ctrl.queryUpdated()>\n\t\t</elastic-bucket-agg>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/grafana-live/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label width-8\">Stream</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.stream spellcheck=false placeholder=metric>\n\t\t</div>\n\t</div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/grafana/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-8\">\n\t\t\t\tFilter by\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li>Dashboard: This will fetch annotation and alert state changes for whole dashboard and show them only on the event's originating panel.</li>\n\t\t\t\t\t\t<li>All: This will fetch any annotation events that match the tags filter.</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</info-popover>\n\t\t\t</span>\n\t\t\t<div class=\"gf-form-select-wrapper width-8\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.annotation.type ng-options=\"f.value as f.text for f in ctrl.types\">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form ng-if=\"ctrl.annotation.type === 'tags'\">\n\t\t\t<span class=gf-form-label>Tags</span>\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.annotation.tags tagclass=\"label label-tag\" placeholder=\"add tags\">\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Max limit</span>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.annotation.limit ng-options=\"f for f in [10,50,100,200,300,500,1000,2000]\">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 637 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/grafana/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=gf-form-label>Test data: random walk</label>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/graphite/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form>\n    <span class=\"gf-form-label width-12\">Graphite query</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.target placeholder=\"Example: statsd.application.counters.*.count\">\n  </div>\n\n\t<h5 class=section-heading>Or</h5>\n\n  <div class=gf-form>\n    <span class=\"gf-form-label width-12\">Graphite events tags</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.tags placeholder=\"Example: event_tag_name\">\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/graphite/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:8080>\n</datasource-http-settings>\n\n<h3 class=page-heading>Graphite details</h3>\n\n<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-8\">\n      Version\n      <info-popover mode=right-normal position=\"top center\">\n        This option controls what functions are available in the Graphite query editor.\n      </info-popover>\n    </span>\n\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.graphiteVersion ng-options=\"f.value as f.name for f in ctrl.graphiteVersions\"></select>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/graphite/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl has-text-edit-mode=true>\n\n\t<div class=gf-form ng-show=ctrl.target.textEditor>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.target.target spellcheck=false ng-blur=ctrl.targetTextChanged()>\n\t</div>\n\n  <div ng-hide=ctrl.target.textEditor>\n\t\t<div class=gf-form-inline>\n      <div ng-repeat=\"segment in ctrl.segments\" role=menuitem class=gf-form>\n        <metric-segment segment=segment get-options=ctrl.getAltSegments($index) on-change=\"ctrl.segmentValueChanged(segment, $index)\"></metric-segment>\n      </div>\n\n      <div ng-repeat=\"func in ctrl.functions\" class=gf-form>\n        <span graphite-func-editor class=\"gf-form-label query-part\"></span>\n      </div>\n\n      <div class=\"gf-form dropdown\">\n        <span graphite-add-func></span>\n      </div>\n\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n  </div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/influxdb/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.query placeholder=\"select text from events where $timeFilter\">\n\t</div>\n</div>\n\n<h5 class=section-heading>Field mappings <tip>If your influxdb query returns more than one field you need to specify the column names below. An annotation event is composed of a title, tags, and an additional text field.</tip></h5>\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-4\">Text</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.textColumn placeholder=\"\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-4\">Tags</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.tagsColumn placeholder=\"\">\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.annotation.titleColumn>\n\t\t\t<span class=\"gf-form-label width-4\">Title <em class=muted>(depricated)</em></span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.titleColumn placeholder=\"\">\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 642 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/influxdb/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:8086>\n</datasource-http-settings>\n\n<h3 class=page-heading>InfluxDB Details</h3>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"\" required>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=\"\">\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.password placeholder=\"\">\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Min time interval</span>\n\t\t\t<input type=text class=\"gf-form-input width-6\" ng-model=ctrl.current.jsonData.timeInterval spellcheck=false placeholder=10s>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tA lower limit for the auto group by time interval. Recommended to be set to write frequency,\n\t\t\t\tfor example <code>1m</code> if your data is written every minute.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 643 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/influxdb/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=true has-text-edit-mode=true>\n\n\t<div ng-if=ctrl.target.rawQuery>\n    <div class=gf-form>\n      <textarea rows=3 class=gf-form-input ng-model=ctrl.target.query spellcheck=false placeholder=\"InfuxDB Query\" ng-model-onblur ng-change=ctrl.refresh()></textarea>\n    </div>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword\">FORMAT AS</label>\n        <div class=gf-form-select-wrapper>\n          <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.resultFormat ng-options=\"f.value as f.text for f in ctrl.resultFormats\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=\"gf-form max-width-25\" ng-hide=\"ctrl.target.resultFormat === 'table'\">\n        <label class=\"gf-form-label query-keyword\">ALIAS BY</label>\n        <input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"Naming pattern\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n  </div>\n\n\t<div ng-if=!ctrl.target.rawQuery>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword width-7\">FROM</label>\n\n\t\t\t\t<metric-segment segment=ctrl.policySegment get-options=ctrl.getPolicySegments() on-change=ctrl.policyChanged()></metric-segment>\n\t\t\t\t<metric-segment segment=ctrl.measurementSegment get-options=ctrl.getMeasurements($query) on-change=ctrl.measurementChanged()></metric-segment>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword\">WHERE</label>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form ng-repeat=\"segment in ctrl.tagSegments\">\n\t\t\t\t<metric-segment segment=segment get-options=\"ctrl.getTagsOrValues(segment, $index)\" on-change=\"ctrl.tagSegmentUpdated(segment, $index)\"></metric-segment>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline ng-repeat=\"selectParts in ctrl.queryModel.selectModels\">\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\t\t\t<span ng-show=\"$index === 0\">SELECT</span>&nbsp;\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form ng-repeat=\"part in selectParts\">\n\t\t\t\t<query-part-editor class=\"gf-form-label query-part\" part=part handle-event=\"ctrl.handleSelectPartEvent(selectParts, part, $event)\">\n\t\t\t\t</query-part-editor>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=dropdown dropdown-typeahead=ctrl.selectMenu dropdown-typeahead-on-select=\"ctrl.addSelectPart(selectParts, $item, $subItem)\">\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\t\t\t<span>GROUP BY</span>\n\t\t\t\t</label>\n\n\t\t\t\t<query-part-editor ng-repeat=\"part in ctrl.queryModel.groupByParts\" part=part class=\"gf-form-label query-part\" handle-event=\"ctrl.handleGroupByPartEvent(part, $index, $event)\">\n\t\t\t\t</query-part-editor>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<metric-segment segment=ctrl.groupBySegment get-options=ctrl.getGroupByOptions() on-change=\"ctrl.groupByAction(part, $index)\"></metric-segment>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t\t</div>\n\n    <div class=gf-form-inline ng-if=\"ctrl.target.orderByTime === 'DESC'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">ORDER BY</label>\n        <label class=\"gf-form-label pointer\" ng-click=ctrl.removeOrderByTime()>time <span class=query-keyword>DESC</span> <i class=\"fa fa-remove\"></i></label>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n\n    <div class=gf-form-inline ng-if=ctrl.target.limit>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">LIMIT</label>\n        <input type=text class=\"gf-form-input width-9\" ng-model=ctrl.target.limit spellcheck=false placeholder=\"No Limit\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n\n    <div class=gf-form-inline ng-if=ctrl.target.slimit>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">SLIMIT</label>\n        <input type=text class=\"gf-form-input width-9\" ng-model=ctrl.target.slimit spellcheck=false placeholder=\"No Limit\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">FORMAT AS</label>\n        <div class=gf-form-select-wrapper>\n          <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.resultFormat ng-options=\"f.value as f.text for f in ctrl.resultFormats\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n\n    <div class=gf-form-inline ng-hide=\"ctrl.target.resultFormat === 'table'\">\n      <div class=\"gf-form max-width-30\">\n        <label class=\"gf-form-label query-keyword width-7\">ALIAS BY</label>\n        <input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"Naming pattern\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n  </div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 644 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mysql/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n  <div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<textarea rows=10 class=gf-form-input ng-model=ctrl.annotation.rawQuery spellcheck=false placeholder=\"query expression\" data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.panelCtrl.refresh()></textarea>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n  </div>\n\n  <div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\"><h6>Annotation Query Format</h6>\nAn annotation is an event that is overlayed on top of graphs. The query can have up to four columns per row, the time_sec column is mandatory. Annotation rendering is expensive so it is important to limit the number of rows returned.\n\n- column with alias: <b>time_sec</b> for the annotation event. Format is UTC in seconds, use UNIX_TIMESTAMP(column)\n- column with alias <b>title</b> for the annotation title\n- column with alias: <b>text</b> for the annotation text\n- column with alias: <b>tags</b> for annotation tags. This is a comma separated string of tags e.g. 'tag1,tag2'\n\n\nMacros:\n- $__time(column) -&gt; UNIX_TIMESTAMP(column) as time_sec\n- $__timeFilter(column) -&gt;  UNIX_TIMESTAMP(time_date_time) &gt; 1492750877 AND UNIX_TIMESTAMP(time_date_time) &lt; 1492750877\n- $__unixEpochFilter(column) -&gt;  time_unix_epoch &gt; 1492750877 AND time_unix_epoch &lt; 1492750877\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  FROM_UNIXTIME(1492750877)\n- $__timeTo() -&gt;  FROM_UNIXTIME(1492750877)\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mysql/partials/config.html';
var html = "\n<h3 class=page-heading>MySQL Connection</h3>\n\n<div class=gf-form-group>\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Host</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.url placeholder=localhost:3306 bs-typeahead=\"{{['localhost:3306', 'localhost:3307']}}\" required>\n\t</div>\n\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"database name\" required>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=user>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.password placeholder=password>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=grafana-info-box>\n\t\t<h5>User Permission</h5>\n\t\t<p>\n\t\t\tThe database user should only be granted SELECT permissions on the specified database &amp; tables you want to query.\n\t\t\tGrafana does not validate that queries are safe so queries can contain any SQL statement. For example, statements\n\t\t\tlike <code>USE otherdb;</code> and <code>DROP TABLE user;</code> would be executed. To protect against this we\n\t\t\t<strong>Highly</strong> recommmend you create a specific MySQL user with restricted permissions.\n\n\t\t\tCheckout the <a class=external-link target=_blank href=http://docs.grafana.org/features/datasources/mysql/ >MySQL Data Source Docs</a> for more information.\n\t\t</p>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 646 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mysql/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<code-editor content=ctrl.target.rawSql datasource=ctrl.datasource on-change=ctrl.panelCtrl.refresh() data-mode=sql>\n\t\t\t</code-editor>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Format as</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.lastQueryMeta>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showLastQuerySQL = !ctrl.showLastQuerySQL\">\n        Generated SQL\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showLastQuerySQL></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showLastQuerySQL></i>\n      </label>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showLastQuerySQL>\n\t\t<pre class=gf-form-pre>{{ctrl.lastQueryMeta.sql}}</pre>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\">Time series:\n- return column named time_sec (UTC in seconds), use UNIX_TIMESTAMP(column)\n- return column named value for the time point value\n- return column named metric to represent the series name\n\nTable:\n- return any set of columns\n\nMacros:\n- $__time(column) -&gt; UNIX_TIMESTAMP(column) as time_sec\n- $__timeFilter(column) -&gt;  UNIX_TIMESTAMP(time_date_time) &ge; 1492750877 AND UNIX_TIMESTAMP(time_date_time) &le; 1492750877\n- $__unixEpochFilter(column) -&gt;  time_unix_epoch &gt; 1492750877 AND time_unix_epoch &lt; 1492750877\n- $__timeGroup(column,'5m') -&gt; (extract(epoch from \"dateColumn\")/extract(epoch from '5m'::interval))::int\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  FROM_UNIXTIME(1492750877)\n- $__timeTo() -&gt;  FROM_UNIXTIME(1492750877)\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n\n\t\n\n\t<div class=gf-form ng-show=ctrl.lastQueryError>\n\t\t<pre class=\"gf-form-pre alert alert-error\">{{ctrl.lastQueryError}}</pre>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/opentsdb/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form>\n    <span class=\"gf-form-label width-13\">OpenTSDB metrics query</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.target placeholder=events.eventname>\n  </div>\n  <gf-form-switch class=gf-form label=\"Show Global Annotations?\" checked=ctrl.annotation.isGlobal switch-class=max-width-6 label-class=width-13></gf-form-switch>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 648 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/opentsdb/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:4242></datasource-http-settings>\n\n<h5>OpenTSDB settings</h5>\n<div class=gf-form>\n  <span class=\"gf-form-label width-7\">\n    Version\n  </span>\n  <span class=gf-form-select-wrapper>\n    <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.tsdbVersion ng-options=\"v.value as v.name for v in ctrl.tsdbVersions\"></select>\n  </span>\n</div>\n<div class=gf-form>\n  <span class=\"gf-form-label width-7\">\n    Resolution\n  </span>\n  <span class=gf-form-select-wrapper>\n    <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.tsdbResolution ng-options=\"v.value as v.name for v in ctrl.tsdbResolutions\"></select>\n  </span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 649 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/opentsdb/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-25\">\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\t\tMetric\n\t\t\t\t<label class=gf-form-label bs-tooltip=ctrl.errors.metric style=color:#e5bd1c ng-show=ctrl.errors.metric>\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t</label>\n\t\t\t</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.metric spellcheck=false bs-typeahead=ctrl.suggestMetrics placeholder=\"metric name\" data-min-length=0 data-items=100 ng-blur=ctrl.targetBlur()>\n\t\t\t\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">\n\t\t\t\tAggregator\n\t\t\t\t<a bs-tooltip=ctrl.errors.aggregator style=color:#e5bd1c ng-show=ctrl.errors.aggregator>\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t<select ng-model=ctrl.target.aggregator class=gf-form-input ng-options=\"agg for agg in ctrl.aggregators\" ng-change=ctrl.targetBlur()>\n\t\t \t </select>\n\t\t\t</div>\n\t\t</div>\n\t\t\t<div class=\"gf-form max-width-20\">\n\t\t\t\t<label class=\"gf-form-label query-keyword width-6\">\n\t\t\t\t\tAlias:\n\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\tUse patterns like $tag_tagname to replace part of the alias for a tag value\n\t\t\t\t\t</info-popover>\n\t\t\t\t</label>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"series alias\" data-min-length=0 data-items=100 ng-blur=ctrl.targetBlur()>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-25\">\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">Down sample</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.downsampleInterval ng-model-onblur ng-change=ctrl.targetBlur() placeholder=interval>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tblank for auto, or for example <code>1m</code>\n\t\t\t</info-popover>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Aggregator</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select ng-model=ctrl.target.downsampleAggregator class=gf-form-input ng-options=\"agg for agg in ctrl.aggregators\" ng-change=ctrl.targetBlur()>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form ng-if=\"ctrl.tsdbVersion >= 2\">\n\t\t\t<label class=\"gf-form-label query-keyword width-6\">Fill</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select ng-model=ctrl.target.downsampleFillPolicy class=gf-form-input ng-options=\"agg for agg in ctrl.fillPolicies\" ng-change=ctrl.targetBlur()>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<gf-form-switch class=gf-form label=\"Disable downsampling\" label-class=query-keyword checked=ctrl.target.disableDownsampling on-change=ctrl.targetBlur()>\n\t\t</gf-form-switch>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline ng-if=\"ctrl.tsdbVersion >= 2\">\n\t\t<div class=gf-form>\n\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\t\tFilters\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tFilters does not work with tags, either of the two will work but not both.\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\n\t\t\t<div ng-repeat=\"fil in ctrl.target.filters track by $index\" class=gf-form-label>\n\t\t\t\t{{fil.tagk}}&nbsp;=&nbsp;{{fil.type}}&#40;{{fil.filter}}&#41;&nbsp;&#44&nbsp;groupBy&nbsp;=&nbsp;{{fil.groupBy}}\n\t\t\t\t<a ng-click=\"ctrl.editFilter(fil, $index)\">\n\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n\t\t\t\t</a>\n\t\t\t\t<a ng-click=ctrl.removeFilter($index)>\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<label class=\"gf-form-label query-keyword\" ng-hide=ctrl.addFilterMode>\n\t\t\t\t<a ng-click=ctrl.addFilter()>\n\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n \t\t</div>\n\n\t\t<div class=gf-form-inline ng-show=ctrl.addFilterMode>\n\t\t\t<div class=gf-form>\n\t\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagKeys data-min-length=0 data-items=100 ng-model=ctrl.target.currentFilterKey placeholder=key>\n\t\t\t\t\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword\">Type</label>\n\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t<select ng-model=ctrl.target.currentFilterType class=gf-form-input ng-options=\"filType for filType in ctrl.filterTypes\">\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagValues data-min-length=0 data-items=100 ng-model=ctrl.target.currentFilterValue placeholder=filter>\n\t\t\t\t\n\t\t\t</div>\n\n      <gf-form-switch class=gf-form label=\"Group by\" label-class=query-keyword checked=ctrl.target.currentFilterGroupBy on-change=ctrl.targetBlur()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<div class=gf-form ng-show=ctrl.addFilterMode>\n\t\t\t\t<label class=gf-form-label ng-show=ctrl.errors.filters>\n\t\t\t\t\t<a bs-tooltip=ctrl.errors.filters style=color:#e5bd1c>\n\t\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</label>\n\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t<a ng-click=ctrl.addFilter() ng-hide=ctrl.errors.filters>add filter</a>\n\t\t\t\t\t<a ng-click=ctrl.closeAddFilterMode()>\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\t\tTags\n\t\t\t\t<info-popover mode=right-normal ng-if=\"ctrl.tsdbVersion >= 2\">\n\t\t\t\t\tPlease use filters, tags are deprecated in opentsdb 2.2\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=gf-form ng-repeat=\"(key, value) in ctrl.target.tags track by $index\" class=gf-form>\n\t\t\t<label class=gf-form-label>\n\t\t\t\t{{key}}&nbsp;=&nbsp;{{value}}\n\t\t\t\t<a ng-click=\"ctrl.editTag(key, value)\">\n\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n\t\t\t\t</a>\n\t\t\t\t<a ng-click=ctrl.removeTag(key)>\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=gf-form ng-hide=ctrl.addTagMode>\n\t\t\t<label class=\"gf-form-label query-keyword\">\n\t\t\t\t<a ng-click=ctrl.addTag()><i class=\"fa fa-plus\"></i></a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=gf-form ng-show=ctrl.addTagMode>\n\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagKeys data-min-length=0 data-items=100 ng-model=ctrl.target.currentTagKey placeholder=key>\n\t\t\t\n\n\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagValues data-min-length=0 data-items=100 ng-model=ctrl.target.currentTagValue placeholder=value>\n\t\t\t\n\n\t\t\t<label class=gf-form-label ng-show=ctrl.errors.tags>\n\t\t\t\t<a bs-tooltip=ctrl.errors.tags style=color:#e5bd1c>\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t\t<label class=gf-form-label>\n\t\t\t\t<a ng-click=ctrl.addTag() ng-hide=ctrl.errors.tags>add tag</a>\n\t\t\t\t<a ng-click=ctrl.closeAddTagMode()><i class=\"fa fa-remove\"></i></a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<gf-form-switch class=gf-form label=Rate label-class=\"width-8 query-keyword\" checked=ctrl.target.shouldComputeRate on-change=ctrl.targetBlur()>\n\t\t</gf-form-switch>\n\n\t\t<gf-form-switch ng-hide=!ctrl.target.shouldComputeRate class=gf-form label=Counter label-class=query-keyword checked=ctrl.target.isCounter on-change=ctrl.targetBlur()>\n\t\t</gf-form-switch>\n\n\n\t\t<div class=gf-form ng-hide=\"!ctrl.target.isCounter || !ctrl.target.shouldComputeRate\">\n\t\t\t<label class=\"gf-form-label query-keyword\">Counter Max</label>\n\t\t\t<input type=text class=gf-form-input ng-disabled=!ctrl.target.shouldComputeRate ng-model=ctrl.target.counterMax spellcheck=false placeholder=\"max value\" ng-model-onblur ng-blur=ctrl.targetBlur()>\n\t\t\t\n\n\t\t\t<label class=\"gf-form-label query-keyword\">Reset Value</label>\n\t\t\t<input type=text class=\"tight-form-input input-small\" ng-disabled=!ctrl.target.shouldComputeRate ng-model=ctrl.target.counterResetValue spellcheck=false placeholder=\"reset value\" ng-model-onblur ng-blur=ctrl.targetBlur()>\n\t\t\t\n\t\t</div>\n\n\t\t<div class=gf-form ng-if=\"ctrl.tsdbVersion > 2\">\n\t\t\t<gf-form-switch class=gf-form label=\"Explicit tags\" label-class=\"width-8 query-keyword\" checked=ctrl.target.explicitTags on-change=ctrl.targetBlur()>\n\t\t\t</gf-form-switch>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/postgres/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n  <div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<textarea rows=10 class=gf-form-input ng-model=ctrl.annotation.rawQuery spellcheck=false placeholder=\"query expression\" data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.panelCtrl.refresh()></textarea>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n  </div>\n\n  <div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\"><h6>Annotation Query Format</h6>\nAn annotation is an event that is overlayed on top of graphs. The query can have up to four columns per row, the time column is mandatory. Annotation rendering is expensive so it is important to limit the number of rows returned.\n\n- column with alias: <b>time</b> for the annotation event. Format is UTC in seconds, use extract(epoch from column) as \"time\"\n- column with alias <b>title</b> for the annotation title\n- column with alias: <b>text</b> for the annotation text\n- column with alias: <b>tags</b> for annotation tags. This is a comma separated string of tags e.g. 'tag1,tag2'\n\n\nMacros:\n- $__time(column) -&gt; column as \"time\"\n- $__timeFilter(column) -&gt;  column &ge; to_timestamp(1492750877) AND column &le; to_timestamp(1492750877)\n- $__unixEpochFilter(column) -&gt;  column &gt; 1492750877 AND column &lt; 1492750877\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  to_timestamp(1492750877)\n- $__timeTo() -&gt;  to_timestamp(1492750877)\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 651 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/postgres/partials/config.html';
var html = "\n<h3 class=page-heading>PostgreSQL Connection</h3>\n\n<div class=gf-form-group>\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Host</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.url placeholder=localhost:5432 bs-typeahead=\"{{['localhost:5432', 'localhost:5433']}}\" required>\n\t</div>\n\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"database name\" required>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=user>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\" ng-if=!ctrl.current.secureJsonFields.password>\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.secureJsonData.password placeholder=password>\n    </div>\n    <div class=\"gf-form max-width-19\" ng-if=ctrl.current.secureJsonFields.password>\n      <span class=\"gf-form-label width-7\">Password</span>\n      <input type=text class=gf-form-input disabled=disabled value=configured>\n      <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"ctrl.current.secureJsonFields.password = false\">reset</a>\n    </div>\n\t</div>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label width-7\">SSL Mode</label>\n\t\t<div class=\"gf-form-select-wrapper max-width-15 gf-form-select-wrapper--has-help-icon\">\n\t\t\t<select class=gf-form-input ng-model=ctrl.current.jsonData.sslmode ng-options=\"mode for mode in ['disable', 'require', 'verify-ca', 'verify-full']\" ng-init=ctrl.current.jsonData.sslmode></select>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tThis option determines whether or with what priority a secure SSL TCP/IP connection will be negotiated with the server.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=grafana-info-box>\n\t\t<h5>User Permission</h5>\n\t\t<p>\n\t\t\tThe database user should only be granted SELECT permissions on the specified database &amp; tables you want to query.\n\t\t\tGrafana does not validate that queries are safe so queries can contain any SQL statement. For example, statements\n\t\t\tlike <code>DELETE FROM user;</code> and <code>DROP TABLE user;</code> would be executed. To protect against this we\n\t\t\t<strong>Highly</strong> recommmend you create a specific PostgreSQL user with restricted permissions.\n\t\t</p>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 652 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/postgres/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<code-editor content=ctrl.target.rawSql datasource=ctrl.datasource on-change=ctrl.panelCtrl.refresh() data-mode=sql>\n\t\t\t</code-editor>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Format as</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.lastQueryMeta>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showLastQuerySQL = !ctrl.showLastQuerySQL\">\n        Generated SQL\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showLastQuerySQL></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showLastQuerySQL></i>\n      </label>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showLastQuerySQL>\n\t\t<pre class=gf-form-pre>{{ctrl.lastQueryMeta.sql}}</pre>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\">Time series:\n- return column named <i>time</i> (UTC in seconds or timestamp)\n- return column(s) with numeric datatype as values\n- (Optional: return column named <i>metric</i> to represent the series name. If no column named metric is found the column name of the value column is used as series name)\n\nTable:\n- return any set of columns\n\nMacros:\n- $__time(column) -&gt; column as \"time\"\n- $__timeEpoch -&gt; extract(epoch from column) as \"time\"\n- $__timeFilter(column) -&gt;  column &ge; to_timestamp(1492750877) AND column &le; to_timestamp(1492750877)\n- $__unixEpochFilter(column) -&gt;  column &gt; 1492750877 AND column &lt; 1492750877\n\nTo group by time use $__timeGroup:\n-&gt; (extract(epoch from column)/extract(epoch from column::interval))::int\n\nExample of group by and order by with $__timeGroup:\nSELECT\n  min(date_time_col) AS time_sec,\n  sum(value_double) as value\nFROM yourtable\ngroup by $__timeGroup(date_time_col, '1h')\norder by $__timeGroup(date_time_col, '1h') ASC\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  to_timestamp(1492750877)\n- $__timeTo() -&gt;  to_timestamp(1492750877)\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n\n\t\n\n\t<div class=gf-form ng-show=ctrl.lastQueryError>\n\t\t<pre class=\"gf-form-pre alert alert-error\">{{ctrl.lastQueryError}}</pre>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 653 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/prometheus/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">Search expression</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.expr placeholder=ALERTS>\n\t</div>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">step</span>\n\t\t<input type=text class=\"gf-form-input max-width-6\" ng-model=ctrl.annotation.step placeholder=60s>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<h5 class=section-heading>Field formats\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-5\">Title</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-9\" ng-model=ctrl.annotation.titleFormat placeholder=alertname>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-5\">Tags</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-9\" ng-model=ctrl.annotation.tagKeys placeholder=label1,label2>\n\t\t</div>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-5\">Text</span>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-9\" ng-model=ctrl.annotation.textFormat placeholder=instance>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</h5></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 654 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/prometheus/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:9090>\n</datasource-http-settings>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Scrape interval</span>\n\t\t\t<input type=text class=\"gf-form-input width-6\" ng-model=ctrl.current.jsonData.timeInterval spellcheck=false placeholder=15s>\n\t\t\t<info-popover mode=right-absolute>\n                Set this to your global scrape interval defined in your Prometheus config file. This will be used as a lower limit for \n                the Prometheus step query parameter.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 655 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/prometheus/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=true has-text-edit-mode=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<code-editor content=ctrl.target.expr datasource=ctrl.datasource on-change=ctrl.refreshMetricData() get-completer=ctrl.getCompleter() data-mode=prometheus code-editor-focus=ctrl.isLastQuery>\n\t\t\t</code-editor>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-26\">\n\t\t\t<label class=\"gf-form-label width-8\">Legend format</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.legendFormat spellcheck=false placeholder=\"legend format\" data-min-length=0 data-items=1000 ng-model-onblur ng-change=ctrl.refreshMetricData()>\n\t\t\t\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-6\">Min step</label>\n\t\t\t<input type=text class=\"gf-form-input width-8\" ng-model=ctrl.target.interval data-placement=right spellcheck=false placeholder={{ctrl.panelCtrl.interval}} data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.refreshMetricData() />\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tLeave blank for auto handling based on time range and panel width\n\t\t\t</info-popover>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=gf-form-label>Resolution</label>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t<select ng-model=ctrl.target.intervalFactor class=gf-form-input ng-options=\"r.factor as r.label for r in ctrl.resolutions\" ng-change=ctrl.refreshMetricData()>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-6\">Format as</label>\n\t\t\t<div class=\"gf-form-select-wrapper width-8\">\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t\t<gf-form-switch class=gf-form label=Instant label-class=width-5 checked=ctrl.target.instant on-change=ctrl.refresh()>\n\t\t\t</gf-form-switch>\n\t\t\t<label class=gf-form-label>\n\t\t\t\t<a href={{ctrl.linkToPrometheus}} target=_blank bs-tooltip=\"'Link to Graph in Prometheus'\">\n\t\t\t\t\t<i class=\"fa fa-share-square-o\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 656 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/alertlist/editor.html';
var html = "<div>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Options</h5>\n    <div class=gf-form>\n      <span class=\"gf-form-label width-8\">Show</span>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=ctrl.panel.show ng-options=\"f.value as f.text for f in ctrl.showOptions\" ng-change=ctrl.onRender()></select>\n      </div>\n    </div>\n    <div class=gf-form>\n      <span class=\"gf-form-label width-8\">Max items</span>\n      <input type=text class=\"gf-form-input max-width-15\" ng-model=ctrl.panel.limit ng-change=ctrl.onRender() />\n    </div>\n    <div class=gf-form ng-show=\"ctrl.panel.show === 'current'\">\n      <span class=\"gf-form-label width-8\">Sort order</span>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=ctrl.panel.sortOrder ng-options=\"f.value as f.text for f in ctrl.sortOrderOptions\" ng-change=ctrl.onRender()></select>\n      </div>\n    </div>\n    <gf-form-switch class=gf-form label=\"Alerts from this dashboard\" label-class=width-18 checked=ctrl.panel.onlyAlertsOnDashboard on-change=ctrl.updateStateFilter()></gf-form-switch>\n  </div>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>State filter</h5>\n    <gf-form-switch class=gf-form label=Ok label-class=width-10 checked=\"ctrl.stateFilter['ok']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=Paused label-class=width-10 checked=\"ctrl.stateFilter['paused']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=\"No data\" label-class=width-10 checked=\"ctrl.stateFilter['no_data']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=\"Execution error\" label-class=width-10 checked=\"ctrl.stateFilter['execution_error']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=Alerting label-class=width-10 checked=\"ctrl.stateFilter['alerting']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 657 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/alertlist/module.html';
var html = "<div class=panel-alert-list style=\"\">\n\t<section class=\"card-section card-list-layout-list\" ng-if=\"ctrl.panel.show === 'current'\">\n\t\t<ol class=card-list>\n\t\t\t<li class=card-item-wrapper ng-repeat=\"alert in ctrl.currentAlerts\">\n\t\t\t\t<div class=\"alert-list card-item card-item--alert\">\n\t\t\t\t\t<div class=alert-list-body>\n\t\t\t\t\t\t<div class=\"alert-list-icon alert-list-item-state {{alert.stateModel.stateClass}}\">\n\t\t\t\t\t\t\t<i class={{alert.stateModel.iconClass}}></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=alert-list-main>\n\t\t\t\t\t\t\t<p class=alert-list-title>\n\t\t\t\t\t\t\t<a href=\"dashboard/{{alert.dashboardUri}}?panelId={{alert.panelId}}&fullscreen&edit&tab=alert\">\n\t\t\t\t\t\t\t\t{{alert.name}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=alert-list-text>\n\t\t\t\t\t\t\t<span class=\"alert-list-state {{alert.stateModel.stateClass}}\">{{alert.stateModel.text}}</span>\n\t\t\t\t\t\t\tfor {{alert.newStateDateAgo}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ol>\n\t</section>\n\n\t<section class=\"card-section card-list-layout-list\" ng-if=\"ctrl.panel.show === 'changes'\">\n\t\t<ol class=card-list>\n\t\t\t<li class=card-item-wrapper ng-repeat=\"al in ctrl.alertHistory\">\n\t\t\t\t<div class=\"alert-list card-item card-item--alert\">\n\t\t\t\t\t<div class=alert-list-body>\n\t\t\t\t\t\t<div class=\"alert-list-icon alert-list-item-state {{al.stateModel.stateClass}}\">\n\t\t\t\t\t\t\t<i class={{al.stateModel.iconClass}}></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=alert-list-main>\n\t\t\t\t\t\t\t<p class=alert-list-title>{{al.alertName}}</p>\n\t\t\t\t\t\t\t<div class=alert-list-text>\n\t\t\t\t\t\t\t\t<span class=\"alert-list-state {{al.stateModel.stateClass}}\">{{al.stateModel.text}}</span>\n\t\t\t\t\t\t\t\t<span class=\"alert-list-info alert-list-info-left\">{{al.info}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=alert-list-footer>\n\t\t\t\t\t\t<span class=alert-list-text>{{al.time}}</span>\n\t\t\t\t\t\t<span class=alert-list-text><!--Img Link--></span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ol>\n\t</section>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/dashlist/editor.html';
var html = "<div>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Options</h5>\n\n    <gf-form-switch class=gf-form label=Starred label-class=width-9 checked=ctrl.panel.starred on-change=ctrl.refresh()></gf-form-switch>\n    <gf-form-switch class=gf-form label=\"Recently viewed\" label-class=width-9 checked=ctrl.panel.recent on-change=ctrl.refresh()></gf-form-switch>\n    <gf-form-switch class=gf-form label=Search label-class=width-9 checked=ctrl.panel.search on-change=ctrl.refresh()></gf-form-switch>\n\n    <gf-form-switch class=gf-form label=\"Show headings\" label-class=width-9 checked=ctrl.panel.headings on-change=ctrl.refresh()></gf-form-switch>\n\n    <div class=gf-form>\n      <span class=\"gf-form-label width-9\">Max items</span>\n      <input class=\"gf-form-input max-width-5\" type=number ng-model=ctrl.panel.limit ng-model-onblur ng-change=ctrl.refresh()>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Search</h5>\n\n    <div class=gf-form>\n      <span class=\"gf-form-label width-6\">Query</span>\n      <input type=text class=gf-form-input placeholder=\"title query\" ng-model=ctrl.panel.query ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n\n    <div class=gf-form>\n      <span class=\"gf-form-label width-6\">Tags</span>\n      <bootstrap-tagsinput ng-model=ctrl.panel.tags tagclass=\"label label-tag\" placeholder=\"add tags\" on-tags-updated=ctrl.refresh()>\n      </bootstrap-tagsinput>\n    </div>\n  </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/dashlist/module.html';
var html = "<div class=dashlist ng-repeat=\"group in ctrl.groups\">\n  <div class=dashlist-section ng-if=group.show>\n    <h6 class=dashlist-section-header ng-show=ctrl.panel.headings>\n      {{group.header}}\n    </h6>\n    <div class=dashlist-item ng-repeat=\"dash in group.list\">\n      <a class=\"dashlist-link dashlist-link-{{dash.type}}\" href=dashboard/{{dash.uri}}>\n        <span class=dashlist-title>\n          {{dash.title}}\n        </span>\n        <span class=dashlist-star>\n          <i class=fa ng-class=\"{'fa-star': dash.isStarred, 'fa-star-o': dash.isStarred === false}\"></i>\n        </span>\n      </a>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 660 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/gettingstarted/editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Mode</span>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-10\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.mode ng-options=\"f for f in ctrl.modes\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form ng-show=\"ctrl.panel.mode === 'recently viewed'\">\n\t\t\t<span class=gf-form-label>\n\t\t\t\t<i class=\"grafana-tip fa fa-question-circle ng-scope\" bs-tooltip=\"'WARNING: This list will be cleared when clearing browser cache'\" data-original-title=\"\" title=\"\"></i>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline ng-if=\"ctrl.panel.mode === 'search'\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Search options</span>\n\t\t\t<span class=gf-form-label>Query</span>\n\n\t\t\t<input type=text class=gf-form-input placeholder=\"title query\" ng-model=ctrl.panel.query ng-change=ctrl.refresh() ng-model-onblur>\n\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Tags</span>\n\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.panel.tags tagclass=\"label label-tag\" placeholder=\"add tags\" on-tags-updated=ctrl.refresh()>\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Limit number to</span>\n\t\t\t<input class=gf-form-input type=number ng-model=ctrl.panel.limit ng-model-onblur ng-change=ctrl.refresh()>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 661 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/gettingstarted/module.html';
var html = "<div class=dashlist ng-if=ctrl.checksDone>\n  <div class=dashlist-section>\n    <h6 class=dashlist-section-header>\n      Getting Started with Grafana\n      <button class=dashlist-cta-close-btn ng-click=ctrl.dismiss()>\n        <i class=\"fa fa-remove\"></i>\n      </button>\n    </h6>\n    <ul class=progress-tracker>\n      <li class=progress-step ng-repeat=\"step in ctrl.steps\" ng-class=step.cssClass>\n        <a class=progress-link ng-href={{step.href}} target={{step.target}} title={{step.note}}>\n          <span class=progress-marker ng-class=step.cssClass><i class={{step.icon}}></i></span>\n          <span class=progress-text ng-href={{step.href}} target={{step.target}}>{{step.title}}</span>\n        </a>\n        <a class=\"btn progress-step-cta\" ng-href={{step.href}} target={{step.target}}>{{step.cta}}</a>\n      </li>\n    </ul>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 662 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/graph/axes_editor.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\" ng-repeat=\"yaxis in ctrl.panel.yaxes\">\n\n\t\t<h5 class=section-heading ng-show=\"$index === 0\">Left Y</h5>\n\t\t<h5 class=section-heading ng-show=\"$index === 1\">Right Y</h5>\n\n\t\t<gf-form-switch class=gf-form label=Show label-class=width-6 checked=yaxis.show on-change=ctrl.render()></gf-form-switch>\n\n\t\t<div ng-if=yaxis.show>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Unit</label>\n\t\t\t\t<div class=\"gf-form-dropdown-typeahead max-width-20\" ng-model=yaxis.format dropdown-typeahead2=ctrl.unitFormats dropdown-typeahead-on-select=\"ctrl.setUnitFormat(yaxis, $subItem)\"></div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Scale</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-20\">\n\t\t\t\t\t<select class=gf-form-input ng-model=yaxis.logBase ng-options=\"v as k for (k, v) in ctrl.logScales\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label width-6\">Y-Min</label>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-5\" placeholder=auto empty-to-null ng-model=yaxis.min ng-change=ctrl.render() ng-model-onblur>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label width-6\">Y-Max</label>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-5\" placeholder=auto empty-to-null ng-model=yaxis.max ng-change=ctrl.render() ng-model-onblur>\n\t\t\t\t</div>\n      </div>\n      <div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Decimals</label>\n\t\t\t\t<input type=number class=\"gf-form-input max-width-20\" placeholder=auto empty-to-null bs-tooltip=\"'Override automatic decimal precision for y-axis'\" data-placement=right ng-model=yaxis.decimals ng-change=ctrl.render() ng-model-onblur>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Label</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-20\" ng-model=yaxis.label ng-change=ctrl.render() ng-model-onblur>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>X-Axis</h5>\n\t\t<gf-form-switch class=gf-form label=Show label-class=width-6 checked=ctrl.panel.xaxis.show on-change=ctrl.render()></gf-form-switch>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-6\">Mode</label>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.xaxis.mode ng-options=\"v as k for (k, v) in ctrl.xAxisModes\" ng-change=ctrl.xAxisModeChanged()> </select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Series mode -->\n\t\t<div class=gf-form ng-if=\"ctrl.panel.xaxis.mode === 'series'\">\n\t\t\t<label class=\"gf-form-label width-6\">Value</label>\n      <metric-segment-model property=ctrl.panel.xaxis.values[0] options=ctrl.xAxisStatOptions on-change=ctrl.xAxisValueChanged() custom=false css-class=width-10 select-mode=true></metric-segment-model>\n\t\t</div>\n\n\t\t<!-- Histogram mode -->\n\t\t<div class=gf-form ng-if=\"ctrl.panel.xaxis.mode === 'histogram'\">\n\t\t\t<label class=\"gf-form-label width-6\">Buckets</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-8\" ng-model=ctrl.panel.xaxis.buckets placeholder=auto ng-change=ctrl.render() ng-model-onblur bs-tooltip=\"'Number of buckets'\" data-placement=right>\n\t\t</div>\n\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 663 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/graph/tab_display.html';
var html = "<div class=edit-tab-with-sidemenu>\n\t<aside class=edit-sidemenu-aside>\n\t\t<ul class=edit-sidemenu>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 0}\">\n\t\t\t\t<a ng-click=\"ctrl.subTabIndex = 0\">Draw options</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 1}\">\n\t\t\t\t<a ng-click=\"ctrl.subTabIndex = 1\">\n\t\t\t\t\tSeries overrides <span class=muted>({{ctrl.panel.seriesOverrides.length}})</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 2}\">\n\t\t\t\t<a ng-click=\"ctrl.subTabIndex = 2\">\n\t\t\t\t\tThresholds <span class=muted>({{ctrl.panel.thresholds.length}})</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</aside>\n\n\t<div class=edit-tab-content ng-if=\"ctrl.subTabIndex === 0\">\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Draw Modes</h5>\n\t\t\t<gf-form-switch class=gf-form label=Bars label-class=width-5 checked=ctrl.panel.bars on-change=ctrl.render()></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label=Lines label-class=width-5 checked=ctrl.panel.lines on-change=ctrl.render()></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label=Points label-class=width-5 checked=ctrl.panel.points on-change=ctrl.render()></gf-form-switch>\n\t\t</div>\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Mode Options</h5>\n\t\t\t<div class=gf-form ng-show=ctrl.panel.lines>\n\t\t\t\t<label class=\"gf-form-label width-8\">Fill</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-5\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.fill ng-options=\"f for f in [0,1,2,3,4,5,6,7,8,9,10]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-show=(ctrl.panel.lines)>\n\t\t\t\t<label class=\"gf-form-label width-8\">Line Width</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-5\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.linewidth ng-options=\"f for f in [0,1,2,3,4,5,6,7,8,9,10]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<gf-form-switch ng-show=ctrl.panel.lines class=gf-form label=Staircase label-class=width-8 checked=ctrl.panel.steppedLine on-change=ctrl.render()>\n\t\t\t</gf-form-switch>\n\t\t\t<div class=gf-form ng-show=ctrl.panel.points>\n\t\t\t\t<label class=\"gf-form-label width-8\">Point Radius</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-5\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.pointradius ng-options=\"f for f in [1,2,3,4,5,6,7,8,9,10]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Hover tooltip</h5>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-9\">Mode</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-8\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.tooltip.shared ng-options=\"f.value as f.text for f in [{text: 'All series', value: true}, {text: 'Single', value: false}]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-9\">Sort order</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-8\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.tooltip.sort ng-options=\"f.value as f.text for f in [{text: 'None', value: 0}, {text: 'Increasing', value: 1}, {text: 'Decreasing', value: 2}]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-show=ctrl.panel.stack>\n\t\t\t\t<label class=\"gf-form-label width-9\">Stacked value</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-8\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.tooltip.value_type ng-options=\"f for f in ['cumulative','individual']\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Stacking & Null value</h5>\n\t\t\t<gf-form-switch class=gf-form label=Stack label-class=width-7 checked=ctrl.panel.stack on-change=ctrl.render()>\n\t\t\t</gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form ng-show=ctrl.panel.stack label=Percent label-class=width-7 checked=ctrl.panel.percentage on-change=ctrl.render()>\n\t\t\t</gf-form-switch>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">Null value</label>\n\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t<select class=\"gf-form-input max-width-8\" ng-model=ctrl.panel.nullPointMode ng-options=\"f for f in ['connected', 'null', 'null as zero']\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=edit-tab-content ng-if=\"ctrl.subTabIndex === 1\">\n\t\t<div class=gf-form-group>\n\t\t\t<h5>Series specific overrides <tip>Regex match example: /server[0-3]/i </tip></h5>\n\t\t\t<div class=gf-form-inline ng-repeat=\"override in ctrl.panel.seriesOverrides\" ng-controller=SeriesOverridesCtrl>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=gf-form-label>alias or regex</label>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gf-form width-15\">\n\t\t\t\t\t<input type=text ng-model=override.alias bs-typeahead=getSeriesNames ng-blur=ctrl.render() data-min-length=0 data-items=100 class=\"gf-form-input width-15\">\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form ng-repeat=\"option in currentOverrides\">\n\t\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t\t<i class=\"pointer fa fa-remove\" ng-click=removeOverride(option)></i>\n\t\t\t\t\t\t<span ng-show=\"option.propertyName === 'color'\">\n\t\t\t\t\t\t\tColor: <i class=\"fa fa-circle\" ng-style={color:option.value}></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-show=\"option.propertyName !== 'color'\">\n\t\t\t\t\t\t\t{{option.name}}: {{option.value}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=dropdown dropdown-typeahead=overrideMenu dropdown-typeahead-on-select=\"setOverride($item, $subItem)\">\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t\t<i class=\"fa fa-trash pointer\" ng-click=ctrl.removeSeriesOverride(override)></i>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<button class=\"btn btn-inverse\" ng-click=ctrl.addSeriesOverride()>\n\t\t\t<i class=\"fa fa-plus\"></i>&nbsp;Add override\n\t\t</button>\n\t</div>\n\n\t<div class=edit-tab-content ng-if=\"ctrl.subTabIndex === 2\">\n\t\t<graph-threshold-form panel-ctrl=ctrl></graph-threshold-form>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/graph/tab_legend.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Options</h5>\n\t\t<gf-form-switch class=gf-form label=Show label-class=width-7 checked=ctrl.panel.legend.show on-change=ctrl.refresh()>\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=gf-form label=\"As Table\" label-class=width-7 checked=ctrl.panel.legend.alignAsTable on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=gf-form label=\"To the right\" label-class=width-7 checked=ctrl.panel.legend.rightSide on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t\t<div ng-if=ctrl.panel.legend.rightSide class=gf-form>\n\t\t\t<label class=\"gf-form-label width-7\">Width</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-5\" placeholder=250 bs-tooltip=\"'Set a min-width for the legend side table/block'\" data-placement=right ng-model=ctrl.panel.legend.sideWidth ng-change=ctrl.render() ng-model-onblur>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Values</h5>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Min label-class=width-4 checked=ctrl.panel.legend.min on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<gf-form-switch class=\"gf-form max-width-12\" label=Max label-class=width-6 switch-class=max-width-5 checked=ctrl.panel.legend.max on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Avg label-class=width-4 checked=ctrl.panel.legend.avg on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<gf-form-switch class=\"gf-form max-width-12\" label=Current label-class=width-6 switch-class=max-width-5 checked=ctrl.panel.legend.current on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Total label-class=width-4 checked=ctrl.panel.legend.total on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Decimals</label>\n\t\t\t\t<input type=number class=\"gf-form-input width-5\" placeholder=auto bs-tooltip=\"'Override automatic decimal precision for legend and tooltips'\" data-placement=right ng-model=ctrl.panel.decimals ng-change=ctrl.render() ng-model-onblur>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Hide series</h5>\n\t\t<gf-form-switch class=gf-form label=\"With only nulls\" label-class=width-10 checked=ctrl.panel.legend.hideEmpty on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=gf-form label=\"With only zeros\" label-class=width-10 checked=ctrl.panel.legend.hideZero on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/heatmap/module.html';
var html = "<div class=heatmap-wrapper>\n\t<div class=heatmap-canvas-wrapper>\n\n\t\t<div class=datapoints-warning ng-if=ctrl.dataWarning>\n\t\t\t<span class=small bs-tooltip=ctrl.dataWarning.tip>{{ctrl.dataWarning.title}}</span>\n\t\t</div>\n\n\t\t<div class=heatmap-panel ng-dblclick=ctrl.zoomOut()></div>\n\t</div>\n\t<div class=heatmap-legend-wrapper ng-if=ctrl.panel.legend.show>\n\t\t<heatmap-legend></heatmap-legend>\n\t</div>\n</div>\n<div class=clearfix></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/heatmap/partials/axes_editor.html';
var html = "<div class=editor-row>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Y Axis</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Unit</label>\n      <div class=\"gf-form-dropdown-typeahead width-12\" ng-model=ctrl.panel.yAxis.format dropdown-typeahead2=editor.unitFormats dropdown-typeahead-on-select=editor.setUnitFormat($subItem)>\n      </div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Scale</label>\n      <div class=\"gf-form-select-wrapper width-12\">\n        <select class=gf-form-input ng-model=ctrl.panel.yAxis.logBase ng-options=\"v as k for (k, v) in editor.logScales\" ng-change=ctrl.refresh()></select>\n      </div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Y-Min</label>\n      <input type=text class=\"gf-form-input width-12\" placeholder=auto empty-to-null ng-model=ctrl.panel.yAxis.min ng-change=ctrl.render() ng-model-onblur>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Y-Max</label>\n      <input type=text class=\"gf-form-input width-12\" placeholder=auto empty-to-null ng-model=ctrl.panel.yAxis.max ng-change=ctrl.render() ng-model-onblur>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Decimals</label>\n      <input type=number class=\"gf-form-input width-12\" placeholder=auto data-placement=right bs-tooltip=\"'Override automatic decimal precision for axis.'\" ng-model=ctrl.panel.yAxis.decimals ng-change=ctrl.render() ng-model-onblur>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\" ng-if=\"ctrl.panel.dataFormat == 'timeseries'\">\n    <h5 class=section-heading>Buckets</h5>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-5\">Y Axis</label>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.panel.yAxis.logBase === 1\">\n        <label class=\"gf-form-label width-5\">Buckets</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Number of buckets for Y axis.'\" ng-model=ctrl.panel.yBucketNumber ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.panel.yAxis.logBase === 1\">\n        <label class=\"gf-form-label width-4\">Size</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Size of bucket. Has priority over Buckets option.'\" ng-model=ctrl.panel.yBucketSize ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.panel.yAxis.logBase !== 1\">\n        <label class=\"gf-form-label width-10\">Split Factor</label>\n        <input type=number class=\"gf-form-input width-9\" placeholder=1 data-placement=right bs-tooltip=\"'For log scales only. By default Y values is splitted by integer powers of log base (1, 2, 4, 8, 16, ... for log2). This option allows to split each default bucket into specified number of buckets.'\" ng-model=ctrl.panel.yAxis.splitFactor ng-change=ctrl.refresh() ng-model-onblur>\n        \n      </div>\n    </div>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-5\">X Axis</label>\n        <label class=\"gf-form-label width-5\">Buckets</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Number of buckets for X axis.'\" ng-model=ctrl.panel.xBucketNumber ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-4\">Size</label>\n        <input type=text class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Size of bucket. Number or interval (10s, 5m, 1h, etc). Supported intervals: ms, s, m, h, d, w, M, y. Has priority over Buckets option.'\" ng-model=ctrl.panel.xBucketSize ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Data format</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-5\">Format</label>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=ctrl.panel.dataFormat ng-options=\"v as k for (k, v) in editor.dataFormats\" ng-change=ctrl.render()></select>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 667 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/heatmap/partials/display_editor.html';
var html = "<div class=editor-row>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Colors</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-9\">Mode</label>\n      <div class=\"gf-form-select-wrapper width-8\">\n        <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.color.mode ng-options=\"s for s in ctrl.colorModes\" ng-change=ctrl.render()></select>\n      </div>\n    </div>\n\n    <div ng-show=\"ctrl.panel.color.mode === 'opacity'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Color</label>\n        <span class=gf-form-label>\n          <color-picker color=ctrl.panel.color.cardColor onchange=ctrl.onCardColorChange></color-picker>\n        </span>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Scale</label>\n        <div class=\"gf-form-select-wrapper width-8\">\n          <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.color.colorScale ng-options=\"s for s in ctrl.opacityScales\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n      <div class=gf-form ng-if=\"ctrl.panel.color.colorScale === 'sqrt'\">\n        <label class=\"gf-form-label width-9\">Exponent</label>\n        <input type=number class=\"gf-form-input width-8\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-model=ctrl.panel.color.exponent ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n    </div>\n\n    <div ng-show=\"ctrl.panel.color.mode === 'spectrum'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Scheme</label>\n        <div class=\"gf-form-select-wrapper width-8\">\n          <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.color.colorScheme ng-options=\"s.value as s.name for s in ctrl.colorSchemes\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form>\n      <color-legend></color-legend>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Color scale</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Min</label>\n      <input type=number ng-model=ctrl.panel.color.min class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Max</label>\n      <input type=number ng-model=ctrl.panel.color.max class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Legend</h5>\n    <gf-form-switch class=gf-form label-class=width-8 label=\"Show legend\" checked=ctrl.panel.legend.show on-change=ctrl.render()>\n    </gf-form-switch>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Buckets</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Space</label>\n      <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-model=ctrl.panel.cards.cardPadding ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Round</label>\n      <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-model=ctrl.panel.cards.cardRound ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Tooltip</h5>\n    <gf-form-switch class=gf-form label-class=width-8 label=\"Show tooltip\" checked=ctrl.panel.tooltip.show on-change=ctrl.render()>\n    </gf-form-switch>\n    <div ng-if=ctrl.panel.tooltip.show>\n      <gf-form-switch class=gf-form label-class=width-8 label=Histogram checked=ctrl.panel.tooltip.showHistogram on-change=ctrl.render()>\n      </gf-form-switch>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Decimals</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Max decimal precision for tooltip.'\" ng-model=ctrl.panel.tooltipDecimals ng-change=ctrl.render() ng-model-onblur>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/pluginlist/editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Mode</span>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-10\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.mode ng-options=\"f for f in ctrl.modes\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form ng-show=\"ctrl.panel.mode === 'recently viewed'\">\n\t\t\t<span class=gf-form-label>\n\t\t\t\t<i class=\"grafana-tip fa fa-question-circle ng-scope\" bs-tooltip=\"'WARNING: This list will be cleared when clearing browser cache'\" data-original-title=\"\" title=\"\"></i>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline ng-if=\"ctrl.panel.mode === 'search'\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Search options</span>\n\t\t\t<span class=gf-form-label>Query</span>\n\n\t\t\t<input type=text class=gf-form-input placeholder=\"title query\" ng-model=ctrl.panel.query ng-change=ctrl.refresh() ng-model-onblur>\n\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Tags</span>\n\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.panel.tags tagclass=\"label label-tag\" placeholder=\"add tags\" on-tags-updated=ctrl.refresh()>\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Limit number to</span>\n\t\t\t<input class=gf-form-input type=number ng-model=ctrl.panel.limit ng-model-onblur ng-change=ctrl.refresh()>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 669 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/pluginlist/module.html';
var html = "<div class=pluginlist>\n  <div class=pluginlist-section ng-repeat=\"category in ctrl.viewModel\">\n    <h6 class=pluginlist-section-header>\n      {{category.header}}\n    </h6>\n    <div class=pluginlist-item ng-repeat=\"plugin in category.list\">\n      <a class=\"pluginlist-link pluginlist-link-{{plugin.state}} pointer\" href={{plugin.defaultNavUrl}}>\n        <span>\n          <img ng-src={{plugin.info.logos.small}} class=pluginlist-image>\n          <span class=pluginlist-title>{{plugin.name}}</span>\n          <span class=pluginlist-version>v{{plugin.info.version}}</span>\n        </span>\n        <span class=\"pluginlist-message pluginlist-message--update\" ng-show=plugin.hasUpdate ng-click=\"ctrl.updateAvailable(plugin, $event)\" bs-tooltip=\"'New version: ' + plugin.latestVersion\">\n          Update available!\n        </span>\n        <span class=\"pluginlist-message pluginlist-message--enable\" ng-show=\"!plugin.enabled && !plugin.hasUpdate\">\n          Enable now\n        </span>\n        <span class=\"pluginlist-message pluginlist-message--no-update\" ng-show=\"plugin.enabled && !plugin.hasUpdate\">\n          Up to date\n        </span>\n      </a>\n    </div>\n    <div class=pluginlist-item ng-show=\"category.list.length === 0\">\n      <a class=\"pluginlist-link pluginlist-link-{{plugin.state}}\" href=https://grafana.com/plugins>\n        <span class=pluginlist-none-installed>None installed. <span class=pluginlist-emphasis>Browse Grafana.com</span></span>\n      </a>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/singlestat/editor.html';
var html = "<div class=editor-row>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Value</h5>\n\n    <div class=gf-form-inline>\n      <div class=gf-form ng-show=\"ctrl.dataType === 'timeseries'\">\n        <label class=\"gf-form-label width-6\">Stat</label>\n        <div class=\"gf-form-select-wrapper width-12\">\n          <select class=gf-form-input ng-model=ctrl.panel.valueName ng-options=\"f.value as f.text for f in ctrl.valueNameOptions\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.dataType === 'table'\">\n        <label class=\"gf-form-label width-6\">Column</label>\n        <div class=\"gf-form-select-wrapper width-12\">\n          <select class=gf-form-input ng-model=ctrl.panel.tableColumn ng-options=\"f for f in ctrl.tableColumnOptions\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-6\">Font size</label>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.panel.valueFontSize ng-options=\"f for f in ctrl.fontSizes\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-6\">Prefix</label>\n        <input type=text class=\"gf-form-input width-12\" ng-model=ctrl.panel.prefix ng-change=ctrl.render() ng-model-onblur>\n        <label class=\"gf-form-label width-6\">Font size</label>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.panel.prefixFontSize ng-options=\"f for f in ctrl.fontSizes\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form>\n      <label class=\"gf-form-label width-6\">Postfix</label>\n      <input type=text class=\"gf-form-input width-12\" ng-model=ctrl.panel.postfix ng-change=ctrl.render() ng-model-onblur>\n      <label class=\"gf-form-label width-6\">Font size</label>\n      <div class=gf-form-select-wrapper>\n        <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.postfixFontSize ng-options=\"f for f in ctrl.fontSizes\" ng-change=ctrl.render()></select>\n      </div>\n    </div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-6\">Unit</label>\n\t\t\t<div class=\"gf-form-dropdown-typeahead width-18\" ng-model=ctrl.panel.format dropdown-typeahead2=ctrl.unitFormats dropdown-typeahead-on-select=ctrl.setUnitFormat($subItem)></div>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-6\">Decimals</label>\n\t\t\t<input type=number class=\"gf-form-input width-18\" placeholder=auto data-placement=right bs-tooltip=\"'Override automatic decimal precision for legend and tooltips'\" ng-model=ctrl.panel.decimals ng-change=ctrl.refresh() ng-model-onblur>\n\t\t</div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Coloring</h5>\n    <div class=gf-form-inline>\n      <gf-form-switch class=gf-form label-class=width-8 label=Background checked=ctrl.panel.colorBackground on-change=ctrl.render()></gf-form-switch>\n      <gf-form-switch class=gf-form label-class=width-4 label=Value checked=ctrl.panel.colorValue on-change=ctrl.render()></gf-form-switch>\n    </div>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-21\">\n        <label class=\"gf-form-label width-8\">Thresholds\n          <tip>Define two threshold values&lt;br /&gt; 50,80 will produce: &lt;50 = Green, 50:80 = Yellow, &gt;80 = Red</tip>\n        </label>\n        <input type=text class=gf-form-input ng-model=ctrl.panel.thresholds ng-blur=ctrl.render() placeholder=50,80>\n      </div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Colors</label>\n      <span class=gf-form-label ng-repeat=\"color in ctrl.panel.colors track by $index\">\n        <color-picker color=color onchange=ctrl.onColorChange($index)></color-picker>\n      </span>\n      <span class=gf-form-label>\n        <a ng-click=ctrl.invertColorOrder()>\n          Invert\n        </a>\n      </span>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Spark lines</h5>\n    <gf-form-switch class=gf-form label-class=width-9 label=Show checked=ctrl.panel.sparkline.show on-change=ctrl.render()></gf-form-switch>\n    <div ng-if=ctrl.panel.sparkline.show>\n      <gf-form-switch class=gf-form label-class=width-9 label=\"Full height\" checked=ctrl.panel.sparkline.full on-change=ctrl.render()></gf-form-switch>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Line Color</label>\n        <span class=gf-form-label>\n          <color-picker color=ctrl.panel.sparkline.lineColor onchange=ctrl.onSparklineColorChange></color-picker>\n        </span>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Fill Color</label>\n        <span class=gf-form-label>\n          <color-picker color=ctrl.panel.sparkline.fillColor onchange=ctrl.onSparklineFillChange></color-picker>\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Gauge</h5>\n    <gf-form-switch class=gf-form label-class=width-10 switch-class=max-width-6 label=Show checked=ctrl.panel.gauge.show on-change=ctrl.render()></gf-form-switch>\n    <div ng-if=ctrl.panel.gauge.show>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-10\">Min</label>\n        <input type=number class=\"gf-form-input width-6\" placeholder=0 data-placement=right ng-model=ctrl.panel.gauge.minValue ng-change=ctrl.refresh() ng-model-onblur>\n        <label class=\"gf-form-label alert-state-critical\" ng-show=ctrl.invalidGaugeRange>\n          &nbsp; <i class=\"fa fa-warning\"></i>\n          Min value is bigger than max.\n        </label>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-10\">Max</label>\n        <input type=number class=\"gf-form-input width-6\" placeholder=0 data-placement=right ng-model=ctrl.panel.gauge.maxValue ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <gf-form-switch class=gf-form label-class=width-10 switch-class=max-width-6 label=\"Threshold labels\" checked=ctrl.panel.gauge.thresholdLabels on-change=ctrl.render()></gf-form-switch>\n      <gf-form-switch class=gf-form label-class=width-10 switch-class=max-width-6 label=\"Threshold markers\" checked=ctrl.panel.gauge.thresholdMarkers on-change=ctrl.render()></gf-form-switch>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 671 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/singlestat/mappings.html';
var html = "<div class=editor-row>\n  <div class=gf-form-group>\n    <div class=gf-form>\n        <span class=gf-form-label>\n          Type\n        </span>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.panel.mappingType ng-options=\"f.value as f.name for f in ctrl.panel.mappingTypes\" ng-change=ctrl.render()></select>\n        </div>\n    </div>\n  </div>\n</div>\n<div class=editor-row ng-if=\"ctrl.panel.mappingType==1\">\n  <h5 class=page-heading>Set value mappings</h5>\n  <div class=gf-form-group>\n    <div class=gf-form ng-repeat=\"map in ctrl.panel.valueMaps\">\n      <span class=gf-form-label>\n        <i class=\"fa fa-remove pointer\" ng-click=ctrl.removeValueMap(map)></i>\n      </span>\n      <input type=text ng-model=map.value placeholder=value class=\"gf-form-input max-width-6\" ng-blur=ctrl.render()>\n      <span class=gf-form-label>\n        <i class=\"fa fa-arrow-right\"></i>\n      </span>\n      <input type=text placeholder=text ng-model=map.text class=\"gf-form-input max-width-8\" ng-blur=ctrl.render()>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button class=\"btn btn-inverse\" ng-click=ctrl.addValueMap();>\n        <i class=\"fa fa-plus\"></i>\n        Add a value mapping\n      </button>\n    </div>\n  </div>\n</div>\n<div class=editor-row ng-if=\"ctrl.panel.mappingType==2\">\n  <h5 class=page-heading>Set range mappings</h5>\n  <div class=gf-form-group>\n    <div class=gf-form ng-repeat=\"rangeMap in ctrl.panel.rangeMaps\">\n        <span class=gf-form-label>\n          <i class=\"fa fa-remove pointer\" ng-click=ctrl.removeRangeMap(rangeMap)></i>\n        </span>\n        <span class=gf-form-label>From</span>\n        <input type=text ng-model=rangeMap.from class=\"gf-form-input max-width-6\" ng-blur=ctrl.render()>\n        <span class=gf-form-label>To</span>\n        <input type=text ng-model=rangeMap.to class=\"gf-form-input max-width-6\" ng-blur=ctrl.render()>\n        <span class=gf-form-label>Text</span>\n        <input type=text ng-model=rangeMap.text class=\"gf-form-input max-width-8\" ng-blur=ctrl.render()>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button class=\"btn btn-inverse\" ng-click=ctrl.addRangeMap()>\n        <i class=\"fa fa-plus\"></i>\n        Add a range mapping\n      </button>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 672 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/singlestat/module.html';
var html = "<div class=singlestat-panel>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 673 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/table/column_options.html';
var html = "\n<div class=edit-tab-with-sidemenu>\n\t<aside class=edit-sidemenu-aside>\n\t\t<ul class=edit-sidemenu>\n      <li ng-repeat=\"style in editor.panel.styles\" ng-class=\"{active: editor.activeStyleIndex === $index}\">\n        <a ng-click=\"editor.activeStyleIndex = $index\">{{style.pattern || 'New rule'}}</a>\n      </li>\n      <li>\n        <a class=pointer ng-click=editor.addColumnStyle()>\n          <i class=\"fa fa-plus\"></i>&nbsp;Add\n        </a>\n      </li>\n\t\t</ul>\n\t</aside>\n\n  <div class=edit-tab-content ng-repeat=\"style in editor.panel.styles\" ng-if=\"editor.activeStyleIndex === $index\">\n\n    <div class=\"section gf-form-group\">\n      <h5 class=section-heading>Options</h5>\n      <div class=gf-form-inline>\n        <div class=gf-form>\n          <label class=\"gf-form-label width-13\">Apply to columns named</label>\n          <input type=text placeholder=\"Name or regex\" class=\"gf-form-input width-13\" ng-model=style.pattern bs-tooltip=\"'Specify regex using /my.*regex/ syntax'\" bs-typeahead=editor.getColumnNames ng-blur=editor.render() data-min-length=0 data-items=100 ng-model-onblur data-placement=right>\n        </div>\n      </div>\n      <div class=gf-form ng-if=\"style.type !== 'hidden'\">\n        <label class=\"gf-form-label width-13\">Column Header</label>\n        <input type=text class=\"gf-form-input width-13\" ng-model=style.alias ng-change=editor.render() ng-model-onblur placeholder=\"Override header label\">\n      </div>\n      <gf-form-switch class=gf-form label-class=width-13 label=\"Render value as link\" checked=style.link change=editor.render()></gf-form-switch>\n    </div>\n\n    <div class=\"section gf-form-group\">\n      <h5 class=section-heading>Type</h5>\n\n      <div class=gf-form>\n        <label class=\"gf-form-label width-11\">Type</label>\n        <div class=\"gf-form-select-wrapper width-16\">\n          <select class=gf-form-input ng-model=style.type ng-options=\"c.value as c.text for c in editor.columnTypes\" ng-change=editor.render()></select>\n        </div>\n      </div>\n      <div class=gf-form ng-if=\"style.type === 'date'\">\n        <label class=\"gf-form-label width-11\">Date Format</label>\n        <div class=\"gf-form-select-wrapper width-16\">\n          <select class=gf-form-input ng-model=style.dateFormat ng-options=\"c.value as c.text for c in editor.dateFormats\" ng-change=editor.render()></select>\n        </div>\n      </div>\n\n      <div ng-if=\"style.type === 'string'\">\n        <gf-form-switch class=gf-form label-class=width-11 ng-if=\"style.type === 'string'\" label=\"Sanitize HTML\" checked=style.sanitize change=editor.render()></gf-form-switch>\n      </div>\n      <div ng-if=\"style.type === 'string'\">\n        <gf-form-switch class=gf-form label-class=width-11 ng-if=\"style.type === 'string'\" label=\"Preserve Formatting\" checked=style.preserveFormat change=editor.render()></gf-form-switch>\n      </div>\n\n      <div ng-if=\"style.type === 'number'\">\n        <div class=gf-form>\n          <label class=\"gf-form-label width-11\">Unit</label>\n          <div class=\"gf-form-dropdown-typeahead width-16\" ng-model=style.unit dropdown-typeahead2=editor.unitFormats dropdown-typeahead-on-select=\"editor.setUnitFormat(style, $subItem)\"></div>\n        </div>\n        <div class=gf-form>\n          <label class=\"gf-form-label width-11\">Decimals</label>\n          <input type=number class=\"gf-form-input width-4\" data-placement=right ng-model=style.decimals ng-change=editor.render() ng-model-onblur>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"section gf-form-group\" ng-if=\"style.type === 'number'\">\n      <h5 class=section-heading>Thresholds</h5>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Thresholds<tip>Comma separated values</tip></label>\n        <input type=text class=\"gf-form-input width-10\" ng-model=style.thresholds placeholder=50,80 ng-blur=editor.render() array-join>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Color Mode</label>\n        <div class=\"gf-form-select-wrapper width-10\">\n          <select class=gf-form-input ng-model=style.colorMode ng-options=\"c.value as c.text for c in editor.colorModes\" ng-change=editor.render()></select>\n        </div>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Colors</label>\n        <span class=gf-form-label>\n          <color-picker color=style.colors[0] onchange=editor.onColorChange($index,0)></color-picker>\n        </span>\n        <span class=gf-form-label>\n          <color-picker color=style.colors[1] onchange=editor.onColorChange($index,1)></color-picker>\n        </span>\n        <span class=gf-form-label>\n          <color-picker color=style.colors[2] onchange=editor.onColorChange($index,2)></color-picker>\n        </span>\n        <div class=gf-form-label>\n          <a class=pointer ng-click=editor.invertColorOrder($index)>Invert</a>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"section gf-form-group\" ng-if=style.link>\n      <h5 class=section-heading>Link</h5>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Url</label>\n        <input type=text class=\"gf-form-input width-29\" ng-model=style.linkUrl ng-blur=editor.render() ng-model-onblur data-placement=right>\n        <info-popover mode=right-absolute>\n          <p>Specify an URL (relative or absolute)</p>\n          <span>\n            Use special variables to specify cell values: <br>\n            <em>$__cell</em> refers to current cell value <br>\n            <em>$__cell_n</em> refers to Nth column value in current row. Column indexes are started from 0. For instance,\n              <em>$__cell_1</em> refers to second column's value.\n          </span>\n        </info-popover>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Tooltip</label>\n        <input type=text class=\"gf-form-input width-29\" ng-model=style.linkTooltip ng-blur=editor.render() ng-model-onblur data-placement=right>\n        <info-popover mode=right-absolute>\n          <p>Specify text for link tooltip.</p>\n          <span>\n            This title appears when user hovers pointer over the cell with link.\n            Use the same variables as for URL.\n          </span>\n        </info-popover>\n      </div>\n      <gf-form-switch class=gf-form label-class=width-9 label=\"Open in new tab\" checked=style.linkTargetBlank></gf-form-switch>\n    </div>\n\n    <div class=clearfix></div>\n\n    <button class=\"btn btn-danger btn-small\" ng-click=editor.removeColumnStyle(style)>\n      <i class=\"fa fa-trash\"></i> Remove Rule\n    </button>\n    <br/>\n    <br/>\n\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 674 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/table/editor.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Data</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-10\">Table Transform</label>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=editor.panel.transform ng-options=\"k as v.description for (k, v) in editor.transformers\" ng-change=editor.transformChanged()></select>\n      </div>\n    </div>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-10\">Columns</label>\n      </div>\n\t\t\t<div class=gf-form ng-repeat=\"column in editor.panel.columns\">\n\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t<i class=\"pointer fa fa-remove\" ng-click=editor.removeColumn(column)></i>\n\t\t\t\t\t<span>{{column.text}}</span>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-show=editor.canSetColumns>\n\t\t\t\t<metric-segment segment=editor.addColumnSegment get-options=editor.getColumnOptions() on-change=editor.addColumn()></metric-segment>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-hide=editor.canSetColumns>\n\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\tAuto\n\t\t\t\t\t<info-popover mode=right-normal ng-if=editor.columnsHelpMessage>\n\t\t\t\t\t\t{{editor.columnsHelpMessage}}\n\t\t\t\t\t</info-popover>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Paging</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Rows per page</label>\n      <input type=number class=\"gf-form-input width-6\" placeholder=100 data-placement=right ng-model=editor.panel.pageSize ng-change=editor.render() ng-model-onblur>\n    </div>\n    <gf-form-switch class=gf-form label-class=width-8 switch-class=max-width-6 label=Scroll checked=editor.panel.scroll on-change=editor.render()></gf-form-switch>\n    <div class=\"gf-form max-width-17\">\n      <label class=\"gf-form-label width-8\">Font size</label>\n      <div class=\"gf-form-select-wrapper width-6\">\n        <select class=gf-form-input ng-model=editor.panel.fontSize ng-options=\"f for f in editor.fontSizes\" ng-change=editor.render()></select>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 675 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/table/module.html';
var html = "\n<div class=table-panel-container>\n\t<div class=table-panel-header-bg ng-show=ctrl.table.rows.length></div>\n\t<div class=table-panel-scroll ng-show=ctrl.table.rows.length>\n\t\t<table class=table-panel-table>\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th ng-repeat=\"col in ctrl.table.columns\" ng-hide=col.hidden>\n\t\t\t\t\t\t<div class=\"table-panel-table-header-inner pointer\" ng-click=\"ctrl.toggleColumnSort(col, $index)\">\n\t\t\t\t\t\t\t{{col.title}}\n\t\t\t\t\t\t\t<span class=table-panel-table-header-controls ng-if=col.sort>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-caret-down\" ng-show=col.desc></i>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-caret-up\" ng-hide=col.desc></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n</div>\n<div class=datapoints-warning ng-show=\"ctrl.table.rows.length===0\">\n\t<span class=small>\n\t\tNo data to show <tip>Nothing returned by data query</tip>\n\t</span>\n</div>\n<div class=table-panel-footer>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 676 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/text/editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Mode</span>\n\t\t\t<span class=gf-form-select-wrapper>\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.mode ng-options=\"f for f in ['html','markdown']\"></select>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n\n<h3 class=page-heading>Content</h3>\n\n<span ng-show=\"ctrl.panel.mode == 'markdown'\">\n\t(This area uses <a target=_blank href=http://en.wikipedia.org/wiki/Markdown>Markdown</a>. HTML is not supported)\n</span>\n\n<textarea class=gf-form-input ng-model=ctrl.panel.content rows=20 style=width:95% give-focus=true ng-change=ctrl.render() ng-model-onblur>\n</textarea>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/text/module.html';
var html = "<p class=\"markdown-html panel-text-content\" ng-bind-html=ctrl.content ng-show=ctrl.content>\n</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 678 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/unknown/module.html';
var html = "<div class=text-center style=padding-top:2rem>\n\tUnknown panel type: <strong>{{ctrl.panel.type}}</strong>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_explorer_json_explorer__ = __webpack_require__(275);


__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].directive('jsonTree', [function jsonTreeDirective() {
        return {
            restrict: 'E',
            scope: {
                object: '=',
                startExpanded: '@',
                rootName: '@',
            },
            link: function (scope, elem) {
                var jsonExp = new __WEBPACK_IMPORTED_MODULE_1__json_explorer_json_explorer__["a" /* JsonExplorer */](scope.object, 3, {
                    animateOpen: true
                });
                var html = jsonExp.render(true);
                elem.html(html);
            }
        };
    }]);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = getObjectName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getValuePreview;
/* unused harmony export getPreview */
/* harmony export (immutable) */ __webpack_exports__["b"] = cssClass;
/* harmony export (immutable) */ __webpack_exports__["a"] = createElement;
// Based on work https://github.com/mohsen1/json-formatter-js
// Licence MIT, Copyright (c) 2015 Mohsen Azimi
/*
 * Escapes `"` charachters from string
*/
function escapeString(str) {
    return str.replace('"', '\"');
}
/*
 * Determines if a value is an object
*/
function isObject(value) {
    var type = typeof value;
    return !!value && (type === 'object');
}
/*
 * Gets constructor name of an object.
 * From http://stackoverflow.com/a/332429
 *
*/
function getObjectName(object) {
    if (object === undefined) {
        return '';
    }
    if (object === null) {
        return 'Object';
    }
    if (typeof object === 'object' && !object.constructor) {
        return 'Object';
    }
    var funcNameRegex = /function ([^(]*)/;
    var results = (funcNameRegex).exec((object).constructor.toString());
    if (results && results.length > 1) {
        return results[1];
    }
    else {
        return '';
    }
}
/*
 * Gets type of an object. Returns "null" for null objects
*/
function getType(object) {
    if (object === null) {
        return 'null';
    }
    return typeof object;
}
/*
 * Generates inline preview for a JavaScript object based on a value
*/
function getValuePreview(object, value) {
    var type = getType(object);
    if (type === 'null' || type === 'undefined') {
        return type;
    }
    if (type === 'string') {
        value = '"' + escapeString(value) + '"';
    }
    if (type === 'function') {
        // Remove content of the function
        return object.toString()
            .replace(/[\r\n]/g, '')
            .replace(/\{.*\}/, '') + '{…}';
    }
    return value;
}
/*
 * Generates inline preview for a JavaScript object
*/
function getPreview(object) {
    var value = '';
    if (isObject(object)) {
        value = getObjectName(object);
        if (Array.isArray(object)) {
            value += '[' + object.length + ']';
        }
    }
    else {
        value = getValuePreview(object, object);
    }
    return value;
}
/*
 * Generates a prefixed CSS class name
*/
function cssClass(className) {
    return "json-formatter-" + className;
}
/*
  * Creates a new DOM element wiht given type and class
  * TODO: move me to helpers
*/
function createElement(type, className, content) {
    var el = document.createElement(type);
    if (className) {
        el.classList.add(cssClass(className));
    }
    if (content !== undefined) {
        if (content instanceof Node) {
            el.appendChild(content);
        }
        else {
            el.appendChild(document.createTextNode(String(content)));
        }
    }
    return el;
}


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export codeEditorDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_brace__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_brace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_brace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_grafana_dark__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_grafana_dark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__theme_grafana_dark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_ext_language_tools__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_ext_language_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_brace_ext_language_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_textmate__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_textmate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_brace_theme_textmate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace_mode_text__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace_mode_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_brace_mode_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_brace_snippets_text__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_brace_snippets_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_brace_snippets_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_brace_mode_sql__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_brace_mode_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_brace_mode_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_brace_snippets_sql__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_brace_snippets_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_brace_snippets_sql__);
/**
 * codeEditor directive based on Ace code editor
 * https://github.com/ajaxorg/ace
 *
 * Basic usage:
 * <code-editor content="ctrl.target.query" on-change="ctrl.panelCtrl.refresh()"
 *  data-mode="sql" data-show-gutter>
 * </code-editor>
 *
 * Params:
 * content:      Editor content.
 * onChange:     Function called on content change (invoked on editor blur, ctrl+enter, not on every change).
 * getCompleter: Function returned external completer. Completer is an object implemented getCompletions() method,
 *               see Prometheus Data Source implementation for details.
 *
 * Some Ace editor options available via data-* attributes:
 * data-mode               - Language mode (text, sql, javascript, etc.). Default is 'text'.
 * data-theme              - Editor theme (eg 'solarized_dark').
 * data-max-lines          - Max editor height in lines. Editor grows automatically from 1 to maxLines.
 * data-show-gutter        - Show gutter (contains line numbers and additional info).
 * data-tab-size           - Tab size, default is 2.
 * data-behaviours-enabled - Specifies whether to use behaviors or not. "Behaviors" in this case is the auto-pairing of
 *                           special characters, like quotation marks, parenthesis, or brackets.
 *
 * Keybindings:
 * Ctrl-Enter (Command-Enter): run onChange() function
 */










var DEFAULT_THEME_DARK = "ace/theme/grafana-dark";
var DEFAULT_THEME_LIGHT = "ace/theme/textmate";
var DEFAULT_MODE = "text";
var DEFAULT_MAX_LINES = 10;
var DEFAULT_TAB_SIZE = 2;
var DEFAULT_BEHAVIOURS = true;
var editorTemplate = "<div></div>";
function link(scope, elem, attrs) {
    // Options
    var langMode = attrs.mode || DEFAULT_MODE;
    var maxLines = attrs.maxLines || DEFAULT_MAX_LINES;
    var showGutter = attrs.showGutter !== undefined;
    var tabSize = attrs.tabSize || DEFAULT_TAB_SIZE;
    var behavioursEnabled = attrs.behavioursEnabled ? attrs.behavioursEnabled === 'true' : DEFAULT_BEHAVIOURS;
    // Initialize editor
    var aceElem = elem.get(0);
    var codeEditor = __WEBPACK_IMPORTED_MODULE_2_brace___default.a.edit(aceElem);
    var editorSession = codeEditor.getSession();
    var editorOptions = {
        maxLines: maxLines,
        showGutter: showGutter,
        tabSize: tabSize,
        behavioursEnabled: behavioursEnabled,
        highlightActiveLine: false,
        showPrintMargin: false,
        autoScrollEditorIntoView: true // this is needed if editor is inside scrollable page
    };
    // Set options
    codeEditor.setOptions(editorOptions);
    // disable depreacation warning
    codeEditor.$blockScrolling = Infinity;
    // Padding hacks
    codeEditor.renderer.setScrollMargin(15, 15);
    codeEditor.renderer.setPadding(10);
    setThemeMode();
    setLangMode(langMode);
    setEditorContent(scope.content);
    // Add classes
    elem.addClass("gf-code-editor");
    var textarea = elem.find("textarea");
    textarea.addClass('gf-form-input');
    if (scope.codeEditorFocus) {
        setTimeout(function () {
            textarea.focus();
            var domEl = textarea[0];
            if (domEl.setSelectionRange) {
                var pos = textarea.val().length * 2;
                domEl.setSelectionRange(pos, pos);
            }
        }, 100);
    }
    // Event handlers
    editorSession.on('change', function (e) {
        scope.$apply(function () {
            var newValue = codeEditor.getValue();
            scope.content = newValue;
        });
    });
    // Sync with outer scope - update editor content if model has been changed from outside of directive.
    scope.$watch('content', function (newValue, oldValue) {
        var editorValue = codeEditor.getValue();
        if (newValue !== editorValue && newValue !== oldValue) {
            scope.$$postDigest(function () {
                setEditorContent(newValue);
            });
        }
    });
    codeEditor.on('blur', function () {
        scope.onChange();
    });
    scope.$on("$destroy", function () {
        codeEditor.destroy();
    });
    // Keybindings
    codeEditor.commands.addCommand({
        name: 'executeQuery',
        bindKey: { win: 'Ctrl-Enter', mac: 'Command-Enter' },
        exec: function () {
            scope.onChange();
        }
    });
    function setLangMode(lang) {
        __WEBPACK_IMPORTED_MODULE_2_brace___default.a.acequire("ace/ext/language_tools");
        codeEditor.setOptions({
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true
        });
        if (scope.getCompleter()) {
            // make copy of array as ace seems to share completers array between instances
            var anyEditor = codeEditor;
            anyEditor.completers = anyEditor.completers.slice();
            anyEditor.completers.push(scope.getCompleter());
        }
        var aceModeName = "ace/mode/" + lang;
        editorSession.setMode(aceModeName);
    }
    function setThemeMode() {
        var theme = DEFAULT_THEME_DARK;
        if (__WEBPACK_IMPORTED_MODULE_1_app_core_config___default.a.bootData.user.lightTheme) {
            theme = DEFAULT_THEME_LIGHT;
        }
        codeEditor.setTheme(theme);
    }
    function setEditorContent(value) {
        codeEditor.setValue(value);
        codeEditor.clearSelection();
    }
}
function codeEditorDirective() {
    return {
        restrict: 'E',
        template: editorTemplate,
        scope: {
            content: "=",
            datasource: "=",
            codeEditorFocus: "<",
            onChange: "&",
            getCompleter: "&"
        },
        link: link
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].directive('codeEditor', codeEditorDirective);


/***/ }),
/* 682 */,
/* 683 */
/***/ (function(module, exports) {

/* jshint ignore:start */

ace.define("ace/theme/grafana-dark",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
  "use strict";

  exports.isDark = true;
  exports.cssClass = "gf-code-dark";
  exports.cssText = ".gf-code-dark .ace_gutter {\
  background: #2f3129;\
  color: #8f908a\
  }\
  .gf-code-dark .ace_print-margin {\
  width: 1px;\
  background: #555651\
  }\
  .gf-code-dark {\
  background-color: #111;\
  color: #e0e0e0\
  }\
  .gf-code-dark .ace_cursor {\
  color: #f8f8f0\
  }\
  .gf-code-dark .ace_marker-layer .ace_selection {\
  background: #49483e\
  }\
  .gf-code-dark.ace_multiselect .ace_selection.ace_start {\
  box-shadow: 0 0 3px 0px #272822;\
  }\
  .gf-code-dark .ace_marker-layer .ace_step {\
  background: rgb(102, 82, 0)\
  }\
  .gf-code-dark .ace_marker-layer .ace_bracket {\
  margin: -1px 0 0 -1px;\
  border: 1px solid #49483e\
  }\
  .gf-code-dark .ace_marker-layer .ace_active-line {\
  background: #202020\
  }\
  .gf-code-dark .ace_gutter-active-line {\
  background-color: #272727\
  }\
  .gf-code-dark .ace_marker-layer .ace_selected-word {\
  border: 1px solid #49483e\
  }\
  .gf-code-dark .ace_invisible {\
  color: #52524d\
  }\
  .gf-code-dark .ace_entity.ace_name.ace_tag,\
  .gf-code-dark .ace_keyword,\
  .gf-code-dark .ace_meta.ace_tag,\
  .gf-code-dark .ace_storage {\
  color: #66d9ef\
  }\
  .gf-code-dark .ace_punctuation,\
  .gf-code-dark .ace_punctuation.ace_tag {\
  color: #fff\
  }\
  .gf-code-dark .ace_constant.ace_character,\
  .gf-code-dark .ace_constant.ace_language,\
  .gf-code-dark .ace_constant.ace_numeric,\
  .gf-code-dark .ace_constant.ace_other {\
  color: #fe85fc\
  }\
  .gf-code-dark .ace_invalid {\
  color: #f8f8f0;\
  background-color: #f92672\
  }\
  .gf-code-dark .ace_invalid.ace_deprecated {\
  color: #f8f8f0;\
  background-color: #ae81ff\
  }\
  .gf-code-dark .ace_support.ace_constant,\
  .gf-code-dark .ace_support.ace_function {\
  color: #59e6e3\
  }\
  .gf-code-dark .ace_fold {\
  background-color: #a6e22e;\
  border-color: #f8f8f2\
  }\
  .gf-code-dark .ace_storage.ace_type,\
  .gf-code-dark .ace_support.ace_class,\
  .gf-code-dark .ace_support.ace_type {\
  font-style: italic;\
  color: #66d9ef\
  }\
  .gf-code-dark .ace_entity.ace_name.ace_function,\
  .gf-code-dark .ace_entity.ace_other,\
  .gf-code-dark .ace_entity.ace_other.ace_attribute-name,\
  .gf-code-dark .ace_variable {\
  color: #a6e22e\
  }\
  .gf-code-dark .ace_variable.ace_parameter {\
  font-style: italic;\
  color: #fd971f\
  }\
  .gf-code-dark .ace_string {\
  color: #74e680\
  }\
  .gf-code-dark .ace_paren {\
    color: #f0a842\
  }\
  .gf-code-dark .ace_operator {\
    color: #FFF\
  }\
  .gf-code-dark .ace_comment {\
  color: #75715e\
  }\
  .gf-code-dark .ace_indent-guide {\
  background: url(data:image/png;base64,ivborw0kggoaaaansuheugaaaaeaaaaccayaaaczgbynaaaaekleqvqimwpq0fd0zxbzd/wpaajvaoxesgneaaaaaelftksuqmcc) right repeat-y\
  }";

  var dom = acequire("../lib/dom");
  dom.importCssString(exports.cssText, exports.cssClass);
});

/* jshint ignore:end */


/***/ }),
/* 684 */
/***/ (function(module, exports) {

ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"], function(acequire, exports, module) {
"use strict";
var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var lang = acequire("./lib/lang");
var Range = acequire("./range").Range;
var Anchor = acequire("./anchor").Anchor;
var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var Tokenizer = acequire("./tokenizer").Tokenizer;
var comparePoints = Range.comparePoints;

var SnippetManager = function() {
    this.snippetMap = {};
    this.snippetNameMap = {};
};

(function() {
    oop.implement(this, EventEmitter);
    
    this.getTokenizer = function() {
        function TabstopToken(str, _, stack) {
            str = str.substr(1);
            if (/^\d+$/.test(str) && !stack.inFormatString)
                return [{tabstopId: parseInt(str, 10)}];
            return [{text: str}];
        }
        function escape(ch) {
            return "(?:[^\\\\" + ch + "]|\\\\.)";
        }
        SnippetManager.$tokenizer = new Tokenizer({
            start: [
                {regex: /:/, onMatch: function(val, state, stack) {
                    if (stack.length && stack[0].expectIf) {
                        stack[0].expectIf = false;
                        stack[0].elseBranch = stack[0];
                        return [stack[0]];
                    }
                    return ":";
                }},
                {regex: /\\./, onMatch: function(val, state, stack) {
                    var ch = val[1];
                    if (ch == "}" && stack.length) {
                        val = ch;
                    }else if ("`$\\".indexOf(ch) != -1) {
                        val = ch;
                    } else if (stack.inFormatString) {
                        if (ch == "n")
                            val = "\n";
                        else if (ch == "t")
                            val = "\n";
                        else if ("ulULE".indexOf(ch) != -1) {
                            val = {changeCase: ch, local: ch > "a"};
                        }
                    }

                    return [val];
                }},
                {regex: /}/, onMatch: function(val, state, stack) {
                    return [stack.length ? stack.shift() : val];
                }},
                {regex: /\$(?:\d+|\w+)/, onMatch: TabstopToken},
                {regex: /\$\{[\dA-Z_a-z]+/, onMatch: function(str, state, stack) {
                    var t = TabstopToken(str.substr(1), state, stack);
                    stack.unshift(t[0]);
                    return t;
                }, next: "snippetVar"},
                {regex: /\n/, token: "newline", merge: false}
            ],
            snippetVar: [
                {regex: "\\|" + escape("\\|") + "*\\|", onMatch: function(val, state, stack) {
                    stack[0].choices = val.slice(1, -1).split(",");
                }, next: "start"},
                {regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
                 onMatch: function(val, state, stack) {
                    var ts = stack[0];
                    ts.fmtString = val;

                    val = this.splitRegex.exec(val);
                    ts.guard = val[1];
                    ts.fmt = val[2];
                    ts.flag = val[3];
                    return "";
                }, next: "start"},
                {regex: "`" + escape("`") + "*`", onMatch: function(val, state, stack) {
                    stack[0].code = val.splice(1, -1);
                    return "";
                }, next: "start"},
                {regex: "\\?", onMatch: function(val, state, stack) {
                    if (stack[0])
                        stack[0].expectIf = true;
                }, next: "start"},
                {regex: "([^:}\\\\]|\\\\.)*:?", token: "", next: "start"}
            ],
            formatString: [
                {regex: "/(" + escape("/") + "+)/", token: "regex"},
                {regex: "", onMatch: function(val, state, stack) {
                    stack.inFormatString = true;
                }, next: "start"}
            ]
        });
        SnippetManager.prototype.getTokenizer = function() {
            return SnippetManager.$tokenizer;
        };
        return SnippetManager.$tokenizer;
    };

    this.tokenizeTmSnippet = function(str, startState) {
        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
            return x.value || x;
        });
    };

    this.$getDefaultValue = function(editor, name) {
        if (/^[A-Z]\d+$/.test(name)) {
            var i = name.substr(1);
            return (this.variables[name[0] + "__"] || {})[i];
        }
        if (/^\d+$/.test(name)) {
            return (this.variables.__ || {})[name];
        }
        name = name.replace(/^TM_/, "");

        if (!editor)
            return;
        var s = editor.session;
        switch(name) {
            case "CURRENT_WORD":
                var r = s.getWordRange();
            case "SELECTION":
            case "SELECTED_TEXT":
                return s.getTextRange(r);
            case "CURRENT_LINE":
                return s.getLine(editor.getCursorPosition().row);
            case "PREV_LINE": // not possible in textmate
                return s.getLine(editor.getCursorPosition().row - 1);
            case "LINE_INDEX":
                return editor.getCursorPosition().column;
            case "LINE_NUMBER":
                return editor.getCursorPosition().row + 1;
            case "SOFT_TABS":
                return s.getUseSoftTabs() ? "YES" : "NO";
            case "TAB_SIZE":
                return s.getTabSize();
            case "FILENAME":
            case "FILEPATH":
                return "";
            case "FULLNAME":
                return "Ace";
        }
    };
    this.variables = {};
    this.getVariableValue = function(editor, varName) {
        if (this.variables.hasOwnProperty(varName))
            return this.variables[varName](editor, varName) || "";
        return this.$getDefaultValue(editor, varName) || "";
    };
    this.tmStrFormat = function(str, ch, editor) {
        var flag = ch.flag || "";
        var re = ch.guard;
        re = new RegExp(re, flag.replace(/[^gi]/, ""));
        var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
        var _self = this;
        var formatted = str.replace(re, function() {
            _self.variables.__ = arguments;
            var fmtParts = _self.resolveVariables(fmtTokens, editor);
            var gChangeCase = "E";
            for (var i  = 0; i < fmtParts.length; i++) {
                var ch = fmtParts[i];
                if (typeof ch == "object") {
                    fmtParts[i] = "";
                    if (ch.changeCase && ch.local) {
                        var next = fmtParts[i + 1];
                        if (next && typeof next == "string") {
                            if (ch.changeCase == "u")
                                fmtParts[i] = next[0].toUpperCase();
                            else
                                fmtParts[i] = next[0].toLowerCase();
                            fmtParts[i + 1] = next.substr(1);
                        }
                    } else if (ch.changeCase) {
                        gChangeCase = ch.changeCase;
                    }
                } else if (gChangeCase == "U") {
                    fmtParts[i] = ch.toUpperCase();
                } else if (gChangeCase == "L") {
                    fmtParts[i] = ch.toLowerCase();
                }
            }
            return fmtParts.join("");
        });
        this.variables.__ = null;
        return formatted;
    };

    this.resolveVariables = function(snippet, editor) {
        var result = [];
        for (var i = 0; i < snippet.length; i++) {
            var ch = snippet[i];
            if (typeof ch == "string") {
                result.push(ch);
            } else if (typeof ch != "object") {
                continue;
            } else if (ch.skip) {
                gotoNext(ch);
            } else if (ch.processed < i) {
                continue;
            } else if (ch.text) {
                var value = this.getVariableValue(editor, ch.text);
                if (value && ch.fmtString)
                    value = this.tmStrFormat(value, ch);
                ch.processed = i;
                if (ch.expectIf == null) {
                    if (value) {
                        result.push(value);
                        gotoNext(ch);
                    }
                } else {
                    if (value) {
                        ch.skip = ch.elseBranch;
                    } else
                        gotoNext(ch);
                }
            } else if (ch.tabstopId != null) {
                result.push(ch);
            } else if (ch.changeCase != null) {
                result.push(ch);
            }
        }
        function gotoNext(ch) {
            var i1 = snippet.indexOf(ch, i + 1);
            if (i1 != -1)
                i = i1;
        }
        return result;
    };

    this.insertSnippetForSelection = function(editor, snippetText) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var tabString = editor.session.getTabString();
        var indentString = line.match(/^\s*/)[0];
        
        if (cursor.column < indentString.length)
            indentString = indentString.slice(0, cursor.column);

        snippetText = snippetText.replace(/\r/g, "");
        var tokens = this.tokenizeTmSnippet(snippetText);
        tokens = this.resolveVariables(tokens, editor);
        tokens = tokens.map(function(x) {
            if (x == "\n")
                return x + indentString;
            if (typeof x == "string")
                return x.replace(/\t/g, tabString);
            return x;
        });
        var tabstops = [];
        tokens.forEach(function(p, i) {
            if (typeof p != "object")
                return;
            var id = p.tabstopId;
            var ts = tabstops[id];
            if (!ts) {
                ts = tabstops[id] = [];
                ts.index = id;
                ts.value = "";
            }
            if (ts.indexOf(p) !== -1)
                return;
            ts.push(p);
            var i1 = tokens.indexOf(p, i + 1);
            if (i1 === -1)
                return;

            var value = tokens.slice(i + 1, i1);
            var isNested = value.some(function(t) {return typeof t === "object"});          
            if (isNested && !ts.value) {
                ts.value = value;
            } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
                ts.value = value.join("");
            }
        });
        tabstops.forEach(function(ts) {ts.length = 0});
        var expanding = {};
        function copyValue(val) {
            var copy = [];
            for (var i = 0; i < val.length; i++) {
                var p = val[i];
                if (typeof p == "object") {
                    if (expanding[p.tabstopId])
                        continue;
                    var j = val.lastIndexOf(p, i - 1);
                    p = copy[j] || {tabstopId: p.tabstopId};
                }
                copy[i] = p;
            }
            return copy;
        }
        for (var i = 0; i < tokens.length; i++) {
            var p = tokens[i];
            if (typeof p != "object")
                continue;
            var id = p.tabstopId;
            var i1 = tokens.indexOf(p, i + 1);
            if (expanding[id]) {
                if (expanding[id] === p)
                    expanding[id] = null;
                continue;
            }
            
            var ts = tabstops[id];
            var arg = typeof ts.value == "string" ? [ts.value] : copyValue(ts.value);
            arg.unshift(i + 1, Math.max(0, i1 - i));
            arg.push(p);
            expanding[id] = p;
            tokens.splice.apply(tokens, arg);

            if (ts.indexOf(p) === -1)
                ts.push(p);
        }
        var row = 0, column = 0;
        var text = "";
        tokens.forEach(function(t) {
            if (typeof t === "string") {
                var lines = t.split("\n");
                if (lines.length > 1){
                    column = lines[lines.length - 1].length;
                    row += lines.length - 1;
                } else
                    column += t.length;
                text += t;
            } else {
                if (!t.start)
                    t.start = {row: row, column: column};
                else
                    t.end = {row: row, column: column};
            }
        });
        var range = editor.getSelectionRange();
        var end = editor.session.replace(range, text);

        var tabstopManager = new TabstopManager(editor);
        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
    };
    
    this.insertSnippet = function(editor, snippetText) {
        var self = this;
        if (editor.inVirtualSelectionMode)
            return self.insertSnippetForSelection(editor, snippetText);
        
        editor.forEachSelection(function() {
            self.insertSnippetForSelection(editor, snippetText);
        }, null, {keepOrder: true});
        
        if (editor.tabstopManager)
            editor.tabstopManager.tabNext();
    };

    this.$getScope = function(editor) {
        var scope = editor.session.$mode.$id || "";
        scope = scope.split("/").pop();
        if (scope === "html" || scope === "php") {
            if (scope === "php" && !editor.session.$mode.inlinePhp) 
                scope = "html";
            var c = editor.getCursorPosition();
            var state = editor.session.getState(c.row);
            if (typeof state === "object") {
                state = state[0];
            }
            if (state.substring) {
                if (state.substring(0, 3) == "js-")
                    scope = "javascript";
                else if (state.substring(0, 4) == "css-")
                    scope = "css";
                else if (state.substring(0, 4) == "php-")
                    scope = "php";
            }
        }
        
        return scope;
    };

    this.getActiveScopes = function(editor) {
        var scope = this.$getScope(editor);
        var scopes = [scope];
        var snippetMap = this.snippetMap;
        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
            scopes.push.apply(scopes, snippetMap[scope].includeScopes);
        }
        scopes.push("_");
        return scopes;
    };

    this.expandWithTab = function(editor, options) {
        var self = this;
        var result = editor.forEachSelection(function() {
            return self.expandSnippetForSelection(editor, options);
        }, null, {keepOrder: true});
        if (result && editor.tabstopManager)
            editor.tabstopManager.tabNext();
        return result;
    };
    
    this.expandSnippetForSelection = function(editor, options) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var before = line.substring(0, cursor.column);
        var after = line.substr(cursor.column);

        var snippetMap = this.snippetMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = this.findMatchingSnippet(snippets, before, after);
            return !!snippet;
        }, this);
        if (!snippet)
            return false;
        if (options && options.dryRun)
            return true;
        editor.session.doc.removeInLine(cursor.row,
            cursor.column - snippet.replaceBefore.length,
            cursor.column + snippet.replaceAfter.length
        );

        this.variables.M__ = snippet.matchBefore;
        this.variables.T__ = snippet.matchAfter;
        this.insertSnippetForSelection(editor, snippet.content);

        this.variables.M__ = this.variables.T__ = null;
        return true;
    };

    this.findMatchingSnippet = function(snippetList, before, after) {
        for (var i = snippetList.length; i--;) {
            var s = snippetList[i];
            if (s.startRe && !s.startRe.test(before))
                continue;
            if (s.endRe && !s.endRe.test(after))
                continue;
            if (!s.startRe && !s.endRe)
                continue;

            s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
            s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
            s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
            s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
            return s;
        }
    };

    this.snippetMap = {};
    this.snippetNameMap = {};
    this.register = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;
        var self = this;
        
        if (!snippets) 
            snippets = [];
        
        function wrapRegexp(src) {
            if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src))
                src = "(?:" + src + ")";

            return src || "";
        }
        function guardedRegexp(re, guard, opening) {
            re = wrapRegexp(re);
            guard = wrapRegexp(guard);
            if (opening) {
                re = guard + re;
                if (re && re[re.length - 1] != "$")
                    re = re + "$";
            } else {
                re = re + guard;
                if (re && re[0] != "^")
                    re = "^" + re;
            }
            return new RegExp(re);
        }

        function addSnippet(s) {
            if (!s.scope)
                s.scope = scope || "_";
            scope = s.scope;
            if (!snippetMap[scope]) {
                snippetMap[scope] = [];
                snippetNameMap[scope] = {};
            }

            var map = snippetNameMap[scope];
            if (s.name) {
                var old = map[s.name];
                if (old)
                    self.unregister(old);
                map[s.name] = s;
            }
            snippetMap[scope].push(s);

            if (s.tabTrigger && !s.trigger) {
                if (!s.guard && /^\w/.test(s.tabTrigger))
                    s.guard = "\\b";
                s.trigger = lang.escapeRegExp(s.tabTrigger);
            }
            
            if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard)
                return;
            
            s.startRe = guardedRegexp(s.trigger, s.guard, true);
            s.triggerRe = new RegExp(s.trigger, "", true);

            s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
            s.endTriggerRe = new RegExp(s.endTrigger, "", true);
        }

        if (snippets && snippets.content)
            addSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(addSnippet);
        
        this._signal("registerSnippets", {scope: scope});
    };
    this.unregister = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;

        function removeSnippet(s) {
            var nameMap = snippetNameMap[s.scope||scope];
            if (nameMap && nameMap[s.name]) {
                delete nameMap[s.name];
                var map = snippetMap[s.scope||scope];
                var i = map && map.indexOf(s);
                if (i >= 0)
                    map.splice(i, 1);
            }
        }
        if (snippets.content)
            removeSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(removeSnippet);
    };
    this.parseSnippetFile = function(str) {
        str = str.replace(/\r/g, "");
        var list = [], snippet = {};
        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
        var m;
        while (m = re.exec(str)) {
            if (m[1]) {
                try {
                    snippet = JSON.parse(m[1]);
                    list.push(snippet);
                } catch (e) {}
            } if (m[4]) {
                snippet.content = m[4].replace(/^\t/gm, "");
                list.push(snippet);
                snippet = {};
            } else {
                var key = m[2], val = m[3];
                if (key == "regex") {
                    var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
                    snippet.guard = guardRe.exec(val)[1];
                    snippet.trigger = guardRe.exec(val)[1];
                    snippet.endTrigger = guardRe.exec(val)[1];
                    snippet.endGuard = guardRe.exec(val)[1];
                } else if (key == "snippet") {
                    snippet.tabTrigger = val.match(/^\S*/)[0];
                    if (!snippet.name)
                        snippet.name = val;
                } else {
                    snippet[key] = val;
                }
            }
        }
        return list;
    };
    this.getSnippetByName = function(name, editor) {
        var snippetMap = this.snippetNameMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = snippets[name];
            return !!snippet;
        }, this);
        return snippet;
    };

}).call(SnippetManager.prototype);


var TabstopManager = function(editor) {
    if (editor.tabstopManager)
        return editor.tabstopManager;
    editor.tabstopManager = this;
    this.$onChange = this.onChange.bind(this);
    this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
    this.$onChangeSession = this.onChangeSession.bind(this);
    this.$onAfterExec = this.onAfterExec.bind(this);
    this.attach(editor);
};
(function() {
    this.attach = function(editor) {
        this.index = 0;
        this.ranges = [];
        this.tabstops = [];
        this.$openTabstops = null;
        this.selectedTabstop = null;

        this.editor = editor;
        this.editor.on("change", this.$onChange);
        this.editor.on("changeSelection", this.$onChangeSelection);
        this.editor.on("changeSession", this.$onChangeSession);
        this.editor.commands.on("afterExec", this.$onAfterExec);
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.detach = function() {
        this.tabstops.forEach(this.removeTabstopMarkers, this);
        this.ranges = null;
        this.tabstops = null;
        this.selectedTabstop = null;
        this.editor.removeListener("change", this.$onChange);
        this.editor.removeListener("changeSelection", this.$onChangeSelection);
        this.editor.removeListener("changeSession", this.$onChangeSession);
        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.tabstopManager = null;
        this.editor = null;
    };

    this.onChange = function(delta) {
        var changeRange = delta;
        var isRemove = delta.action[0] == "r";
        var start = delta.start;
        var end = delta.end;
        var startRow = start.row;
        var endRow = end.row;
        var lineDif = endRow - startRow;
        var colDiff = end.column - start.column;

        if (isRemove) {
            lineDif = -lineDif;
            colDiff = -colDiff;
        }
        if (!this.$inChange && isRemove) {
            var ts = this.selectedTabstop;
            var changedOutside = ts && !ts.some(function(r) {
                return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
            });
            if (changedOutside)
                return this.detach();
        }
        var ranges = this.ranges;
        for (var i = 0; i < ranges.length; i++) {
            var r = ranges[i];
            if (r.end.row < start.row)
                continue;

            if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
                this.removeRange(r);
                i--;
                continue;
            }

            if (r.start.row == startRow && r.start.column > start.column)
                r.start.column += colDiff;
            if (r.end.row == startRow && r.end.column >= start.column)
                r.end.column += colDiff;
            if (r.start.row >= startRow)
                r.start.row += lineDif;
            if (r.end.row >= startRow)
                r.end.row += lineDif;

            if (comparePoints(r.start, r.end) > 0)
                this.removeRange(r);
        }
        if (!ranges.length)
            this.detach();
    };
    this.updateLinkedFields = function() {
        var ts = this.selectedTabstop;
        if (!ts || !ts.hasLinkedRanges)
            return;
        this.$inChange = true;
        var session = this.editor.session;
        var text = session.getTextRange(ts.firstNonLinked);
        for (var i = ts.length; i--;) {
            var range = ts[i];
            if (!range.linked)
                continue;
            var fmt = exports.snippetManager.tmStrFormat(text, range.original);
            session.replace(range, fmt);
        }
        this.$inChange = false;
    };
    this.onAfterExec = function(e) {
        if (e.command && !e.command.readOnly)
            this.updateLinkedFields();
    };
    this.onChangeSelection = function() {
        if (!this.editor)
            return;
        var lead = this.editor.selection.lead;
        var anchor = this.editor.selection.anchor;
        var isEmpty = this.editor.selection.isEmpty();
        for (var i = this.ranges.length; i--;) {
            if (this.ranges[i].linked)
                continue;
            var containsLead = this.ranges[i].contains(lead.row, lead.column);
            var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
            if (containsLead && containsAnchor)
                return;
        }
        this.detach();
    };
    this.onChangeSession = function() {
        this.detach();
    };
    this.tabNext = function(dir) {
        var max = this.tabstops.length;
        var index = this.index + (dir || 1);
        index = Math.min(Math.max(index, 1), max);
        if (index == max)
            index = 0;
        this.selectTabstop(index);
        if (index === 0)
            this.detach();
    };
    this.selectTabstop = function(index) {
        this.$openTabstops = null;
        var ts = this.tabstops[this.index];
        if (ts)
            this.addTabstopMarkers(ts);
        this.index = index;
        ts = this.tabstops[this.index];
        if (!ts || !ts.length)
            return;
        
        this.selectedTabstop = ts;
        if (!this.editor.inVirtualSelectionMode) {        
            var sel = this.editor.multiSelect;
            sel.toSingleRange(ts.firstNonLinked.clone());
            for (var i = ts.length; i--;) {
                if (ts.hasLinkedRanges && ts[i].linked)
                    continue;
                sel.addRange(ts[i].clone(), true);
            }
            if (sel.ranges[0])
                sel.addRange(sel.ranges[0].clone());
        } else {
            this.editor.selection.setRange(ts.firstNonLinked);
        }
        
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.addTabstops = function(tabstops, start, end) {
        if (!this.$openTabstops)
            this.$openTabstops = [];
        if (!tabstops[0]) {
            var p = Range.fromPoints(end, end);
            moveRelative(p.start, start);
            moveRelative(p.end, start);
            tabstops[0] = [p];
            tabstops[0].index = 0;
        }

        var i = this.index;
        var arg = [i + 1, 0];
        var ranges = this.ranges;
        tabstops.forEach(function(ts, index) {
            var dest = this.$openTabstops[index] || ts;
                
            for (var i = ts.length; i--;) {
                var p = ts[i];
                var range = Range.fromPoints(p.start, p.end || p.start);
                movePoint(range.start, start);
                movePoint(range.end, start);
                range.original = p;
                range.tabstop = dest;
                ranges.push(range);
                if (dest != ts)
                    dest.unshift(range);
                else
                    dest[i] = range;
                if (p.fmtString) {
                    range.linked = true;
                    dest.hasLinkedRanges = true;
                } else if (!dest.firstNonLinked)
                    dest.firstNonLinked = range;
            }
            if (!dest.firstNonLinked)
                dest.hasLinkedRanges = false;
            if (dest === ts) {
                arg.push(dest);
                this.$openTabstops[index] = dest;
            }
            this.addTabstopMarkers(dest);
        }, this);
        
        if (arg.length > 2) {
            if (this.tabstops.length)
                arg.push(arg.splice(2, 1)[0]);
            this.tabstops.splice.apply(this.tabstops, arg);
        }
    };

    this.addTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            if  (!range.markerId)
                range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
        });
    };
    this.removeTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            session.removeMarker(range.markerId);
            range.markerId = null;
        });
    };
    this.removeRange = function(range) {
        var i = range.tabstop.indexOf(range);
        range.tabstop.splice(i, 1);
        i = this.ranges.indexOf(range);
        this.ranges.splice(i, 1);
        this.editor.session.removeMarker(range.markerId);
        if (!range.tabstop.length) {
            i = this.tabstops.indexOf(range.tabstop);
            if (i != -1)
                this.tabstops.splice(i, 1);
            if (!this.tabstops.length)
                this.detach();
        }
    };

    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys({
        "Tab": function(ed) {
            if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) {
                return;
            }

            ed.tabstopManager.tabNext(1);
        },
        "Shift-Tab": function(ed) {
            ed.tabstopManager.tabNext(-1);
        },
        "Esc": function(ed) {
            ed.tabstopManager.detach();
        },
        "Return": function(ed) {
            return false;
        }
    });
}).call(TabstopManager.prototype);



var changeTracker = {};
changeTracker.onChange = Anchor.prototype.onChange;
changeTracker.setPosition = function(row, column) {
    this.pos.row = row;
    this.pos.column = column;
};
changeTracker.update = function(pos, delta, $insertRight) {
    this.$insertRight = $insertRight;
    this.pos = pos; 
    this.onChange(delta);
};

var movePoint = function(point, diff) {
    if (point.row == 0)
        point.column += diff.column;
    point.row += diff.row;
};

var moveRelative = function(point, start) {
    if (point.row == start.row)
        point.column -= start.column;
    point.row -= start.row;
};


acequire("./lib/dom").importCssString("\
.ace_snippet-marker {\
    -moz-box-sizing: border-box;\
    box-sizing: border-box;\
    background: rgba(194, 193, 208, 0.09);\
    border: 1px dotted rgba(211, 208, 235, 0.62);\
    position: absolute;\
}");

exports.snippetManager = new SnippetManager();


var Editor = acequire("./editor").Editor;
(function() {
    this.insertSnippet = function(content, options) {
        return exports.snippetManager.insertSnippet(this, content, options);
    };
    this.expandSnippet = function(options) {
        return exports.snippetManager.expandWithTab(this, options);
    };
}).call(Editor.prototype);

});

ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var Renderer = acequire("../virtual_renderer").VirtualRenderer;
var Editor = acequire("../editor").Editor;
var Range = acequire("../range").Range;
var event = acequire("../lib/event");
var lang = acequire("../lib/lang");
var dom = acequire("../lib/dom");

var $singleLineEditor = function(el) {
    var renderer = new Renderer(el);

    renderer.$maxLines = 4;

    var editor = new Editor(renderer);

    editor.setHighlightActiveLine(false);
    editor.setShowPrintMargin(false);
    editor.renderer.setShowGutter(false);
    editor.renderer.setHighlightGutterLine(false);

    editor.$mouseHandler.$focusWaitTimout = 0;
    editor.$highlightTagPending = true;

    return editor;
};

var AcePopup = function(parentNode) {
    var el = dom.createElement("div");
    var popup = new $singleLineEditor(el);

    if (parentNode)
        parentNode.appendChild(el);
    el.style.display = "none";
    popup.renderer.content.style.cursor = "default";
    popup.renderer.setStyle("ace_autocomplete");

    popup.setOption("displayIndentGuides", false);
    popup.setOption("dragDelay", 150);

    var noop = function(){};

    popup.focus = noop;
    popup.$isFocused = true;

    popup.renderer.$cursorLayer.restartTimer = noop;
    popup.renderer.$cursorLayer.element.style.opacity = 0;

    popup.renderer.$maxLines = 8;
    popup.renderer.$keepTextAreaAtCursor = false;

    popup.setHighlightActiveLine(false);
    popup.session.highlight("");
    popup.session.$searchHighlight.clazz = "ace_highlight-marker";

    popup.on("mousedown", function(e) {
        var pos = e.getDocumentPosition();
        popup.selection.moveToPosition(pos);
        selectionMarker.start.row = selectionMarker.end.row = pos.row;
        e.stop();
    });

    var lastMouseEvent;
    var hoverMarker = new Range(-1,0,-1,Infinity);
    var selectionMarker = new Range(-1,0,-1,Infinity);
    selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
    popup.setSelectOnHover = function(val) {
        if (!val) {
            hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
        } else if (hoverMarker.id) {
            popup.session.removeMarker(hoverMarker.id);
            hoverMarker.id = null;
        }
    };
    popup.setSelectOnHover(false);
    popup.on("mousemove", function(e) {
        if (!lastMouseEvent) {
            lastMouseEvent = e;
            return;
        }
        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
            return;
        }
        lastMouseEvent = e;
        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
        var row = lastMouseEvent.getDocumentPosition().row;
        if (hoverMarker.start.row != row) {
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row);
        }
    });
    popup.renderer.on("beforeRender", function() {
        if (lastMouseEvent && hoverMarker.start.row != -1) {
            lastMouseEvent.$pos = null;
            var row = lastMouseEvent.getDocumentPosition().row;
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row, true);
        }
    });
    popup.renderer.on("afterRender", function() {
        var row = popup.getRow();
        var t = popup.renderer.$textLayer;
        var selected = t.element.childNodes[row - t.config.firstRow];
        if (selected == t.selectedNode)
            return;
        if (t.selectedNode)
            dom.removeCssClass(t.selectedNode, "ace_selected");
        t.selectedNode = selected;
        if (selected)
            dom.addCssClass(selected, "ace_selected");
    });
    var hideHoverMarker = function() { setHoverMarker(-1) };
    var setHoverMarker = function(row, suppressRedraw) {
        if (row !== hoverMarker.start.row) {
            hoverMarker.start.row = hoverMarker.end.row = row;
            if (!suppressRedraw)
                popup.session._emit("changeBackMarker");
            popup._emit("changeHoverMarker");
        }
    };
    popup.getHoveredRow = function() {
        return hoverMarker.start.row;
    };

    event.addListener(popup.container, "mouseout", hideHoverMarker);
    popup.on("hide", hideHoverMarker);
    popup.on("changeSelection", hideHoverMarker);

    popup.session.doc.getLength = function() {
        return popup.data.length;
    };
    popup.session.doc.getLine = function(i) {
        var data = popup.data[i];
        if (typeof data == "string")
            return data;
        return (data && data.value) || "";
    };

    var bgTokenizer = popup.session.bgTokenizer;
    bgTokenizer.$tokenizeRow = function(row) {
        var data = popup.data[row];
        var tokens = [];
        if (!data)
            return tokens;
        if (typeof data == "string")
            data = {value: data};
        if (!data.caption)
            data.caption = data.value || data.name;

        var last = -1;
        var flag, c;
        for (var i = 0; i < data.caption.length; i++) {
            c = data.caption[i];
            flag = data.matchMask & (1 << i) ? 1 : 0;
            if (last !== flag) {
                tokens.push({type: data.className || "" + ( flag ? "completion-highlight" : ""), value: c});
                last = flag;
            } else {
                tokens[tokens.length - 1].value += c;
            }
        }

        if (data.meta) {
            var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
            var metaData = data.meta;
            if (metaData.length + data.caption.length > maxW - 2) {
                metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026"
            }
            tokens.push({type: "rightAlignedText", value: metaData});
        }
        return tokens;
    };
    bgTokenizer.$updateOnChange = noop;
    bgTokenizer.start = noop;

    popup.session.$computeWidth = function() {
        return this.screenWidth = 0;
    };

    popup.$blockScrolling = Infinity;
    popup.isOpen = false;
    popup.isTopdown = false;

    popup.data = [];
    popup.setData = function(list) {
        popup.setValue(lang.stringRepeat("\n", list.length), -1);
        popup.data = list || [];
        popup.setRow(0);
    };
    popup.getData = function(row) {
        return popup.data[row];
    };

    popup.getRow = function() {
        return selectionMarker.start.row;
    };
    popup.setRow = function(line) {
        line = Math.max(0, Math.min(this.data.length, line));
        if (selectionMarker.start.row != line) {
            popup.selection.clearSelection();
            selectionMarker.start.row = selectionMarker.end.row = line || 0;
            popup.session._emit("changeBackMarker");
            popup.moveCursorTo(line || 0, 0);
            if (popup.isOpen)
                popup._signal("select");
        }
    };

    popup.on("changeSelection", function() {
        if (popup.isOpen)
            popup.setRow(popup.selection.lead.row);
        popup.renderer.scrollCursorIntoView();
    });

    popup.hide = function() {
        this.container.style.display = "none";
        this._signal("hide");
        popup.isOpen = false;
    };
    popup.show = function(pos, lineHeight, topdownOnly) {
        var el = this.container;
        var screenHeight = window.innerHeight;
        var screenWidth = window.innerWidth;
        var renderer = this.renderer;
        var maxH = renderer.$maxLines * lineHeight * 1.4;
        var top = pos.top + this.$borderSize;
        var allowTopdown = top > screenHeight / 2 && !topdownOnly;
        if (allowTopdown && top + lineHeight + maxH > screenHeight) {
            renderer.$maxPixelHeight = top - 2 * this.$borderSize;
            el.style.top = "";
            el.style.bottom = screenHeight - top + "px";
            popup.isTopdown = false;
        } else {
            top += lineHeight;
            renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
            el.style.top = top + "px";
            el.style.bottom = "";
            popup.isTopdown = true;
        }

        el.style.display = "";
        this.renderer.$textLayer.checkForSizeChanges();

        var left = pos.left;
        if (left + el.offsetWidth > screenWidth)
            left = screenWidth - el.offsetWidth;

        el.style.left = left + "px";

        this._signal("show");
        lastMouseEvent = null;
        popup.isOpen = true;
    };

    popup.getTextLeftOffset = function() {
        return this.$borderSize + this.renderer.$padding + this.$imageSize;
    };

    popup.$imageSize = 0;
    popup.$borderSize = 1;

    return popup;
};

dom.importCssString("\
.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
    background-color: #CAD6FA;\
    z-index: 1;\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    border: 1px solid #abbffe;\
    margin-top: -1px;\
    background: rgba(233,233,253,0.4);\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    position: absolute;\
    z-index: 2;\
}\
.ace_editor.ace_autocomplete .ace_scroller {\
   background: none;\
   border: none;\
   box-shadow: none;\
}\
.ace_rightAlignedText {\
    color: gray;\
    display: inline-block;\
    position: absolute;\
    right: 4px;\
    text-align: right;\
    z-index: -1;\
}\
.ace_editor.ace_autocomplete .ace_completion-highlight{\
    color: #000;\
    text-shadow: 0 0 0.01em;\
}\
.ace_editor.ace_autocomplete {\
    width: 280px;\
    z-index: 200000;\
    background: #fbfbfb;\
    color: #444;\
    border: 1px lightgray solid;\
    position: fixed;\
    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
    line-height: 1.4;\
}");

exports.AcePopup = AcePopup;

});

ace.define("ace/autocomplete/util",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.parForEach = function(array, fn, callback) {
    var completed = 0;
    var arLength = array.length;
    if (arLength === 0)
        callback();
    for (var i = 0; i < arLength; i++) {
        fn(array[i], function(result, err) {
            completed++;
            if (completed === arLength)
                callback(result, err);
        });
    }
};

var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;

exports.retrievePrecedingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos-1; i >= 0; i--) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf.reverse().join("");
};

exports.retrieveFollowingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos; i < text.length; i++) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf;
};

exports.getCompletionPrefix = function (editor) {
    var pos = editor.getCursorPosition();
    var line = editor.session.getLine(pos.row);
    var prefix;
    editor.completers.forEach(function(completer) {
        if (completer.identifierRegexps) {
            completer.identifierRegexps.forEach(function(identifierRegex) {
                if (!prefix && identifierRegex)
                    prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
            }.bind(this));
        }
    }.bind(this));
    return prefix || this.retrievePrecedingIdentifier(line, pos.column);
};

});

ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"], function(acequire, exports, module) {
"use strict";

var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var AcePopup = acequire("./autocomplete/popup").AcePopup;
var util = acequire("./autocomplete/util");
var event = acequire("./lib/event");
var lang = acequire("./lib/lang");
var dom = acequire("./lib/dom");
var snippetManager = acequire("./snippets").snippetManager;

var Autocomplete = function() {
    this.autoInsert = false;
    this.autoSelect = true;
    this.exactMatch = false;
    this.gatherCompletionsId = 0;
    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys(this.commands);

    this.blurListener = this.blurListener.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.mousedownListener = this.mousedownListener.bind(this);
    this.mousewheelListener = this.mousewheelListener.bind(this);

    this.changeTimer = lang.delayedCall(function() {
        this.updateCompletions(true);
    }.bind(this));

    this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
};

(function() {

    this.$init = function() {
        this.popup = new AcePopup(document.body || document.documentElement);
        this.popup.on("click", function(e) {
            this.insertMatch();
            e.stop();
        }.bind(this));
        this.popup.focus = this.editor.focus.bind(this.editor);
        this.popup.on("show", this.tooltipTimer.bind(null, null));
        this.popup.on("select", this.tooltipTimer.bind(null, null));
        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
        return this.popup;
    };

    this.getPopup = function() {
        return this.popup || this.$init();
    };

    this.openPopup = function(editor, prefix, keepPopupPosition) {
        if (!this.popup)
            this.$init();

        this.popup.setData(this.completions.filtered);

        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        
        var renderer = editor.renderer;
        this.popup.setRow(this.autoSelect ? 0 : -1);
        if (!keepPopupPosition) {
            this.popup.setTheme(editor.getTheme());
            this.popup.setFontSize(editor.getFontSize());

            var lineHeight = renderer.layerConfig.lineHeight;

            var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
            pos.left -= this.popup.getTextLeftOffset();

            var rect = editor.container.getBoundingClientRect();
            pos.top += rect.top - renderer.layerConfig.offset;
            pos.left += rect.left - editor.renderer.scrollLeft;
            pos.left += renderer.gutterWidth;

            this.popup.show(pos, lineHeight);
        } else if (keepPopupPosition && !prefix) {
            this.detach();
        }
    };

    this.detach = function() {
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.off("changeSelection", this.changeListener);
        this.editor.off("blur", this.blurListener);
        this.editor.off("mousedown", this.mousedownListener);
        this.editor.off("mousewheel", this.mousewheelListener);
        this.changeTimer.cancel();
        this.hideDocTooltip();

        this.gatherCompletionsId += 1;
        if (this.popup && this.popup.isOpen)
            this.popup.hide();

        if (this.base)
            this.base.detach();
        this.activated = false;
        this.completions = this.base = null;
    };

    this.changeListener = function(e) {
        var cursor = this.editor.selection.lead;
        if (cursor.row != this.base.row || cursor.column < this.base.column) {
            this.detach();
        }
        if (this.activated)
            this.changeTimer.schedule();
        else
            this.detach();
    };

    this.blurListener = function(e) {
        if (e.relatedTarget && e.relatedTarget.nodeName == "A" && e.relatedTarget.href) {
            window.open(e.relatedTarget.href, "_blank");
        }
        var el = document.activeElement;
        var text = this.editor.textInput.getElement();
        var fromTooltip = e.relatedTarget && e.relatedTarget == this.tooltipNode;
        var container = this.popup && this.popup.container;
        if (el != text && el.parentNode != container && !fromTooltip
            && el != this.tooltipNode && e.relatedTarget != text
        ) {
            this.detach();
        }
    };

    this.mousedownListener = function(e) {
        this.detach();
    };

    this.mousewheelListener = function(e) {
        this.detach();
    };

    this.goTo = function(where) {
        var row = this.popup.getRow();
        var max = this.popup.session.getLength() - 1;

        switch(where) {
            case "up": row = row <= 0 ? max : row - 1; break;
            case "down": row = row >= max ? -1 : row + 1; break;
            case "start": row = 0; break;
            case "end": row = max; break;
        }

        this.popup.setRow(row);
    };

    this.insertMatch = function(data, options) {
        if (!data)
            data = this.popup.getData(this.popup.getRow());
        if (!data)
            return false;

        if (data.completer && data.completer.insertMatch) {
            data.completer.insertMatch(this.editor, data);
        } else {
            if (this.completions.filterText) {
                var ranges = this.editor.selection.getAllRanges();
                for (var i = 0, range; range = ranges[i]; i++) {
                    range.start.column -= this.completions.filterText.length;
                    this.editor.session.remove(range);
                }
            }
            if (data.snippet)
                snippetManager.insertSnippet(this.editor, data.snippet);
            else
                this.editor.execCommand("insertstring", data.value || data);
        }
        this.detach();
    };


    this.commands = {
        "Up": function(editor) { editor.completer.goTo("up"); },
        "Down": function(editor) { editor.completer.goTo("down"); },
        "Ctrl-Up|Ctrl-Home": function(editor) { editor.completer.goTo("start"); },
        "Ctrl-Down|Ctrl-End": function(editor) { editor.completer.goTo("end"); },

        "Esc": function(editor) { editor.completer.detach(); },
        "Return": function(editor) { return editor.completer.insertMatch(); },
        "Shift-Return": function(editor) { editor.completer.insertMatch(null, {deleteSuffix: true}); },
        "Tab": function(editor) {
            var result = editor.completer.insertMatch();
            if (!result && !editor.tabstopManager)
                editor.completer.goTo("down");
            else
                return result;
        },

        "PageUp": function(editor) { editor.completer.popup.gotoPageUp(); },
        "PageDown": function(editor) { editor.completer.popup.gotoPageDown(); }
    };

    this.gatherCompletions = function(editor, callback) {
        var session = editor.getSession();
        var pos = editor.getCursorPosition();

        var line = session.getLine(pos.row);
        var prefix = util.getCompletionPrefix(editor);

        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
        this.base.$insertRight = true;

        var matches = [];
        var total = editor.completers.length;
        editor.completers.forEach(function(completer, i) {
            completer.getCompletions(editor, session, pos, prefix, function(err, results) {
                if (!err && results)
                    matches = matches.concat(results);
                var pos = editor.getCursorPosition();
                var line = session.getLine(pos.row);
                callback(null, {
                    prefix: prefix,
                    matches: matches,
                    finished: (--total === 0)
                });
            });
        });
        return true;
    };

    this.showPopup = function(editor) {
        if (this.editor)
            this.detach();

        this.activated = true;

        this.editor = editor;
        if (editor.completer != this) {
            if (editor.completer)
                editor.completer.detach();
            editor.completer = this;
        }

        editor.on("changeSelection", this.changeListener);
        editor.on("blur", this.blurListener);
        editor.on("mousedown", this.mousedownListener);
        editor.on("mousewheel", this.mousewheelListener);

        this.updateCompletions();
    };

    this.updateCompletions = function(keepPopupPosition) {
        if (keepPopupPosition && this.base && this.completions) {
            var pos = this.editor.getCursorPosition();
            var prefix = this.editor.session.getTextRange({start: this.base, end: pos});
            if (prefix == this.completions.filterText)
                return;
            this.completions.setFilter(prefix);
            if (!this.completions.filtered.length)
                return this.detach();
            if (this.completions.filtered.length == 1
            && this.completions.filtered[0].value == prefix
            && !this.completions.filtered[0].snippet)
                return this.detach();
            this.openPopup(this.editor, prefix, keepPopupPosition);
            return;
        }
        var _id = this.gatherCompletionsId;
        this.gatherCompletions(this.editor, function(err, results) {
            var detachIfFinished = function() {
                if (!results.finished) return;
                return this.detach();
            }.bind(this);

            var prefix = results.prefix;
            var matches = results && results.matches;

            if (!matches || !matches.length)
                return detachIfFinished();
            if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId)
                return;

            this.completions = new FilteredList(matches);

            if (this.exactMatch)
                this.completions.exactMatch = true;

            this.completions.setFilter(prefix);
            var filtered = this.completions.filtered;
            if (!filtered.length)
                return detachIfFinished();
            if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet)
                return detachIfFinished();
            if (this.autoInsert && filtered.length == 1 && results.finished)
                return this.insertMatch(filtered[0]);

            this.openPopup(this.editor, prefix, keepPopupPosition);
        }.bind(this));
    };

    this.cancelContextMenu = function() {
        this.editor.$mouseHandler.cancelContextMenu();
    };

    this.updateDocTooltip = function() {
        var popup = this.popup;
        var all = popup.data;
        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
        var doc = null;
        if (!selected || !this.editor || !this.popup.isOpen)
            return this.hideDocTooltip();
        this.editor.completers.some(function(completer) {
            if (completer.getDocTooltip)
                doc = completer.getDocTooltip(selected);
            return doc;
        });
        if (!doc)
            doc = selected;

        if (typeof doc == "string")
            doc = {docText: doc};
        if (!doc || !(doc.docHTML || doc.docText))
            return this.hideDocTooltip();
        this.showDocTooltip(doc);
    };

    this.showDocTooltip = function(item) {
        if (!this.tooltipNode) {
            this.tooltipNode = dom.createElement("div");
            this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
            this.tooltipNode.style.margin = 0;
            this.tooltipNode.style.pointerEvents = "auto";
            this.tooltipNode.tabIndex = -1;
            this.tooltipNode.onblur = this.blurListener.bind(this);
        }

        var tooltipNode = this.tooltipNode;
        if (item.docHTML) {
            tooltipNode.innerHTML = item.docHTML;
        } else if (item.docText) {
            tooltipNode.textContent = item.docText;
        }

        if (!tooltipNode.parentNode)
            document.body.appendChild(tooltipNode);
        var popup = this.popup;
        var rect = popup.container.getBoundingClientRect();
        tooltipNode.style.top = popup.container.style.top;
        tooltipNode.style.bottom = popup.container.style.bottom;

        if (window.innerWidth - rect.right < 320) {
            tooltipNode.style.right = window.innerWidth - rect.left + "px";
            tooltipNode.style.left = "";
        } else {
            tooltipNode.style.left = (rect.right + 1) + "px";
            tooltipNode.style.right = "";
        }
        tooltipNode.style.display = "block";
    };

    this.hideDocTooltip = function() {
        this.tooltipTimer.cancel();
        if (!this.tooltipNode) return;
        var el = this.tooltipNode;
        if (!this.editor.isFocused() && document.activeElement == el)
            this.editor.focus();
        this.tooltipNode = null;
        if (el.parentNode)
            el.parentNode.removeChild(el);
    };

}).call(Autocomplete.prototype);

Autocomplete.startCommand = {
    name: "startAutocomplete",
    exec: function(editor) {
        if (!editor.completer)
            editor.completer = new Autocomplete();
        editor.completer.autoInsert = false;
        editor.completer.autoSelect = true;
        editor.completer.showPopup(editor);
        editor.completer.cancelContextMenu();
    },
    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
};

var FilteredList = function(array, filterText) {
    this.all = array;
    this.filtered = array;
    this.filterText = filterText || "";
    this.exactMatch = false;
};
(function(){
    this.setFilter = function(str) {
        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0)
            var matches = this.filtered;
        else
            var matches = this.all;

        this.filterText = str;
        matches = this.filterCompletions(matches, this.filterText);
        matches = matches.sort(function(a, b) {
            return b.exactMatch - a.exactMatch || b.score - a.score;
        });
        var prev = null;
        matches = matches.filter(function(item){
            var caption = item.snippet || item.caption || item.value;
            if (caption === prev) return false;
            prev = caption;
            return true;
        });

        this.filtered = matches;
    };
    this.filterCompletions = function(items, needle) {
        var results = [];
        var upper = needle.toUpperCase();
        var lower = needle.toLowerCase();
        loop: for (var i = 0, item; item = items[i]; i++) {
            var caption = item.value || item.caption || item.snippet;
            if (!caption) continue;
            var lastIndex = -1;
            var matchMask = 0;
            var penalty = 0;
            var index, distance;

            if (this.exactMatch) {
                if (needle !== caption.substr(0, needle.length))
                    continue loop;
            }else{
                for (var j = 0; j < needle.length; j++) {
                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
                    index = (i1 >= 0) ? ((i2 < 0 || i1 < i2) ? i1 : i2) : i2;
                    if (index < 0)
                        continue loop;
                    distance = index - lastIndex - 1;
                    if (distance > 0) {
                        if (lastIndex === -1)
                            penalty += 10;
                        penalty += distance;
                    }
                    matchMask = matchMask | (1 << index);
                    lastIndex = index;
                }
            }
            item.matchMask = matchMask;
            item.exactMatch = penalty ? 0 : 1;
            item.score = (item.score || 0) - penalty;
            results.push(item);
        }
        return results;
    };
}).call(FilteredList.prototype);

exports.Autocomplete = Autocomplete;
exports.FilteredList = FilteredList;

});

ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"], function(acequire, exports, module) {
    var Range = acequire("../range").Range;
    
    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;

    function getWordIndex(doc, pos) {
        var textBefore = doc.getTextRange(Range.fromPoints({row: 0, column:0}, pos));
        return textBefore.split(splitRegex).length - 1;
    }
    function wordDistance(doc, pos) {
        var prefixPos = getWordIndex(doc, pos);
        var words = doc.getValue().split(splitRegex);
        var wordScores = Object.create(null);
        
        var currentWord = words[prefixPos];

        words.forEach(function(word, idx) {
            if (!word || word === currentWord) return;

            var distance = Math.abs(prefixPos - idx);
            var score = words.length - distance;
            if (wordScores[word]) {
                wordScores[word] = Math.max(score, wordScores[word]);
            } else {
                wordScores[word] = score;
            }
        });
        return wordScores;
    }

    exports.getCompletions = function(editor, session, pos, prefix, callback) {
        var wordScore = wordDistance(session, pos, prefix);
        var wordList = Object.keys(wordScore);
        callback(null, wordList.map(function(word) {
            return {
                caption: word,
                value: word,
                score: wordScore[word],
                meta: "local"
            };
        }));
    };
});

ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"], function(acequire, exports, module) {
"use strict";

var snippetManager = acequire("../snippets").snippetManager;
var Autocomplete = acequire("../autocomplete").Autocomplete;
var config = acequire("../config");
var lang = acequire("../lib/lang");
var util = acequire("../autocomplete/util");

var textCompleter = acequire("../autocomplete/text_completer");
var keyWordCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        if (session.$mode.completer) {
            return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
        }
        var state = editor.session.getState(pos.row);
        var completions = session.$mode.getCompletions(state, session, pos, prefix);
        callback(null, completions);
    }
};

var snippetCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        var snippetMap = snippetManager.snippetMap;
        var completions = [];
        snippetManager.getActiveScopes(editor).forEach(function(scope) {
            var snippets = snippetMap[scope] || [];
            for (var i = snippets.length; i--;) {
                var s = snippets[i];
                var caption = s.name || s.tabTrigger;
                if (!caption)
                    continue;
                completions.push({
                    caption: caption,
                    snippet: s.content,
                    meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
                    type: "snippet"
                });
            }
        }, this);
        callback(null, completions);
    },
    getDocTooltip: function(item) {
        if (item.type == "snippet" && !item.docHTML) {
            item.docHTML = [
                "<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>",
                lang.escapeHTML(item.snippet)
            ].join("");
        }
    }
};

var completers = [snippetCompleter, textCompleter, keyWordCompleter];
exports.setCompleters = function(val) {
    completers.length = 0;
    if (val) completers.push.apply(completers, val);
};
exports.addCompleter = function(completer) {
    completers.push(completer);
};
exports.textCompleter = textCompleter;
exports.keyWordCompleter = keyWordCompleter;
exports.snippetCompleter = snippetCompleter;

var expandSnippet = {
    name: "expandSnippet",
    exec: function(editor) {
        return snippetManager.expandWithTab(editor);
    },
    bindKey: "Tab"
};

var onChangeMode = function(e, editor) {
    loadSnippetsForMode(editor.session.$mode);
};

var loadSnippetsForMode = function(mode) {
    var id = mode.$id;
    if (!snippetManager.files)
        snippetManager.files = {};
    loadSnippetFile(id);
    if (mode.modes)
        mode.modes.forEach(loadSnippetsForMode);
};

var loadSnippetFile = function(id) {
    if (!id || snippetManager.files[id])
        return;
    var snippetFilePath = id.replace("mode", "snippets");
    snippetManager.files[id] = {};
    config.loadModule(snippetFilePath, function(m) {
        if (m) {
            snippetManager.files[id] = m;
            if (!m.snippets && m.snippetText)
                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
            snippetManager.register(m.snippets || [], m.scope);
            if (m.includeScopes) {
                snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
                m.includeScopes.forEach(function(x) {
                    loadSnippetFile("ace/mode/" + x);
                });
            }
        }
    });
};

var doLiveAutocomplete = function(e) {
    var editor = e.editor;
    var hasCompleter = editor.completer && editor.completer.activated;
    if (e.command.name === "backspace") {
        if (hasCompleter && !util.getCompletionPrefix(editor))
            editor.completer.detach();
    }
    else if (e.command.name === "insertstring") {
        var prefix = util.getCompletionPrefix(editor);
        if (prefix && !hasCompleter) {
            if (!editor.completer) {
                editor.completer = new Autocomplete();
            }
            editor.completer.autoInsert = false;
            editor.completer.showPopup(editor);
        }
    }
};

var Editor = acequire("../editor").Editor;
acequire("../config").defineOptions(Editor.prototype, "editor", {
    enableBasicAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.addCommand(Autocomplete.startCommand);
            } else {
                this.commands.removeCommand(Autocomplete.startCommand);
            }
        },
        value: false
    },
    enableLiveAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.on('afterExec', doLiveAutocomplete);
            } else {
                this.commands.removeListener('afterExec', doLiveAutocomplete);
            }
        },
        value: false
    },
    enableSnippets: {
        set: function(val) {
            if (val) {
                this.commands.addCommand(expandSnippet);
                this.on("changeMode", onChangeMode);
                onChangeMode(null, this);
            } else {
                this.commands.removeCommand(expandSnippet);
                this.off("changeMode", onChangeMode);
            }
        },
        value: false
    }
});
});
                (function() {
                    ace.acequire(["ace/ext/language_tools"], function() {});
                })();
            

/***/ }),
/* 685 */
/***/ (function(module, exports) {

ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

exports.isDark = false;
exports.cssClass = "ace-tm";
exports.cssText = ".ace-tm .ace_gutter {\
background: #f0f0f0;\
color: #333;\
}\
.ace-tm .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-tm .ace_fold {\
background-color: #6B72E6;\
}\
.ace-tm {\
background-color: #FFFFFF;\
color: black;\
}\
.ace-tm .ace_cursor {\
color: black;\
}\
.ace-tm .ace_invisible {\
color: rgb(191, 191, 191);\
}\
.ace-tm .ace_storage,\
.ace-tm .ace_keyword {\
color: blue;\
}\
.ace-tm .ace_constant {\
color: rgb(197, 6, 11);\
}\
.ace-tm .ace_constant.ace_buildin {\
color: rgb(88, 72, 246);\
}\
.ace-tm .ace_constant.ace_language {\
color: rgb(88, 92, 246);\
}\
.ace-tm .ace_constant.ace_library {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_invalid {\
background-color: rgba(255, 0, 0, 0.1);\
color: red;\
}\
.ace-tm .ace_support.ace_function {\
color: rgb(60, 76, 114);\
}\
.ace-tm .ace_support.ace_constant {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_support.ace_type,\
.ace-tm .ace_support.ace_class {\
color: rgb(109, 121, 222);\
}\
.ace-tm .ace_keyword.ace_operator {\
color: rgb(104, 118, 135);\
}\
.ace-tm .ace_string {\
color: rgb(3, 106, 7);\
}\
.ace-tm .ace_comment {\
color: rgb(76, 136, 107);\
}\
.ace-tm .ace_comment.ace_doc {\
color: rgb(0, 102, 255);\
}\
.ace-tm .ace_comment.ace_doc.ace_tag {\
color: rgb(128, 159, 191);\
}\
.ace-tm .ace_constant.ace_numeric {\
color: rgb(0, 0, 205);\
}\
.ace-tm .ace_variable {\
color: rgb(49, 132, 149);\
}\
.ace-tm .ace_xml-pe {\
color: rgb(104, 104, 91);\
}\
.ace-tm .ace_entity.ace_name.ace_function {\
color: #0000A2;\
}\
.ace-tm .ace_heading {\
color: rgb(12, 7, 255);\
}\
.ace-tm .ace_list {\
color:rgb(185, 6, 144);\
}\
.ace-tm .ace_meta.ace_tag {\
color:rgb(0, 22, 142);\
}\
.ace-tm .ace_string.ace_regex {\
color: rgb(255, 0, 0)\
}\
.ace-tm .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-tm.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px white;\
}\
.ace-tm .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-tm .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-tm .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-tm .ace_marker-layer .ace_active-line {\
background: rgba(0, 0, 0, 0.07);\
}\
.ace-tm .ace_gutter-active-line {\
background-color : #dcdcdc;\
}\
.ace-tm .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-tm .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}\
";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});


/***/ }),
/* 686 */
/***/ (function(module, exports) {




/***/ }),
/* 687 */
/***/ (function(module, exports) {

ace.define("ace/snippets/text",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="text"})

/***/ }),
/* 688 */
/***/ (function(module, exports) {

ace.define("ace/mode/sql_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var SqlHighlightRules = function() {

    var keywords = (
        "select|insert|update|delete|from|where|and|or|group|by|order|limit|offset|having|as|case|" +
        "when|else|end|type|left|right|join|on|outer|desc|asc|union|create|table|primary|key|if|" +
        "foreign|not|references|default|null|inner|cross|natural|database|drop|grant"
    );

    var builtinConstants = (
        "true|false"
    );

    var builtinFunctions = (
        "avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|" + 
        "coalesce|ifnull|isnull|nvl"
    );

    var dataTypes = (
        "int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|" +
        "money|real|number|integer"
    );

    var keywordMapper = this.createKeywordMapper({
        "support.function": builtinFunctions,
        "keyword": keywords,
        "constant.language": builtinConstants,
        "storage.type": dataTypes
    }, "identifier", true);

    this.$rules = {
        "start" : [ {
            token : "comment",
            regex : "--.*$"
        },  {
            token : "comment",
            start : "/\\*",
            end : "\\*/"
        }, {
            token : "string",           // " string
            regex : '".*?"'
        }, {
            token : "string",           // ' string
            regex : "'.*?'"
        }, {
            token : "constant.numeric", // float
            regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
        }, {
            token : keywordMapper,
            regex : "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token : "keyword.operator",
            regex : "\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="
        }, {
            token : "paren.lparen",
            regex : "[\\(]"
        }, {
            token : "paren.rparen",
            regex : "[\\)]"
        }, {
            token : "text",
            regex : "\\s+"
        } ]
    };
    this.normalizeRules();
};

oop.inherits(SqlHighlightRules, TextHighlightRules);

exports.SqlHighlightRules = SqlHighlightRules;
});

ace.define("ace/mode/sql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/sql_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var SqlHighlightRules = acequire("./sql_highlight_rules").SqlHighlightRules;

var Mode = function() {
    this.HighlightRules = SqlHighlightRules;
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = "--";

    this.$id = "ace/mode/sql";
}).call(Mode.prototype);

exports.Mode = Mode;

});


/***/ }),
/* 689 */
/***/ (function(module, exports) {

ace.define("ace/snippets/sql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText="snippet tbl\n	create table ${1:table} (\n		${2:columns}\n	);\nsnippet col\n	${1:name}	${2:type}	${3:default ''}	${4:not null}\nsnippet ccol\n	${1:name}	varchar2(${2:size})	${3:default ''}	${4:not null}\nsnippet ncol\n	${1:name}	number	${3:default 0}	${4:not null}\nsnippet dcol\n	${1:name}	date	${3:default sysdate}	${4:not null}\nsnippet ind\n	create index ${3:$1_$2} on ${1:table}(${2:column});\nsnippet uind\n	create unique index ${1:name} on ${2:table}(${3:column});\nsnippet tblcom\n	comment on table ${1:table} is '${2:comment}';\nsnippet colcom\n	comment on column ${1:table}.${2:column} is '${3:comment}';\nsnippet addcol\n	alter table ${1:table} add (${2:column} ${3:type});\nsnippet seq\n	create sequence ${1:name} start with ${2:1} increment by ${3:1} minvalue ${4:1};\nsnippet s*\n	select * from ${1:table}\n",t.scope="sql"})

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// outline.js
// based on http://www.paciellogroup.com/blog/2012/04/how-to-remove-css-outlines-in-an-accessible-manner/
(function(d) {
  "use strict";

  var style_element = d.createElement('STYLE'),
    dom_events = 'addEventListener' in d,
    add_event_listener = function(type, callback) {
      // Basic cross-browser event handling
      if(dom_events){
        d.addEventListener(type, callback);
      } else {
        d.attachEvent('on' + type, callback);
      }
    },
    set_css = function(css_text) {
      // Handle setting of <style> element contents in IE8
      !!style_element.styleSheet ? style_element.styleSheet.cssText = css_text : style_element.innerHTML = css_text;
    };

  d.getElementsByTagName('HEAD')[0].appendChild(style_element);

  // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
  add_event_listener('mousedown', function() {
    set_css(':focus{outline:0 !important}::-moz-focus-inner{border:0;}');
  });

  add_event_listener('keydown', function() {
    set_css('');
  });

})(document);


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tether_drop__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tether_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorPickerPopover__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_utils_react2angular__ = __webpack_require__(107);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.openColorPicker = _this.openColorPicker.bind(_this);
        _this.closeColorPicker = _this.closeColorPicker.bind(_this);
        _this.setPickerElem = _this.setPickerElem.bind(_this);
        _this.onColorSelect = _this.onColorSelect.bind(_this);
        return _this;
    }
    ColorPicker.prototype.setPickerElem = function (elem) {
        this.pickerElem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem);
    };
    ColorPicker.prototype.openColorPicker = function () {
        var dropContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColorPickerPopover__["a" /* ColorPickerPopover */], { color: this.props.color, onColorSelect: this.onColorSelect });
        var dropContentElem = document.createElement('div');
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(dropContent, dropContentElem);
        var drop = new __WEBPACK_IMPORTED_MODULE_3_tether_drop___default.a({
            target: this.pickerElem[0],
            content: dropContentElem,
            position: 'top center',
            classes: 'drop-popover',
            openOn: 'click',
            hoverCloseDelay: 200,
            tetherOptions: {
                constraints: [{ to: 'scrollParent', attachment: 'none both' }],
            },
        });
        drop.on('close', this.closeColorPicker);
        this.colorPickerDrop = drop;
        this.colorPickerDrop.open();
    };
    ColorPicker.prototype.closeColorPicker = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.colorPickerDrop && _this.colorPickerDrop.tether) {
                _this.colorPickerDrop.destroy();
            }
        }, 100);
    };
    ColorPicker.prototype.onColorSelect = function (color) {
        this.props.onChange(color);
    };
    ColorPicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sp-replacer sp-light", onClick: this.openColorPicker, ref: this.setPickerElem },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sp-preview" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sp-preview-inner", style: { backgroundColor: this.props.color } }))));
    };
    return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

Object(__WEBPACK_IMPORTED_MODULE_5_app_core_utils_react2angular__["a" /* react2AngularDirective */])('colorPicker', ColorPicker, [
    'color',
    ['onChange', { watchDepth: 'reference', wrapApply: true }],
]);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GfColorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_colors__ = __webpack_require__(112);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var GfColorPalette = /** @class */ (function (_super) {
    __extends(GfColorPalette, _super);
    function GfColorPalette(props) {
        var _this = _super.call(this, props) || this;
        _this.paletteColors = __WEBPACK_IMPORTED_MODULE_1_app_core_utils_colors__["g" /* sortedColors */];
        _this.onColorSelect = _this.onColorSelect.bind(_this);
        return _this;
    }
    GfColorPalette.prototype.onColorSelect = function (color) {
        var _this = this;
        return function () {
            _this.props.onColorSelect(color);
        };
    };
    GfColorPalette.prototype.render = function () {
        var _this = this;
        var colorPaletteItems = this.paletteColors.map(function (paletteColor) {
            var cssClass = paletteColor.toLowerCase() === _this.props.color.toLowerCase() ? 'fa-circle-o' : 'fa-circle';
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { key: paletteColor, className: 'pointer fa ' + cssClass, style: { color: paletteColor }, onClick: _this.onColorSelect(paletteColor) }, "\u00A0"));
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "graph-legend-popover" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "m-b-0" }, colorPaletteItems)));
    };
    return GfColorPalette;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GfSpectrumPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_spectrum__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_spectrum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendor_spectrum__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var GfSpectrumPicker = /** @class */ (function (_super) {
    __extends(GfSpectrumPicker, _super);
    function GfSpectrumPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onSpectrumMove = _this.onSpectrumMove.bind(_this);
        _this.setComponentElem = _this.setComponentElem.bind(_this);
        return _this;
    }
    GfSpectrumPicker.prototype.setComponentElem = function (elem) {
        this.elem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem);
    };
    GfSpectrumPicker.prototype.onSpectrumMove = function (color) {
        this.isMoving = true;
        this.props.onColorSelect(color);
    };
    GfSpectrumPicker.prototype.componentDidMount = function () {
        var spectrumOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.assignIn({
            flat: true,
            showAlpha: true,
            showButtons: false,
            color: this.props.color,
            appendTo: this.elem,
            move: this.onSpectrumMove,
        }, this.props.options);
        this.elem.spectrum(spectrumOptions);
        this.elem.spectrum('show');
        this.elem.spectrum('set', this.props.color);
    };
    GfSpectrumPicker.prototype.componentWillUpdate = function (nextProps) {
        // If user move pointer over spectrum field this produce 'move' event and component
        // may update props.color. We don't want to update spectrum color in this case, so we can use
        // isMoving flag for tracking moving state. Flag should be cleared in componentDidUpdate() which
        // is called after updating occurs (when user finished moving).
        if (!this.isMoving) {
            this.elem.spectrum('set', nextProps.color);
        }
    };
    GfSpectrumPicker.prototype.componentDidUpdate = function () {
        if (this.isMoving) {
            this.isMoving = false;
        }
    };
    GfSpectrumPicker.prototype.componentWillUnmount = function () {
        this.elem.spectrum('destroy');
    };
    GfSpectrumPicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "spectrum-container", ref: this.setComponentElem }));
    };
    return GfSpectrumPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Spectrum Colorpicker v1.7.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

(function (factory) {
    "use strict";

    if (true) { // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof exports == "object" && typeof module == "object") { // CommonJS
        module.exports = factory;
    }
    else { // Browser
        factory(jQuery);
    }
})(function($, undefined) {
    "use strict";

    var defaultOpts = {

        // Callbacks
        beforeShow: noop,
        move: noop,
        change: noop,
        show: noop,
        hide: noop,

        // Options
        color: false,
        flat: false,
        showInput: false,
        allowEmpty: false,
        showButtons: true,
        clickoutFiresChange: true,
        showInitial: false,
        showPalette: false,
        showPaletteOnly: false,
        hideAfterPaletteSelect: false,
        togglePaletteOnly: false,
        showSelectionPalette: true,
        localStorageKey: false,
        appendTo: "body",
        maxSelectionSize: 7,
        cancelText: "cancel",
        chooseText: "choose",
        togglePaletteMoreText: "more",
        togglePaletteLessText: "less",
        clearText: "Clear Color Selection",
        noColorSelectedText: "No Color Selected",
        preferredFormat: false,
        className: "", // Deprecated - use containerClassName and replacerClassName instead.
        containerClassName: "",
        replacerClassName: "",
        showAlpha: false,
        theme: "sp-light",
        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
        selectionPalette: [],
        disabled: false,
        offset: null
    },
    spectrums = [],
    IE = !!/msie/i.exec( window.navigator.userAgent ),
    rgbaSupport = (function() {
        function contains( str, substr ) {
            return !!~('' + str).indexOf(substr);
        }

        var elem = document.createElement('div');
        var style = elem.style;
        style.cssText = 'background-color:rgba(0,0,0,.5)';
        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
    })(),
    replaceInput = [
        "<div class='sp-replacer'>",
            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
            "<div class='sp-dd'>&#9660;</div>",
        "</div>"
    ].join(''),
    markup = (function () {

        // IE does not support gradients with multiple stops, so we need to simulate
        //  that for the rainbow slider with 8 divs that each have a single gradient
        var gradientFix = "";
        if (IE) {
            for (var i = 1; i <= 6; i++) {
                gradientFix += "<div class='sp-" + i + "'></div>";
            }
        }

        return [
            "<div class='sp-container sp-hidden'>",
                "<div class='sp-palette-container'>",
                    "<div class='sp-palette sp-thumb sp-cf'></div>",
                    "<div class='sp-palette-button-container sp-cf'>",
                        "<button type='button' class='sp-palette-toggle'></button>",
                    "</div>",
                "</div>",
                "<div class='sp-picker-container'>",
                    "<div class='sp-top sp-cf'>",
                        "<div class='sp-fill'></div>",
                        "<div class='sp-top-inner'>",
                            "<div class='sp-color'>",
                                "<div class='sp-sat'>",
                                    "<div class='sp-val'>",
                                        "<div class='sp-dragger'></div>",
                                    "</div>",
                                "</div>",
                            "</div>",
                            "<div class='sp-clear sp-clear-display'>",
                            "</div>",
                            "<div class='sp-hue'>",
                                "<div class='sp-slider'></div>",
                                gradientFix,
                            "</div>",
                        "</div>",
                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
                    "</div>",
                    "<div class='sp-input-container sp-cf'>",
                        "<input class='sp-input' type='text' spellcheck='false'  />",
                    "</div>",
                    "<div class='sp-initial sp-thumb sp-cf'></div>",
                    "<div class='sp-button-container sp-cf'>",
                        "<a class='sp-cancel' href='#'></a>",
                        "<button type='button' class='sp-choose'></button>",
                    "</div>",
                "</div>",
            "</div>"
        ].join("");
    })();

    function paletteTemplate (p, color, className, opts) {
        var html = [];
        for (var i = 0; i < p.length; i++) {
            var current = p[i];
            if(current) {
                var tiny = tinycolor(current);
                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
                var formattedString = tiny.toString(opts.preferredFormat || "rgb");
                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
            } else {
                var cls = 'sp-clear-display';
                html.push($('<div />')
                    .append($('<span data-color="" style="background-color:transparent;" class="' + cls + '"></span>')
                        .attr('title', opts.noColorSelectedText)
                    )
                    .html()
                );
            }
        }
        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
    }

    function hideAll() {
        for (var i = 0; i < spectrums.length; i++) {
            if (spectrums[i]) {
                spectrums[i].hide();
            }
        }
    }

    function instanceOptions(o, callbackContext) {
        var opts = $.extend({}, defaultOpts, o);
        opts.callbacks = {
            'move': bind(opts.move, callbackContext),
            'change': bind(opts.change, callbackContext),
            'show': bind(opts.show, callbackContext),
            'hide': bind(opts.hide, callbackContext),
            'beforeShow': bind(opts.beforeShow, callbackContext)
        };

        return opts;
    }

    function spectrum(element, o) {

        var opts = instanceOptions(o, element),
            flat = opts.flat,
            showSelectionPalette = opts.showSelectionPalette,
            localStorageKey = opts.localStorageKey,
            theme = opts.theme,
            callbacks = opts.callbacks,
            resize = throttle(reflow, 10),
            visible = false,
            isDragging = false,
            dragWidth = 0,
            dragHeight = 0,
            dragHelperHeight = 0,
            slideHeight = 0,
            slideWidth = 0,
            alphaWidth = 0,
            alphaSlideHelperWidth = 0,
            slideHelperHeight = 0,
            currentHue = 0,
            currentSaturation = 0,
            currentValue = 0,
            currentAlpha = 1,
            palette = [],
            paletteArray = [],
            paletteLookup = {},
            selectionPalette = opts.selectionPalette.slice(0),
            maxSelectionSize = opts.maxSelectionSize,
            draggingClass = "sp-dragging",
            shiftMovementDirection = null;

        var doc = element.ownerDocument,
            body = doc.body,
            boundElement = $(element),
            disabled = false,
            container = $(markup, doc).addClass(theme),
            pickerContainer = container.find(".sp-picker-container"),
            dragger = container.find(".sp-color"),
            dragHelper = container.find(".sp-dragger"),
            slider = container.find(".sp-hue"),
            slideHelper = container.find(".sp-slider"),
            alphaSliderInner = container.find(".sp-alpha-inner"),
            alphaSlider = container.find(".sp-alpha"),
            alphaSlideHelper = container.find(".sp-alpha-handle"),
            textInput = container.find(".sp-input"),
            paletteContainer = container.find(".sp-palette"),
            initialColorContainer = container.find(".sp-initial"),
            cancelButton = container.find(".sp-cancel"),
            clearButton = container.find(".sp-clear"),
            chooseButton = container.find(".sp-choose"),
            toggleButton = container.find(".sp-palette-toggle"),
            isInput = boundElement.is("input"),
            isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
            shouldReplace = isInput && !flat,
            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
            offsetElement = (shouldReplace) ? replacer : boundElement,
            previewElement = replacer.find(".sp-preview-inner"),
            initialColor = opts.color || (isInput && boundElement.val()),
            colorOnShow = false,
            preferredFormat = opts.preferredFormat,
            currentPreferredFormat = preferredFormat,
            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
            isEmpty = !initialColor,
            allowEmpty = opts.allowEmpty && !isInputTypeColor;

        function applyOptions() {

            if (opts.showPaletteOnly) {
                opts.showPalette = true;
            }

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

            if (opts.palette) {
                palette = opts.palette.slice(0);
                paletteArray = $.isArray(palette[0]) ? palette : [palette];
                paletteLookup = {};
                for (var i = 0; i < paletteArray.length; i++) {
                    for (var j = 0; j < paletteArray[i].length; j++) {
                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
                        paletteLookup[rgb] = true;
                    }
                }
            }

            container.toggleClass("sp-flat", flat);
            container.toggleClass("sp-input-disabled", !opts.showInput);
            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
            container.toggleClass("sp-clear-enabled", allowEmpty);
            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
            container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
            container.toggleClass("sp-palette-disabled", !opts.showPalette);
            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
            container.toggleClass("sp-initial-disabled", !opts.showInitial);
            container.addClass(opts.className).addClass(opts.containerClassName);

            reflow();
        }

        function initialize() {

            if (IE) {
                container.find("*:not(input)").attr("unselectable", "on");
            }

            applyOptions();

            if (shouldReplace) {
                boundElement.after(replacer).hide();
            }

            if (!allowEmpty) {
                clearButton.hide();
            }

            if (flat) {
                boundElement.after(container).hide();
            }
            else {

                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
                if (appendTo.length !== 1) {
                    appendTo = $("body");
                }

                appendTo.append(container);
            }

            updateSelectionPaletteFromStorage();

            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
                if (!disabled) {
                    toggle();
                }

                e.stopPropagation();

                if (!$(e.target).is("input")) {
                    e.preventDefault();
                }
            });

            if(boundElement.is(":disabled") || (opts.disabled === true)) {
                disable();
            }

            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
            container.click(stopPropagation);

            // Handle user typed input
            textInput.change(setFromTextInput);
            textInput.bind("paste", function () {
                setTimeout(setFromTextInput, 1);
            });
            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });

            cancelButton.text(opts.cancelText);
            cancelButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                revert();
                hide();
            });

            clearButton.attr("title", opts.clearText);
            clearButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                isEmpty = true;
                move();

                if(flat) {
                    //for the flat style, this is a change event
                    updateOriginalInput(true);
                }
            });

            chooseButton.text(opts.chooseText);
            chooseButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                if (IE && textInput.is(":focus")) {
                    textInput.trigger('change');
                }

                if (isValid()) {
                    updateOriginalInput(true);
                    hide();
                }
            });

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
            toggleButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                opts.showPaletteOnly = !opts.showPaletteOnly;

                // To make sure the Picker area is drawn on the right, next to the
                // Palette area (and not below the palette), first move the Palette
                // to the left to make space for the picker, plus 5px extra.
                // The 'applyOptions' function puts the whole container back into place
                // and takes care of the button-text and the sp-palette-only CSS class.
                if (!opts.showPaletteOnly && !flat) {
                    container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
                }
                applyOptions();
            });

            draggable(alphaSlider, function (dragX, dragY, e) {
                currentAlpha = (dragX / alphaWidth);
                isEmpty = false;
                if (e.shiftKey) {
                    currentAlpha = Math.round(currentAlpha * 10) / 10;
                }

                move();
            }, dragStart, dragStop);

            draggable(slider, function (dragX, dragY) {
                currentHue = parseFloat(dragY / slideHeight);
                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }
                move();
            }, dragStart, dragStop);

            draggable(dragger, function (dragX, dragY, e) {

                // shift+drag should snap the movement to either the x or y axis.
                if (!e.shiftKey) {
                    shiftMovementDirection = null;
                }
                else if (!shiftMovementDirection) {
                    var oldDragX = currentSaturation * dragWidth;
                    var oldDragY = dragHeight - (currentValue * dragHeight);
                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

                    shiftMovementDirection = furtherFromX ? "x" : "y";
                }

                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

                if (setSaturation) {
                    currentSaturation = parseFloat(dragX / dragWidth);
                }
                if (setValue) {
                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
                }

                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }

                move();

            }, dragStart, dragStop);

            if (!!initialColor) {
                set(initialColor);

                // In case color was black - update the preview UI and set the format
                // since the set function will not run (default color is black).
                updateUI();
                currentPreferredFormat = preferredFormat || tinycolor(initialColor).format;

                addColorToSelectionPalette(initialColor);
            }
            else {
                updateUI();
            }

            if (flat) {
                show();
            }

            function paletteElementClick(e) {
                if (e.data && e.data.ignore) {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                }
                else {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                    updateOriginalInput(true);
                    if (opts.hideAfterPaletteSelect) {
                      hide();
                    }
                }

                return false;
            }

            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            paletteContainer.delegate(".sp-thumb-el", paletteEvent, paletteElementClick);
            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, paletteElementClick);
        }

        function updateSelectionPaletteFromStorage() {

            if (localStorageKey && window.localStorage) {

                // Migrate old palettes over to new format.  May want to remove this eventually.
                try {
                    var oldPalette = window.localStorage[localStorageKey].split(",#");
                    if (oldPalette.length > 1) {
                        delete window.localStorage[localStorageKey];
                        $.each(oldPalette, function(i, c) {
                             addColorToSelectionPalette(c);
                        });
                    }
                }
                catch(e) { }

                try {
                    selectionPalette = window.localStorage[localStorageKey].split(";");
                }
                catch (e) { }
            }
        }

        function addColorToSelectionPalette(color) {
            if (showSelectionPalette) {
                var rgb = tinycolor(color).toRgbString();
                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
                    selectionPalette.push(rgb);
                    while(selectionPalette.length > maxSelectionSize) {
                        selectionPalette.shift();
                    }
                }

                if (localStorageKey && window.localStorage) {
                    try {
                        window.localStorage[localStorageKey] = selectionPalette.join(";");
                    }
                    catch(e) { }
                }
            }
        }

        function getUniqueSelectionPalette() {
            var unique = [];
            if (opts.showPalette) {
                for (var i = 0; i < selectionPalette.length; i++) {
                    var rgb = tinycolor(selectionPalette[i]).toRgbString();

                    if (!paletteLookup[rgb]) {
                        unique.push(selectionPalette[i]);
                    }
                }
            }

            return unique.reverse().slice(0, opts.maxSelectionSize);
        }

        function drawPalette() {

            var currentColor = get();

            var html = $.map(paletteArray, function (palette, i) {
                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
            });

            updateSelectionPaletteFromStorage();

            if (selectionPalette) {
                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
            }

            paletteContainer.html(html.join(""));
        }

        function drawInitial() {
            if (opts.showInitial) {
                var initial = colorOnShow;
                var current = get();
                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
            }
        }

        function dragStart() {
            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
                reflow();
            }
            isDragging = true;
            container.addClass(draggingClass);
            shiftMovementDirection = null;
            boundElement.trigger('dragstart.spectrum', [ get() ]);
        }

        function dragStop() {
            isDragging = false;
            container.removeClass(draggingClass);
            boundElement.trigger('dragstop.spectrum', [ get() ]);
        }

        function setFromTextInput() {

            var value = textInput.val();

            if ((value === null || value === "") && allowEmpty) {
                set(null);
                updateOriginalInput(true);
            }
            else {
                var tiny = tinycolor(value);
                if (tiny.isValid()) {
                    set(tiny);
                    updateOriginalInput(true);
                }
                else {
                    textInput.addClass("sp-validation-error");
                }
            }
        }

        function toggle() {
            if (visible) {
                hide();
            }
            else {
                show();
            }
        }

        function show() {
            var event = $.Event('beforeShow.spectrum');

            if (visible) {
                reflow();
                return;
            }

            boundElement.trigger(event, [ get() ]);

            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
                return;
            }

            hideAll();
            visible = true;

            $(doc).bind("keydown.spectrum", onkeydown);
            $(doc).bind("click.spectrum", clickout);
            $(window).bind("resize.spectrum", resize);
            replacer.addClass("sp-active");
            container.removeClass("sp-hidden");

            reflow();
            updateUI();

            colorOnShow = get();

            drawInitial();
            callbacks.show(colorOnShow);
            boundElement.trigger('show.spectrum', [ colorOnShow ]);
        }

        function onkeydown(e) {
            // Close on ESC
            if (e.keyCode === 27) {
                hide();
            }
        }

        function clickout(e) {
            // Return on right click.
            if (e.button == 2) { return; }

            // If a drag event was happening during the mouseup, don't hide
            // on click.
            if (isDragging) { return; }

            if (clickoutFiresChange) {
                updateOriginalInput(true);
            }
            else {
                revert();
            }
            hide();
        }

        function hide() {
            // Return if hiding is unnecessary
            if (!visible || flat) { return; }
            visible = false;

            $(doc).unbind("keydown.spectrum", onkeydown);
            $(doc).unbind("click.spectrum", clickout);
            $(window).unbind("resize.spectrum", resize);

            replacer.removeClass("sp-active");
            container.addClass("sp-hidden");

            callbacks.hide(get());
            boundElement.trigger('hide.spectrum', [ get() ]);
        }

        function revert() {
            set(colorOnShow, true);
        }

        function set(color, ignoreFormatChange) {
            if (tinycolor.equals(color, get())) {
                // Update UI just in case a validation error needs
                // to be cleared.
                updateUI();
                return;
            }

            var newColor, newHsv;
            if (!color && allowEmpty) {
                isEmpty = true;
            } else {
                isEmpty = false;
                newColor = tinycolor(color);
                newHsv = newColor.toHsv();

                currentHue = (newHsv.h % 360) / 360;
                currentSaturation = newHsv.s;
                currentValue = newHsv.v;
                currentAlpha = newHsv.a;
            }
            updateUI();

            if (newColor && newColor.isValid() && !ignoreFormatChange) {
                currentPreferredFormat = preferredFormat || newColor.getFormat();
            }
        }

        function get(opts) {
            opts = opts || { };

            if (allowEmpty && isEmpty) {
                return null;
            }

            return tinycolor.fromRatio({
                h: currentHue,
                s: currentSaturation,
                v: currentValue,
                a: Math.round(currentAlpha * 100) / 100
            }, { format: opts.format || currentPreferredFormat });
        }

        function isValid() {
            return !textInput.hasClass("sp-validation-error");
        }

        function move() {
            updateUI();

            callbacks.move(get());
            boundElement.trigger('move.spectrum', [ get() ]);
        }

        function updateUI() {

            textInput.removeClass("sp-validation-error");

            updateHelperLocations();

            // Update dragger background color (gradients take care of saturation and value).
            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
            dragger.css("background-color", flatColor.toHexString());

            // Get a format that alpha will be included in (hex and names ignore alpha)
            var format = currentPreferredFormat;
            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
                    format = "rgb";
                }
            }

            var realColor = get({ format: format }),
                displayColor = '';

             //reset background info for preview element
            previewElement.removeClass("sp-clear-display");
            previewElement.css('background-color', 'transparent');

            if (!realColor && allowEmpty) {
                // Update the replaced elements background with icon indicating no color selection
                previewElement.addClass("sp-clear-display");
            }
            else {
                var realHex = realColor.toHexString(),
                    realRgb = realColor.toRgbString();

                // Update the replaced elements background color (with actual selected color)
                if (rgbaSupport || realColor.alpha === 1) {
                    previewElement.css("background-color", realRgb);
                }
                else {
                    previewElement.css("background-color", "transparent");
                    previewElement.css("filter", realColor.toFilter());
                }

                if (opts.showAlpha) {
                    var rgb = realColor.toRgb();
                    rgb.a = 0;
                    var realAlpha = tinycolor(rgb).toRgbString();
                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

                    if (IE) {
                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
                    }
                    else {
                        alphaSliderInner.css("background", "-webkit-" + gradient);
                        alphaSliderInner.css("background", "-moz-" + gradient);
                        alphaSliderInner.css("background", "-ms-" + gradient);
                        // Use current syntax gradient on unprefixed property.
                        alphaSliderInner.css("background",
                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
                    }
                }

                displayColor = realColor.toString(format);
            }

            // Update the text entry input as it changes happen
            if (opts.showInput) {
                textInput.val(displayColor);
            }

            if (opts.showPalette) {
                drawPalette();
            }

            drawInitial();
        }

        function updateHelperLocations() {
            var s = currentSaturation;
            var v = currentValue;

            if(allowEmpty && isEmpty) {
                //if selected color is empty, hide the helpers
                alphaSlideHelper.hide();
                slideHelper.hide();
                dragHelper.hide();
            }
            else {
                //make sure helpers are visible
                alphaSlideHelper.show();
                slideHelper.show();
                dragHelper.show();

                // Where to show the little circle in that displays your current selected color
                var dragX = s * dragWidth;
                var dragY = dragHeight - (v * dragHeight);
                dragX = Math.max(
                    -dragHelperHeight,
                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
                );
                dragY = Math.max(
                    -dragHelperHeight,
                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
                );
                dragHelper.css({
                    "top": dragY + "px",
                    "left": dragX + "px"
                });

                var alphaX = currentAlpha * alphaWidth;
                alphaSlideHelper.css({
                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
                });

                // Where to show the bar that displays your current selected hue
                var slideY = (currentHue) * slideHeight;
                slideHelper.css({
                    "top": (slideY - slideHelperHeight) + "px"
                });
            }
        }

        function updateOriginalInput(fireCallback) {
            var color = get(),
                displayColor = '',
                hasChanged = !tinycolor.equals(color, colorOnShow);

            if (color) {
                displayColor = color.toString(currentPreferredFormat);
                // Update the selection palette with the current color
                addColorToSelectionPalette(color);
            }

            if (isInput) {
                boundElement.val(displayColor);
            }

            if (fireCallback && hasChanged) {
                callbacks.change(color);
                boundElement.trigger('change', [ color ]);
            }
        }

        function reflow() {
            dragWidth = dragger.width();
            dragHeight = dragger.height();
            dragHelperHeight = dragHelper.height();
            slideWidth = slider.width();
            slideHeight = slider.height();
            slideHelperHeight = slideHelper.height();
            alphaWidth = alphaSlider.width();
            alphaSlideHelperWidth = alphaSlideHelper.width();

            if (!flat) {
                container.css("position", "absolute");
                if (opts.offset) {
                    container.offset(opts.offset);
                } else {
                    container.offset(getOffset(container, offsetElement));
                }
            }

            updateHelperLocations();

            if (opts.showPalette) {
                drawPalette();
            }

            boundElement.trigger('reflow.spectrum');
        }

        function destroy() {
            boundElement.show();
            offsetElement.unbind("click.spectrum touchstart.spectrum");
            container.remove();
            replacer.remove();
            spectrums[spect.id] = null;
        }

        function option(optionName, optionValue) {
            if (optionName === undefined) {
                return $.extend({}, opts);
            }
            if (optionValue === undefined) {
                return opts[optionName];
            }

            opts[optionName] = optionValue;
            applyOptions();
        }

        function enable() {
            disabled = false;
            boundElement.attr("disabled", false);
            offsetElement.removeClass("sp-disabled");
        }

        function disable() {
            hide();
            disabled = true;
            boundElement.attr("disabled", true);
            offsetElement.addClass("sp-disabled");
        }

        function setOffset(coord) {
            opts.offset = coord;
            reflow();
        }

        initialize();

        var spect = {
            show: show,
            hide: hide,
            toggle: toggle,
            reflow: reflow,
            option: option,
            enable: enable,
            disable: disable,
            offset: setOffset,
            set: function (c) {
                set(c);
                updateOriginalInput();
            },
            get: get,
            destroy: destroy,
            container: container
        };

        spect.id = spectrums.push(spect) - 1;

        return spect;
    }

    /**
    * checkOffset - get the offset below/above and left/right element depending on screen position
    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
    */
    function getOffset(picker, input) {
        var extraY = 0;
        var dpWidth = picker.outerWidth();
        var dpHeight = picker.outerHeight();
        var inputHeight = input.outerHeight();
        var doc = picker[0].ownerDocument;
        var docElem = doc.documentElement;
        var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
        var viewHeight = docElem.clientHeight + $(doc).scrollTop();
        var offset = input.offset();
        offset.top += inputHeight;

        offset.left -=
            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
            Math.abs(offset.left + dpWidth - viewWidth) : 0);

        offset.top -=
            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
            Math.abs(dpHeight + inputHeight - extraY) : extraY));

        return offset;
    }

    /**
    * noop - do nothing
    */
    function noop() {

    }

    /**
    * stopPropagation - makes the code only doing this a little easier to read in line
    */
    function stopPropagation(e) {
        e.stopPropagation();
    }

    /**
    * Create a function bound to a given object
    * Thanks to underscore.js
    */
    function bind(func, obj) {
        var slice = Array.prototype.slice;
        var args = slice.call(arguments, 2);
        return function () {
            return func.apply(obj, args.concat(slice.call(arguments)));
        };
    }

    /**
    * Lightweight drag helper.  Handles containment within the element, so that
    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
    */
    function draggable(element, onmove, onstart, onstop) {
        onmove = onmove || function () { };
        onstart = onstart || function () { };
        onstop = onstop || function () { };
        var doc = document;
        var dragging = false;
        var offset = {};
        var maxHeight = 0;
        var maxWidth = 0;
        var hasTouch = ('ontouchstart' in window);

        var duringDragEvents = {};
        duringDragEvents["selectstart"] = prevent;
        duringDragEvents["dragstart"] = prevent;
        duringDragEvents["touchmove mousemove"] = move;
        duringDragEvents["touchend mouseup"] = stop;

        function prevent(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        function move(e) {
            if (dragging) {
                // Mouseup happened outside of window
                if (IE && doc.documentMode < 9 && !e.button) {
                    return stop();
                }

                var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
                var pageX = t0 && t0.pageX || e.pageX;
                var pageY = t0 && t0.pageY || e.pageY;

                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

                if (hasTouch) {
                    // Stop scrolling in iOS
                    prevent(e);
                }

                onmove.apply(element, [dragX, dragY, e]);
            }
        }

        function start(e) {
            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

            if (!rightclick && !dragging) {
                if (onstart.apply(element, arguments) !== false) {
                    dragging = true;
                    maxHeight = $(element).height();
                    maxWidth = $(element).width();
                    offset = $(element).offset();

                    $(doc).bind(duringDragEvents);
                    $(doc.body).addClass("sp-dragging");

                    move(e);

                    prevent(e);
                }
            }
        }

        function stop() {
            if (dragging) {
                $(doc).unbind(duringDragEvents);
                $(doc.body).removeClass("sp-dragging");

                // Wait a tick before notifying observers to allow the click event
                // to fire in Chrome.
                setTimeout(function() {
                    onstop.apply(element, arguments);
                }, 0);
            }
            dragging = false;
        }

        $(element).bind("touchstart mousedown", start);
    }

    function throttle(func, wait, debounce) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var throttler = function () {
                timeout = null;
                func.apply(context, args);
            };
            if (debounce) clearTimeout(timeout);
            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
        };
    }

    function inputTypeColorSupport() {
        return $.fn.spectrum.inputTypeColorSupport();
    }

    /**
    * Define a jQuery plugin
    */
    var dataID = "spectrum.id";
    $.fn.spectrum = function (opts, extra) {

        if (typeof opts == "string") {

            var returnValue = this;
            var args = Array.prototype.slice.call( arguments, 1 );

            this.each(function () {
                var spect = spectrums[$(this).data(dataID)];
                if (spect) {
                    var method = spect[opts];
                    if (!method) {
                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
                    }

                    if (opts == "get") {
                        returnValue = spect.get();
                    }
                    else if (opts == "container") {
                        returnValue = spect.container;
                    }
                    else if (opts == "option") {
                        returnValue = spect.option.apply(spect, args);
                    }
                    else if (opts == "destroy") {
                        spect.destroy();
                        $(this).removeData(dataID);
                    }
                    else {
                        method.apply(spect, args);
                    }
                }
            });

            return returnValue;
        }

        // Initializing a new instance of spectrum
        return this.spectrum("destroy").each(function () {
            var options = $.extend({}, opts, $(this).data());
            var spect = spectrum(this, options);
            $(this).data(dataID, spect.id);
        });
    };

    $.fn.spectrum.load = true;
    $.fn.spectrum.loadOpts = {};
    $.fn.spectrum.draggable = draggable;
    $.fn.spectrum.defaults = defaultOpts;
    $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
        if (typeof inputTypeColorSupport._cachedResult === "undefined") {
            var colorInput = $("<input type='color' value='!' />")[0];
            inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "!";
        }
        return inputTypeColorSupport._cachedResult;
    };

    $.spectrum = { };
    $.spectrum.localization = { };
    $.spectrum.palettes = { };

    $.fn.spectrum.processNativeColorInputs = function () {
        var colorInputs = $("input[type=color]");
        if (colorInputs.length && !inputTypeColorSupport()) {
            colorInputs.spectrum({
                preferredFormat: "hex6"
            });
        }
    };

    // TinyColor v1.1.2
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License

    (function() {

    var trimLeft = /^[\s,#]+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        math = Math,
        mathRound = math.round,
        mathMin = math.min,
        mathMax = math.max,
        mathRandom = math.random;

    var tinycolor = function(color, opts) {

        color = (color) ? color : '';
        opts = opts || { };

        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) {
           return color;
        }
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
        }

        var rgb = inputToRGB(color);
        this._originalInput = color,
        this._r = rgb.r,
        this._g = rgb.g,
        this._b = rgb.b,
        this._a = rgb.a,
        this._roundA = mathRound(100*this._a) / 100,
        this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;

        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) { this._r = mathRound(this._r); }
        if (this._g < 1) { this._g = mathRound(this._g); }
        if (this._b < 1) { this._b = mathRound(this._b); }

        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    };

    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100*this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return (this._a == 1) ?
              "hsv("  + h + ", " + s + "%, " + v + "%)" :
              "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return (this._a == 1) ?
              "hsl("  + h + ", " + s + "%, " + l + "%)" :
              "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function() {
            return rgbaToHex(this._r, this._g, this._b, this._a);
        },
        toHex8String: function() {
            return '#' + this.toHex8();
        },
        toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
              "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
              "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) {
                return "transparent";
            }

            if (this._a < 1) {
                return false;
            }

            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";

            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = s.toHex8String();
            }

            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;

            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }

            return formattedString || this.toHexString();
        },

        _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },

        _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
                if (color.hasOwnProperty(i)) {
                    if (i === "a") {
                        newColor[i] = color[i];
                    }
                    else {
                        newColor[i] = convertToPercentage(color[i]);
                    }
                }
            }
            color = newColor;
        }

        return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {

        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var ok = false;
        var format = false;

        if (typeof color == "string") {
            color = stringInputToObject(color);
        }

        if (typeof color == "object") {
            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
                color.s = convertToPercentage(color.s);
                color.v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, color.s, color.v);
                ok = true;
                format = "hsv";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
                color.s = convertToPercentage(color.s);
                color.l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, color.s, color.l);
                ok = true;
                format = "hsl";
            }

            if (color.hasOwnProperty("a")) {
                a = color.a;
            }
        }

        a = boundAlpha(a);

        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }


    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return { h: h, s: s, l: l };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;

        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);

        function hue2rgb(p, q, t) {
            if(t < 0) t += 1;
            if(t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        if(s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if(max == min) {
            h = 0; // achromatic
        }
        else {
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { h: h, s: s, v: v };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
     function hsvToRgb(h, s, v) {

        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);

        var i = math.floor(h),
            f = h - i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            mod = i % 6,
            r = [v, q, p, p, t, v][mod],
            g = [t, v, v, q, p, p][mod],
            b = [p, p, t, v, v, q][mod];

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }

        return hex.join("");
    }
        // `rgbaToHex`
        // Converts an RGBA color plus alpha transparency to hex
        // Assumes r, g, b and a are contained in the set [0, 255]
        // Returns an 8 character hex
        function rgbaToHex(r, g, b, a) {

            var hex = [
                pad2(convertDecimalToHex(a)),
                pad2(mathRound(r).toString(16)),
                pad2(mathRound(g).toString(16)),
                pad2(mathRound(b).toString(16))
            ];

            return hex.join("");
        }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
        if (!color1 || !color2) { return false; }
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };


    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function saturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    function brighten(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
        return tinycolor(rgb);
    }

    function darken (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (mathRound(hsl.h) + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }

    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
        ];
    }

    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;

        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];

        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }

    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;

        while (results--) {
            ret.push(tinycolor({ h: h, s: s, v: v}));
            v = (v + modification) % 1;
        }

        return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function(color1, color2, amount) {
        amount = (amount === 0) ? 0 : (amount || 50);

        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();

        var p = amount / 100;
        var w = p * 2 - 1;
        var a = rgb2.a - rgb1.a;

        var w1;

        if (w * a == -1) {
            w1 = w;
        } else {
            w1 = (w + a) / (1 + w * a);
        }

        w1 = (w1 + 1) / 2;

        var w2 = 1 - w1;

        var rgba = {
            r: rgb2.r * w1 + rgb1.r * w2,
            g: rgb2.g * w1 + rgb1.g * w2,
            b: rgb2.b * w1 + rgb1.b * w2,
            a: rgb2.a * p  + rgb1.a * (1 - p)
        };

        return tinycolor(rgba);
    };


    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/AERT#color-contrast>

    // `readability`
    // Analyze the 2 colors and returns an object with the following properties:
    //    `brightness`: difference in brightness between the two colors
    //    `color`: difference in color/hue between the two colors
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        var rgb1 = c1.toRgb();
        var rgb2 = c2.toRgb();
        var brightnessA = c1.getBrightness();
        var brightnessB = c2.getBrightness();
        var colorDiff = (
            Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
            Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
            Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
        );

        return {
            brightness: Math.abs(brightnessA - brightnessB),
            color: colorDiff
        };
    };

    // `readable`
    // http://www.w3.org/TR/AERT#color-contrast
    // Ensure that foreground and background color combinations provide sufficient contrast.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    tinycolor.isReadable = function(color1, color2) {
        var readability = tinycolor.readability(color1, color2);
        return readability.brightness > 125 && readability.color > 500;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // *Example*
    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
    tinycolor.mostReadable = function(baseColor, colorList) {
        var bestColor = null;
        var bestScore = 0;
        var bestIsReadable = false;
        for (var i=0; i < colorList.length; i++) {

            // We normalize both around the "acceptable" breaking point,
            // but rank brightness constrast higher than hue.

            var readability = tinycolor.readability(baseColor, colorList[i]);
            var readable = readability.brightness > 125 && readability.color > 500;
            var score = 3 * (readability.brightness / 125) + (readability.color / 500);

            if ((readable && ! bestIsReadable) ||
                (readable && bestIsReadable && score > bestScore) ||
                ((! readable) && (! bestIsReadable) && score > bestScore)) {
                bestIsReadable = readable;
                bestScore = score;
                bestColor = tinycolor(colorList[i]);
            }
        }
        return bestColor;
    };


    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = { };
        for (var i in o) {
            if (o.hasOwnProperty(i)) {
                flipped[o[i]] = i;
            }
        }
        return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);

        if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
        }

        return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) { n = "100%"; }

        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));

        // Automatically convert percentage into number
        if (processPercent) {
            n = parseInt(n * max, 10) / 100;
        }

        // Handle floating point rounding errors
        if ((math.abs(n - max) < 0.000001)) {
            return 1;
        }

        // Convert into [0, 1] range if it isn't already
        return (n % max) / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) {
            n = (n * 100) + "%";
        }

        return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";

        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

        return {
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    })();

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        }
        else if (color == 'transparent') {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }

        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if ((match = matchers.rgb.exec(color))) {
            return { r: match[1], g: match[2], b: match[3] };
        }
        if ((match = matchers.rgba.exec(color))) {
            return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if ((match = matchers.hsl.exec(color))) {
            return { h: match[1], s: match[2], l: match[3] };
        }
        if ((match = matchers.hsla.exec(color))) {
            return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if ((match = matchers.hsv.exec(color))) {
            return { h: match[1], s: match[2], v: match[3] };
        }
        if ((match = matchers.hsva.exec(color))) {
            return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if ((match = matchers.hex8.exec(color))) {
            return {
                a: convertHexToDecimal(match[1]),
                r: parseIntFromHex(match[2]),
                g: parseIntFromHex(match[3]),
                b: parseIntFromHex(match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex6.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                format: named ? "name" : "hex"
            };
        }
        if ((match = matchers.hex3.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                format: named ? "name" : "hex"
            };
        }

        return false;
    }

    window.tinycolor = tinycolor;
    })();

    $(function () {
        if ($.fn.spectrum.load) {
            $.fn.spectrum.processNativeColorInputs();
        }
    });

});


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SeriesColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPickerPopover__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_utils_react2angular__ = __webpack_require__(107);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var SeriesColorPicker = /** @class */ (function (_super) {
    __extends(SeriesColorPicker, _super);
    function SeriesColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onToggleAxis = _this.onToggleAxis.bind(_this);
        return _this;
    }
    SeriesColorPicker.prototype.onColorChange = function (color) {
        this.props.onColorChange(color);
    };
    SeriesColorPicker.prototype.onToggleAxis = function () {
        this.props.onToggleAxis();
    };
    SeriesColorPicker.prototype.renderAxisSelection = function () {
        var leftButtonClass = this.props.series.yaxis === 1 ? 'btn-success' : 'btn-inverse';
        var rightButtonClass = this.props.series.yaxis === 2 ? 'btn-success' : 'btn-inverse';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "p-b-1" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "small p-r-1" }, "Y Axis:"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onClick: this.onToggleAxis, className: 'btn btn-small ' + leftButtonClass }, "Left"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onClick: this.onToggleAxis, className: 'btn btn-small ' + rightButtonClass }, "Right")));
    };
    SeriesColorPicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "graph-legend-popover" },
            this.props.series.yaxis && this.renderAxisSelection(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ColorPickerPopover__["a" /* ColorPickerPopover */], { color: this.props.series.color, onColorSelect: this.onColorChange })));
    };
    return SeriesColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

Object(__WEBPACK_IMPORTED_MODULE_2_app_core_utils_react2angular__["a" /* react2AngularDirective */])('seriesColorPicker', SeriesColorPicker, ['series', 'onColorChange', 'onToggleAxis']);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export spectrumPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(2);
/**
 * Wrapper for the new ngReact <color-picker> directive for backward compatibility.
 * Allows remaining <spectrum-picker> untouched in outdated plugins.
 * Technically, it's just a wrapper for react component with two-way data binding support.
 */

/** @ngInject */
function spectrumPicker() {
    return {
        restrict: 'E',
        require: 'ngModel',
        scope: true,
        replace: true,
        template: '<color-picker color="ngModel.$viewValue" onChange="onColorChange"></color-picker>',
        link: function (scope, element, attrs, ngModel) {
            scope.ngModel = ngModel;
            scope.onColorChange = function (color) {
                ngModel.$setViewValue(color);
            };
        }
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["default"].directive('spectrumPicker', spectrumPicker);


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GrafanaCtrl */
/* harmony export (immutable) */ 
grafanaAppDirective.$inject = ["playlistSrv", "contextSrv"];__webpack_exports__["a"] = grafanaAppDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_profiler__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tether_drop__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tether_drop__);
///<reference path="../../headers/common.d.ts" />







var GrafanaCtrl = /** @class */ (function () {
    /** @ngInject */
    GrafanaCtrl.$inject = ["$scope", "alertSrv", "utilSrv", "$rootScope", "$controller", "contextSrv"];
    function GrafanaCtrl($scope, alertSrv, utilSrv, $rootScope, $controller, contextSrv) {
        $scope.init = function () {
            $scope.contextSrv = contextSrv;
            $rootScope.appSubUrl = __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.appSubUrl;
            $scope._ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;
            __WEBPACK_IMPORTED_MODULE_4_app_core_profiler__["a" /* profiler */].init(__WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a, $rootScope);
            alertSrv.init();
            utilSrv.init();
            $scope.dashAlerts = alertSrv;
        };
        $scope.initDashboard = function (dashboardData, viewScope) {
            $scope.appEvent("dashboard-fetch-end", dashboardData);
            $controller('DashboardCtrl', { $scope: viewScope }).init(dashboardData);
        };
        $rootScope.onAppEvent = function (name, callback, localScope) {
            var unbind = $rootScope.$on(name, callback);
            var callerScope = this;
            if (callerScope.$id === 1 && !localScope) {
                console.log('warning rootScope onAppEvent called without localscope');
            }
            if (localScope) {
                callerScope = localScope;
            }
            callerScope.$on('$destroy', unbind);
        };
        $rootScope.appEvent = function (name, payload) {
            $rootScope.$emit(name, payload);
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit(name, payload);
        };
        $rootScope.colors = [
            "#7EB26D", "#EAB839", "#6ED0E0", "#EF843C", "#E24D42", "#1F78C1", "#BA43A9", "#705DA0",
            "#508642", "#CCA300", "#447EBC", "#C15C17", "#890F02", "#0A437C", "#6D1F62", "#584477",
            "#B7DBAB", "#F4D598", "#70DBED", "#F9BA8F", "#F29191", "#82B5D8", "#E5A8E2", "#AEA2E0",
            "#629E51", "#E5AC0E", "#64B0C8", "#E0752D", "#BF1B00", "#0A50A1", "#962D82", "#614D93",
            "#9AC48A", "#F2C96D", "#65C5DB", "#F9934E", "#EA6460", "#5195CE", "#D683CE", "#806EB7",
            "#3F6833", "#967302", "#2F575E", "#99440A", "#58140C", "#052B51", "#511749", "#3F2B5B",
            "#E0F9D7", "#FCEACA", "#CFFAFF", "#F9E2D2", "#FCE2DE", "#BADFF4", "#F9D9F9", "#DEDAF7"
        ];
        $scope.init();
    }
    return GrafanaCtrl;
}());

/** @ngInject */
function grafanaAppDirective(playlistSrv, contextSrv) {
    return {
        restrict: 'E',
        controller: GrafanaCtrl,
        link: function (scope, elem) {
            var ignoreSideMenuHide;
            var body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
            // see https://github.com/zenorocha/clipboard.js/issues/155
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.fn.modal.Constructor.prototype.enforceFocus = function () { };
            // handle sidemenu open state
            scope.$watch('contextSrv.sidemenu', function (newVal) {
                if (newVal !== undefined) {
                    body.toggleClass('sidemenu-open', scope.contextSrv.sidemenu);
                    if (!newVal) {
                        contextSrv.setPinnedState(false);
                    }
                }
                if (contextSrv.sidemenu) {
                    ignoreSideMenuHide = true;
                    setTimeout(function () {
                        ignoreSideMenuHide = false;
                    }, 300);
                }
            });
            scope.$watch('contextSrv.pinned', function (newVal) {
                if (newVal !== undefined) {
                    body.toggleClass('sidemenu-pinned', newVal);
                }
            });
            // tooltip removal fix
            // manage page classes
            var pageClass;
            scope.$on("$routeChangeSuccess", function (evt, data) {
                if (pageClass) {
                    body.removeClass(pageClass);
                }
                if (data.$$route) {
                    pageClass = data.$$route.pageClass;
                    if (pageClass) {
                        body.addClass(pageClass);
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#tooltip, .tooltip").remove();
                // check for kiosk url param
                if (data.params.kiosk) {
                    __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('toggle-kiosk-mode');
                }
                // close all drops
                for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_6_tether_drop___default.a.drops; _i < _a.length; _i++) {
                    var drop = _a[_i];
                    drop.destroy();
                }
            });
            // handle kiosk mode
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-kiosk-mode', function () {
                body.toggleClass('page-kiosk-mode');
            });
            // handle in active view state class
            var lastActivity = new Date().getTime();
            var activeUser = true;
            var inActiveTimeLimit = 60 * 1000;
            function checkForInActiveUser() {
                if (!activeUser) {
                    return;
                }
                // only go to activity low mode on dashboard page
                if (!body.hasClass('page-dashboard')) {
                    return;
                }
                if ((new Date().getTime() - lastActivity) > inActiveTimeLimit) {
                    activeUser = false;
                    body.addClass('user-activity-low');
                }
            }
            function userActivityDetected() {
                lastActivity = new Date().getTime();
                if (!activeUser) {
                    activeUser = true;
                    body.removeClass('user-activity-low');
                }
            }
            // mouse and keyboard is user activity
            body.mousemove(userActivityDetected);
            body.keydown(userActivityDetected);
            // treat tab change as activity
            document.addEventListener('visibilitychange', userActivityDetected);
            // check every 2 seconds
            setInterval(checkForInActiveUser, 2000);
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-view-mode', function () {
                lastActivity = 0;
                checkForInActiveUser();
            });
            // handle document clicks that should hide things
            body.click(function (evt) {
                var target = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(evt.target);
                if (target.parents().length === 0) {
                    return;
                }
                // for stuff that animates, slides out etc, clicking it needs to
                // hide it right away
                var clickAutoHide = target.closest('[data-click-hide]');
                if (clickAutoHide.length) {
                    var clickAutoHideParent = clickAutoHide.parent();
                    clickAutoHide.detach();
                    setTimeout(function () {
                        clickAutoHideParent.append(clickAutoHide);
                    }, 100);
                }
                if (target.parents('.dash-playlist-actions').length === 0) {
                    playlistSrv.stop();
                }
                // hide search
                if (body.find('.search-container').length > 0) {
                    if (target.parents('.search-results-container, .search-field-wrapper').length === 0) {
                        scope.$apply(function () {
                            scope.appEvent('hide-dash-search');
                        });
                    }
                }
                // hide menus
                var openMenus = body.find('.navbar-page-btn--open');
                if (openMenus.length > 0) {
                    if (target.parents('.navbar-page-btn--open').length === 0) {
                        openMenus.removeClass('navbar-page-btn--open');
                    }
                }
                // hide sidemenu
                if (!ignoreSideMenuHide && !contextSrv.pinned && body.find('.sidemenu').length > 0) {
                    if (target.parents('.sidemenu').length === 0) {
                        scope.$apply(function () {
                            scope.contextSrv.toggleSideMenu();
                        });
                    }
                }
                // hide popovers
                var popover = elem.find('.popover');
                if (popover.length > 0 && target.parents('.graph-legend').length === 0) {
                    popover.hide();
                }
            });
        }
    };
}
__WEBPACK_IMPORTED_MODULE_3_app_core_core_module__["default"].directive('grafanaApp', grafanaAppDirective);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SideMenuCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = sideMenuDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(2);
///<reference path="../../../headers/common.d.ts" />



var SideMenuCtrl = /** @class */ (function () {
    /** @ngInject */
    SideMenuCtrl.$inject = ["$scope", "$location", "contextSrv", "backendSrv"];
    function SideMenuCtrl($scope, $location, contextSrv, backendSrv) {
        var _this = this;
        this.$scope = $scope;
        this.$location = $location;
        this.contextSrv = contextSrv;
        this.backendSrv = backendSrv;
        this.isSignedIn = contextSrv.isSignedIn;
        this.user = contextSrv.user;
        this.appSubUrl = __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.appSubUrl;
        this.showSignout = this.contextSrv.isSignedIn && !__WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a['disableSignoutMenu'];
        this.maxShownOrgs = 10;
        this.mainLinks = __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.bootData.mainNavLinks;
        this.openUserDropdown();
        this.loginUrl = 'login?redirect=' + encodeURIComponent(this.$location.path());
        this.$scope.$on('$routeChangeSuccess', function () {
            if (!_this.contextSrv.pinned) {
                _this.contextSrv.sidemenu = false;
            }
            _this.loginUrl = 'login?redirect=' + encodeURIComponent(_this.$location.path());
        });
        this.orgFilter = '';
    }
    SideMenuCtrl.prototype.getUrl = function (url) {
        return __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.appSubUrl + url;
    };
    SideMenuCtrl.prototype.openUserDropdown = function () {
        var _this = this;
        this.orgMenu = [
            { section: 'You', cssClass: 'dropdown-menu-title' },
            { text: 'Profile', url: this.getUrl('/profile') },
        ];
        if (this.showSignout) {
            this.orgMenu.push({ text: "Sign out", url: this.getUrl("/logout"), target: "_self" });
        }
        if (this.contextSrv.hasRole('Admin')) {
            this.orgMenu.push({ section: this.user.orgName, cssClass: 'dropdown-menu-title' });
            this.orgMenu.push({
                text: "Preferences",
                url: this.getUrl("/org")
            });
            this.orgMenu.push({
                text: "Users",
                url: this.getUrl("/org/users")
            });
            this.orgMenu.push({
                text: "API Keys",
                url: this.getUrl("/org/apikeys")
            });
        }
        this.orgMenu.push({ cssClass: "divider" });
        this.backendSrv.get('/api/user/orgs').then(function (orgs) {
            _this.orgs = orgs;
            _this.loadOrgsItems();
        });
    };
    SideMenuCtrl.prototype.loadOrgsItems = function () {
        var _this = this;
        this.orgItems = [];
        this.orgs.forEach(function (org) {
            if (org.orgId === _this.contextSrv.user.orgId) {
                return;
            }
            if (_this.orgItems.length === _this.maxShownOrgs) {
                return;
            }
            if (_this.orgFilter === '' || (org.name.toLowerCase().indexOf(_this.orgFilter.toLowerCase()) !== -1)) {
                _this.orgItems.push({
                    text: "Switch to " + org.name,
                    icon: "fa fa-fw fa-random",
                    url: _this.getUrl('/profile/switch-org/' + org.orgId),
                    target: '_self'
                });
            }
        });
        if (__WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.allowOrgCreate) {
            this.orgItems.push({ text: "New organization", icon: "fa fa-fw fa-plus", url: this.getUrl('/org/new') });
        }
    };
    return SideMenuCtrl;
}());

function sideMenuDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/sidemenu/sidemenu.html',
        controller: SideMenuCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {},
        link: function (scope, elem) {
            // hack to hide dropdown menu
            elem.on('click.dropdown', '.dropdown-menu a', function (evt) {
                var menu = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(evt.target).parents('.dropdown-menu');
                var parent = menu.parent();
                menu.detach();
                setTimeout(function () {
                    parent.append(menu);
                }, 100);
            });
            scope.$on("$destory", function () {
                elem.off('click.dropdown');
            });
        }
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["default"].directive('sidemenu', sideMenuDirective);


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = searchDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(2);
///<reference path="../../../headers/common.d.ts" />



var SearchCtrl = /** @class */ (function () {
    /** @ngInject */
    SearchCtrl.$inject = ["$scope", "$location", "$timeout", "backendSrv", "contextSrv", "$rootScope"];
    function SearchCtrl($scope, $location, $timeout, backendSrv, contextSrv, $rootScope) {
        this.$location = $location;
        this.$timeout = $timeout;
        this.backendSrv = backendSrv;
        this.contextSrv = contextSrv;
        $rootScope.onAppEvent('show-dash-search', this.openSearch.bind(this), $scope);
        $rootScope.onAppEvent('hide-dash-search', this.closeSearch.bind(this), $scope);
    }
    SearchCtrl.prototype.closeSearch = function () {
        this.isOpen = this.ignoreClose;
        this.openCompleted = false;
    };
    SearchCtrl.prototype.openSearch = function (evt, payload) {
        var _this = this;
        if (this.isOpen) {
            this.isOpen = false;
            return;
        }
        this.isOpen = true;
        this.giveSearchFocus = 0;
        this.selectedIndex = -1;
        this.results = [];
        this.query = { query: '', tag: [], starred: false };
        this.currentSearchId = 0;
        this.ignoreClose = true;
        if (payload && payload.starred) {
            this.query.starred = true;
        }
        if (payload && payload.tagsMode) {
            return this.$timeout(function () {
                _this.ignoreClose = false;
                _this.giveSearchFocus = _this.giveSearchFocus + 1;
                _this.getTags();
            }, 100);
        }
        this.$timeout(function () {
            _this.openCompleted = true;
            _this.ignoreClose = false;
            _this.giveSearchFocus = _this.giveSearchFocus + 1;
            _this.search();
        }, 100);
    };
    SearchCtrl.prototype.keyDown = function (evt) {
        if (evt.keyCode === 27) {
            this.closeSearch();
        }
        if (evt.keyCode === 40) {
            this.moveSelection(1);
        }
        if (evt.keyCode === 38) {
            this.moveSelection(-1);
        }
        if (evt.keyCode === 13) {
            if (this.tagsMode) {
                var tag = this.results[this.selectedIndex];
                if (tag) {
                    this.filterByTag(tag.term, null);
                }
                return;
            }
            var selectedDash = this.results[this.selectedIndex];
            if (selectedDash) {
                this.$location.search({});
                this.$location.path(selectedDash.url);
            }
        }
    };
    SearchCtrl.prototype.moveSelection = function (direction) {
        var max = (this.results || []).length;
        var newIndex = this.selectedIndex + direction;
        this.selectedIndex = ((newIndex %= max) < 0) ? newIndex + max : newIndex;
    };
    SearchCtrl.prototype.searchDashboards = function () {
        var _this = this;
        this.tagsMode = false;
        this.currentSearchId = this.currentSearchId + 1;
        var localSearchId = this.currentSearchId;
        return this.backendSrv.search(this.query).then(function (results) {
            if (localSearchId < _this.currentSearchId) {
                return;
            }
            _this.results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(results, function (dash) {
                dash.url = 'dashboard/' + dash.uri;
                return dash;
            });
            if (_this.queryHasNoFilters()) {
                _this.results.unshift({ title: 'Home', url: __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.appSubUrl + '/', type: 'dash-home' });
            }
        });
    };
    SearchCtrl.prototype.queryHasNoFilters = function () {
        var query = this.query;
        return query.query === '' && query.starred === false && query.tag.length === 0;
    };
    SearchCtrl.prototype.filterByTag = function (tag, evt) {
        this.query.tag.push(tag);
        this.search();
        this.giveSearchFocus = this.giveSearchFocus + 1;
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    };
    SearchCtrl.prototype.removeTag = function (tag, evt) {
        this.query.tag = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.without(this.query.tag, tag);
        this.search();
        this.giveSearchFocus = this.giveSearchFocus + 1;
        evt.stopPropagation();
        evt.preventDefault();
    };
    SearchCtrl.prototype.getTags = function () {
        var _this = this;
        return this.backendSrv.get('/api/dashboards/tags').then(function (results) {
            _this.tagsMode = !_this.tagsMode;
            _this.results = results;
            _this.giveSearchFocus = _this.giveSearchFocus + 1;
            if (!_this.tagsMode) {
                _this.search();
            }
        });
    };
    SearchCtrl.prototype.showStarred = function () {
        this.query.starred = !this.query.starred;
        this.giveSearchFocus = this.giveSearchFocus + 1;
        this.search();
    };
    SearchCtrl.prototype.search = function () {
        this.showImport = false;
        this.selectedIndex = 0;
        this.searchDashboards();
    };
    return SearchCtrl;
}());

function searchDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/search/search.html',
        controller: SearchCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {},
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["default"].directive('dashboardSearch', searchDirective);


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = infoPopover;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tether_drop__);
///<reference path="../../headers/common.d.ts" />



function infoPopover() {
    return {
        restrict: 'E',
        template: '<i class="fa fa-info-circle"></i>',
        transclude: true,
        link: function (scope, elem, attrs, ctrl, transclude) {
            var offset = attrs.offset || '0 -10px';
            var position = attrs.position || 'right middle';
            var classes = 'drop-help drop-hide-out-of-bounds';
            var openOn = 'hover';
            elem.addClass('gf-form-help-icon');
            if (attrs.wide) {
                classes += ' drop-wide';
            }
            if (attrs.mode) {
                elem.addClass('gf-form-help-icon--' + attrs.mode);
            }
            transclude(function (clone, newScope) {
                var content = document.createElement("div");
                content.className = 'markdown-html';
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(clone, function (node) {
                    content.appendChild(node);
                });
                var drop = new __WEBPACK_IMPORTED_MODULE_2_tether_drop___default.a({
                    target: elem[0],
                    content: content,
                    position: position,
                    classes: classes,
                    openOn: openOn,
                    hoverOpenDelay: 400,
                    tetherOptions: {
                        offset: offset,
                        constraints: [
                            {
                                to: 'window',
                                attachment: 'together',
                                pin: true
                            }
                        ],
                    }
                });
                var unbind = scope.$on('$destroy', function () {
                    drop.destroy();
                    unbind();
                });
            });
        }
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["default"].directive('infoPopover', infoPopover);


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavbarCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = navbarDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(2);
///<reference path="../../../headers/common.d.ts" />

var NavbarCtrl = /** @class */ (function () {
    /** @ngInject */
    NavbarCtrl.$inject = ["$rootScope", "contextSrv"];
    function NavbarCtrl($rootScope, contextSrv) {
        this.$rootScope = $rootScope;
        this.contextSrv = contextSrv;
        this.section = this.model.section;
        this.hasMenu = this.model.menu.length > 0;
    }
    NavbarCtrl.prototype.showSearch = function () {
        this.$rootScope.appEvent('show-dash-search');
    };
    NavbarCtrl.prototype.toggleSideMenu = function () {
        this.contextSrv.toggleSideMenu();
    };
    NavbarCtrl.prototype.navItemClicked = function (navItem, evt) {
        if (navItem.clickHandler) {
            navItem.clickHandler();
            evt.preventDefault();
        }
    };
    return NavbarCtrl;
}());

function navbarDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/navbar/navbar.html',
        controller: NavbarCtrl,
        bindToController: true,
        transclude: true,
        controllerAs: 'ctrl',
        scope: {
            model: "=",
        },
        link: function (scope, elem) {
            elem.addClass('navbar');
        }
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["default"].directive('navbar', navbarDirective);


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayJoin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />


function arrayJoin() {
    'use strict';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            function split_array(text) {
                return (text || '').split(',');
            }
            function join_array(text) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(text)) {
                    return (text || '').join(',');
                }
                else {
                    return text;
                }
            }
            ngModel.$parsers.push(split_array);
            ngModel.$formatters.push(join_array);
        }
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["default"].directive('arrayJoin', arrayJoin);


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LiveSrv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);



var LiveSrv = /** @class */ (function () {
    function LiveSrv() {
        this.observers = {};
    }
    LiveSrv.prototype.getWebSocketUrl = function () {
        var l = window.location;
        return ((l.protocol === "https:") ? "wss://" : "ws://") + l.host + __WEBPACK_IMPORTED_MODULE_1_app_core_config___default.a.appSubUrl + '/ws';
    };
    LiveSrv.prototype.getConnection = function () {
        var _this = this;
        if (this.initPromise) {
            return this.initPromise;
        }
        if (this.conn && this.conn.readyState === 1) {
            return Promise.resolve(this.conn);
        }
        this.initPromise = new Promise(function (resolve, reject) {
            console.log('Live: connecting...');
            _this.conn = new WebSocket(_this.getWebSocketUrl());
            _this.conn.onclose = function (evt) {
                console.log("Live: websocket onclose", evt);
                reject({ message: 'Connection closed' });
                _this.initPromise = null;
                setTimeout(_this.reconnect.bind(_this), 2000);
            };
            _this.conn.onmessage = function (evt) {
                _this.handleMessage(evt.data);
            };
            _this.conn.onerror = function (evt) {
                _this.initPromise = null;
                reject({ message: 'Connection error' });
                console.log("Live: websocket error", evt);
            };
            _this.conn.onopen = function (evt) {
                console.log('opened');
                _this.initPromise = null;
                resolve(_this.conn);
            };
        });
        return this.initPromise;
    };
    LiveSrv.prototype.handleMessage = function (message) {
        message = JSON.parse(message);
        if (!message.stream) {
            console.log("Error: stream message without stream!", message);
            return;
        }
        var observer = this.observers[message.stream];
        if (!observer) {
            this.removeObserver(message.stream, null);
            return;
        }
        observer.next(message);
    };
    LiveSrv.prototype.reconnect = function () {
        var _this = this;
        // no need to reconnect if no one cares
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(this.observers).length === 0) {
            return;
        }
        console.log('LiveSrv: Reconnecting');
        this.getConnection().then(function (conn) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this.observers, function (value, key) {
                _this.send({ action: 'subscribe', stream: key });
            });
        });
    };
    LiveSrv.prototype.send = function (data) {
        this.conn.send(JSON.stringify(data));
    };
    LiveSrv.prototype.addObserver = function (stream, observer) {
        var _this = this;
        this.observers[stream] = observer;
        this.getConnection().then(function (conn) {
            _this.send({ action: 'subscribe', stream: stream });
        });
    };
    LiveSrv.prototype.removeObserver = function (stream, observer) {
        var _this = this;
        console.log('unsubscribe', stream);
        delete this.observers[stream];
        this.getConnection().then(function (conn) {
            _this.send({ action: 'unsubscribe', stream: stream });
        });
    };
    LiveSrv.prototype.subscribe = function (streamName) {
        var _this = this;
        console.log('LiveSrv.subscribe: ' + streamName);
        return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].create(function (observer) {
            _this.addObserver(streamName, observer);
            return function () {
                _this.removeObserver(streamName, observer);
            };
        });
        // return this.init().then(() =>  {
        //   this.send({action: 'subscribe', stream: name});
        // });
    };
    return LiveSrv;
}());

var instance = new LiveSrv();



/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(293);
var rxSubscriber_1 = __webpack_require__(114);
var Observer_1 = __webpack_require__(282);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(281);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LayoutSelectorCtrl */
/* harmony export (immutable) */ 
layoutMode.$inject = ["$rootScope"];__webpack_exports__["a"] = layoutSelector;
/* unused harmony export layoutMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_store__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_app_core_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(2);
///<reference path="../../../headers/common.d.ts" />


var template = "\n<div class=\"layout-selector\">\n  <button ng-click=\"ctrl.listView()\" ng-class=\"{active: ctrl.mode === 'list'}\">\n    <i class=\"fa fa-list\"></i>\n  </button>\n  <button ng-click=\"ctrl.gridView()\" ng-class=\"{active: ctrl.mode === 'grid'}\">\n    <i class=\"fa fa-th\"></i>\n  </button>\n</div>\n";
var LayoutSelectorCtrl = /** @class */ (function () {
    /** @ngInject **/
    LayoutSelectorCtrl.$inject = ["$rootScope"];
    function LayoutSelectorCtrl($rootScope) {
        this.$rootScope = $rootScope;
        this.mode = __WEBPACK_IMPORTED_MODULE_0_app_core_store___default.a.get('grafana.list.layout.mode') || 'grid';
    }
    LayoutSelectorCtrl.prototype.listView = function () {
        this.mode = 'list';
        __WEBPACK_IMPORTED_MODULE_0_app_core_store___default.a.set('grafana.list.layout.mode', 'list');
        this.$rootScope.appEvent('layout-mode-changed', 'list');
    };
    LayoutSelectorCtrl.prototype.gridView = function () {
        this.mode = 'grid';
        __WEBPACK_IMPORTED_MODULE_0_app_core_store___default.a.set('grafana.list.layout.mode', 'grid');
        this.$rootScope.appEvent('layout-mode-changed', 'grid');
    };
    return LayoutSelectorCtrl;
}());

/** @ngInject **/
function layoutSelector() {
    return {
        restrict: 'E',
        controller: LayoutSelectorCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {},
        template: template,
    };
}
/** @ngInject **/
function layoutMode($rootScope) {
    return {
        restrict: 'A',
        scope: {},
        link: function (scope, elem) {
            var layout = __WEBPACK_IMPORTED_MODULE_0_app_core_store___default.a.get('grafana.list.layout.mode') || 'grid';
            var className = 'card-list-layout-' + layout;
            elem.addClass(className);
            $rootScope.onAppEvent('layout-mode-changed', function (evt, newLayout) {
                elem.removeClass(className);
                className = 'card-list-layout-' + newLayout;
                elem.addClass(className);
            }, scope);
        }
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["default"].directive('layoutSelector', layoutSelector);
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["default"].directive('layoutMode', layoutMode);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwitchCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = switchDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />

var template = "\n<label for=\"check-{{ctrl.id}}\" class=\"gf-form-label {{ctrl.labelClass}} pointer\" ng-show=\"ctrl.label\">\n  {{ctrl.label}}\n  <info-popover mode=\"right-normal\" ng-if=\"ctrl.tooltip\" position=\"top center\">\n    {{ctrl.tooltip}}\n  </info-popover>\n</label>\n<div class=\"gf-form-switch {{ctrl.switchClass}}\" ng-if=\"ctrl.show\">\n  <input id=\"check-{{ctrl.id}}\" type=\"checkbox\" ng-model=\"ctrl.checked\" ng-change=\"ctrl.internalOnChange()\">\n  <label for=\"check-{{ctrl.id}}\" data-on=\"Yes\" data-off=\"No\"></label>\n</div>\n";
var SwitchCtrl = /** @class */ (function () {
    /** @ngInject */
    SwitchCtrl.$inject = ["$scope", "$timeout"];
    function SwitchCtrl($scope, $timeout) {
        this.$timeout = $timeout;
        this.show = true;
        this.id = $scope.$id;
    }
    SwitchCtrl.prototype.internalOnChange = function () {
        var _this = this;
        return this.$timeout(function () {
            return _this.onChange();
        });
    };
    return SwitchCtrl;
}());

function switchDirective() {
    return {
        restrict: 'E',
        controller: SwitchCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        scope: {
            checked: "=",
            label: "@",
            labelClass: "@",
            tooltip: "@",
            switchClass: "@",
            onChange: "&",
        },
        template: template,
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].directive('gfFormSwitch', switchDirective);


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DashboardSelectorCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = dashboardSelector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />

var template = "\n<select class=\"gf-form-input\" ng-model=\"ctrl.model\" ng-options=\"f.value as f.text for f in ctrl.options\"></select>\n";
var DashboardSelectorCtrl = /** @class */ (function () {
    /** @ngInject */
    DashboardSelectorCtrl.$inject = ["backendSrv"];
    function DashboardSelectorCtrl(backendSrv) {
        this.backendSrv = backendSrv;
    }
    DashboardSelectorCtrl.prototype.$onInit = function () {
        var _this = this;
        this.options = [{ value: 0, text: 'Default' }];
        return this.backendSrv.search({ starred: true }).then(function (res) {
            res.forEach(function (dash) {
                _this.options.push({ value: dash.id, text: dash.title });
            });
        });
    };
    return DashboardSelectorCtrl;
}());

function dashboardSelector() {
    return {
        restrict: 'E',
        controller: DashboardSelectorCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        template: template,
        scope: {
            model: '='
        }
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].directive('dashboardSelector', dashboardSelector);


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ 
queryPartEditorDirective.$inject = ["$compile", "templateSrv"];__webpack_exports__["a"] = queryPartEditorDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(2);
///<reference path="../../../headers/common.d.ts" />



var template = "\n<div class=\"dropdown cascade-open\">\n<a ng-click=\"showActionsMenu()\" class=\"query-part-name pointer dropdown-toggle\" data-toggle=\"dropdown\">{{part.def.type}}</a>\n<span>(</span><span class=\"query-part-parameters\"></span><span>)</span>\n<ul class=\"dropdown-menu\">\n  <li ng-repeat=\"action in partActions\">\n    <a ng-click=\"triggerPartAction(action)\">{{action.text}}</a>\n  </li>\n</ul>\n";
/** @ngInject */
function queryPartEditorDirective($compile, templateSrv) {
    var paramTemplate = '<input type="text" class="hide input-mini tight-form-func-param"></input>';
    return {
        restrict: 'E',
        template: template,
        scope: {
            part: "=",
            handleEvent: "&",
        },
        link: function postLink($scope, elem) {
            var part = $scope.part;
            var partDef = part.def;
            var $paramsContainer = elem.find('.query-part-parameters');
            $scope.partActions = [];
            function clickFuncParam(paramIndex) {
                /*jshint validthis:true */
                var $link = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
                var $input = $link.next();
                $input.val(part.params[paramIndex]);
                $input.css('width', ($link.width() + 16) + 'px');
                $link.hide();
                $input.show();
                $input.focus();
                $input.select();
                var typeahead = $input.data('typeahead');
                if (typeahead) {
                    $input.val('');
                    typeahead.lookup();
                }
            }
            function inputBlur(paramIndex) {
                /*jshint validthis:true */
                var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
                var $link = $input.prev();
                var newValue = $input.val();
                if (newValue !== '' || part.def.params[paramIndex].optional) {
                    $link.html(templateSrv.highlightVariablesAsHtml(newValue));
                    part.updateParam($input.val(), paramIndex);
                    $scope.$apply(function () {
                        $scope.handleEvent({ $event: { name: 'part-param-changed' } });
                    });
                }
                $input.hide();
                $link.show();
            }
            function inputKeyPress(paramIndex, e) {
                /*jshint validthis:true */
                if (e.which === 13) {
                    inputBlur.call(this, paramIndex);
                }
            }
            function inputKeyDown() {
                /*jshint validthis:true */
                this.style.width = (3 + this.value.length) * 8 + 'px';
            }
            function addTypeahead($input, param, paramIndex) {
                if (!param.options && !param.dynamicLookup) {
                    return;
                }
                var typeaheadSource = function (query, callback) {
                    if (param.options) {
                        var options = param.options;
                        if (param.type === 'int') {
                            options = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(options, function (val) { return val.toString(); });
                        }
                        return options;
                    }
                    $scope.$apply(function () {
                        $scope.handleEvent({ $event: { name: 'get-param-options' } }).then(function (result) {
                            var dynamicOptions = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(result, function (op) { return op.value; });
                            callback(dynamicOptions);
                        });
                    });
                };
                $input.attr('data-provide', 'typeahead');
                $input.typeahead({
                    source: typeaheadSource,
                    minLength: 0,
                    items: 1000,
                    updater: function (value) {
                        setTimeout(function () {
                            inputBlur.call($input[0], paramIndex);
                        }, 0);
                        return value;
                    }
                });
                var typeahead = $input.data('typeahead');
                typeahead.lookup = function () {
                    this.query = this.$element.val() || '';
                    var items = this.source(this.query, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.proxy(this.process, this));
                    return items ? this.process(items) : items;
                };
            }
            $scope.showActionsMenu = function () {
                $scope.handleEvent({ $event: { name: 'get-part-actions' } }).then(function (res) {
                    $scope.partActions = res;
                });
            };
            $scope.triggerPartAction = function (action) {
                $scope.handleEvent({ $event: { name: 'action', action: action } });
            };
            function addElementsAndCompile() {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(partDef.params, function (param, index) {
                    if (param.optional && part.params.length <= index) {
                        return;
                    }
                    if (index > 0) {
                        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<span>, </span>').appendTo($paramsContainer);
                    }
                    var paramValue = templateSrv.highlightVariablesAsHtml(part.params[index]);
                    var $paramLink = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<a class="graphite-func-param-link pointer">' + paramValue + '</a>');
                    var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(paramTemplate);
                    $paramLink.appendTo($paramsContainer);
                    $input.appendTo($paramsContainer);
                    $input.blur(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(inputBlur, index));
                    $input.keyup(inputKeyDown);
                    $input.keypress(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(inputKeyPress, index));
                    $paramLink.click(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(clickFuncParam, index));
                    addTypeahead($input, param, index);
                });
            }
            function relink() {
                $paramsContainer.empty();
                addElementsAndCompile();
            }
            relink();
        }
    };
}
__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["default"].directive('queryPartEditor', queryPartEditorDirective);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormDropdownCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = formDropdownDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(2);
///<reference path="../../../headers/common.d.ts" />



function typeaheadMatcher(item) {
    var str = this.query;
    if (str[0] === '/') {
        str = str.substring(1);
    }
    if (str[str.length - 1] === '/') {
        str = str.substring(0, str.length - 1);
    }
    return item.toLowerCase().match(str.toLowerCase());
}
var FormDropdownCtrl = /** @class */ (function () {
    /** @ngInject **/
    FormDropdownCtrl.$inject = ["$scope", "$element", "$sce", "templateSrv", "$q"];
    function FormDropdownCtrl($scope, $element, $sce, templateSrv, $q) {
        var _this = this;
        this.$scope = $scope;
        this.$sce = $sce;
        this.templateSrv = templateSrv;
        this.$q = $q;
        this.inputElement = $element.find('input').first();
        this.linkElement = $element.find('a').first();
        this.linkMode = true;
        this.cancelBlur = null;
        // listen to model changes
        $scope.$watch("ctrl.model", this.modelChanged.bind(this));
        if (this.labelMode) {
            this.cssClasses = 'gf-form-label ' + this.cssClass;
        }
        else {
            this.cssClasses = 'gf-form-input gf-form-input--dropdown ' + this.cssClass;
        }
        this.inputElement.attr('data-provide', 'typeahead');
        this.inputElement.typeahead({
            source: this.typeaheadSource.bind(this),
            minLength: 0,
            items: 10000,
            updater: this.typeaheadUpdater.bind(this),
            matcher: typeaheadMatcher,
        });
        // modify typeahead lookup
        // this = typeahead
        var typeahead = this.inputElement.data('typeahead');
        typeahead.lookup = function () {
            this.query = this.$element.val() || '';
            var items = this.source(this.query, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.proxy(this.process, this));
            return items ? this.process(items) : items;
        };
        this.linkElement.keydown(function (evt) {
            // trigger typeahead on down arrow or enter key
            if (evt.keyCode === 40 || evt.keyCode === 13) {
                _this.linkElement.click();
            }
        });
        this.inputElement.keydown(function (evt) {
            if (evt.keyCode === 13) {
                setTimeout(function () {
                    _this.inputElement.blur();
                }, 100);
            }
        });
        this.inputElement.blur(this.inputBlur.bind(this));
    }
    FormDropdownCtrl.prototype.getOptionsInternal = function (query) {
        var result = this.getOptions({ $query: query });
        if (this.isPromiseLike(result)) {
            return result;
        }
        return this.$q.when(result);
    };
    FormDropdownCtrl.prototype.isPromiseLike = function (obj) {
        return obj && (typeof obj.then === 'function');
    };
    FormDropdownCtrl.prototype.modelChanged = function () {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.model)) {
            this.updateDisplay(this.model.text);
        }
        else {
            // if we have text use it
            if (this.lookupText) {
                this.getOptionsInternal("").then(function (options) {
                    var item = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(options, { value: _this.model });
                    _this.updateDisplay(item ? item.text : _this.model);
                });
            }
            else {
                this.updateDisplay(this.model);
            }
        }
    };
    FormDropdownCtrl.prototype.typeaheadSource = function (query, callback) {
        var _this = this;
        this.getOptionsInternal(query).then(function (options) {
            _this.optionCache = options;
            // extract texts
            var optionTexts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(options, function (op) {
                return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.escape(op.text);
            });
            // add custom values
            if (_this.allowCustom) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(optionTexts, _this.text) === -1) {
                    options.unshift(_this.text);
                }
            }
            callback(optionTexts);
        });
    };
    FormDropdownCtrl.prototype.typeaheadUpdater = function (text) {
        if (text === this.text) {
            clearTimeout(this.cancelBlur);
            this.inputElement.focus();
            return text;
        }
        this.inputElement.val(text);
        this.switchToLink(true);
        return text;
    };
    FormDropdownCtrl.prototype.switchToLink = function (fromClick) {
        if (this.linkMode && !fromClick) {
            return;
        }
        clearTimeout(this.cancelBlur);
        this.cancelBlur = null;
        this.linkMode = true;
        this.inputElement.hide();
        this.linkElement.show();
        this.updateValue(this.inputElement.val());
    };
    FormDropdownCtrl.prototype.inputBlur = function () {
        // happens long before the click event on the typeahead options
        // need to have long delay because the blur
        this.cancelBlur = setTimeout(this.switchToLink.bind(this), 200);
    };
    FormDropdownCtrl.prototype.updateValue = function (text) {
        var _this = this;
        text = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.unescape(text);
        if (text === '' || this.text === text) {
            return;
        }
        this.$scope.$apply(function () {
            var option = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this.optionCache, { text: text });
            if (option) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(_this.model)) {
                    _this.model = option;
                }
                else {
                    _this.model = option.value;
                }
                _this.text = option.text;
            }
            else if (_this.allowCustom) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(_this.model)) {
                    _this.model.text = _this.model.value = text;
                }
                else {
                    _this.model = text;
                }
                _this.text = text;
            }
            // needs to call this after digest so
            // property is synced with outerscope
            _this.$scope.$$postDigest(function () {
                _this.$scope.$apply(function () {
                    _this.onChange({ $option: option });
                });
            });
        });
    };
    FormDropdownCtrl.prototype.updateDisplay = function (text) {
        this.text = text;
        this.display = this.$sce.trustAsHtml(this.templateSrv.highlightVariablesAsHtml(text));
    };
    FormDropdownCtrl.prototype.open = function () {
        this.inputElement.show();
        this.inputElement.css('width', (Math.max(this.linkElement.width(), 80) + 16) + 'px');
        this.inputElement.focus();
        this.linkElement.hide();
        this.linkMode = false;
        var typeahead = this.inputElement.data('typeahead');
        if (typeahead) {
            this.inputElement.val('');
            typeahead.lookup();
        }
    };
    return FormDropdownCtrl;
}());

var template = "\n<input type=\"text\"\n  data-provide=\"typeahead\"\n  class=\"gf-form-input\"\n  spellcheck=\"false\"\n  style=\"display:none\">\n</input>\n<a ng-class=\"ctrl.cssClasses\"\n\t tabindex=\"1\"\n\t ng-click=\"ctrl.open()\"\n\t give-focus=\"ctrl.focus\"\n\t ng-bind-html=\"ctrl.display\">\n</a>\n";
function formDropdownDirective() {
    return {
        restrict: 'E',
        template: template,
        controller: FormDropdownCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            model: "=",
            getOptions: "&",
            onChange: "&",
            cssClass: "@",
            allowCustom: "@",
            labelMode: "@",
            lookupText: "@",
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["default"].directive('gfFormDropdown', formDropdownDirective);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(713),
  __webpack_require__(714),
  __webpack_require__(715),
  __webpack_require__(716),
  __webpack_require__(717),
  __webpack_require__(718),
  __webpack_require__(719),
], __WEBPACK_AMD_DEFINE_RESULT__ = function () {}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(4),
  __webpack_require__(10),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, $, coreModule) {
  'use strict';

  coreModule.default.controller('InspectCtrl', ["$scope", "$sanitize", function($scope, $sanitize) {
    var model = $scope.inspector;

    function getParametersFromQueryString(queryString) {
      var result = [];
      var parameters = queryString.split("&");
      for (var i = 0; i < parameters.length; i++) {
        var keyValue = parameters[i].split("=");
        if (keyValue[1].length > 0) {
          result.push({ key: keyValue[0], value: window.unescape(keyValue[1]) });
        }
      }
      return result;
    }

    $scope.init = function () {
      $scope.editor = { index: 0 };

      if (!model.error)  {
        return;
      }

      if (_.isString(model.error.data)) {
        $scope.response = $("<div>" + model.error.data + "</div>").text();
      } else if (model.error.data) {
        if (model.error.data.response) {
          $scope.response = $sanitize(model.error.data.response);
        } else {
          $scope.response = angular.toJson(model.error.data, true);
        }
      } else if (model.error.message) {
        $scope.message = model.error.message;
      }

      if (model.error.config && model.error.config.params) {
        $scope.request_parameters = _.map(model.error.config.params, function(value, key) {
          return { key: key, value: value};
        });
      }

      if (model.error.stack) {
        $scope.editor.index = 3;
        $scope.stack_trace = model.error.stack;
        $scope.message = model.error.message;
      }

      if (model.error.config && model.error.config.data) {
        $scope.editor.index = 2;

        if (_.isString(model.error.config.data)) {
          $scope.request_parameters = getParametersFromQueryString(model.error.config.data);
        } else  {
          $scope.request_parameters = _.map(model.error.config.data, function(value, key) {
            return {key: key, value: angular.toJson(value, true)};
          });
        }
      }
    };

  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, coreModule) {
  'use strict';

  coreModule.default.controller('JsonEditorCtrl', ["$scope", function($scope) {

    $scope.json = angular.toJson($scope.object, true);
    $scope.canUpdate = $scope.updateHandler !== void 0 && $scope.contextSrv.isEditor;

    $scope.update = function () {
      var newObject = angular.fromJson($scope.json);
      $scope.updateHandler(newObject, $scope.object);
    };

  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(4),
  __webpack_require__(2),
  __webpack_require__(21),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, coreModule, config) {
  'use strict';

  coreModule.default.controller('LoginCtrl', ["$scope", "backendSrv", "contextSrv", "$location", function($scope, backendSrv, contextSrv, $location) {
    $scope.formModel = {
      user: '',
      email: '',
      password: '',
    };

    contextSrv.sidemenu = false;

    $scope.oauth = config.oauth;
    $scope.oauthEnabled = _.keys(config.oauth).length > 0;

    $scope.disableLoginForm = config.disableLoginForm;
    $scope.disableUserSignUp = config.disableUserSignUp;
    $scope.loginHint     = config.loginHint;

    $scope.loginMode = true;
    $scope.submitBtnText = 'Log in';

    $scope.init = function() {
      $scope.$watch("loginMode", $scope.loginModeChanged);

      if (config.loginError) {
        $scope.appEvent('alert-warning', ['Login Failed', config.loginError]);
      }
    };

    $scope.submit = function() {
      if ($scope.loginMode) {
        $scope.login();
      } else {
        $scope.signUp();
      }
    };

    $scope.loginModeChanged = function(newValue) {
      $scope.submitBtnText = newValue ? 'Log in' : 'Sign up';
    };

    $scope.signUp = function() {
      if (!$scope.loginForm.$valid) {
        return;
      }

      backendSrv.post('/api/user/signup', $scope.formModel).then(function(result) {
        if (result.status === 'SignUpCreated') {
          $location.path('/signup').search({email: $scope.formModel.email});
        } else {
          window.location.href = config.appSubUrl + '/';
        }
      });
    };

    $scope.login = function() {
      delete $scope.loginError;

      if (!$scope.loginForm.$valid) {
        return;
      }

      backendSrv.post('/login', $scope.formModel).then(function(result) {
        var params = $location.search();

        if (params.redirect && params.redirect[0] === '/') {
          window.location.href = config.appSubUrl + params.redirect;
        }
        else if (result.redirectUrl) {
          window.location.href = result.redirectUrl;
        } else {
          window.location.href = config.appSubUrl + '/';
        }
      });
    };

    $scope.init();
  }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(2),
  __webpack_require__(21),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, coreModule, config) {
  'use strict';

  coreModule.default.controller('InvitedCtrl', ["$scope", "$routeParams", "contextSrv", "backendSrv", function($scope, $routeParams, contextSrv, backendSrv) {
    contextSrv.sidemenu = false;
    $scope.formModel = {};

    $scope.init = function() {
      backendSrv.get('/api/user/invite/' + $routeParams.code).then(function(invite) {
        $scope.formModel.name = invite.name;
        $scope.formModel.email = invite.email;
        $scope.formModel.username = invite.email;
        $scope.formModel.inviteCode =  $routeParams.code;

        $scope.greeting = invite.name || invite.email || invite.username;
        $scope.invitedBy = invite.invitedBy;
      });
    };

    $scope.submit = function() {
      if (!$scope.inviteForm.$valid) {
        return;
      }

      backendSrv.post('/api/user/invite/complete', $scope.formModel).then(function() {
        window.location.href = config.appSubUrl + '/';
      });
    };

    $scope.init();

  }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignUpCtrl", function() { return SignUpCtrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_app_core_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />


var SignUpCtrl = /** @class */ (function () {
    /** @ngInject */
    SignUpCtrl.$inject = ["$scope", "backendSrv", "$location", "contextSrv"];
    function SignUpCtrl($scope, backendSrv, $location, contextSrv) {
        this.$scope = $scope;
        this.backendSrv = backendSrv;
        contextSrv.sidemenu = false;
        $scope.ctrl = this;
        $scope.formModel = {};
        var params = $location.search();
        $scope.formModel.orgName = params.email;
        $scope.formModel.email = params.email;
        $scope.formModel.username = params.email;
        $scope.formModel.code = params.code;
        $scope.verifyEmailEnabled = false;
        $scope.autoAssignOrg = false;
        backendSrv.get('/api/user/signup/options').then(function (options) {
            $scope.verifyEmailEnabled = options.verifyEmailEnabled;
            $scope.autoAssignOrg = options.autoAssignOrg;
        });
    }
    SignUpCtrl.prototype.submit = function () {
        if (!this.$scope.signUpForm.$valid) {
            return;
        }
        this.backendSrv.post('/api/user/signup/step2', this.$scope.formModel).then(function (rsp) {
            if (rsp.code === 'redirect-to-select-org') {
                window.location.href = __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.appSubUrl + '/profile/select-org?signup=1';
            }
            else {
                window.location.href = __WEBPACK_IMPORTED_MODULE_0_app_core_config___default.a.appSubUrl + '/';
            }
        });
    };
    return SignUpCtrl;
}());

__WEBPACK_IMPORTED_MODULE_1__core_module__["default"].controller('SignUpCtrl', SignUpCtrl);


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, coreModule) {
  'use strict';

  coreModule.default.controller('ResetPasswordCtrl', ["$scope", "contextSrv", "backendSrv", "$location", function($scope, contextSrv, backendSrv, $location) {
    contextSrv.sidemenu = false;
    $scope.formModel = {};
    $scope.mode = 'send';

    var params = $location.search();
    if (params.code) {
      $scope.mode = 'reset';
      $scope.formModel.code = params.code;
    }

    $scope.sendResetEmail = function() {
      if (!$scope.sendResetForm.$valid) {
        return;
      }
      backendSrv.post('/api/user/password/send-reset-email', $scope.formModel).then(function() {
        $scope.mode = 'email-sent';
      });
    };

    $scope.submitReset = function() {
      if (!$scope.resetForm.$valid) { return; }

      if ($scope.formModel.newPassword !== $scope.formModel.confirmPassword) {
        $scope.appEvent('alert-warning', ['New passwords do not match', '']);
        return;
      }

      backendSrv.post('/api/user/password/reset', $scope.formModel).then(function() {
        $location.path('login');
      });
    };

  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(21),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, config, coreModule) {
  'use strict';

  coreModule.default.controller('ErrorCtrl', ["$scope", "contextSrv", "navModelSrv", function($scope, contextSrv, navModelSrv) {

    $scope.navModel = navModelSrv.getNotFoundNav();
    $scope.appSubUrl = config.appSubUrl;

    var showSideMenu = contextSrv.sidemenu;
    contextSrv.sidemenu = false;

    $scope.$on('$destroy', function() {
      contextSrv.sidemenu = showSideMenu;
    });

  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(722),
  __webpack_require__(725),
  __webpack_require__(283),
  __webpack_require__(723),
  __webpack_require__(724),
  __webpack_require__(721),
  __webpack_require__(726),
  __webpack_require__(727),
  __webpack_require__(728),
  __webpack_require__(729),
], __WEBPACK_AMD_DEFINE_RESULT__ = function () {}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(10),
  __webpack_require__(2),
  __webpack_require__(21),
], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, $, coreModule, config) {
  'use strict';

  coreModule.default.service('googleAnalyticsSrv', ["$rootScope", "$location", function($rootScope, $location) {

    function gaInit() {
      $.getScript('https://www.google-analytics.com/analytics.js'); // jQuery shortcut
      var ga = window.ga = window.ga || function () { (ga.q = ga.q || []).push(arguments); }; ga.l = +new Date;
      ga('create', config.googleAnalyticsId, 'auto');
      return ga;
    }

    this.init = function() {

      $rootScope.$on('$viewContentLoaded', function() {
        var track =  { page: $location.url() };

        var ga = window.ga || gaInit();

        ga('set', track);
        ga('send', 'pageview');
      });

    };

  }]).run(["googleAnalyticsSrv", function(googleAnalyticsSrv) {

    if (config.googleAnalyticsId) {
      googleAnalyticsSrv.init();
    }

  }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertSrv", function() { return AlertSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(39);
///<reference path="../../headers/common.d.ts" />




var AlertSrv = /** @class */ (function () {
    /** @ngInject */
    AlertSrv.$inject = ["$timeout", "$rootScope", "$modal"];
    function AlertSrv($timeout, $rootScope, $modal) {
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$modal = $modal;
        this.list = [];
    }
    AlertSrv.prototype.init = function () {
        var _this = this;
        this.$rootScope.onAppEvent('alert-error', function (e, alert) {
            _this.set(alert[0], alert[1], 'error', 12000);
        }, this.$rootScope);
        this.$rootScope.onAppEvent('alert-warning', function (e, alert) {
            _this.set(alert[0], alert[1], 'warning', 5000);
        }, this.$rootScope);
        this.$rootScope.onAppEvent('alert-success', function (e, alert) {
            _this.set(alert[0], alert[1], 'success', 3000);
        }, this.$rootScope);
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('alert-warning', function (options) { return _this.set(options[0], options[1], 'warning', 5000); });
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('alert-success', function (options) { return _this.set(options[0], options[1], 'success', 3000); });
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('alert-error', function (options) { return _this.set(options[0], options[1], 'error', 7000); });
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('confirm-modal', this.showConfirmModal.bind(this));
    };
    AlertSrv.prototype.getIconForSeverity = function (severity) {
        switch (severity) {
            case 'success': return 'fa fa-check';
            case 'error': return 'fa fa-exclamation-triangle';
            default: return 'fa fa-exclamation';
        }
    };
    AlertSrv.prototype.set = function (title, text, severity, timeout) {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(text)) {
            console.log('alert error', text);
            if (text.statusText) {
                text = "HTTP Error (" + text.status + ") " + text.statusText;
            }
        }
        var newAlert = {
            title: title || '',
            text: text || '',
            severity: severity || 'info',
            icon: this.getIconForSeverity(severity)
        };
        var newAlertJson = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson(newAlert);
        // remove same alert if it already exists
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.list, function (value) {
            return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson(value) === newAlertJson;
        });
        this.list.push(newAlert);
        if (timeout > 0) {
            this.$timeout(function () {
                _this.list = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.without(_this.list, newAlert);
            }, timeout);
        }
        if (!this.$rootScope.$$phase) {
            this.$rootScope.$digest();
        }
        return (newAlert);
    };
    AlertSrv.prototype.clear = function (alert) {
        this.list = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.without(this.list, alert);
    };
    AlertSrv.prototype.clearAll = function () {
        this.list = [];
    };
    AlertSrv.prototype.showConfirmModal = function (payload) {
        var scope = this.$rootScope.$new();
        scope.onConfirm = function () {
            payload.onConfirm();
            scope.dismiss();
        };
        scope.updateConfirmText = function (value) {
            scope.confirmTextValid = payload.confirmText.toLowerCase() === value.toLowerCase();
        };
        scope.title = payload.title;
        scope.text = payload.text;
        scope.text2 = payload.text2;
        scope.confirmText = payload.confirmText;
        scope.onConfirm = payload.onConfirm;
        scope.onAltAction = payload.onAltAction;
        scope.altActionText = payload.altActionText;
        scope.icon = payload.icon || "fa-check";
        scope.yesText = payload.yesText || "Yes";
        scope.noText = payload.noText || "Cancel";
        scope.confirmTextValid = scope.confirmText ? false : true;
        var confirmModal = this.$modal({
            template: 'public/app/partials/confirm_modal.html',
            persist: false,
            modalClass: 'confirm-modal',
            show: false,
            scope: scope,
            keyboard: false
        });
        confirmModal.then(function (modalEl) {
            modalEl.modal('show');
        });
    };
    return AlertSrv;
}());

__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["default"].service('alertSrv', AlertSrv);


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(4),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, coreModule) {
  'use strict';

  coreModule.default.service('timer', ["$timeout", function($timeout) {
    // This service really just tracks a list of $timeout promises to give us a
    // method for cancelling them all when we need to

    var timers = [];

    this.register = function(promise) {
      timers.push(promise);
      return promise;
    };

    this.cancel = function(promise) {
      timers = _.without(timers,promise);
      $timeout.cancel(promise);
    };

    this.cancelAll = function() {
      _.each(timers, function(t) {
        $timeout.cancel(t);
      });
      timers = [];
    };
  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(4),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, coreModule) {
  'use strict';

  // This service was based on OpenJS library available in BSD License
  // http://www.openjs.com/scripts/events/keyboard_shortcuts/index.php
  coreModule.default.factory('keyboardManager', ['$window', '$timeout', function ($window, $timeout) {
    var keyboardManagerService = {};

    var defaultOpt = {
      'type':             'keydown',
      'propagate':        false,
      'inputDisabled':    false,
      'target':           $window.document,
      'keyCode':          false
    };
    // Store all keyboard combination shortcuts
    keyboardManagerService.keyboardEvent = {};
    // Add a new keyboard combination shortcut
    keyboardManagerService.bind = function (label, callback, opt) {
      var fct, elt, code, k;
      // Initialize opt object
      opt   = angular.extend({}, defaultOpt, opt);
      label = label.toLowerCase();
      elt   = opt.target;

      if (typeof opt.target === 'string') {
        elt = document.getElementById(opt.target);
      }

      fct = function (e) {
        e = e || $window.event;

        // Disable event handler when focus input and textarea
        if (opt['inputDisabled']) {
          var elt;
          if (e.target) {
            elt = e.target;
          }
          else if (e.srcElement) {
            elt = e.srcElement;
          }

          if (elt.nodeType === 3) {
            elt = elt.parentNode;
          }

          if (elt.tagName === 'INPUT' || elt.tagName === 'TEXTAREA') {
            return;
          }
        }

        // Find out which key is pressed
        if (e.keyCode) {
          code = e.keyCode;
        }
        else if (e.which) {
          code = e.which;
        }

        var character = String.fromCharCode(code).toLowerCase();

        if (code === 188) {
          character = ","; // If the user presses , when the type is onkeydown
        }
        if (code === 190) {
          character = "."; // If the user presses , when the type is onkeydown
        }

        var keys = label.split("+");
        // Key Pressed - counts the number of valid keypresses - if it is same as the number of keys, the shortcut function is invoked
        var kp = 0;
        // Work around for stupid Shift key bug created by using lowercase - as a result the shift+num combination was broken
        var shift_nums = {
          "`": "~",
          "1": "!",
          "2": "@",
          "3": "#",
          "4": "$",
          "5": "%",
          "6": "^",
          "7": "&",
          "8": "*",
          "9": "(",
          "0": ")",
          "-": "_",
          "=": "+",
          ";": ":",
          "'": "\"",
          ",": "<",
          ".": ">",
          "/": "?",
          "»": "?",
          "«": "?",
          "¿": "?",
          "\\": "|"
        };
        // Special Keys - and their codes
        var special_keys = {
          'esc': 27,
          'escape': 27,
          'tab': 9,
          'space': 32,
          'return': 13,
          'enter': 13,
          'backspace': 8,

          'scrolllock': 145,
          'scroll_lock': 145,
          'scroll': 145,
          'capslock': 20,
          'caps_lock': 20,
          'caps': 20,
          'numlock': 144,
          'num_lock': 144,
          'num': 144,

          'pause': 19,
          'break': 19,

          'insert': 45,
          'home': 36,
          'delete': 46,
          'end': 35,

          'pageup': 33,
          'page_up': 33,
          'pu': 33,

          'pagedown': 34,
          'page_down': 34,
          'pd': 34,

          'left': 37,
          'up': 38,
          'right': 39,
          'down': 40,

          'f1': 112,
          'f2': 113,
          'f3': 114,
          'f4': 115,
          'f5': 116,
          'f6': 117,
          'f7': 118,
          'f8': 119,
          'f9': 120,
          'f10': 121,
          'f11': 122,
          'f12': 123
        };
        // Some modifiers key
        var modifiers = {
          shift: {
            wanted:   false,
            pressed:  e.shiftKey ? true : false
          },
          ctrl : {
            wanted:   false,
            pressed:  e.ctrlKey ? true : false
          },
          alt  : {
            wanted:   false,
            pressed:  e.altKey ? true : false
          },
          meta : { //Meta is Mac specific
            wanted:   false,
            pressed:  e.metaKey ? true : false
          }
        };
        // Foreach keys in label (split on +)
        for (var i = 0, l = keys.length; k = keys[i], i < l; i++) {
          switch (k) {
            case 'ctrl':
            case 'control':
              kp++;
              modifiers.ctrl.wanted = true;
              break;
            case 'shift':
            case 'alt':
            case 'meta':
              kp++;
              modifiers[k].wanted = true;
              break;
          }

          if (k.length > 1) { // If it is a special key
            if (special_keys[k] === code) {
              kp++;
            }
          } else if (opt['keyCode']) { // If a specific key is set into the config
            if (opt['keyCode'] === code) {
              kp++;
            }
          } else { // The special keys did not match
            if (character === k) {
              kp++;
            }
            else {
              if (shift_nums[character] && e.shiftKey) { // Stupid Shift key bug created by using lowercase
                character = shift_nums[character];
                if (character === k) {
                  kp++;
                }
              }
            }
          }
        }

        if (kp === keys.length &&
          modifiers.ctrl.pressed === modifiers.ctrl.wanted &&
          modifiers.shift.pressed === modifiers.shift.wanted &&
          modifiers.alt.pressed === modifiers.alt.wanted &&
          modifiers.meta.pressed === modifiers.meta.wanted) {
          $timeout(function() {
            callback(e);
          }, 1);

          if (!opt['propagate']) { // Stop the event
            // e.cancelBubble is supported by IE - this will kill the bubbling process.
            e.cancelBubble = true;
            e.returnValue = false;

            // e.stopPropagation works in Firefox.
            if (e.stopPropagation) {
              e.stopPropagation();
              e.preventDefault();
            }
            return false;
          }
        }

      };
      // Store shortcut
      keyboardManagerService.keyboardEvent[label] = {
        'callback': fct,
        'target':   elt,
        'event':    opt['type']
      };
      //Attach the function with the event
      if (elt.addEventListener) {
        elt.addEventListener(opt['type'], fct, false);
      }
      else if (elt.attachEvent) {
        elt.attachEvent('on' + opt['type'], fct);
      }
      else {
        elt['on' + opt['type']] = fct;
      }
    };

    keyboardManagerService.unbindAll = function() {
      _.each(keyboardManagerService.keyboardEvent, function(value, key) {
        keyboardManagerService.unbind(key);
      });
    };

    // Remove the shortcut - just specify the shortcut and I will remove the binding
    keyboardManagerService.unbind = function (label) {
      label = label.toLowerCase();

      var binding = keyboardManagerService.keyboardEvent[label];
      delete(keyboardManagerService.keyboardEvent[label]);

      if (!binding) {
        return;
      }

      var type    = binding['event'],
      elt     = binding['target'],
      callback  = binding['callback'];

      if (elt.detachEvent) {
        elt.detachEvent('on' + type, callback);
      }
      else if (elt.removeEventListener) {
        elt.removeEventListener(type, callback, false);
      }
      else {
        elt['on' + type] = false;
      }
    };
    //
    return keyboardManagerService;
  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UtilSrv", function() { return UtilSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(39);
///<reference path="../../headers/common.d.ts" />


var UtilSrv = /** @class */ (function () {
    /** @ngInject */
    UtilSrv.$inject = ["$rootScope", "$modal"];
    function UtilSrv($rootScope, $modal) {
        this.$rootScope = $rootScope;
        this.$modal = $modal;
    }
    UtilSrv.prototype.init = function () {
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('show-modal', this.showModal.bind(this), this.$rootScope);
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('hide-modal', this.hideModal.bind(this), this.$rootScope);
    };
    UtilSrv.prototype.hideModal = function () {
        if (this.modalScope && this.modalScope.dismiss) {
            this.modalScope.dismiss();
        }
    };
    UtilSrv.prototype.showModal = function (options) {
        if (this.modalScope && this.modalScope.dismiss) {
            this.modalScope.dismiss();
        }
        this.modalScope = options.scope;
        if (options.model) {
            this.modalScope = this.$rootScope.$new();
            this.modalScope.model = options.model;
        }
        else if (!this.modalScope) {
            this.modalScope = this.$rootScope.$new();
        }
        var modal = this.$modal({
            modalClass: options.modalClass,
            template: options.src,
            templateHtml: options.templateHtml,
            persist: false,
            show: false,
            scope: this.modalScope,
            keyboard: false,
            backdrop: options.backdrop
        });
        Promise.resolve(modal).then(function (modalEl) {
            modalEl.modal('show');
        });
    };
    return UtilSrv;
}());

__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].service('utilSrv', UtilSrv);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
popoverSrv.$inject = ["$compile", "$rootScope", "$timeout"];
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tether_drop__);
///<reference path="../../headers/common.d.ts" />



/** @ngInject **/
function popoverSrv($compile, $rootScope, $timeout) {
    var openDrop = null;
    this.close = function () {
        if (openDrop) {
            openDrop.close();
        }
    };
    this.show = function (options) {
        if (openDrop) {
            openDrop.close();
            openDrop = null;
        }
        var scope = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend($rootScope.$new(true), options.model);
        var drop;
        var cleanUp = function () {
            setTimeout(function () {
                scope.$destroy();
                if (drop.tether) {
                    drop.destroy();
                }
                if (options.onClose) {
                    options.onClose();
                }
            });
            openDrop = null;
        };
        scope.dismiss = function () {
            drop.close();
        };
        var contentElement = document.createElement('div');
        contentElement.innerHTML = options.template;
        $compile(contentElement)(scope);
        $timeout(function () {
            drop = new __WEBPACK_IMPORTED_MODULE_2_tether_drop___default.a({
                target: options.element,
                content: contentElement,
                position: options.position,
                classes: options.classNames || 'drop-popover',
                openOn: options.openOn,
                hoverCloseDelay: 200,
                tetherOptions: {
                    constraints: [{ to: 'scrollParent', attachment: "none both" }]
                }
            });
            drop.on('close', function () {
                cleanUp();
            });
            openDrop = drop;
            openDrop.open();
        }, 100);
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["default"].service('popoverSrv', popoverSrv);


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(8),
  __webpack_require__(4),
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, coreModule) {
  'use strict';

  coreModule.default.service('uiSegmentSrv', ["$sce", "templateSrv", function($sce, templateSrv) {
    var self = this;

    function MetricSegment(options) {
      if (options === '*' || options.value === '*') {
        this.value = '*';
        this.html = $sce.trustAsHtml('<i class="fa fa-asterisk"><i>');
        this.type = options.type;
        this.expandable = true;
        return;
      }

      if (_.isString(options)) {
        this.value = options;
        this.html = $sce.trustAsHtml(templateSrv.highlightVariablesAsHtml(this.value));
        return;
      }

      // temp hack to work around legacy inconsistency in segment model
      this.text = options.value;

      this.cssClass = options.cssClass;
      this.custom = options.custom;
      this.type = options.type;
      this.fake = options.fake;
      this.value = options.value;
      this.selectMode = options.selectMode;
      this.type = options.type;
      this.expandable = options.expandable;
      this.html = options.html || $sce.trustAsHtml(templateSrv.highlightVariablesAsHtml(this.value));
    }

    this.getSegmentForValue = function(value, fallbackText) {
      if (value) {
        return this.newSegment(value);
      } else {
        return this.newSegment({value: fallbackText, fake: true});
      }
    };

    this.newSelectMeasurement = function() {
      return new MetricSegment({value: 'select measurement', fake: true});
    };

    this.newFake = function(text, type, cssClass) {
      return new MetricSegment({value: text, fake: true, type: type, cssClass: cssClass});
    };

    this.newSegment = function(options) {
      return new MetricSegment(options);
    };

    this.newKey = function(key) {
      return new MetricSegment({value: key, type: 'key', cssClass: 'query-segment-key' });
    };

    this.newKeyValue = function(value) {
      return new MetricSegment({value: value, type: 'value', cssClass: 'query-segment-value' });
    };

    this.newCondition = function(condition) {
      return new MetricSegment({value: condition, type: 'condition', cssClass: 'query-keyword' });
    };

    this.newOperator = function(op) {
      return new MetricSegment({value: op, type: 'operator', cssClass: 'query-segment-operator' });
    };

    this.newOperators = function(ops) {
      return _.map(ops, function(op) {
        return new MetricSegment({value: op, type: 'operator', cssClass: 'query-segment-operator' });
      });
    };

    this.transformToSegments = function(addTemplateVars, variableTypeFilter) {
      return function(results) {
        var segments = _.map(results, function(segment) {
          return self.newSegment({value: segment.text, expandable: segment.expandable});
        });

        if (addTemplateVars) {
          _.each(templateSrv.variables, function(variable) {
            if (variableTypeFilter === void 0 || variableTypeFilter === variable.type) {
              segments.unshift(self.newSegment({ type: 'template', value: '$' + variable.name, expandable: true }));
            }
          });
        }

        return segments;
      };
    };

    this.newSelectMetric = function() {
      return new MetricSegment({value: 'select metric', fake: true});
    };

    this.newPlusButton = function() {
      return new MetricSegment({fake: true, html: '<i class="fa fa-plus "></i>', type: 'plus-button' });
    };

    this.newSelectTagValue = function() {
      return new MetricSegment({value: 'select tag value', fake: true});
    };

  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BackendSrv", function() { return BackendSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__ = __webpack_require__(39);
///<reference path="../../headers/common.d.ts" />



var BackendSrv = /** @class */ (function () {
    /** @ngInject */
    BackendSrv.$inject = ["$http", "alertSrv", "$q", "$timeout", "contextSrv"];
    function BackendSrv($http, alertSrv, $q, $timeout, contextSrv) {
        this.$http = $http;
        this.alertSrv = alertSrv;
        this.$q = $q;
        this.$timeout = $timeout;
        this.contextSrv = contextSrv;
        this.inFlightRequests = {};
        this.HTTP_REQUEST_CANCELLED = -1;
    }
    BackendSrv.prototype.get = function (url, params) {
        return this.request({ method: 'GET', url: url, params: params });
    };
    BackendSrv.prototype.delete = function (url) {
        return this.request({ method: 'DELETE', url: url });
    };
    BackendSrv.prototype.post = function (url, data) {
        return this.request({ method: 'POST', url: url, data: data });
    };
    BackendSrv.prototype.patch = function (url, data) {
        return this.request({ method: 'PATCH', url: url, data: data });
    };
    BackendSrv.prototype.put = function (url, data) {
        return this.request({ method: 'PUT', url: url, data: data });
    };
    BackendSrv.prototype.withNoBackendCache = function (callback) {
        var _this = this;
        this.noBackendCache = true;
        return callback().finally(function () {
            _this.noBackendCache = false;
        });
    };
    BackendSrv.prototype.requestErrorHandler = function (err) {
        if (err.isHandled) {
            return;
        }
        var data = err.data || { message: 'Unexpected error' };
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(data)) {
            data = { message: data };
        }
        if (err.status === 422) {
            this.alertSrv.set("Validation failed", data.message, "warning", 4000);
            throw data;
        }
        data.severity = 'error';
        if (err.status < 500) {
            data.severity = "warning";
        }
        if (data.message) {
            var description = "";
            var message = data.message;
            if (message.length > 80) {
                description = message;
                message = "Error";
            }
            this.alertSrv.set(message, description, data.severity, 10000);
        }
        throw data;
    };
    BackendSrv.prototype.request = function (options) {
        var _this = this;
        options.retry = options.retry || 0;
        var requestIsLocal = !options.url.match(/^http/);
        var firstAttempt = options.retry === 0;
        if (requestIsLocal) {
            if (this.contextSrv.user && this.contextSrv.user.orgId) {
                options.headers = options.headers || {};
                options.headers['X-Grafana-Org-Id'] = this.contextSrv.user.orgId;
            }
            if (options.url.indexOf("/") === 0) {
                options.url = options.url.substring(1);
            }
        }
        return this.$http(options).then(function (results) {
            if (options.method !== 'GET') {
                if (results && results.data.message) {
                    if (options.showSuccessAlert !== false) {
                        _this.alertSrv.set(results.data.message, '', 'success', 3000);
                    }
                }
            }
            return results.data;
        }, function (err) {
            // handle unauthorized
            if (err.status === 401 && _this.contextSrv.user.isSignedIn && firstAttempt) {
                return _this.loginPing().then(function () {
                    options.retry = 1;
                    return _this.request(options);
                });
            }
            _this.$timeout(_this.requestErrorHandler.bind(_this, err), 50);
            throw err;
        });
    };
    BackendSrv.prototype.addCanceler = function (requestId, canceler) {
        if (requestId in this.inFlightRequests) {
            this.inFlightRequests[requestId].push(canceler);
        }
        else {
            this.inFlightRequests[requestId] = [canceler];
        }
    };
    BackendSrv.prototype.resolveCancelerIfExists = function (requestId) {
        var cancelers = this.inFlightRequests[requestId];
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isUndefined(cancelers) && cancelers.length) {
            cancelers[0].resolve();
        }
    };
    BackendSrv.prototype.datasourceRequest = function (options) {
        var _this = this;
        options.retry = options.retry || 0;
        // A requestID is provided by the datasource as a unique identifier for a
        // particular query. If the requestID exists, the promise it is keyed to
        // is canceled, canceling the previous datasource request if it is still
        // in-flight.
        var requestId = options.requestId;
        if (requestId) {
            this.resolveCancelerIfExists(requestId);
            // create new canceler
            var canceler = this.$q.defer();
            options.timeout = canceler.promise;
            this.addCanceler(requestId, canceler);
        }
        var requestIsLocal = !options.url.match(/^http/);
        var firstAttempt = options.retry === 0;
        if (requestIsLocal) {
            if (this.contextSrv.user && this.contextSrv.user.orgId) {
                options.headers = options.headers || {};
                options.headers['X-Grafana-Org-Id'] = this.contextSrv.user.orgId;
            }
            if (options.url.indexOf("/") === 0) {
                options.url = options.url.substring(1);
            }
            if (options.headers && options.headers.Authorization) {
                options.headers['X-DS-Authorization'] = options.headers.Authorization;
                delete options.headers.Authorization;
            }
            if (this.noBackendCache) {
                options.headers['X-Grafana-NoCache'] = 'true';
            }
        }
        return this.$http(options).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('ds-request-response', response);
            return response;
        }).catch(function (err) {
            if (err.status === _this.HTTP_REQUEST_CANCELLED) {
                throw { err: err, cancelled: true };
            }
            // handle unauthorized for backend requests
            if (requestIsLocal && firstAttempt && err.status === 401) {
                return _this.loginPing().then(function () {
                    options.retry = 1;
                    if (canceler) {
                        canceler.resolve();
                    }
                    return _this.datasourceRequest(options);
                });
            }
            // populate error obj on Internal Error
            if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(err.data) && err.status === 500) {
                err.data = {
                    error: err.statusText,
                    response: err.data,
                };
            }
            // for Prometheus
            if (err.data && !err.data.message && __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(err.data.error)) {
                err.data.message = err.data.error;
            }
            __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('ds-request-error', err);
            throw err;
        }).finally(function () {
            // clean up
            if (options.requestId) {
                _this.inFlightRequests[options.requestId].shift();
            }
        });
    };
    BackendSrv.prototype.loginPing = function () {
        return this.request({ url: '/api/login/ping', method: 'GET', retry: 1 });
    };
    BackendSrv.prototype.search = function (query) {
        return this.get('/api/search', query);
    };
    BackendSrv.prototype.getDashboard = function (type, slug) {
        return this.get('/api/dashboards/' + type + '/' + slug);
    };
    BackendSrv.prototype.saveDashboard = function (dash, options) {
        options = (options || {});
        return this.post('/api/dashboards/db/', {
            dashboard: dash,
            overwrite: options.overwrite === true,
            message: options.message || '',
        });
    };
    return BackendSrv;
}());

__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["default"].service('backendSrv', BackendSrv);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />


var DynamicDirectiveSrv = /** @class */ (function () {
    /** @ngInject */
    DynamicDirectiveSrv.$inject = ["$compile", "$rootScope"];
    function DynamicDirectiveSrv($compile, $rootScope) {
        this.$compile = $compile;
        this.$rootScope = $rootScope;
    }
    DynamicDirectiveSrv.prototype.addDirective = function (element, name, scope) {
        var child = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(document.createElement(name));
        this.$compile(child)(scope);
        element.empty();
        element.append(child);
    };
    DynamicDirectiveSrv.prototype.link = function (scope, elem, attrs, options) {
        var _this = this;
        options.directive(scope).then(function (directiveInfo) {
            if (!directiveInfo || !directiveInfo.fn) {
                elem.empty();
                return;
            }
            if (!directiveInfo.fn.registered) {
                __WEBPACK_IMPORTED_MODULE_1__core_module__["default"].directive(attrs.$normalize(directiveInfo.name), directiveInfo.fn);
                directiveInfo.fn.registered = true;
            }
            _this.addDirective(elem, directiveInfo.name, scope);
        }).catch(function (err) {
            console.log('Plugin load:', err);
            _this.$rootScope.appEvent('alert-error', ['Plugin error', err.toString()]);
        });
    };
    DynamicDirectiveSrv.prototype.create = function (options) {
        var _this = this;
        var directiveDef = {
            restrict: 'E',
            scope: options.scope,
            link: function (scope, elem, attrs) {
                if (options.watchPath) {
                    var childScope_1 = null;
                    scope.$watch(options.watchPath, function () {
                        if (childScope_1) {
                            childScope_1.$destroy();
                        }
                        childScope_1 = scope.$new();
                        _this.link(childScope_1, elem, attrs, options);
                    });
                }
                else {
                    _this.link(scope, elem, attrs, options);
                }
            }
        };
        return directiveDef;
    };
    return DynamicDirectiveSrv;
}());
__WEBPACK_IMPORTED_MODULE_1__core_module__["default"].service('dynamicDirectiveSrv', DynamicDirectiveSrv);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
setupAngularRoutes.$inject = ["$routeProvider", "$locationProvider"];var __WEBPACK_IMPORTED_MODULE_0__dashboard_loaders__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dashboard_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(2);


/** @ngInject **/
function setupAngularRoutes($routeProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    var loadOrgBundle = {
        lazy: ["$q", "$route", "$rootScope", function ($q, $route, $rootScope) {
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 793));
            }]
    };
    var loadAdminBundle = {
        lazy: ["$q", "$route", "$rootScope", function ($q, $route, $rootScope) {
                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 794));
            }]
    };
    var loadAlertingBundle = {
        lazy: ["$q", "$route", "$rootScope", function ($q, $route, $rootScope) {
                return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 795));
            }]
    };
    $routeProvider
        .when('/', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'LoadDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard/:type/:slug', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'LoadDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard-solo/:type/:slug', {
        templateUrl: 'public/app/features/panel/partials/soloPanel.html',
        controller: 'SoloPanelCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard/new', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'NewDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboards/list', {
        templateUrl: 'public/app/features/dashboard/partials/dash_list.html',
        controller: 'DashListCtrl',
    })
        .when('/datasources', {
        templateUrl: 'public/app/features/plugins/partials/ds_list.html',
        controller: 'DataSourcesCtrl',
        controllerAs: 'ctrl',
    })
        .when('/datasources/edit/:id', {
        templateUrl: 'public/app/features/plugins/partials/ds_edit.html',
        controller: 'DataSourceEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/datasources/new', {
        templateUrl: 'public/app/features/plugins/partials/ds_edit.html',
        controller: 'DataSourceEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/org', {
        templateUrl: 'public/app/features/org/partials/orgDetails.html',
        controller: 'OrgDetailsCtrl',
        resolve: loadOrgBundle,
    })
        .when('/org/new', {
        templateUrl: 'public/app/features/org/partials/newOrg.html',
        controller: 'NewOrgCtrl',
        resolve: loadOrgBundle,
    })
        .when('/org/users', {
        templateUrl: 'public/app/features/org/partials/orgUsers.html',
        controller: 'OrgUsersCtrl',
        controllerAs: 'ctrl',
        resolve: loadOrgBundle,
    })
        .when('/org/apikeys', {
        templateUrl: 'public/app/features/org/partials/orgApiKeys.html',
        controller: 'OrgApiKeysCtrl',
        resolve: loadOrgBundle,
    })
        .when('/profile', {
        templateUrl: 'public/app/features/org/partials/profile.html',
        controller: 'ProfileCtrl',
        controllerAs: 'ctrl',
        resolve: loadOrgBundle,
    })
        .when('/profile/password', {
        templateUrl: 'public/app/features/org/partials/change_password.html',
        controller: 'ChangePasswordCtrl',
        resolve: loadOrgBundle,
    })
        .when('/profile/select-org', {
        templateUrl: 'public/app/features/org/partials/select_org.html',
        controller: 'SelectOrgCtrl',
        resolve: loadOrgBundle,
    })
        .when('/admin', {
        templateUrl: 'public/app/features/admin/partials/admin_home.html',
        controller: 'AdminHomeCtrl',
        controllerAs: 'ctrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/settings', {
        templateUrl: 'public/app/features/admin/partials/settings.html',
        controller: 'AdminSettingsCtrl',
        controllerAs: 'ctrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/users', {
        templateUrl: 'public/app/features/admin/partials/users.html',
        controller: 'AdminListUsersCtrl',
        controllerAs: 'ctrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/users/create', {
        templateUrl: 'public/app/features/admin/partials/new_user.html',
        controller: 'AdminEditUserCtrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/users/edit/:id', {
        templateUrl: 'public/app/features/admin/partials/edit_user.html',
        controller: 'AdminEditUserCtrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/orgs', {
        templateUrl: 'public/app/features/admin/partials/orgs.html',
        controller: 'AdminListOrgsCtrl',
        controllerAs: 'ctrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/orgs/edit/:id', {
        templateUrl: 'public/app/features/admin/partials/edit_org.html',
        controller: 'AdminEditOrgCtrl',
        controllerAs: 'ctrl',
        resolve: loadAdminBundle,
    })
        .when('/admin/stats', {
        templateUrl: 'public/app/features/admin/partials/stats.html',
        controller: 'AdminStatsCtrl',
        controllerAs: 'ctrl',
        resolve: loadAdminBundle,
    })
        .when('/login', {
        templateUrl: 'public/app/partials/login.html',
        controller: 'LoginCtrl',
    })
        .when('/invite/:code', {
        templateUrl: 'public/app/partials/signup_invited.html',
        controller: 'InvitedCtrl',
    })
        .when('/signup', {
        templateUrl: 'public/app/partials/signup_step2.html',
        controller: 'SignUpCtrl',
    })
        .when('/user/password/send-reset-email', {
        templateUrl: 'public/app/partials/reset_password.html',
        controller: 'ResetPasswordCtrl',
    })
        .when('/user/password/reset', {
        templateUrl: 'public/app/partials/reset_password.html',
        controller: 'ResetPasswordCtrl',
    })
        .when('/dashboard/snapshots', {
        templateUrl: 'public/app/features/snapshot/partials/snapshots.html',
        controller: 'SnapshotsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/plugins', {
        templateUrl: 'public/app/features/plugins/partials/plugin_list.html',
        controller: 'PluginListCtrl',
        controllerAs: 'ctrl',
    })
        .when('/plugins/:pluginId/edit', {
        templateUrl: 'public/app/features/plugins/partials/plugin_edit.html',
        controller: 'PluginEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/plugins/:pluginId/page/:slug', {
        templateUrl: 'public/app/features/plugins/partials/plugin_page.html',
        controller: 'AppPageCtrl',
        controllerAs: 'ctrl',
    })
        .when('/styleguide/:page?', {
        controller: 'StyleGuideCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'public/app/features/styleguide/styleguide.html',
    })
        .when('/alerting', {
        redirectTo: '/alerting/list'
    })
        .when('/alerting/list', {
        templateUrl: 'public/app/features/alerting/partials/alert_list.html',
        controller: 'AlertListCtrl',
        controllerAs: 'ctrl',
        resolve: loadAlertingBundle,
    })
        .when('/alerting/notifications', {
        templateUrl: 'public/app/features/alerting/partials/notifications_list.html',
        controller: 'AlertNotificationsListCtrl',
        controllerAs: 'ctrl',
        resolve: loadAlertingBundle,
    })
        .when('/alerting/notification/new', {
        templateUrl: 'public/app/features/alerting/partials/notification_edit.html',
        controller: 'AlertNotificationEditCtrl',
        controllerAs: 'ctrl',
        resolve: loadAlertingBundle,
    })
        .when('/alerting/notification/:id/edit', {
        templateUrl: 'public/app/features/alerting/partials/notification_edit.html',
        controller: 'AlertNotificationEditCtrl',
        controllerAs: 'ctrl',
        resolve: loadAlertingBundle,
    })
        .otherwise({
        templateUrl: 'public/app/partials/error.html',
        controller: 'ErrorCtrl'
    });
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["default"].config(setupAngularRoutes);


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
  __webpack_require__(2),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (coreModule) {
  "use strict";

  coreModule.default.controller('LoadDashboardCtrl', ["$scope", "$routeParams", "dashboardLoaderSrv", "backendSrv", "$location", function($scope, $routeParams, dashboardLoaderSrv, backendSrv, $location) {
    $scope.appEvent("dashboard-fetch-start");

    if (!$routeParams.slug) {
      backendSrv.get('/api/dashboards/home').then(function(homeDash) {
        if (homeDash.redirectUri) {
          $location.path('dashboard/' + homeDash.redirectUri);
        } else {
          var meta = homeDash.meta;
          meta.canSave = meta.canShare = meta.canStar = false;
          $scope.initDashboard(homeDash, $scope);
        }
      });
      return;
    }

    dashboardLoaderSrv.loadDashboard($routeParams.type, $routeParams.slug).then(function(result) {
      $scope.initDashboard(result, $scope);
    });

  }]);

  coreModule.default.controller('NewDashboardCtrl', ["$scope", function($scope) {
    $scope.initDashboard({
      meta: { canStar: false, canShare: false, isNew: true },
      dashboard: {
        title: "New dashboard",
        rows: [
          {
            title: 'Dashboard Row',
            height: '250px',
            panels:[],
            isNew: true,
          }
        ]
      },
    }, $scope);
  }]);

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
interpolateTemplateVars.$inject = ["templateSrv"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_module__ = __webpack_require__(2);
///<reference path="../../headers/common.d.ts" />




__WEBPACK_IMPORTED_MODULE_3__core_module__["default"].filter('stringSort', function () {
    return function (input) {
        return input.sort();
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["default"].filter('slice', function () {
    return function (arr, start, end) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isUndefined(arr)) {
            return arr.slice(start, end);
        }
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["default"].filter('stringify', function () {
    return function (arr) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(arr) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(arr)) {
            return __WEBPACK_IMPORTED_MODULE_1_angular___default.a.toJson(arr);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNull(arr) ? null : arr.toString();
        }
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["default"].filter('moment', function () {
    return function (date, mode) {
        switch (mode) {
            case 'ago':
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).fromNow();
        }
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).fromNow();
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["default"].filter('noXml', function () {
    var noXml = function (text) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(text)
            ? text
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/'/g, '&#39;')
                .replace(/"/g, '&quot;')
            : text;
    };
    return function (text) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(text)
            ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(text, noXml)
            : noXml(text);
    };
});
/** @ngInject */
function interpolateTemplateVars(templateSrv) {
    var filterFunc = function (text, scope) {
        var scopedVars;
        if (scope.ctrl) {
            scopedVars = (scope.ctrl.panel || scope.ctrl.row).scopedVars;
        }
        else {
            scopedVars = scope.row.scopedVars;
        }
        return templateSrv.replaceWithText(text, scopedVars);
    };
    filterFunc.$stateful = true;
    return filterFunc;
}
__WEBPACK_IMPORTED_MODULE_3__core_module__["default"].filter('interpolateTemplateVars', interpolateTemplateVars);
/* unused harmony default export */ var _unused_webpack_default_export = ({});


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assignModelProperties;
function assignModelProperties(target, source, defaults, removeDefaults) {
    for (var key in defaults) {
        if (!defaults.hasOwnProperty(key)) {
            continue;
        }
        target[key] = source[key] === undefined ? defaults[key] : source[key];
    }
}


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeybindingSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mousetrap__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mousetrap__);
///<reference path="../../headers/common.d.ts" />





var KeybindingSrv = /** @class */ (function () {
    /** @ngInject */
    KeybindingSrv.$inject = ["$rootScope", "$location"];
    function KeybindingSrv($rootScope, $location) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$location = $location;
        // clear out all shortcuts on route change
        $rootScope.$on('$routeChangeSuccess', function () {
            __WEBPACK_IMPORTED_MODULE_4_mousetrap___default.a.reset();
            // rebind global shortcuts
            _this.setupGlobal();
        });
        this.setupGlobal();
    }
    KeybindingSrv.prototype.setupGlobal = function () {
        this.bind(['?', 'h'], this.showHelpModal);
        this.bind("g h", this.goToHome);
        this.bind("g a", this.openAlerting);
        this.bind("g p", this.goToProfile);
        this.bind("s s", this.openSearchStarred);
        this.bind('s o', this.openSearch);
        this.bind('s t', this.openSearchTags);
        this.bind('f', this.openSearch);
    };
    KeybindingSrv.prototype.openSearchStarred = function () {
        this.$rootScope.appEvent('show-dash-search', { starred: true });
    };
    KeybindingSrv.prototype.openSearchTags = function () {
        this.$rootScope.appEvent('show-dash-search', { tagsMode: true });
    };
    KeybindingSrv.prototype.openSearch = function () {
        this.$rootScope.appEvent('show-dash-search');
    };
    KeybindingSrv.prototype.openAlerting = function () {
        this.$location.url("/alerting");
    };
    KeybindingSrv.prototype.goToHome = function () {
        this.$location.url("/");
    };
    KeybindingSrv.prototype.goToProfile = function () {
        this.$location.url("/profile");
    };
    KeybindingSrv.prototype.showHelpModal = function () {
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-modal', { templateHtml: '<help-modal></help-modal>' });
    };
    KeybindingSrv.prototype.bind = function (keyArg, fn) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4_mousetrap___default.a.bind(keyArg, function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            evt.returnValue = false;
            return _this.$rootScope.$apply(fn.bind(_this));
        }, 'keydown');
    };
    KeybindingSrv.prototype.showDashEditView = function (view) {
        var search = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend(this.$location.search(), { editview: view });
        this.$location.search(search);
    };
    KeybindingSrv.prototype.setupDashboardBindings = function (scope, dashboard) {
        var _this = this;
        this.bind('mod+o', function () {
            dashboard.graphTooltip = (dashboard.graphTooltip + 1) % 3;
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('graph-hover-clear');
            scope.broadcastRefresh();
        });
        this.bind('mod+h', function () {
            dashboard.hideControls = !dashboard.hideControls;
        });
        this.bind('mod+s', function (e) {
            scope.appEvent('save-dashboard');
        });
        this.bind('t z', function () {
            scope.appEvent('zoom-out', 2);
        });
        this.bind('ctrl+z', function () {
            scope.appEvent('zoom-out', 2);
        });
        this.bind('t left', function () {
            scope.appEvent('shift-time-backward');
        });
        this.bind('t right', function () {
            scope.appEvent('shift-time-forward');
        });
        // edit panel
        this.bind('e', function () {
            if (dashboard.meta.focusPanelId && dashboard.meta.canEdit) {
                _this.$rootScope.appEvent('panel-change-view', {
                    fullscreen: true,
                    edit: true,
                    panelId: dashboard.meta.focusPanelId,
                    toggle: true
                });
            }
        });
        // view panel
        this.bind('v', function () {
            if (dashboard.meta.focusPanelId) {
                _this.$rootScope.appEvent('panel-change-view', {
                    fullscreen: true,
                    edit: null,
                    panelId: dashboard.meta.focusPanelId,
                    toggle: true,
                });
            }
        });
        // delete panel
        this.bind('p r', function () {
            if (dashboard.meta.focusPanelId && dashboard.meta.canEdit) {
                var panelInfo = dashboard.getPanelInfoById(dashboard.meta.focusPanelId);
                panelInfo.row.removePanel(panelInfo.panel);
                dashboard.meta.focusPanelId = 0;
            }
        });
        // share panel
        this.bind('p s', function () {
            if (dashboard.meta.focusPanelId) {
                var shareScope = scope.$new();
                var panelInfo = dashboard.getPanelInfoById(dashboard.meta.focusPanelId);
                shareScope.panel = panelInfo.panel;
                shareScope.dashboard = dashboard;
                __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-modal', {
                    src: 'public/app/features/dashboard/partials/shareModal.html',
                    scope: shareScope
                });
            }
        });
        // delete row
        this.bind('r r', function () {
            if (dashboard.meta.focusPanelId && dashboard.meta.canEdit) {
                var panelInfo = dashboard.getPanelInfoById(dashboard.meta.focusPanelId);
                dashboard.removeRow(panelInfo.row);
                dashboard.meta.focusPanelId = 0;
            }
        });
        // collapse row
        this.bind('r c', function () {
            if (dashboard.meta.focusPanelId) {
                var panelInfo = dashboard.getPanelInfoById(dashboard.meta.focusPanelId);
                panelInfo.row.toggleCollapse();
                dashboard.meta.focusPanelId = 0;
            }
        });
        // collapse all rows
        this.bind('d shift+c', function () {
            for (var _i = 0, _a = dashboard.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                row.collapse = true;
            }
        });
        // expand all rows
        this.bind('d shift+e', function () {
            for (var _i = 0, _a = dashboard.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                row.collapse = false;
            }
        });
        this.bind('d n', function (e) {
            _this.$location.url("/dashboard/new");
        });
        this.bind('d r', function () {
            scope.broadcastRefresh();
        });
        this.bind('d s', function () {
            _this.showDashEditView('settings');
        });
        this.bind('d k', function () {
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('toggle-kiosk-mode');
        });
        this.bind('d v', function () {
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('toggle-view-mode');
        });
        this.bind('esc', function () {
            var popups = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.popover.in');
            if (popups.length > 0) {
                return;
            }
            scope.appEvent('hide-modal');
            scope.appEvent('hide-dash-editor');
            scope.appEvent('panel-change-view', { fullscreen: false, edit: false });
        });
    };
    return KeybindingSrv;
}());

__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["default"].service('keybindingSrv', KeybindingSrv);


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HelpCtrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = helpModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(39);
///<reference path="../../../headers/common.d.ts" />


var HelpCtrl = /** @class */ (function () {
    /** @ngInject */
    function HelpCtrl() {
        this.tabIndex = 0;
        this.shortcuts = {
            'Global': [
                { keys: ['g', 'h'], description: 'Go to Home Dashboard' },
                { keys: ['g', 'p'], description: 'Go to Profile' },
                { keys: ['s', 'o'], description: 'Open search' },
                { keys: ['s', 's'], description: 'Open search with starred filter' },
                { keys: ['s', 't'], description: 'Open search in tags view' },
                { keys: ['esc'], description: 'Exit edit/setting views' },
            ],
            'Dashboard': [
                { keys: ['mod+s'], description: 'Save dashboard' },
                { keys: ['mod+h'], description: 'Hide row controls' },
                { keys: ['d', 'r'], description: 'Refresh all panels' },
                { keys: ['d', 's'], description: 'Dashboard settings' },
                { keys: ['d', 'v'], description: 'Toggle in-active / view mode' },
                { keys: ['d', 'k'], description: 'Toggle kiosk mode (hides top nav)' },
                { keys: ['d', 'E'], description: 'Expand all rows' },
                { keys: ['d', 'C'], description: 'Collapse all rows' },
                { keys: ['mod+o'], description: 'Toggle shared graph crosshair' },
            ],
            'Focused Panel': [
                { keys: ['e'], description: 'Toggle panel edit view' },
                { keys: ['v'], description: 'Toggle panel fullscreen view' },
                { keys: ['p', 's'], description: 'Open Panel Share Modal' },
                { keys: ['p', 'r'], description: 'Remove Panel' },
            ],
            'Focused Row': [
                { keys: ['r', 'c'], description: 'Collapse Row' },
                { keys: ['r', 'r'], description: 'Remove Row' },
            ],
            'Time Range': [
                { keys: ['t', 'z'], description: 'Zoom out time range' },
                { keys: ['t', '<i class="fa fa-long-arrow-left"></i>'], description: 'Move time range back' },
                { keys: ['t', '<i class="fa fa-long-arrow-right"></i>'], description: 'Move time range forward' },
            ],
        };
    }
    HelpCtrl.prototype.dismiss = function () {
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].emit('hide-modal');
    };
    return HelpCtrl;
}());

function helpModal() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/help/help.html',
        controller: HelpCtrl,
        bindToController: true,
        transclude: true,
        controllerAs: 'ctrl',
        scope: {},
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["default"].directive('helpModal', helpModal);


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordStrength; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_react2angular__ = __webpack_require__(107);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var PasswordStrength = /** @class */ (function (_super) {
    __extends(PasswordStrength, _super);
    function PasswordStrength(props) {
        return _super.call(this, props) || this;
    }
    PasswordStrength.prototype.render = function () {
        var strengthText = "strength: strong like a bull.";
        var strengthClass = "password-strength-good";
        if (this.props.password.length <= 8) {
            strengthText = "strength: you can do better.";
            strengthClass = "password-strength-ok";
        }
        if (this.props.password.length < 4) {
            strengthText = "strength: weak sauce.";
            strengthClass = "password-strength-bad";
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "password-strength small " + strengthClass },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, strengthText)));
    };
    return PasswordStrength;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

Object(__WEBPACK_IMPORTED_MODULE_1_app_core_utils_react2angular__["a" /* react2AngularDirective */])('passwordStrength', PasswordStrength, ['password']);


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavModelSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(2);
///<reference path="../headers/common.d.ts" />

var NavModelSrv = /** @class */ (function () {
    /** @ngInject */
    NavModelSrv.$inject = ["contextSrv"];
    function NavModelSrv(contextSrv) {
        this.contextSrv = contextSrv;
    }
    NavModelSrv.prototype.getAlertingNav = function (subPage) {
        return {
            section: {
                title: 'Alerting',
                url: 'plugins',
                icon: 'icon-gf icon-gf-alert'
            },
            menu: [
                { title: 'Alert List', active: subPage === 0, url: 'alerting/list', icon: 'fa fa-list-ul' },
                { title: 'Notification channels', active: subPage === 1, url: 'alerting/notifications', icon: 'fa fa-bell-o' },
            ]
        };
    };
    NavModelSrv.prototype.getDatasourceNav = function (subPage) {
        return {
            section: {
                title: 'Data Sources',
                url: 'datasources',
                icon: 'icon-gf icon-gf-datasources'
            },
            menu: [
                { title: 'List view', active: subPage === 0, url: 'datasources', icon: 'fa fa-list-ul' },
                { title: 'Add data source', active: subPage === 1, url: 'datasources/new', icon: 'fa fa-plus' },
            ]
        };
    };
    NavModelSrv.prototype.getPlaylistsNav = function (subPage) {
        return {
            section: {
                title: 'Playlists',
                url: 'playlists',
                icon: 'fa fa-fw fa-film'
            },
            menu: [
                { title: 'List view', active: subPage === 0, url: 'playlists', icon: 'fa fa-list-ul' },
                { title: 'Add Playlist', active: subPage === 1, url: 'playlists/create', icon: 'fa fa-plus' },
            ]
        };
    };
    NavModelSrv.prototype.getProfileNav = function () {
        return {
            section: {
                title: 'User Profile',
                url: 'profile',
                icon: 'fa fa-fw fa-user'
            },
            menu: []
        };
    };
    NavModelSrv.prototype.getNotFoundNav = function () {
        return {
            section: {
                title: 'Page',
                url: '',
                icon: 'fa fa-fw fa-warning'
            },
            menu: []
        };
    };
    NavModelSrv.prototype.getOrgNav = function (subPage) {
        return {
            section: {
                title: 'Organization',
                url: 'org',
                icon: 'icon-gf icon-gf-users'
            },
            menu: [
                { title: 'Preferences', active: subPage === 0, url: 'org', icon: 'fa fa-fw fa-cog' },
                { title: 'Org Users', active: subPage === 1, url: 'org/users', icon: 'fa fa-fw fa-users' },
                { title: 'API Keys', active: subPage === 2, url: 'org/apikeys', icon: 'fa fa-fw fa-key' },
            ]
        };
    };
    NavModelSrv.prototype.getAdminNav = function (subPage) {
        return {
            section: {
                title: 'Admin',
                url: 'admin',
                icon: 'fa fa-fw fa-cogs'
            },
            menu: [
                { title: 'Users', active: subPage === 0, url: 'admin/users', icon: 'fa fa-fw fa-user' },
                { title: 'Orgs', active: subPage === 1, url: 'admin/orgs', icon: 'fa fa-fw fa-users' },
                { title: 'Server Settings', active: subPage === 2, url: 'admin/settings', icon: 'fa fa-fw fa-cogs' },
                { title: 'Server Stats', active: subPage === 2, url: 'admin/stats', icon: 'fa fa-fw fa-line-chart' },
                { title: 'Style Guide', active: subPage === 2, url: 'styleguide', icon: 'fa fa-fw fa-key' },
            ]
        };
    };
    NavModelSrv.prototype.getPluginsNav = function () {
        return {
            section: {
                title: 'Plugins',
                url: 'plugins',
                icon: 'icon-gf icon-gf-apps'
            },
            menu: []
        };
    };
    NavModelSrv.prototype.getDashboardNav = function (dashboard, dashNavCtrl) {
        // special handling for snapshots
        if (dashboard.meta.isSnapshot) {
            return {
                section: {
                    title: dashboard.title,
                    icon: 'icon-gf icon-gf-snapshot'
                },
                menu: [
                    {
                        title: 'Go to original dashboard',
                        icon: 'fa fa-fw fa-external-link',
                        url: dashboard.snapshot.originalUrl,
                    }
                ]
            };
        }
        var menu = [];
        if (dashboard.meta.canEdit) {
            menu.push({
                title: 'Settings',
                icon: 'fa fa-fw fa-cog',
                clickHandler: function () { return dashNavCtrl.openEditView('settings'); }
            });
            menu.push({
                title: 'Templating',
                icon: 'fa fa-fw fa-code',
                clickHandler: function () { return dashNavCtrl.openEditView('templating'); }
            });
            menu.push({
                title: 'Annotations',
                icon: 'fa fa-fw fa-comment',
                clickHandler: function () { return dashNavCtrl.openEditView('annotations'); }
            });
            if (!dashboard.meta.isHome) {
                menu.push({
                    title: 'Version history',
                    icon: 'fa fa-fw fa-history',
                    clickHandler: function () { return dashNavCtrl.openEditView('history'); }
                });
            }
            menu.push({
                title: 'View JSON',
                icon: 'fa fa-fw fa-eye',
                clickHandler: function () { return dashNavCtrl.viewJson(); }
            });
        }
        if (this.contextSrv.isEditor && !dashboard.editable) {
            menu.push({
                title: 'Make Editable',
                icon: 'fa fa-fw fa-edit',
                clickHandler: function () { return dashNavCtrl.makeEditable(); }
            });
        }
        menu.push({
            title: 'Shortcuts',
            icon: 'fa fa-fw fa-keyboard-o',
            clickHandler: function () { return dashNavCtrl.showHelpModal(); }
        });
        if (this.contextSrv.isEditor) {
            menu.push({
                title: 'Save As ...',
                icon: 'fa fa-fw fa-save',
                clickHandler: function () { return dashNavCtrl.saveDashboardAs(); }
            });
        }
        if (dashboard.meta.canSave) {
            menu.push({
                title: 'Delete',
                icon: 'fa fa-fw fa-trash',
                clickHandler: function () { return dashNavCtrl.deleteDashboard(); }
            });
        }
        return {
            section: {
                title: dashboard.title,
                icon: 'icon-gf icon-gf-dashboard'
            },
            menu: menu
        };
    };
    return NavModelSrv;
}());

__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["default"].service('navModelSrv', NavModelSrv);


/***/ })
],[301]);


// WEBPACK FOOTER //
// app.5331f559bd9a1bed9a93.js